
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});

import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-ui/ui/widgets/sortable.js';
import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/droppable.js';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/accordion.js';
import 'jquery-ui/ui/widgets/slider.js';
import 'jquery-ui/ui/widgets/tabs.js';
import 'jquery.scrollto/jquery.scrollTo.js';


/******** REMOVE 'ARE YOU SURE' CONFIRMATION *********/
$('.sbmt-delete-form').submit(function() {
    var c = confirm("Are you sure?");
    return c;
});

/************ PREVENT DEFAULT LINKS************/
$('.prevent-default-link').click(function(e){
    e.preventDefault();
});

// add csrf header to all possible ajax requests
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

jQuery('body').addClass('js');


/************************************************* FOR OTHERS PAGE *********************************************************/

if (location.href.indexOf('get_possible_combinations_for_sum') != -1) {

    function subsetSum(numbers, target, partial) {

        var s, n, remaining;

        console.log(target);

        partial = partial || [];

        // sum partial
        s = partial.reduce(function (a, b) {
            return a + b;
        }, 0);

        var with2Decimals = s.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        var s = parseFloat(with2Decimals);

        // check if the partial sum is equals to target
        if (s === target) {

            console.log("%s=%s", partial.join("+"), target);
        }

        if (s >= target) {

            return;  // if we reach the number why bother to continue
        }

        for (var i = 0; i < numbers.length; i++) {

            n = parseFloat(numbers[i]);

            remaining = numbers.slice(i + 1);
            subsetSum(remaining, target, partial.concat([n]));

        }

        $('.spinner-border.psc').remove();
    }

    var _all_amounts_ = JSON.parse($('#_all_amounts_').val());
    //console.log(_all_amounts_);
    var _ready_amounts_ = [];

    for (var zz in _all_amounts_) {
        _ready_amounts_.push(_all_amounts_[zz]);
    }

    subsetSum(_ready_amounts_, parseFloat($('#custom_amount').val()));


}

/************************************************* FOR OTHERS PAGE END*********************************************************/

/**************************** PLUGIN FOR ACCORDION MULTI OPENED TABS ********************************/
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = function (root, jQuery) {
            if (jQuery === undefined) {
                if (typeof window !== 'undefined') {
                    jQuery = require('jquery');
                } else {
                    jQuery = require('jquery')(root);
                }
            }
            factory(jQuery);
            return jQuery;
        };
    } else {
        factory(jQuery);
    }
}(function ($) {

    var originalToggle = $.ui.accordion.prototype._toggle;

    $.extend($.ui.accordion.prototype, {
        multiple: false,
        _toggle: function (data) {
            if (this.options.multiple && data.newPanel.length) {
                data.oldPanel = data.oldHeader = this.prevShow = $('');

                if (this.options.collapsible && data.newPanel.is(':visible')) {
                    data.oldPanel = data.newPanel;
                    data.newPanel = $('');
                }
            }
            originalToggle.apply(this, arguments);
        }
    });

}));

$('#main-questions-modal').on('show.bs.modal', function (event) {
    $('#have_your_courses_select').multiSelect({
        noneText: $('#have_your_courses_select_container_text').data('text'),
        menuItemHTML: '<label class="multi-select-menuitem"></label>'
    });
});

/*************** UNIVERSAL MODAL *****************/
$('#universalModal').on('show.bs.modal', function (event) {

    /******************** MULTISELECT FOR COURSE MUST HAVE MODULES IN ADMIN *********************/
    if ($('.das-page').length > 0) {

        setTimeout(function(){

            $('#das_courses_ids').multiSelect({
                noneText: $('#text_select_mmodule').data('text').trim(),
                menuItemHTML: '<label class="multi-select-menuitem"></label>'
            });

            var last_valid_selection1 = $('#das_courses_ids').val();

            $('#das_courses_ids').change(function(event) {

                if ($(this).val().length > 2) {

                    $(this).val(last_valid_selection1);

                    $('#das_courses_ids').change();

                } else {
                    last_valid_selection1 = $(this).val();
                }
            });


            $('#range_courses_1').multiSelect({
                noneText: $('#text_select_mmodule').data('text').trim(),
                menuItemHTML: '<label class="multi-select-menuitem"></label>'
            });

            $('#range_courses_2').multiSelect({
                noneText: $('#text_select_mmodule').data('text').trim(),
                menuItemHTML: '<label class="multi-select-menuitem"></label>'
            });

            $('#range_courses_3').multiSelect({
                noneText: $('#text_select_mmodule').data('text').trim(),
                menuItemHTML: '<label class="multi-select-menuitem"></label>'
            });


            $('#range_courses_1').change(function(event) {

                $('#range_courses_2 option.labelHasDisabledAttrR1').removeAttr('disabled');
                $('#range_courses_2+.multi-select-container .multi-select-menuitem.labelHasDisabledAttrR1 input[type="checkbox"]').removeAttr('disabled');
                $('#range_courses_3 option.labelHasDisabledAttrR1').removeAttr('disabled');
                $('#range_courses_3+.multi-select-container .multi-select-menuitem.labelHasDisabledAttrR1 input[type="checkbox"]').removeAttr('disabled');

                $('.labelHasDisabledAttrR1').removeClass('labelHasDisabledAttrR1');

                var _rc_1_values = $(this).val();
                console.log('_rc_1_values');
                console.log(_rc_1_values);

                $(this).find('option').each(function() {
                    if ($(this).hasClass('labelHasDisabledAttrR2')) {
                        var _th_opt_val1 =  $(this).attr('value');
                        $('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_th_opt_val1 +'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR2');
                    }
                    if ($(this).hasClass('labelHasDisabledAttrR3')) {
                        var _th_opt_val2 =  $(this).attr('value');
                        $('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_th_opt_val2 +'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR3');
                    }
                });

                for (var _rc1 = 0; _rc1 < _rc_1_values.length; _rc1++) {

                    $('#range_courses_2 option[value="'+_rc_1_values[_rc1]+'"]').attr('disabled', 'disabled').addClass('labelHasDisabledAttrR1');

                    $('#range_courses_2+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_1_values[_rc1]+'"]').attr('disabled', 'disabled').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR1');


                    $('#range_courses_3 option[value="'+_rc_1_values[_rc1]+'"]').attr('disabled', 'disabled').addClass('labelHasDisabledAttrR1');

                    $('#range_courses_3+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_1_values[_rc1]+'"]').attr('disabled', 'disabled').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR1');


                }

                /*$('#range_courses_2').change();
                $('#range_courses_3').change();*/

                /*$('#range_courses_2+.multi-select-container .multi-select-menuitem input.labelHasDisabledAttrR1[type="checkbox"][disabled="disabled"]').each(function() {
                    $(this).parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR1');
                });

                $('#range_courses_3+.multi-select-container .multi-select-menuitem input.labelHasDisabledAttrR1[type="checkbox"][disabled="disabled"]').each(function() {
                    $(this).parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR1');
                });*/

            });






            $('#range_courses_2').change(function(event) {


                $('#range_courses_1 option.labelHasDisabledAttrR2').removeAttr('disabled');
                $('#range_courses_1+.multi-select-container .multi-select-menuitem.labelHasDisabledAttrR2 input[type="checkbox"]').removeAttr('disabled');

                $('#range_courses_3 option.labelHasDisabledAttrR2').removeAttr('disabled');
                $('#range_courses_3+.multi-select-container .multi-select-menuitem.labelHasDisabledAttrR2 input[type="checkbox"]').removeAttr('disabled');

                $('.labelHasDisabledAttrR2').removeClass('labelHasDisabledAttrR2');

                var _rc_2_values = $(this).val();

                $(this).find('option').each(function() {
                    if ($(this).hasClass('labelHasDisabledAttrR1')) {
                        var _th_opt_val1 =  $(this).attr('value');
                        $('#range_courses_2+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_th_opt_val1 +'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR1');
                    }
                    if ($(this).hasClass('labelHasDisabledAttrR3')) {
                        var _th_opt_val2 =  $(this).attr('value');
                        $('#range_courses_2+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_th_opt_val2 +'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR3');
                    }
                });

                for (var _rc1 = 0; _rc1 < _rc_2_values.length; _rc1++) {

                    $('#range_courses_1 option[value="'+_rc_2_values[_rc1]+'"]').attr('disabled', 'disabled').addClass('labelHasDisabledAttrR2');
                    $('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_2_values[_rc1]+'"]').attr('disabled', 'disabled');
                    $('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_2_values[_rc1]+'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR2');

                    $('#range_courses_3 option[value="'+_rc_2_values[_rc1]+'"]').attr('disabled', 'disabled').addClass('labelHasDisabledAttrR2');
                    $('#range_courses_3+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_2_values[_rc1]+'"]').attr('disabled', 'disabled');
                    $('#range_courses_3+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_2_values[_rc1]+'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR2');

                }

                /*$('#range_courses_1').change();
                $('#range_courses_3').change();*/

                /*$('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][disabled="disabled"]').each(function() {
                    $(this).parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttr');
                });

                $('#range_courses_3+.multi-select-container .multi-select-menuitem input[type="checkbox"][disabled="disabled"]').each(function() {
                    $(this).parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttr');
                });*/

            });



            $('#range_courses_3').change(function(event) {

                $('#range_courses_1 option.labelHasDisabledAttrR3').removeAttr('disabled');
                $('#range_courses_1+.multi-select-container .multi-select-menuitem.labelHasDisabledAttrR3 input[type="checkbox"]').removeAttr('disabled');

                $('#range_courses_2 option.labelHasDisabledAttrR3').removeAttr('disabled');
                $('#range_courses_2+.multi-select-container .multi-select-menuitem.labelHasDisabledAttrR3 input[type="checkbox"]').removeAttr('disabled');

                $('.labelHasDisabledAttrR3').removeClass('labelHasDisabledAttrR3');

                var _rc_3_values = $(this).val();


                $(this).find('option').each(function() {
                    if ($(this).hasClass('labelHasDisabledAttrR1')) {
                        var _th_opt_val1 =  $(this).attr('value');
                        $('#range_courses_3+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_th_opt_val1 +'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR1');
                    }
                    if ($(this).hasClass('labelHasDisabledAttrR2')) {
                        var _th_opt_val2 =  $(this).attr('value');
                        $('#range_courses_3+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_th_opt_val2 +'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR2');
                    }
                });

                for (var _rc1 = 0; _rc1 < _rc_3_values.length; _rc1++) {

                    $('#range_courses_1 option[value="'+_rc_3_values[_rc1]+'"]').attr('disabled', 'disabled').addClass('labelHasDisabledAttrR3');
                    $('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_3_values[_rc1]+'"]').attr('disabled', 'disabled');
                    $('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_3_values[_rc1]+'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR3');

                    $('#range_courses_2 option[value="'+_rc_3_values[_rc1]+'"]').attr('disabled', 'disabled').addClass('labelHasDisabledAttrR3');
                    $('#range_courses_2+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_3_values[_rc1]+'"]').attr('disabled', 'disabled');
                    $('#range_courses_2+.multi-select-container .multi-select-menuitem input[type="checkbox"][value="'+_rc_3_values[_rc1]+'"]').parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttrR3');

                }


                /*$('#range_courses_1').change();
                $('#range_courses_2').change();*/

                /*$('#range_courses_1+.multi-select-container .multi-select-menuitem input[type="checkbox"][disabled="disabled"]').each(function() {
                    $(this).parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttr');
                });

                $('#range_courses_2+.multi-select-container .multi-select-menuitem input[type="checkbox"][disabled="disabled"]').each(function() {
                    $(this).parents('.multi-select-menuitem:first').addClass('labelHasDisabledAttr');
                });*/

            });

            $('#range_courses_1').change();

            $('#range_courses_2').change();

            $('#range_courses_3').change();

        }, 2500);

    }


    if ($('.role-page').length > 0) {

        $('#universalModal').addClass('role-modal');

        setTimeout(function(){

            $('.hlg_links').each(function() {

                if ($(this).find('input[type="checkbox"]:checked').length == $(this).find('input[type="checkbox"]').length) {

                    $(this).parents('.hidden_links_group:first').find('.hlg_head input[type="checkbox"]').prop('checked', true);

                }

            });

        }, 1000);

    }

    // empty old modal data holders
    $('#elem-id-holder').val('');
    $('.success-message').text('');

    // use target button to get data from it
    var button = $(event.relatedTarget);
    var _title = button.data('title');
    var _route = button.data('route');
    var _action = button.data('action');
    var _elemid = button.data('elemid');
    var _submitroute = button.data('submitroute');
    var _method = 'GET';

    if (button.data('method')) {
        _method = button.data('method');
    }

    var dataObj = {};

    // collect object to send
    if (_elemid) {
        dataObj.id = _elemid;
        $('#elem-id-holder').val(_elemid);
    }

    // assign title and show loading spinner
    var modal = $(this);
    modal.find('.modal-title').text(_title);
    modal.find('.modal-body').html('<div class="text-center"><div class="spinner-border text-success"></div></div>');

    // choose what modal footer buttons will be show or hidden
    if (_action == 'create' || _action == 'edit') {

        //console.log('sss-ddd');

        modal.find('.btn-edit').hide();
        modal.find('.btn-save').show();

        // ADD SAVE BUTTON BEHAVIOUR
        $(document).off('click', '#universalModal .btn-save');
        $(document).on('click', '#universalModal .btn-save', function(e) {

            // at first we need to remove all prev validation errors and red borders from inputs
            $('#universalModal form input, #universalModal form textarea, #universalModal form select#module_id').removeClass('errorInput');
            $('#universalModal form .err-container').text('');

            var _serializedForm = $('#universalModal form').serialize();

            // send submitted create / edit form
            if (typeof _serializedForm != 'undefined' && _serializedForm != '' && _serializedForm != null) {

                /*console.log('avat');
                console.log($('#universalModal form .slide-content #avatarimage').attr('src'));*/

                if ($('#universalModal form .slide-content').length > 0 && $('#universalModal form .slide-content #avatarimage').length > 0 && $('#universalModal form .slide-content #avatarimage').attr('src') != '/images/grey_cube.png') {

                    _serializedForm = 'slide_image=' + $('#universalModal form .slide-content #avatarimage').attr('src') + '&' + _serializedForm;

                }

                /*console.log('_serializedForm 111');
                console.log(_serializedForm);
                return false;*/

                $.ajax({
                    url: _submitroute,
                    method: 'POST',
                    data: _serializedForm,
                    /*processData: $('#universalModal form .slide-content').length > 0 ? false : true,
                    contentType: $('#universalModal form .slide-content').length > 0 ? false : 'application/x-www-form-urlencoded; charset=UTF-8',*/
                    success: function(data) {

                        if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                            $('.success-message').text(data.success);

                            if ($(button).hasClass('no-reload-on-save')) {

                                //console.log('no-reload-on-save');

                                var _lecturer_selected_option = $('#universalModal form').find('select[name="lecturer_id"] option:selected');

                                var _lecturer_name = $('#universalModal form').find('select[name="lecturer_id"]').val() != '0' ? $(_lecturer_selected_option).text().trim() : '';

                                var _status = $('#universalModal form').find('select[name="status_id"]').val() != '0' ? $('#universalModal form').find('select[name="status_id"] option:selected').text().trim() : '';

                                if (_status == '' && _lecturer_name != '') {

                                    _status = $('#universalModal form').find('select[name="status_id"] option.planned').text().trim();

                                }

                                var _date = $('#universalModal form').find('input[name="date"]').val().trim();

                                //var aSplitDate = _date.split('.');

                                //_date = aSplitDate[0] + '.' + aSplitDate[1] + '.' + aSplitDate[2];


                                var _name = $('#universalModal form').find('input[name="name"]').val().trim();


                                $(button).parents('.row-me-days:first').find('.quick-assign_lecturer_name').text(_lecturer_name);
                                $(button).parents('.row-me-days:first').find('.quick-assign_name').text(_name);
                                $(button).parents('.row-me-days:first').find('.quick-assign_status').text(_status);
                                $(button).parents('.row-me-days:first').find('.quick-assign_date').text(_date);

                                if ($('#universalModal form').find('select[name="lecturer_id"]').val() == '0') {

                                    $(button).parents('.row-me-days:first').find('.quick-assign_request .btn-request-to-lecturer').data('lecturerid', '').data('lecturerfullname','').data('lectureremail','').addClass('make-invisible');

                                }
                                else {

                                    $(button).parents('.row-me-days:first').find('.quick-assign_request .btn-request-to-lecturer').data('lecturerid', $(_lecturer_selected_option).data('lecturerid')).data('lecturerfullname',$(_lecturer_selected_option).data('lecturerfullname')).data('lectureremail',$(_lecturer_selected_option).data('lectureremail')).removeClass('make-invisible');

                                }

                                $('#universalModal .close.close-modal').click();

                            }
                            else {
                                setTimeout(function(){
                                    location.reload();
                                }, 1000);
                            }


                        }
                        if (typeof data.error != 'undefined') {

                            for (var errFieldName in data.error) {
                                //console.log(data.error[errFieldName]);
                                $('#universalModal form').find('[name="'+errFieldName+'"]').addClass('errorInput');
                                $('#universalModal form').find('[name="'+errFieldName+'"]').parents('.column-parent:first').find('.err-container').text(data.error[errFieldName]);
                            }
                        }

                    }
                });

            }
        });

    }
    else {

        modal.find('.btn-edit').show();
        modal.find('.btn-save').hide();

        $(document).off('click', '#universalModal .btn-edit');
        $(document).on('click', '#universalModal .btn-edit', function(e) {
            //console.log('edit-clicked');
            $('#universalModal .close.close-modal').click();
            setTimeout(function() {
                //console.log(button);
                $(button).parents('form:first').find('.edit-elem').click();
            }, 300);

        });

    }

    // get lecturers assigned to current topic
    if ($(button).hasClass('get-lecturers-assigned-to-topic')) {

        $(document).on('click', '.topic_lecturers', function() {

            var _topic_lecturer_id_and_index = $(this).attr('id').replace('topic_lecturers_', '');
            var a_tl_id_ind = _topic_lecturer_id_and_index.split('_');
            var _topic_lecturer_id = a_tl_id_ind[0];
            var _ind = a_tl_id_ind[1];

            $('#lecturer_id_'+_ind).val(_topic_lecturer_id);

        });

        // remove lecturers block
        $(document).on('click', '.existing-lecturers-and-statuses .els-remove', function(){
            $(this).parents('.existing-lecturers-and-statuses:first').remove();
        });

    }

    // sending ajax request to show based on _route
    if (typeof _route != 'undefined' && _route != null && _route != '') {

        $.ajax({
            url: _route,
            data: dataObj,
            success: function(data) {

                setTimeout(function(){
                    modal.find('.modal-body').html(data);

                    if ($('#predefined_element_id').length > 0 && $('#predefined_element_id').val() != '') {
                        $('#predefined_element_id').change();
                    }

                }, 400);

            }
        });

    }

});



/*************** IMPORT MODULE EVENT DAYS MODAL *****************/
$('#importModuleDaysModal').on('show.bs.modal', function (event) {

    // empty old modal data holders
    $('#elem-id-holder-me').val('');
    $('.success-message').text('');



    // use target button to get data from it
    var button = $(event.relatedTarget);
    var _title = button.data('title');
    var _route = button.data('route');
    var _action = button.data('action');
    var _elemid = button.data('elemid');
    var _submitroute = button.data('submitroute');
    var _method = 'GET';

    if (button.data('method')) {
        _method = button.data('method');
    }

    var dataObj = {};

    // collect object to send
    if (_elemid) {
        dataObj.id = _elemid;
        $('#elem-id-holder-me').val(_elemid);
    }

    // assign title and show loading spinner
    var modal = $(this);
    modal.find('.modal-title').text(_title);
    modal.find('.modal-body').html('<div class="text-center"><div class="spinner-border text-success"></div></div>');

    if (typeof _route != 'undefined' && _route != null && _route != '') {

        $.ajax({
            url: _route,
            data: dataObj,
            method: 'POST',
            success: function(data) {

                setTimeout(function(){

                    modal.find('.modal-body').html(data);



                    $(document).off('click', '#importModuleDaysModal .btn-save');
                    $(document).on('click', '#importModuleDaysModal .btn-save', function(e) {

                        if ($('.day-for-module-event').length > 0) {

                            var _data_for_sending = 'module_event_id='+_elemid;

                            $('.day-for-module-event').each(function() {

                                var _day_id = $(this).attr('id').replace('day-for-module-event-', '');

                                _data_for_sending += (_data_for_sending == '' ? '' : '&')+'day_ids[]='+_day_id;

                            });

                            $.ajax({
                                url: _submitroute,
                                method: 'POST',
                                data: _data_for_sending,
                                success: function(data) {

                                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                        $('.success-message').text(data.success);

                                        setTimeout(function(){
                                            location.reload();
                                        }, 1000);

                                    }

                                }
                            });

                        }


                    });




                }, 400);

            }
        });

    }

});

/*********************** SHOW / HIDE Module event days ******************************/
$('.expand-me-days').click(function() {

    $(this).parents('.row.r-actions').next('.row-with-me-days').slideDown("slow");
    $(this).hide();
    $(this).next('.hide-me-days').css('display', 'block');
});
$('.hide-me-days').click(function() {

    $(this).parents('.row.r-actions').next('.row-with-me-days').slideUp("slow");
    $(this).hide();
    $(this).prev('.expand-me-days').css('display', 'block');

});
/*********************** SHOW / HIDE Module event days end ******************************/

/******************* Start: Find collisions in dates *********************************/
function findDateCollisions() {
    console.log('inside findDateCollisions')
  $('.me-day-date').removeClass('error-collision-date');
  $('#errorDateCollisionMessage').addClass('invisible');
  var list1 = $('#card-front-info-1 .front-me-name.active+.front-me-days .me-day-date');
  var list2 = $('#card-front-info-2 .front-me-name.active+.front-me-days .me-day-date');
  var bError = false;
  list1.each(function() {
    var date1 = $(this).html();
    for (var elem of list2) {
      var date2 = $(elem).html();
      if (date2 == date1) {
        bError = true;
        $(this).addClass('error-collision-date');
        $(elem).addClass('error-collision-date');
        console.log('Found collision on ' + date1);
        $('#errorDateCollisionMessage').removeClass('invisible');
      }
    }
  });

  if (bError == true) {
      $('#collisions_happened').val(1);
  }
  else {
      $('#collisions_happened').val(0);
  }
}

$('.collisions-warning-head').click(function() {
    $(this).parent().toggleClass('opened');
});
/******************* End: Find collisions in dates *********************************/

/* BULK FUNCTIONS*/

/*************** BULK CHECKBOX CLICK *****************/
$('document').on('click', '#bulk_all', function(){
//console.log('b-all');

    var _parent = '.rows-list:first';
    if ($(this).hasClass('module-combinations-bulk-all')) {
        _parent = '.mc-all-container';
    }
    if ($(this).hasClass('course-combinations-bulk-all')) {
        _parent = '.dc-all-container';
    }
    var all_bulk_checkboxes = $(this).parents(_parent).find('.bulk_check:visible');

    if ($(this).is(":checked")) {
        all_bulk_checkboxes.each(function(){
            $(this).prop('checked', true);
        });
    }
    else {
        all_bulk_checkboxes.each(function(){
            $(this).prop('checked', false);
        });
    }

});



/****************** BULK DELETE ********************/
$('#delete_chosen').click(function() {

    var removeElementsName = $(this).data('removeelementsname');
    var removeElementsUrl = $(this).data('removeelementsurl');


    if ($('.bulk_check:checked').length > 0) {

        var c = confirm($('#are_you_sure_text').text());

        if (c == true) {

            var removeElementsIds = '';

            $('.bulk_check:checked').each(function() {

                var _entity_id = $(this).attr('id').replace('bulk_', '');
                removeElementsIds += (removeElementsIds == '' ? '' : '&') + 'removeElementsIds[]=' + _entity_id;

            });

            var _finalString = 'removeElementsName='+removeElementsName + '&' + removeElementsIds;

            $.ajax({
                url: removeElementsUrl,
                method: 'POST',
                data: _finalString,
                success: function (data) {
                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {
                        $('.bulk_check:checked').each(function() {
                            $(this).parents('.r-actions:first').remove();
                        });
                    }
                }
            });
        }
    }
    else {
        $('#noItemsChosenModalTrigger').click();
    }

});













/************************************************ CONNECTIONS PAGE SORTABLE ACCORDIONS ***************************************************/

// save connections of current module
function saveModuleLectureConnections(elementObject)
{


    var _moduleContainer = $(elementObject).parents('.module-container:first');

    var _objectToSend = {
        "module_id": $(_moduleContainer).attr('id').replace('module-container-', ''),
        "days": []
    };

    $(_moduleContainer).find('.day-container').each(function() {


        var _day_obj = this;
        var _day_id_str = $(this).attr('id');

        var _dayStrSplitToIdsArray = _day_id_str.split('-');

        var day_id = _dayStrSplitToIdsArray[3];
        var day_order = $(this).parents('.day_panel:first').find('h6.can-be-edited').data('dayindex');


        var dayObj = {
            "day_id": day_id,
            "sort_order": day_order,
            "lecture_slots": []
        };

        $(_day_obj).find('.slot-container').each(function(){

            var _slot_obj = this;

            var _slot_id_str = $(this).attr('id');

            var _slotStrSplitToIdsArray = _slot_id_str.split('-');

            var slot_id = _slotStrSplitToIdsArray[4];
            var slot_order = $(this).data('slotindex');

            var slotObj = {
                "slot_id": slot_id,
                "sort_order": slot_order,
                "lectures": []
            };

            if ($(_slot_obj).find('.drg-elem-lecture, .existed-drg-elem-lecture').length > 0) {
                $(_slot_obj).find('.drg-elem-lecture, .existed-drg-elem-lecture').each(function() {
                    var lecture_id = $(this).data('lectureid');
                    slotObj.lectures.push(lecture_id);

                    console.log('added lec id');
                });
            }
            if (slotObj.lectures.length == 0) {
                delete slotObj['lectures'];
            }

            dayObj.lecture_slots.push(slotObj);
        });

        _objectToSend.days.push(dayObj);




    });


        $.ajax({
            url: $('#connections_store').data('urlstore'),
            method: 'POST',
            data: _objectToSend,
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                   //console.log(data);

                }

            }
        });



}

// count connections of each lecture
function setNumConnectionsOfLectures(chosen_lecture_id='', isFromDayPool=false)
{
    var selector = 'div[data-type="lecture"]';
    var _decrease_num = 1;

    if (chosen_lecture_id != '') {
        _decrease_num = 2;
    }


    if (chosen_lecture_id != '') {
        selector = 'div[data-lectureid="'+chosen_lecture_id+'"]';
    }


// not('#c_panel_lectures_to_day div[data-type="lecture"]')
    $(selector).each(function() {

        var _modulesLecturesContainer = [];

        var lecture_id = $(this).data('lectureid');

        // create html for popopver based on modules -> days
        if (typeof _modulesLecturesContainer[lecture_id] == 'undefined') {


            if ($('.module-container div[data-lectureid="'+lecture_id+'"]').length > 0) {

                var _module_day_content = '';

                $('.module-container div[data-lectureid="'+lecture_id+'"]').each(function() {

                    // add module name
                    var module_id = $(this).parents('.module-container').prev('h5').data('moduleid');
                    _module_day_content += '<div class="pp-module-parent" data-ppmd="' + module_id + '"><div class="popover-module-title">' + $(this).parents('.module-container').prev('h5').find('.editable-content').text().trim() + '</div>';

                    // add days names
                    $(this).parents('.module-container').find('.day-container').each(function() {

                        if ($(this).find('div[data-lectureid="' + lecture_id + '"]').length > 0) {
                            _module_day_content += '<div class="popover-day-title">' + $(this).prev('h6').find('.editable-content').text().trim() + '</div>';
                        }

                    });

                    _module_day_content += '</div>';

                    //if (typeof _modulesLecturesContainer[lecture_id] == 'undefined') {
                        _modulesLecturesContainer[lecture_id] = _module_day_content;
                   // }


                });


            }

        }


        var _popover_html = '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';

        var current_lecture_counters = parseInt($('div[data-lectureid="'+lecture_id+'"]').length) - _decrease_num;

        if ($(this).find('.amount-of-lectures').length > 0) {

            $(this).find('.amount-of-lectures').remove();

        }

        $(' <span class="amount-of-lectures popover-will-be-set" title="' + $(this).find('.editable-content').text().trim() + '"> <strong> (' + current_lecture_counters + ') </strong> </span> ').insertAfter($(this).find('.editable-content'));

        var final_content = (typeof _modulesLecturesContainer[lecture_id] != 'undefined' ? _modulesLecturesContainer[lecture_id] : '');

        if (final_content != '') {

            $('body').append('<div class="secret-element1">'+final_content+'</div>');

            $('.secret-element1 .pp-module-parent').each(function() {
                var _ppmd_id = $(this).data('ppmd');
                $(this).addClass('only-one');
                $('.secret-element1 div[data-ppmd="'+_ppmd_id+'"]').not('.only-one').remove();
            });

            final_content = $('.secret-element1').html();

            $('.secret-element1').remove();
        }


        $('.popover-will-be-set').popover({
            template: _popover_html,
            content: final_content,
            title: $(this).find('.editable-content').text().trim(),
            html: true,
            trigger: 'hover',
            placement: 'top',
            attachment: 'top right',
            targetAttachment: 'top left',
            offset: '0,10px'
        }).removeClass('popover-will-be-set');

    });






}


setNumConnectionsOfLectures();


$('.drpbl.slot-container').sortable({
    revert: false,
    start: function(event, ui) {
        $(ui.item).addClass('placed-in-sortable');
    },
    stop: function(event, ui) {

        saveModuleLectureConnections(ui.item);

    }
});



// EDIT elements on the fly
$(document).on('click', '.fa-pencil-square-o.edit-pencil', function(e) {

    e.stopImmediatePropagation();
    e.stopPropagation();

//console.log('pencil-clicked');
//console.log($(this).parents('.can-be-edited:first').attr('id'));

    var _editable_content_text = $(this).parents('.can-be-edited:first').find('.editable-content').hide().text();
    var _editable_content_text_2 = '';
    var _selector_ =  '.new_editing_element';

    if ($(this).parents('.can-be-edited:first').find('.editable-content-2')) {
        _editable_content_text_2 = $(this).parents('.can-be-edited:first').find('.editable-content-2').hide().text();
    }

    $(this).parents('.can-be-edited:first').find('.amount-of-lectures').hide();
    $(this).parents('.can-be-edited:first').find('.edit-pencil').hide();
    $(this).parents('.can-be-edited:first').find('.fa-times').hide();

    $(this).parents('.can-be-edited:first').append('<input type="text" class="new_editing_element" name="new_editing_element" value="' + _editable_content_text + '"/>');

    if (_editable_content_text_2 != '') {

        $(this).parents('.can-be-edited:first').append('<input type="text" class="new_editing_element_2" name="new_editing_element_2" value="' + _editable_content_text_2 + '"/>');
        _selector_ = '.new_editing_element_2';

    }

    $('.new_editing_element').focus();


    $(_selector_).blur(function() {

        //console.log('blur happened');

        var _the_parent = $(this).parents('.can-be-edited:first');
        var _current_val = $(this).val();

        //console.log($(_the_parent).attr('id'));

        if (_current_val != '') {

            var _create_url = $(_the_parent).data('urlstore');

            var id = '';
            var _item_type = $(_the_parent).data('type');
            var _code = '';
            var _lecturer_name = '';
            var _name = '';
            var _module_id = '';
            var _day_sort_order_ = '';

            if (_item_type == 'lecture') {

                id = $(_the_parent).data('lectureid');
                //_lecturer_name = _current_val;
                _name = $(_the_parent).find('.new_editing_element').val().trim();

            }
            if (_item_type == 'module') {

                id = $(_the_parent).data('moduleid');
                _code = $(_the_parent).data('modulecode');
                _name = _current_val;

            }

            if (_item_type == 'day') {

                id = $(_the_parent).data('dayid');
                _name = _current_val;
                _module_id = $(this).parents('.module-container:first').attr('id').replace('module-container-', '');

                _day_sort_order_ = $(this).parents('.day_panel:first').find('h6.can-be-edited').data('dayindex');
            }

            $.ajax({
                url: _create_url,
                method: 'POST',
                data: {'name': _name, 'id': id, 'code': _code/*, 'lecturer_name': _lecturer_name*/, 'module_id': _module_id, sort_order: _day_sort_order_},
                success: function(data) {

                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $(_the_parent).find('.new_editing_element, .new_editing_element_2').remove();

                        $(_the_parent).find('.editable-content').text(_name).show();
                        //$(_the_parent).find('.editable-content-2').text(_lecturer_name).show();
                        $(_the_parent).find('.amount-of-lectures').show();
                        $(_the_parent).find('.edit-pencil').show();
                        $(_the_parent).find('.fa-times').show();

                        if (_item_type == 'lecture') {
                            $('div[data-lectureid="'+id+'"]').find('.editable-content').text(_name);
                            //$('div[data-lectureid="'+id+'"]').find('.editable-content-2').text(_lecturer_name);
                        }

                    }
                }
            });

            // make newly added lecture draggable

        }

    });

});

$(document).on('keypress', '.new_editing_element, .new_editing_element_2', function(e) {

    if(e.which == 13) {

       $(this).parents('.ui-sortable-handle:first').next('.ui-sortable-handle').find('.fa-pencil-square-o.edit-pencil:first').click();
       $(this).blur();

    }
});

// ACCORDION FOR MODULES
$( "#modules_accordion" ).accordion({
    active: false,
    collapsible: true,
    multiple: true,
    header: 'h5',
    beforeActivate:function(event, ui ) {
        if (typeof event.originalEvent != 'undefined' && typeof event.originalEvent.target != 'undefined') {
            var fromIcon = $(event.originalEvent.target).is('*:not(.fa-pencil-square-o.edit-pencil, .fa-times, .new_editing_element)');
            return fromIcon;
        }
    }
});

function makeModulesSortable() {

    $('#modules_accordion').sortable({
        items: '.module_panel',
        stop: function(event, ui) {

            var _modules_ids = '';

            $('#modules_accordion .module-header').each(function(_index) {

                var _module_id = $(this).data('moduleid');
                _modules_ids += (_modules_ids == '' ? '' : '&') + 'modules_ids[' + _module_id + ']=' + parseInt(_index+1);

            });


            var _change_modules_order_url = $('#change_modules_sort_order').data('urlstore');

            $.ajax({
                url: _change_modules_order_url,
                method: 'POST',
                data: _modules_ids,
                success: function(data) {

                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $('.success-message').text(data.success);

                    }

                }
            });

        }
    });

}

makeModulesSortable();

// ACCORDION FOR DAYS
$(".modules_accordion_lvl_2").accordion({
    active: false,
    collapsible: true,
    multiple: true,
    header: 'h6',
    beforeActivate:function(event, ui ) {
        if (typeof event.originalEvent != 'undefined' && typeof event.originalEvent.target != 'undefined') {
            var fromIcon = $(event.originalEvent.target).is('*:not(.fa-pencil-square-o.edit-pencil, .fa-times, .new_editing_element)');
            return fromIcon;
        }
    }
}).sortable({
    items: '.day_panel',
    stop: function(event, ui) {


        var _sortable_parent = $(ui.item).parents('.modules_accordion_lvl_2:first');

        $(_sortable_parent).find('.day_panel').each(function(index) {

            var new_index = parseInt(index) + 1;

            // change header dayindex
            $(this).find('h6.can-be-edited').data('dayindex', new_index);

        });

        saveModuleLectureConnections(ui.item);

    }
});

/*************** Connections module actions ****************/
// EXPAND ALL
$('.expand_all').click(function() {

    $('#modules_accordion .ui-accordion-header:not(.ui-state-active)').addClass('ui-accordion-header-active ui-state-active').next().slideDown();
    $('#modules_accordion .ui-accordion-header .ui-icon').removeClass('ui-icon-triangle-1-e').addClass('ui-icon-triangle-1-s');

    $('.expand_all').hide();
    $('.collapse_all').show();

});

// COLLAPSE ALL
$('.collapse_all').click(function() {

    $('#modules_accordion .ui-accordion-header').removeClass('ui-accordion-header-active ui-state-active').next().slideUp();
    $('#modules_accordion .ui-accordion-header .ui-icon').addClass('ui-icon-triangle-1-e').removeClass('ui-icon-triangle-1-s');

    $('.collapse_all').hide();
    $('.expand_all').show();

});

$('.modules_draggable_mode').click(function() {

    $(this).hide();
    $('.modules_draggable_mode_off').show();

    $('.day-for-pool').addClass('hide-element');

    //$('#modules_accordion, .modules_accordion_lvl_2').accordion('option', 'collapsible', false );

    $('.module_panel').draggable({
        appendTo: "body",
        stop: function( event, ui ) {
            $(this).addClass('positionAbsolute').css({'position': 'absolute'});
        }
    });

});

$('.modules_draggable_mode_off').click(function() {

    $(this).hide();
    $('.modules_draggable_mode').show();
    $('.day-for-pool').removeClass('hide-element');
    location.reload();
});


// small hook for keyboard hot keys disable for accordion
$.ui.accordion.prototype._keydown = function( event ) {
    // your new code for the "_keydown" function
};

$('#modules_accordion h5').off('dblclick');

$('#c_panel_modules').css({'visibility': 'visible'});

// drag and drop lectures in modules
function makeDraggableLectures(selector) {
    $(selector).draggable({
        appendTo: "body",
        helper: "clone",
        drag: function( event, ui ) {

        },
        start: function( event, ui ) {

        },
        stop: function( event, ui ) {

        }
    });

    $(selector).removeClass('newly-created-lecture');
}

makeDraggableLectures(".drg-elem-lecture");

function makeDroppableModulesDaySlots(selector)
{
    $(selector).droppable({
        accept: ".drg-elem-lecture",
        hoverClass: 'highlight-droppable',
        tolerance: 'touch',
        drop: function (event, ui) {


            // change id and classes of ui elem
            if (!$(ui.draggable).hasClass('placed-in-sortable')) {
                var _lecture_to_add_ = $(ui.draggable).clone().addClass('placed-in-sortable');
            }
            else {
                var _lecture_to_add_ = $(ui.draggable);
            }

            $(_lecture_to_add_).find('.edit-pencil').remove();

            var _new_ui_id = $(_lecture_to_add_).data('lectureid');

            var counter_of_existing_elms = $(this).find('.drg-elem').length;
            var number_of_max_lectures_allowed = parseInt($('#max_amount_of_lectures_in_slot').data('max_amount_of_lectures_in_slot'));

            // for days pools we dont have restriction of amount of lectures
            if ($(this).hasClass('day-for-pool')) {
                number_of_max_lectures_allowed = 100;
            }

            if ($(this).find('div[data-lectureid="'+_new_ui_id+'"]').length == 0 && counter_of_existing_elms < number_of_max_lectures_allowed) {

                if ($(this).hasClass('day-for-pool')) {

                    // adding day pool indicator class
                    $(_lecture_to_add_).addClass('day-pool-lecture');
                    $(this).find('.card-body').append(_lecture_to_add_);

                }
                else {
                    $(this).append(_lecture_to_add_);
                }

                // remove if duplicated
                if ($(this).find('div[data-lectureid="'+_new_ui_id+'"]').length > 1) {
                    $(this).find('div[data-lectureid="'+_new_ui_id+'"]:nth-child(2)').remove();
                }

                if (selector != '.newly-created-module-slot' && selector != '.drpbl-day-pool') {
                    $( this ).sortable( "refresh" );
                }

                setNumConnectionsOfLectures(_new_ui_id, true);

                if ($(this).hasClass('day-for-pool')) {
                    saveDayLectureConnections(_lecture_to_add_);
                }
                else {
                    saveModuleLectureConnections(_lecture_to_add_);
                }

            }

        }
    });

    $(selector).removeClass('newly-created-module-slot');
}

function saveDayLectureConnections(elementObject) {


    var _day_id = $(elementObject).parents('.day-for-pool:first').attr('id').replace('day-for-pool-', '');
    var _lecture_id = $(elementObject).data('lectureid');

    $.ajax({
        url: $('#day_lecture_connection').data('urlstore'),
        method: 'POST',
        data: {'day_id': _day_id, lecture_id: _lecture_id},
        success: function(data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                //console.log(data);

            }

        }
    });
}

function removeDayLectureConnection(objectToRemove)
{
    var _day_id = $(objectToRemove).parents('.day-for-pool:first').attr('id').replace('day-for-pool-', '');
    if ($(objectToRemove).hasClass('fa-times')) {
        var _lecture_id = $(objectToRemove).parent().data('lectureid');
    }
    else {
        var _lecture_id = $(objectToRemove).data('lectureid');
    }


    $.ajax({
        url: $('#day_lecture_connection_remove').data('urlstore'),
        method: 'POST',
        data: {'day_id': _day_id, lecture_id: _lecture_id},
        success: function(data) {

            $('#day-for-pool-'+_day_id).find('div[data-lectureid="'+_lecture_id+'"]').remove();

        }
    });
}



makeDroppableModulesDaySlots(".drpbl-module");
makeDroppableModulesDaySlots(".drpbl-day-pool");

// ADD LECTURE
$('.add-lecture').click(function() {
    $('#c_panel_lectures .dragging-parent').append('<div class="drg-elem drg-elem-lecture"><input type="text" value="" name="new_lecture_name" class="new_lecture_name" placeholder="lecture name"><!--<input type="text" value="" name="new_lecturer_name" class="new_lecturer_name" placeholder="lecturer">--></div>');

    $('.new_lecture_name').focus();

    // on focus out add new lecture if name is not empty
    //$('.new_lecturer_name').blur(function() {
    $('.new_lecture_name').blur(function() {

        var _the_parent = $(this).parents('.c_panel:first');
        //var _lecturer_name = $(this).val();
        var _name = $(_the_parent).find('.new_lecture_name').val().trim();




        if (_name != '') {

            var _create_url = $(_the_parent).data('urlstore');

            $.ajax({
                url: _create_url,
                method: 'POST',
                data: {'name': _name/*, 'lecturer_name': _lecturer_name*/},
                success: function(data) {

                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $('.success-message').text(data.success);

                    }

                    if (typeof data.id != 'undefined' && data.id != null && data.id != '') {

                        $('.new_lecture_name').parent().remove();

                        $('#c_panel_lectures .dragging-parent').append('<div data-type="lecture" data-lectureid="'+data.id+'" class="drg-elem drg-elem-lecture newly-created-lecture can-be-deleted can-be-edited" data-urlstore="'+$('#lecture_store_url').data('urlstore')+'"><span class="editable-content">' + _name + '</span><i class="fa fa-pencil-square-o edit-pencil" aria-hidden="true"></i><i class="fa fa-times" aria-hidden="true"></i></div>');

                        makeDraggableLectures('.newly-created-lecture');
                    }

                }
            });

            // make newly added lecture draggable

        }

    });
});

// HANDLE ENTER PRESS DURING LECTURE CREATING
$(document).on('keypress', '.new_lecture_name', function(e) {
    if(e.which == 13) {
        $('.new_lecture_name').blur();
        setTimeout(function() {
            $('.add-lecture').click();
        }, 1000);

    }
});

// ADD MODULE
$('.add-module').click(function() {
    $('#modules_accordion').append('<h5 class="ui-accordion-header ui-corner-top ui-state-default ui-accordion-icons" role="tab" id="ui-id-4" aria-controls="module-container-4" aria-selected="true" aria-expanded="true" tabindex="0"><input type="text" value="" name="new_module_name" class="new_module_name" placeholder="module name"><input type="text" value="" name="new_module_code" class="new_module_code" placeholder="module code"></h5>');

    $('.new_module_name').focus();

    // on focus out add new lecture if name is not empty
    $('.new_module_code').blur(function() {

        var _the_parent = $(this).parents('.c_panel:first');
        var _current_name_val = $('.new_module_name').val();
        var _current_code_val = $(this).val();



        if (_current_name_val != '' && _current_code_val != '') {

            var _create_url = $(_the_parent).data('urlstore');

            //console.log('_create_url');
            //console.log(_create_url);

            $.ajax({
                url: _create_url,
                method: 'POST',
                data: {'name': _current_name_val, 'code' : _current_code_val, 'with_days_slots': '1'},
                success: function(data) {

                    $('.new_module_name').parent().remove();

                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $('.success-message').text(data.success);

                    }

                    if (typeof data.id != 'undefined' && data.id != null && data.id != '' && typeof data.moduleData != 'undefined') {

                        var max_amount_of_module_days = parseInt($('#max_amount_of_module_days').data('max_amount_of_module_days'));
                        var max_amount_of_lecture_slots = parseInt($('#max_amount_of_lecture_slots').data('max_amount_of_lecture_slots'));
                        var _module_days_and_slots = '';

                        if (max_amount_of_module_days && max_amount_of_lecture_slots) {

                            for (var day_id in data.moduleData.days) {

                                _module_days_and_slots += '<div class="day_panel"><h6 class="can-be-edited" data-urlstore="'+$('#day_store_url').data('urlstore')+'" data-dayindex="' + data.moduleData.days[day_id].sort_order +'" data-type="day" data-dayid="'+day_id+'"><span class="editable-content">'+$('#translation-day').text()+' ' + data.moduleData.days[day_id].sort_order + '</span><i class="fa fa-pencil-square-o edit-pencil" aria-hidden="true"></i></h6><div class="acc_lvl_2_content day-container" id="day-container-' + data.id + '-' + day_id + '">';

                                for (var slot_id in data.moduleData.days[day_id]['slots']) {
                                    _module_days_and_slots += '<small>'+$('#translation-lecture_slot').text()+' ' + data.moduleData.days[day_id]['slots'][slot_id].sort_order + '</small><div class="acc_lvl3_parent"><span class="droppable-area-text">'+$('#translation-droppable_area').text()+'</span><div class="acc_lvl_3_content drpbl drpbl-module slot-container newly-created-module-slot" id="slot-container-' + data.id + '-' + day_id + '-' + slot_id + '" data-slotindex="'+data.moduleData.days[day_id]['slots'][slot_id].sort_order+'"></div></div>';
                                }
                                _module_days_and_slots += '</div></div>';
                            }

                            $('#modules_accordion').append('<div class="module_panel"><h5 class="module-header can-be-deleted can-be-edited a-tmp-hidden" data-urlstore="'+_create_url+'" data-moduleid="' + data.id + '" data-type="module" data-modulecode="' + data.code + '"><span class="editable-content" >' + _current_name_val + '</span><i class="fa fa-pencil-square-o edit-pencil" aria-hidden="true"></i><i class="fa fa-times" aria-hidden="true"></i></h5><div class="acc_lvl_2 module-container" id="module-container-' + data.id + '"><div class="modules_accordion_lvl_2 a-tmp-hidden">'+_module_days_and_slots+'</div></div></div>');


                            $("#modules_accordion").accordion("refresh");

                            makeModulesSortable();

                            $('.modules_accordion_lvl_2.a-tmp-hidden').accordion({
                                active: false,
                                collapsible: true,
                                multiple: true,
                                header: 'h6',
                                beforeActivate:function(event, ui ){
                                    var fromIcon = $(event.originalEvent.target).is('*:not(.fa-pencil-square-o.edit-pencil, .fa-times, .new_editing_element)');
                                    return fromIcon;
                                }
                            }).sortable({
                                items: '.day_panel',
                                stop: function(event, ui) {


                                    var _sortable_parent = $(ui.item).parents('.modules_accordion_lvl_2:first');

                                    $(_sortable_parent).find('.day_panel').each(function(index) {

                                        var new_index = parseInt(index) + 1;


                                        // change header dayindex
                                        $(this).find('h6.can-be-edited').data('dayindex', new_index);


                                    });

                                    saveModuleLectureConnections(ui.item);

                                }
                            });


                            makeDroppableModulesDaySlots(".newly-created-module-slot");

                            $('.module-header, .modules_accordion_lvl_2').removeClass('a-tmp-hidden');



                        }
                    }
                }
            });
            // make newly added lecture draggable
        }
    });
});

// HANDLE ENTER PRESS INSIDE MODULE_CODE
$(document).on('keypress', '.new_module_code', function(e) {
    if(e.which == 13) {
        $('.new_module_code').blur();
        setTimeout(function() {
            $('.add-module').click();
        }, 1300);

    }
});

// FOR MODULE CODE FIELD REMOVE ALL SPACES ON ENTERING TEXT
$(document).on('keyup', '.new_module_code', function() {

    $(this).val($(this).val().replace(/\s/g, ''));

});

// DELETE ELEMENT
$(document).on('click', '.can-be-deleted .fa-times', function(e) {

    var c = confirm($('#are_you_sure_text').text());

    if (c == true) {


        // if remove from day pool then remove it and return

        if ($(this).parents('.day-for-pool').length > 0) {
            removeDayLectureConnection(this);
            return;
        }


        if ($(this).parent().parent().hasClass('slot-container')) {

            var _slot_container_of_lecture = $(this).parent().parent();

            $(this).parent().remove();

            setNumConnectionsOfLectures();

            saveModuleLectureConnections(_slot_container_of_lecture);

            return false;
        }

        var _item_type = $(this).parent().data('type');
        var _id = '';
        var _current_obj = this;
        var _current_parent = $(_current_obj).parent();
        var _current_parent_next = $(_current_parent).next('.module-container');
        var _urlremove = $(_current_obj).parents('.c_panel:first').data('urlremove');

        if (_item_type == 'lecture') {
            _id = $(this).parent().data('lectureid');
        }

        if (_item_type == 'module') {
            _id = $(_current_obj).parent().data('moduleid');
            $(_current_parent).remove();
            $(_current_parent_next).remove();
        }

        if (_id != '') {

            _urlremove = _urlremove.replace('0', _id);

            $.ajax({
                url: _urlremove,
                method: 'POST',
                data: {'_method':'DELETE'},
                success: function (data) {
                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {
                        $(_current_obj).parents('.can-be-deleted:first').remove();

                        if (_item_type == 'lecture') {
                            $('div[data-lectureid="'+_id+'"]').remove();
                        }

                        $(_current_obj).parents('.can-be-deleted:first').next('.module-container').remove();
                    }
                }
            });

        }
    }

});

$(document).on('click','h6.can-be-edited.ui-accordion-header', function(e) {

    var _day_id = $(this).data('dayid');
    $('.day-for-pool').hide();
    if ($(this).hasClass('ui-state-active')) {
        $('#day-for-pool-' + _day_id).show();
    }
    else {
        $('#day-for-pool-' + _day_id).hide();
    }



});




















/************************************************** COMBINATIONS ***************************************************/

function assignNewHeader(chosenElement, massAssignment = false, makeCopy=false)
{

    $('.you-are-copying').hide();
    var _allBulkCombinations = '';
    var _current_header = '';
    var _module_id_1 = '';
    var _module_id_2 = '';
    var _course_id_ = '';
    var _course_to_module_id_ = '';

    if (massAssignment == false) {

        $(chosenElement).addClass('mcp-head-active');

        $('#setModalCombinationName').click();

         _current_header = chosenElement;
         _module_id_1 = $(chosenElement).parents('.mc-container:first').find('.module-holder.mod-hold-1').data('moduleholder');
         _module_id_2 = $(chosenElement).parents('.mc-container:first').find('.module-holder.mod-hold-2').data('moduleholder');


        // load all courses
         _course_id_ = $(chosenElement).data('courseid');
         _course_to_module_id_ = $(chosenElement).data('coursetomoduleid');

    }
    else {

        _allBulkCombinations = $('#modulesPairsInp').val();
        //console.log(_allBulkCombinations);

    }

    if (makeCopy == true) {
        $('.you-are-copying').show();
    }

    $.ajax({
        url: $('#get_all_courses_names').data('urlstore'),
        method: 'GET',
        data: '',
        success: function (data) {
            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                var _courses_names_html = '<div class="choose_course_name_container"><div class="form-group"><label for="new_course_name">'+$('#translation-new_course_title').text()+'</label><input class="form-control" type="text" value="" id="new_course_name" placeholder=""/></div><div class="form-group"><label for="choose_course_name">'+$('#translation-choose_existing_course_title').text()+'</label><select size="3" class="custom-select" id="choose_course_name">';

                for (var i = 0; i < data.courses.length; i++) {

                    if (massAssignment == false) {

                        if (makeCopy == true) {

                            if (
                                (typeof data.courses[i].must_have_module_id == 'undefined' || data.courses[i].must_have_module_id == null || data.courses[i].must_have_module_id == '0' || data.courses[i].must_have_module_id == 0 ||

                                (typeof data.courses[i].must_have_module_id != 'undefined' && data.courses[i].must_have_module_id != null && data.courses[i].must_have_module_id != '0' && data.courses[i].must_have_module_id != 0 && (data.courses[i].must_have_module_id == _module_id_1 || data.courses[i].must_have_module_id == _module_id_2)))

                                && parseInt(data.courses[i].id) != parseInt(_course_id_)) {

                                _courses_names_html += '<option value="' + data.courses[i].id + '" '+ (parseInt(data.courses[i].id) == parseInt(_course_id_) ? 'selected="selected"' : '') +' >' + data.courses[i].title + '</option>';

                            }

                        }
                        else {
//console.log('make copy false')
                            if (typeof data.courses[i].must_have_module_id != 'undefined' && data.courses[i].must_have_module_id != null && data.courses[i].must_have_module_id != '0') {

                                if (data.courses[i].must_have_module_id == _module_id_1 || data.courses[i].must_have_module_id == _module_id_2) {
                                    _courses_names_html += '<option value="' + data.courses[i].id + '" '+ (parseInt(data.courses[i].id) == parseInt(_course_id_) ? 'selected="selected"' : '') +' >' + data.courses[i].title + '</option>';
                                }

                            }
                            else {
                                _courses_names_html += '<option value="' + data.courses[i].id + '" '+ (parseInt(data.courses[i].id) == parseInt(_course_id_) ? 'selected="selected"' : '') +' >' + data.courses[i].title + '</option>';
                            }

                        }

                    }
                    else {
                        _courses_names_html += '<option value="' + data.courses[i].id + '" '+ (parseInt(data.courses[i].id) == parseInt(_course_id_) ? 'selected="selected"' : '') +' >' + data.courses[i].title + '</option>';
                    }

                }

                _courses_names_html += '</select></div></div>';

                $('#modalCombinationName .modal-body').html(_courses_names_html);

            }
        }
    });

    $(document).off('focus', '#new_course_name');
    $(document).on('focus', '#new_course_name', function() {
        //console.log('focus in');
        $('#choose_course_name').attr('disabled', 'disabled');
    });

    // if user entered a new name
    $(document).off('blur', '#new_course_name');
    $(document).on('blur', '#new_course_name', function() {

        var _title = $(this).val().trim();

        if (_title != '') {

            var _valuesToSend = {'course_to_module_id': _course_to_module_id_, 'title': _title, 'module_id_1' : _module_id_1, 'module_id_2': _module_id_2};

            if (massAssignment == true && _allBulkCombinations != '') {
                _valuesToSend = _allBulkCombinations + '&title='+_title;
            }

            if (makeCopy == true) {
                _valuesToSend.makeCopy = 1;
            }

            $.ajax({
                url: $('#courses_store').data('urlstore'),
                method: 'POST',
                data: _valuesToSend,
                success: function (data) {

                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        if (massAssignment == true && _allBulkCombinations != '') {
                            $(chosenElement).each(function() {

                                $(this).parent().find('.mcp-head-text').text(_title);
                                $(this).parent().data('courseid', data.course_id).removeClass('mcp-combination-impossible');

                                var _elem_head_id = $(this).parent().attr('id');

                                if (typeof data.coursesToModulesIds != 'undefined') {

                                    $('#'+_elem_head_id).data('coursetomoduleid', data.coursesToModulesIds[_elem_head_id.replace('mcp-head-', '')]);

                                }

                            });
                        }
                        else {

                            $(_current_header).find('.mcp-head-text').text(_title);
                            $(_current_header).data('courseid', data.course_id).removeClass('mcp-combination-impossible');
                            $(_current_header).data('coursetomoduleid', data.course_to_module_id);

                        }

                        $('#modalCombinationName .close-modal').click();
                    }

                    if (makeCopy == true) {
                        location.reload();
                    }

                }
            });
        }

        $('#choose_course_name').removeAttr('disabled');
    });


    // if user chose existing course title
    $(document).off('click', '.btn-save-combination-name');
    $(document).on('click', '.btn-save-combination-name', function() {

        var _course_id = $('#choose_course_name').val();
        var _title = '';

        $('#choose_course_name').find("option:selected").each(function(index) {
            _title += (_title == '' ? '' : ' / ') + $(this).text().trim();
        });


        var _valuesToSend = {'course_to_module_id': _course_to_module_id_, 'course_id': _course_id, 'module_id_1' : _module_id_1, 'module_id_2': _module_id_2};

        if (massAssignment == true && _allBulkCombinations != '') {
            _valuesToSend = _allBulkCombinations + '&title='+_title+'&course_id='+_course_id;
        }

        if (makeCopy == true) {
            _valuesToSend.makeCopy = 1;
        }

        if (_title != '' && _course_id != '') {

            $.ajax({
                url: $('#set_course_name').data('urlstore'),
                method: 'POST',
                data: _valuesToSend,
                success: function (data) {
                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        if (massAssignment == true && _allBulkCombinations != '') {
                            $(chosenElement).each(function() {

                                $(this).parent().find('.mcp-head-text').html(_title);
                                $(this).parent().data('courseid', data.course_id);

                                if (data.course_id == 1) {
                                    $(this).parent().addClass('mcp-combination-impossible');
                                }
                                else {
                                    $(this).parent().removeClass('mcp-combination-impossible');
                                }


                                var _elem_head_id = $(this).parent().attr('id');

                                if (typeof data.coursesToModulesIds != 'undefined') {

                                    $('#'+_elem_head_id).data('coursetomoduleid', data.coursesToModulesIds[_elem_head_id.replace('mcp-head-', '')]);


                                }

                            });
                        }
                        else {

                            $(_current_header).find('.mcp-head-text').text(_title);
                            $(_current_header).data('courseid', data.course_id);
                            $(_current_header).data('coursetomoduleid', data.course_to_module_id);

                            if (data.course_id == 1) {
                                $(_current_header).addClass('mcp-combination-impossible');
                            }
                            else {
                                $(_current_header).removeClass('mcp-combination-impossible');
                            }

                        }

                        $(_current_header).parents('.mc-container:first').appendTo('.modules-combinations');

                        $('#modalCombinationName .close-modal').click();

                    }

                    if (makeCopy == true) {
                        location.reload();
                    }
                }
            });

        }

    });
}


$(document).off('dblclick', '.mcp-head');
$(document).on('dblclick', '.mcp-head', function() {
    $('#modulesPairsInp').remove();
    assignNewHeader(this, false, false);

});

$('#modalCombinationName').on('show.bs.modal', function (event) {
    $('.mcp-head.mcp-head-active').removeClass('mcp-head-active');
});


if ($('.mcp-head').length > 0) {

    // hide copy icon for combinations which already have 2 combinations
    $('.mcp-head').each(function(){

        var combomod1 = $(this).data('combomod1');
        var combomod2 = $(this).data('combomod2');

        if (typeof combomod1 != 'undefined' && typeof combomod2 != 'undefined' && $('.combo-mod-'+ combomod1 + '-' + combomod2).length > 1) {
            $(this).find('.fa-files-o').hide();
        }

    });

    $('.fa-files-o').click(function(){

        assignNewHeader($(this).parent(), false, true);

    });
}


/************************ MASS ASSIGNMENT ******************************/

//deprecated function
$('#set_course_for_chosen').click(function() {

    $('#modulesPairsInp').remove();

    if ($('.bulk_check:checked').length > 0) {

        $('#setModalCombinationName').click();

        var modulesPairsIds = '';

        $('.bulk_check:checked').each(function() {

            var _check_parent = $(this).parents('.mc-container:first');
            var _check_head = $(_check_parent).find('.mcp-head');

            var _modules_ = $(_check_parent).find('.module-holder');

            modulesPairsIds += (modulesPairsIds == '' ? '' : '&') + 'modulesPairsIds[]=' + $(_modules_[0]).data('moduleholder') + '_'  + $(_modules_[1]).data('moduleholder');

            $(_check_head).attr('id', 'mcp-head-' + $(_modules_[0]).data('moduleholder') + '_'  + $(_modules_[1]).data('moduleholder'));

        });

        $('<input type="hidden" id="modulesPairsInp" value="'+modulesPairsIds+'"/>').appendTo('#modalCombinationName');

        assignNewHeader($('.bulk_check:checked'), true, false);

    }

});

/*********************** COMBINATIONS SORTABLE MODULES ****************************/

/*$('.mc-parent').sortable({
    items: '.module-holder',
    start: function(event, ui) {
        $(ui.item).parent().find('.module-holder').addClass('allBorders');
    },
    stop: function(event, ui) {

        $(ui.item).parent().find('.module-holder').removeClass('allBorders');

        var _current_header = $(ui.item).parents('.mc-container:first').find('.mcp-head');
        var _course_id = $(_current_header).data('courseid');
        var course_to_module_id = $(_current_header).data('coursetomoduleid');


        if (course_to_module_id == '') {
            return false;
        }


        var _title = $(ui.item).parents('.mc-container:first').find('.mcp-head-text').text().trim();
        var _module_id_1 = $(ui.item).parents('.mc-container:first').find('.module-holder:first').data('moduleholder');
        var _module_id_2 = $(ui.item).parents('.mc-container:first').find('.module-holder:last').data('moduleholder');

        /!*console.log('_course_id');
        console.log(_course_id);

        console.log('course_to_module_id');
        console.log(course_to_module_id);

        console.log('_module_id_1');
        console.log(_module_id_1);

        console.log('_module_id_2');
        console.log(_module_id_2);

        console.log('_title');
        console.log(_title);*!/


        if (_title != '') {

            var _valuesToSend = {'course_to_module_id': course_to_module_id, 'course_id': _course_id, 'title': _title, 'module_id_1' : _module_id_1, 'module_id_2': _module_id_2};

            var _urlstore = $('#courses_store').data('urlstore');

            if (_course_id != '' && _course_id != null) {
                _urlstore = $('#set_course_name').data('urlstore');
            }

            $.ajax({
                url: _urlstore,
                method: 'POST',
                data: _valuesToSend,
                success: function (data) {

                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $(_current_header).data('courseid', data.course_id);

                        if (course_to_module_id == '') {
                            $(_current_header).data('coursetomoduleid', data.course_to_module_id);
                        }
                    }
                }
            });
        }
    }
});*/

/****************************************** GET COMBINATION INFO *********************************************/

$('.mcp-head .fa-eye').click(function() {

    $('.mc-combinations-without-course').hide();
    // remove previous click on show details
    $('.mc-container.greenBorder').removeClass('greenBorder');
    $('.combination-details').removeClass('active');

    $('.bulk_check.disabledCheck').removeAttr('disabled').removeClass('disabledCheck');
    //$('.mc-parent-disabled').sortable("enable").removeClass('mc-parent-disabled');

    var _disable_must_have_module = false;

    if ($(this).parents('.mcp-head').hasClass('mcp-combination-impossible')) {
        _disable_must_have_module = true;
    }


    var _parent = $(this).parents('.mc-container:first');
    var course_to_module_id = $(_parent).find('.mcp-head').data('coursetomoduleid');


    if (typeof course_to_module_id != 'undefined' && course_to_module_id != null && course_to_module_id != '') {

        $.ajax({
            url: $('#get_combination_info').data('urlstore'),
            method: 'POST',
            data: {'course_to_module_id': course_to_module_id},
            success: function (data) {

                if (typeof data != 'undefined' && data != null && data != '') {

                   $(_parent).addClass('greenBorder');
                   $('.combination-details').addClass('active');

                   // change width of box container to 50% and set 2 columns
                   $('.mc-all-container').removeClass('col-md-12');
                   $('.mc-all-container').addClass('col-md-6');
                   $('.modules-combinations').css('columns', '2');

                   $(_parent).find('.bulk_check').attr('disabled', 'disabled').addClass('disabledCheck');
                   //$(_parent).find('.mc-parent').sortable( "disable").addClass('mc-parent-disabled');

                   // show returned info

                    $('.combination-details .cd-body').html(data);

                    if (_disable_must_have_module == true) {
                        $('.combination-details .cd-body input.must-have-module-check').attr('disabled', 'disabled');
                    }

                    /* ACCORDION FOR DAYS IN COMBINATION DETAILS*/
                    $(".modules_accordion_days").accordion({
                        active: false,
                        collapsible: true,
                        multiple: true,
                        header: 'h6',
                        beforeActivate:function(event, ui ){

                        }
                    });

                    $('.mandatory-modules-combos-tooltip, .recommended-modules-combos-tooltip').popover({'html': true});

                }
            }
        });

    }

});

//$('.should-remove').remove();

$('#hide_chosen_combinations, #show_chosen_combinations').click(function(e){

    e.preventDefault();

    var _user_action = '&user_action=hide';

    if ($(this).attr('id') == 'show_chosen_combinations') {

        _user_action = '&user_action=show';
    }

    if ($('.mc-container .bulk_check:checked').length > 0) {


        var _dataToSend = '';

        $('.mc-container .bulk_check:checked').each(function() {

           // console.log($(this).parent());

            var _combo_id = $(this).parent().data('coursetomoduleid');


            if (typeof _combo_id != 'undefined' && _combo_id != null && _combo_id != '') {

                _dataToSend += (_dataToSend == '' ? '' : '&') + 'coursetomoduleid[]='+_combo_id;

            }

        });
    }

    if ($('.dc-container .bulk_check:checked').length > 0) {


        var _dataToSend = '';

        $('.dc-container .bulk_check:checked').each(function() {

            // console.log($(this).parent());

            var _combo_id = $(this).parent().data('dastocourseid');


            if (typeof _combo_id != 'undefined' && _combo_id != null && _combo_id != '') {

                _dataToSend += (_dataToSend == '' ? '' : '&') + 'dastocourseid[]='+_combo_id;

            }

        });
    }

    if ($('.mac-container .bulk_check:checked').length > 0) {


        var _dataToSend = '';

        $('.mac-container .bulk_check:checked').each(function() {

            // console.log($(this).parent());

            var _combo_id = $(this).parent().data('dastocourseid');


            if (typeof _combo_id != 'undefined' && _combo_id != null && _combo_id != '') {

                _dataToSend += (_dataToSend == '' ? '' : '&') + 'mastocourseid[]='+_combo_id;

            }

        });
    }

    if (_dataToSend != '') {

        $.ajax({
            url: $('#hide_combinations').data('urlstore'),
            method: 'GET',
            data: _dataToSend + _user_action,
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    location.reload();

                }

            }
        });

    }

});

// cas
$('.mc-cd-head button.close').click(function() {

    $('.mc-container.greenBorder').removeClass('greenBorder');
    $('.combination-details').removeClass('active');

    $('.bulk_check.disabledCheck').removeAttr('disabled').removeClass('disabledCheck');
    //$('.mc-parent-disabled').sortable("enable").removeClass('mc-parent-disabled');

    // restore width of box container to 100% and set 4 columns
    $('.mc-all-container').removeClass('col-md-6');
    $('.mc-all-container').addClass('col-md-12');
    $('.modules-combinations').css('columns', '4');
    $('.mc-combinations-without-course').css('display', 'flex');

});



$('.module-combinations-bulk-all').click(function(){
    $('.cd-head button.close').click();
});


/**************************************** FILTER BY MODULE NAME ************************************************/



function combinationsFilters() {

    var w_r_timer_sm;

    $('.mc-container').removeClass('mc-filtered').show();
    $('.mc-container').removeClass('active');

    $('.search-by-module').each(function(){

        var _input_ind = $(this).attr('id').replace('search-by-module-', '');



        w_r_timer_sm && clearTimeout(w_r_timer_sm);

        var _current_value = $(this).val().toLowerCase();

        var search_input = this;

        var special_search_phrase = $('.special_search').data('special_search').trim().toLowerCase();

        //var _excluder_value = $('#exclude_courses').val();

        var _suffix = '';

        if ($('.mc-container.mc-filtered').length > 0) {
            _suffix = '.mc-filtered';
        }



        if (_current_value != '') {



            //w_r_timer_sm = setTimeout(function() {

//console.log('.mc-container:not(.mc-bulk-container)'+_suffix);

                $('.mc-container'+_suffix).each(function (zz) {

                    var mc_container = this;
                    var mc_header_text = $(mc_container).find('.mcp-head-text').text().trim().toLowerCase();

                    /*console.log('mc_header_text');
                    console.log(mc_header_text);*/

                    var _has_correct_module = 0;


                    if (_input_ind == 'types') {

                        console.log('_current_value kz');
                        console.log(_current_value);

                        switch(_current_value) {

                            case('hidden'):
//console.log('hidden');
                                if ($(mc_container).hasClass('should-hide')) {
                                    //console.log('_has_correct_module');
                                    $(mc_container).addClass('active');
                                    _has_correct_module = 1;

                                }

                            break;

                            case('course_not_set'):
//console.log('course_not_set');
                                if ($(mc_container).find('.mcp-head-text').text().trim() == '' || $(mc_container).find('.mcp-head-text').text().trim() == 'BITTE TITEL WÄHLEN') {
                                    //console.log('_has_correct_module');
                                    _has_correct_module = 1;
                                }

                            break;

                            case('course_set'):
//console.log('course_set');
                                if ($(mc_container).find('.mcp-head-text').text().trim() != '' && $(mc_container).find('.mcp-head-text').text().trim() != 'BITTE TITEL WÄHLEN') {
                                   // console.log('_has_correct_module');
                                    _has_correct_module = 1;
                                }

                            break;

                        }

                    }
                    else {

                        _input_ind = parseInt(_input_ind);

                        $(mc_container).find('.mc-mh-name').each(function (index) {

                            var curr_ind = parseInt(index)+1;

                            var mc_mh_name = this;
                            var current_mod_name = $(mc_mh_name).text().trim().toLowerCase();

                            /*console.log('current_mod_name');
                             console.log(current_mod_name);*/

                            if (current_mod_name.indexOf(_current_value) != -1 /*&& curr_ind == _input_ind*/) {
                                _has_correct_module = 1;
                            }

                        });
                    }



                    /*if (_current_value.length >= 3 && special_search_phrase.indexOf(_current_value) != -1) {


                        if (mc_header_text.indexOf(_current_value) == -1) {
                            _has_correct_module = 0;
                        }
                        else {
                            _has_correct_module = 1;
                        }


                    }*/

                    /*console.log('_has_correct_module');
                    console.log(_has_correct_module);*/

                    if (_has_correct_module == 1) {
                        $(mc_container).addClass('mc-filtered').show();
                    }
                    else {
                        $(mc_container).removeClass('mc-filtered').hide();
                    }

                });
            //}, 250);
        }
        else {

           // $('.mc-container').removeClass('make-invisible');

        }

    });


}

function combinationsFiltersDas() {

    var w_r_timer_sm;

    $('.dc-container').removeClass('dc-filtered').show();
    $('.dc-container').removeClass('active');

    $('.search-by-course').each(function(){

        var _input_ind = $(this).attr('id').replace('search-by-course-', '');



        w_r_timer_sm && clearTimeout(w_r_timer_sm);

        var _current_value = $(this).val().toLowerCase();

        var search_input = this;

        var special_search_phrase = $('.special_search').data('special_search').trim().toLowerCase();

        //var _excluder_value = $('#exclude_courses').val();

        var _suffix = '';

        if ($('.dc-container.dc-filtered').length > 0) {
            _suffix = '.dc-filtered';
        }



        if (_current_value != '') {



            //w_r_timer_sm = setTimeout(function() {

//console.log('.mc-container:not(.mc-bulk-container)'+_suffix);

            $('.dc-container'+_suffix).each(function (zz) {

                var dc_container = this;
                var dc_header_text = $(dc_container).find('.dcp-head-text').text().trim().toLowerCase();

                /*console.log('mc_header_text');
                console.log(mc_header_text);*/

                var _has_correct_course = 0;


                if (_input_ind == 'types') {

                    switch(_current_value) {

                        case('hidden'):
//console.log('hidden');
                            if ($(dc_container).hasClass('should-hide')) {
                                //console.log('_has_correct_module');
                                $(dc_container).addClass('active');
                                _has_correct_course = 1;

                            }

                            break;

                        case('das_not_set'):
//console.log('course_not_set');
                            if ($(dc_container).find('.dcp-head-text').text().trim() == '') {

                                _has_correct_course = 1;
                            }

                            break;

                        case('das_set'):
//console.log('course_set');
                            if ($(dc_container).find('.dcp-head-text').text().trim() != '') {
                                // console.log('_has_correct_module');
                                _has_correct_course = 1;
                            }

                            break;

                    }

                }
                else {

                    _input_ind = parseInt(_input_ind);

                    $(dc_container).find('.dc-mh-name').each(function (index) {

                        var curr_ind = parseInt(index)+1;

                        var dc_mh_name = this;
                        var current_course_name = $(dc_mh_name).text().trim().toLowerCase();



                        if (current_course_name.indexOf(_current_value) != -1 /*&& curr_ind == _input_ind*/) {
                            _has_correct_course = 1;
                        }

                    });
                }



                /*if (_current_value.length >= 3 && special_search_phrase.indexOf(_current_value) != -1) {


                    if (mc_header_text.indexOf(_current_value) == -1) {
                        _has_correct_module = 0;
                    }
                    else {
                        _has_correct_module = 1;
                    }


                }*/

                /*console.log('_has_correct_module');
                console.log(_has_correct_module);*/

                if (_has_correct_course == 1) {
                    $(dc_container).addClass('dc-filtered').show();
                }
                else {
                    $(dc_container).removeClass('dc-filtered').hide();
                }

            });
            //}, 250);
        }
        else {

            // $('.mc-container').removeClass('make-invisible');

        }

    });


}

function combinationsFiltersMas() {

    var w_r_timer_sm;

    $('.mac-container').removeClass('mac-filtered').show();
    $('.mac-container').removeClass('active');

    $('.search-by-course').each(function(){

        var _input_ind = $(this).attr('id').replace('search-by-course-', '');



        w_r_timer_sm && clearTimeout(w_r_timer_sm);

        var _current_value = $(this).val().toLowerCase();

        var search_input = this;

        var special_search_phrase = $('.special_search').data('special_search').trim().toLowerCase();

        //var _excluder_value = $('#exclude_courses').val();

        var _suffix = '';

        if ($('.mac-container.mc-filtered').length > 0) {
            _suffix = '.mac-filtered';
        }



        if (_current_value != '') {



            //w_r_timer_sm = setTimeout(function() {

//console.log('.mc-container:not(.mc-bulk-container)'+_suffix);

            $('.mac-container'+_suffix).each(function (zz) {

                var mac_container = this;
                var mac_header_text = $(mac_container).find('.macp-head-text').text().trim().toLowerCase();

                /*console.log('mc_header_text');
                console.log(mc_header_text);*/

                var _has_correct_course = 0;


                if (_input_ind == 'types') {

                    switch(_current_value) {

                        case('hidden'):
//console.log('hidden');
                            if ($(mac_container).hasClass('should-hide')) {
                                //console.log('_has_correct_module');
                                $(mac_container).addClass('active');
                                _has_correct_course = 1;

                            }

                            break;

                        case('mas_not_set'):
//console.log('course_not_set');
                            if ($(mac_container).find('.macp-head-text').text().trim() == '') {
                                //console.log('_has_correct_module');
                                _has_correct_course = 1;
                            }

                            break;

                        case('mas_set'):
//console.log('course_set');
                            if ($(mac_container).find('.macp-head-text').text().trim() != '') {
                                // console.log('_has_correct_module');
                                _has_correct_course = 1;
                            }

                            break;

                    }

                }
                else {

                    _input_ind = parseInt(_input_ind);

                    $(mac_container).find('.mac-mh-name').each(function (index) {

                        var curr_ind = parseInt(index)+1;

                        var mac_mh_name = this;
                        var current_course_name = $(mac_mh_name).text().trim().toLowerCase();

                        /*console.log('current_mod_name');
                         console.log(current_mod_name);*/

                        if (current_course_name.indexOf(_current_value) != -1 /*&& curr_ind == _input_ind*/) {
                            _has_correct_course = 1;
                        }

                    });
                }



                /*if (_current_value.length >= 3 && special_search_phrase.indexOf(_current_value) != -1) {


                    if (mc_header_text.indexOf(_current_value) == -1) {
                        _has_correct_module = 0;
                    }
                    else {
                        _has_correct_module = 1;
                    }


                }*/

                /*console.log('_has_correct_module');
                console.log(_has_correct_module);*/

                if (_has_correct_course == 1) {
                    $(mac_container).addClass('mac-filtered').show();
                }
                else {
                    $(mac_container).removeClass('mac-filtered').hide();
                }

            });
            //}, 250);
        }
        else {

            // $('.mc-container').removeClass('make-invisible');

        }

    });


}

$('#search-by-course').change(function() {

    $('.mc-combinations-without-course .mc-container').appendTo('.modules-combinations');
    $('.mc-combinations-without-course').remove();
    $('.mc-container').removeClass('make-invisible');
    $('#search-by-module-1,#search-by-module-2,#search-by-module-types').val('');

    combinationsFilters();

    var _crs_id = $(this).val();

    //console.log('_crs_id');
    //console.log(_crs_id);

    if (_crs_id != '') {

        $('<div class="mc-combinations-without-course"></div>').insertAfter('.modules-combinations');

        var _crs_must_have_m_id = $('.mcp-head-'+_crs_id+':first').data('musthavemoduleid');

        $('.mc-container .mcp-head').each(function() {
            if ($(this).hasClass('mcp-head-'+_crs_id)) {

                var _current_must_have_m = $(this).data('musthavemoduleid');

                var mh_module = $(this).parents('.mc-container:first').find('.mc-parent .module-holder-'+_current_must_have_m);

                $(mh_module).prependTo($(this).parents('.mc-container:first').find('.mc-parent'));

            }
            else {

                if ($(this).parents('.mc-container:first').find('.mc-parent .module-holder-'+_crs_must_have_m_id).length == 0) {

                    $(this).parents('.mc-container:first').addClass('make-invisible');

                }
                else {
                    if ($(this).hasClass('mcp-combination-impossible') || $(this).data('courseid')=='') {

                        $(this).parents('.mc-container:first').appendTo('.mc-combinations-without-course');

                    }
                    else {
                        $(this).parents('.mc-container:first').addClass('make-invisible');
                    }
                }

            }

            console.log('ko');
        });

    }
    else {

    }

});



$('.search-by-module').keyup(function() {
    combinationsFilters();
});

$('#search-by-module-types').change(function(){
    combinationsFilters();
});


/*************************************** MUST HAVE CHECKBOX ***************************************************/

$(document).on('click', '.must-have-module-check', function() {

    var _current_id = $(this).attr('id');
    var _module_id = $(this).val();
    var _course_id = $('.cd-course').attr('id').replace('course-id-', '');
    var _action = '';

    $('.must-have-module-check').not('#'+_current_id).prop('checked', false);
    $(this).parents('.cd-module:first').find('.recommended-module-check').prop('checked', false);


    if ($(this).is(":checked")) {

        _action = 'add';

    }
    else {

        _action = 'remove';
    }

    var _urlstore = $('#set_must_have_module').data('urlstore');

    $.ajax({
        url: _urlstore,
        method: 'POST',
        data: {'action': _action, 'module_id': _module_id, 'course_id': _course_id},
        success: function (data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



            }
        }
    });
});



/*************************************** RECOMMENDED CHECKBOX ***************************************************/

$(document).on('click', '.recommended-module-check', function() {

    var _current_id = $(this).attr('id');
    var _module_id = $(this).val();
    var _course_id = $('.cd-course').attr('id').replace('course-id-', '');
    var _action = '';

    $('.recommended-module-check').not('#'+_current_id).prop('checked', false);
    $(this).parents('.cd-module:first').find('.must-have-module-check').prop('checked', false);



    if ($(this).is(":checked")) {

        _action = 'add';

    }
    else {

        _action = 'remove';
    }

    var _urlstore = $('#set_recommended_module').data('urlstore');

    $.ajax({
        url: _urlstore,
        method: 'POST',
        data: {'action': _action, 'module_id': _module_id, 'course_id': _course_id},
        success: function (data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



            }
        }
    });
});

















/******************************* FRONT AREA ****************************************/

$(".front-statuses-checkbox").change(function() {

    $(".front-statuses-checkbox").prop('checked', false);

    $('.row-with-general-user-data').appendTo('body');

    $(this).prop('checked', true);

    var status_id = $(this).attr('id').replace('front-statuses-checkbox-', '');

    console.log('status_id');
    console.log(status_id);

    if (status_id == '31' || status_id == '32' || status_id == '34') {
        $('.row-with-general-user-data-'+status_id).insertAfter('form.front-user-form .row-with-status-checkboxes');
        console.log('added');
    }
    else {
        $('.row-with-general-user-data-'+status_id).appendTo('body');
        console.log('removed');
    }

    if (status_id == '33') {
        $('.specFhnwRegistrationForm').appendTo('form.front-user-form');
        $('.ajs-1').hide();
    }
    else {
        $('.specFhnwRegistrationForm').appendTo('body');
        $('.ajs-1').show();
    }

    if (status_id == '32') {

        $('.info-events-checkboxes').insertAfter($('#front-statuses-checkbox-'+status_id).next('label'));

    }
    else {

        $('.info-events-checkboxes').appendTo('body');

    }

});



$('body').on('click', function (e) {
    $('[data-toggle="popover"]').each(function () {
        //the 'is' for buttons that trigger popups
        //the 'has' for icons within a button that triggers a popup
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
        }
    });
});

$('.search-by-name').keyup(function(){

    var _current_value = $(this).val();
    var search_input = this;

    if (_current_value != '') {

        _current_value = _current_value.toLowerCase();

        $(this).parents('.card:first').find('.searchable-parent').each(function() {

            var search_parent = this;

            var _has_correct_txt = 0;

            $(search_parent).find('.searchable-1, .searchable-2').each(function() {

                var _name = this;
                var current_mod_name = $(_name).text().trim().toLowerCase();

                if (current_mod_name.indexOf(_current_value) != -1) {
                    _has_correct_txt = 1;
                }

            });

            if (_has_correct_txt == 1) {
                $(search_parent).removeClass('make-invisible');
            }
            else {
                $(search_parent).addClass('make-invisible');
            }

        });

    }
    else {

        $('.searchable-parent').removeClass('make-invisible');

    }

});

function arrayUnique(value, index, self) {
    return self.indexOf(value) === index;
}

function getIdsArrayFromString(idsString) {

    var final_array = [];

    if (typeof idsString != 'undefined' && idsString != null) {
        if (idsString.toString().indexOf(",") > -1) {

            final_array = idsString.split(',');

        }
        else {

            final_array.push(idsString);

        }
    }

    return final_array;
}

// js in_array equivalent

function in_array(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
}

$('.no-me-of-active-statuses').each(function(){

    $(this).parents('.front-module:first').remove();

});

function find_duplicate_in_array(arra1) {
    var object = {};
    var result = [];

    arra1.forEach(function (item) {
        if(!object[item])
            object[item] = 0;
        object[item] += 1;
    });

    for (var prop in object) {
        if(object[prop] >= 2) {
            result.push(prop);
        }
    }

    return result;

}

// Click on module or certificate or course should highlight connected entities
$('.entities').click(function() {
    //console.log('ords');
    if ($(this).hasClass('unclickable')) {
        return false;
    }
    var entityid = $(this).data('entityid');
    var entitytype = $(this).data('entitytype');
    var belongsto = $(this).data('belongsto');
    var belongstoids = $(this).data('belongstoids');
    var dependenciesids = $(this).data('dependenciesids');
    var dependencytype = $(this).data('dependencytype');
    var combinationscount = $(this).data('combinationscount');
    var musthavemoduleid = $(this).data('musthavemoduleid');
    var recommendedmoduleid = $(this).data('recommendedmoduleid');
    var connectionids = $(this).data('connectionid');

    $('.choose-more-specific').hide();

    /************ Process situation when user picked course and modules and then unclicked course, we need to remove also checkboxes for module events *************/
    if ($(this).hasClass('active') && entitytype == 'course' && $('.entities.front-course.active').length > 0) {

        console.log('active course clicked');
        $('.module_events_ids_checkbox:checked').each(function(){
            $(this).click();
        });

    }

    /************ Process combination when 2 modules were active and then user unclicks one of them *************/
    if ($(this).hasClass('active') && entitytype == 'module' && $('.entities.front-module.active').length == 2) {

        console.log('two active modules one clicked');

        $(this).removeClass('active');

        var _id_of_one_remained_module = $('.entities.front-module.active:first').data('entityid');

        $('.front-course, .front-module').removeClass('unclickable').removeClass('front-highlighted').removeClass('active');

        $('.calendar-module').removeClass('unclickable').removeClass('front-highlighted').removeClass('active');

        $('.content-of-event-cell').removeClass('active').removeClass('inactive-event');

        $('.front-m.mandatory-module, .front-m.recommended-module').hide();

        $('.double-course-chosen').css('visibility', 'hidden');
        $('.card-front-courses').removeClass('has-two-active-courses');

        $('.entity-module-' + _id_of_one_remained_module).click();

        return false;
    }


    /************ Process combination of clicks when user clicked on course, then clicked on module, then unclicked the module ************/

    if ($(this).hasClass('active') && entitytype == 'course' && $('.entities.front-course.active').length > 1) {

        console.log('clicked on active course and have several course active');

        $('.double-course-chosen').css('visibility', 'hidden');

        $('.entities.front-course.active').each(function(){

            if (!$(this).hasClass('entity-course-' + entityid)) {

                $(this).removeClass('active').removeClass('front-highlighted').addClass('unclickable');

                var _must_have_module_id_other = $(this).data('musthavemoduleid');
                var _recommendedmoduleid_other = $(this).data('recommendedmoduleid');

                $('.entity-module-' + _must_have_module_id_other).find('.mandatory-module').hide();
                $('.entity-module-' + _recommendedmoduleid_other).find('.recommended-module').hide();

            }

        });

        $('.entity-module-' + musthavemoduleid).find('.mandatory-module').show();
        $('.entity-module-' + recommendedmoduleid).find('.recommended-module').show();

        return false;
    }

    if ($(this).hasClass('active') && entitytype == 'module' && $('.entities.front-course.active').length > 0) {

        console.log('unclick module which was active');

        $(this).find('.mandatory-module,.recommended-module').hide();

        $(this).removeClass('active');

        $('#calendar-module-' + entityid).removeClass('active');

        //var _final_courses_ids = [];
        //var _final_modules_ids = [];

        // If we have active modules, we go via them and get all belongids and go by those courses ids we get all modules and highlight them
        /*if ($('.entities.front-module.active').length > 0) {
console.log('active exist');
            $('.entities.front-module.active').each(function() {

                var belong_ids_str = $(this).data('belongstoids');

                _final_courses_ids = _final_courses_ids.concat(getIdsArrayFromString(belong_ids_str));

            });

        }
        else { // If we dont have active modules we go by all highlighted courses and get all dependencies ids and make those modules highlighted
            console.log('only highlighted');
            $('.entities.front-module.front-highlighted').each(function() {

                var belong_ids_str = $(this).data('belongstoids');

                _final_courses_ids = _final_courses_ids.concat(getIdsArrayFromString(belong_ids_str));

            });

        }*/

        var _final_courses_ids = [];

        _final_courses_ids.push($('.entities.front-course.active').data('entityid'));


        if (_final_courses_ids.length > 0) {

            for (var aa = 0; aa < _final_courses_ids.length; aa++) {

                var _course_dependencies = $('.entity-course-'+_final_courses_ids[aa]).data('dependenciesids');

                var _modules_ids_array = getIdsArrayFromString(_course_dependencies);

                if (_modules_ids_array.length > 0) {

                    for (var mm = 0; mm < _modules_ids_array.length; mm++) {
                        $('.entity-module-'+_modules_ids_array[mm]).removeClass('unclickable').addClass('front-highlighted');
                        $('#calendar-module-' + _modules_ids_array[mm]).removeClass('unclickable').addClass('front-highlighted');
                    }

                }
            }
        }

        // IF LAST ACTIVE MODULE WAS UNCLICKED WE REMOVE ACTIVE AND UNCLICKABLE CLASSES FROM ALL COURSES AND UNCLICKABLE CLASS FROM ALL MODULES
        if ($('.entities.front-module.active').length == 0) {

            $('.entities.front-course').each(function(){

                $(this).removeClass('active').removeClass('unclickable').removeClass('front-highlighted');

            });

            $('.entities.front-module').each(function(){

                $(this).removeClass('unclickable').removeClass('front-highlighted');

                $('#calendar-module-' + $(this).data('entityid')).removeClass('unclickable').removeClass('front-highlighted');

            });

        }

        return false;
    }

    /************ Process combination of clicks when user clicked on course, then clicked on module, then unclicked the module END ************/


    /** WHEN USER CLICKS ON HIGHLIGHTED ELEMENTS - FILTER **/
    if ($(this).hasClass('front-highlighted') && !$(this).hasClass('active') && entitytype == 'module') {

console.log('click on highlighted module');

        var __current_entity__ = this;
        var _current_entity_connections_ids = $(this).data('connectionid');

        var _current_entity_connections_ids_array = [];

        if (typeof _current_entity_connections_ids != 'undefined' && _current_entity_connections_ids != '' && _current_entity_connections_ids != null) {

            // GET BELONGS TO IDS LEVEL 1 (courses)

            console.log('_current_entity_connections_ids');
            console.log(_current_entity_connections_ids);


            _current_entity_connections_ids_array = getIdsArrayFromString(_current_entity_connections_ids);

            console.log('_current_entity_connections_ids_array');
            console.log(_current_entity_connections_ids_array);

            if (_current_entity_connections_ids_array.length > 0) {


                /******* GET ALL ACTIVE ENTITIES CONNECTIONS *********/

                var _active_entities_connections_array = [];


                if ($(__current_entity__).parents('.card-body:first').find('.active').length == 1) {

                    $(__current_entity__).parents('.card-body:first').find('.active').each(function() {

                        var _active_entity_connections = $(this).data('connectionid');

                        _active_entities_connections_array = _active_entities_connections_array.concat(getIdsArrayFromString(_active_entity_connections));

                    });

                }



                if (_active_entities_connections_array.length > 0) {
                    _active_entities_connections_array = _active_entities_connections_array.filter(arrayUnique);
                }

                console.log('_active_entities_connections_array');
                console.log(_active_entities_connections_array);

                var intersections_array = [];

                if (_active_entities_connections_array.length > 0 && _current_entity_connections_ids_array.length > 0) {

                    console.log('_active_entities_connections_array and _current_entity_connections_ids_array');

                    intersections_array = _current_entity_connections_ids_array.filter(function(n) {

                        return _active_entities_connections_array.indexOf(n.toString()) != -1;

                    });

                    //intersections_array = _current_entity_connections_ids_array.filter(value => _active_entities_connections_array.includes(value));

                }

                console.log('intersections_array');
                console.log(intersections_array);

                if (intersections_array.length > 0) {
                    _current_entity_connections_ids_array = intersections_array;
                }

                console.log('_current_entity_connections_ids_array');
                console.log(_current_entity_connections_ids_array);

                var _number_of_already_active_elements_ = parseInt($(__current_entity__).parents('.card-body:first').find('.front-highlighted.active').length);

                console.log('_number_of_already_active_elements_');
                console.log(_number_of_already_active_elements_);

                for (var ee = 0; ee < _current_entity_connections_ids_array.length; ee++) {

                    $(__current_entity__).parents('.card-body:first').find('.front-highlighted:not(.active)').each(function() {

                        var _flow_entity_connections = $(this).data('connectionid');

                        console.log('_flow_entity_connections');
                        console.log(_flow_entity_connections);

                        var _flow_entity_connections_array = [];

                        if (typeof _flow_entity_connections != 'undefined' && _flow_entity_connections != '') {

                            _flow_entity_connections_array = getIdsArrayFromString(_flow_entity_connections);

                        }

                        console.log('_flow_entity_connections_array');
                        console.log(_flow_entity_connections_array);

                        if (_flow_entity_connections_array.indexOf(_current_entity_connections_ids_array[ee].toString()) > -1 && _number_of_already_active_elements_ < 1) {

                            console.log('can-stay');
                            console.log($(this).data('entityid'));

                            $(this).addClass('can-stay');
                            $('#calendar-module-' + $(this).data('entityid')).addClass('can-stay');

                        }

                    });

                }

                $(__current_entity__).parents('.card-body:first').find('.front-highlighted:not(.active):not(.can-stay)').addClass('unclickable').removeClass('front-highlighted');

                $('#calendar-module-'+ entityid).parents('#real_events_next_year').find('.front-highlighted:not(.active):not(.can-stay)').addClass('unclickable').removeClass('front-highlighted');

                $(__current_entity__).parents('.card-body:first').find('.front-highlighted.can-stay').removeClass('can-stay');

                $('#calendar-module-'+ entityid).parents('#real_events_next_year').find('.front-highlighted.can-stay').removeClass('can-stay');
            }
        }

        $(this).addClass('active').removeClass('unclickable');

        if (entitytype == 'module') {

            $('#calendar-module-'+ entityid).addClass('active').removeClass('unclickable');

        }

        //MAKE ACTIVE THOSE COURSES TO WHICH ACTIVE MODULES BELONG
        var _activeModulesCoursesIds = [];

        $('.front-module.entities.active').each(function() {

            var _belongToCourseIds = $(this).data('belongstoids');
            //var _belongToCourseIdsArray = [];
            console.log('_belongToCourseIds');
            console.log(_belongToCourseIds);

            if (_belongToCourseIds != '') {

                _activeModulesCoursesIds = _activeModulesCoursesIds.concat(getIdsArrayFromString(_belongToCourseIds));

            }

        });

        var _courseIntersectionsIds = find_duplicate_in_array(_activeModulesCoursesIds);

        console.log('_courseIntersectionsIds');
        console.log(_courseIntersectionsIds);



        if (_courseIntersectionsIds.length > 0) {

            for (var _tt = 0; _tt < _courseIntersectionsIds.length; _tt++) {

                // ONLY COURSE with correct connection ids will stay
                if (_current_entity_connections_ids_array.length > 0) {

                    var _curr_course_connections_ids = $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).data('connectionid');

                    if (typeof _curr_course_connections_ids != 'undefined' && _curr_course_connections_ids != '' && _curr_course_connections_ids != null) {

                       var _curr_course_connections_ids_array = getIdsArrayFromString(_curr_course_connections_ids);

                        //console.log('_curr_course_connections_ids_array');
                        //console.log(_curr_course_connections_ids_array);

                        for (var _yy = 0; _yy < _current_entity_connections_ids_array.length; _yy++) {
                            if (_curr_course_connections_ids_array.length > 0 && in_array(_current_entity_connections_ids_array[_yy], _curr_course_connections_ids_array)) {

                                console.log('intersection with '+_current_entity_connections_ids_array[_yy]);

                                $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).addClass('active');

                                var _course_must_have_module_ = $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).data('musthavemoduleid');
                                var _course_recommended_module_ = $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).data('recommendedmoduleid');

                                if (_course_must_have_module_ !== '0' && _course_must_have_module_ != '') {

                                    $('.entity-module-'+_course_must_have_module_+'.active').find('.mandatory-module').show();

                                }
                                if (_course_recommended_module_ !== '0' && _course_recommended_module_ != '') {

                                    $('.entity-module-'+_course_recommended_module_+'.active').find('.recommended-module').show();

                                }

                            }
                        }

                    }

                }
                else {

                    $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).addClass('active');

                    var _course_must_have_module_ = $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).data('musthavemoduleid');
                    var _course_recommended_module_ = $('.entities.front-highlighted.entity-course-'+_courseIntersectionsIds[_tt]).data('recommendedmoduleid');

                    if (_course_must_have_module_ !== '0' && _course_must_have_module_ != '') {

                        $('.entity-module-'+_course_must_have_module_+'.active').find('.mandatory-module').show();

                    }
                    if (_course_recommended_module_ !== '0' && _course_recommended_module_ != '') {

                        $('.entity-module-'+_course_must_have_module_+'.active').find('.recommended-module').show();

                    }

                }

            }

            $('.front-course.front-highlighted:not(.active)').removeClass('front-highlighted').addClass('unclickable');

        }

        return false;
    }

    /** WHEN USER CLICKS ON HIGHLIGHTED ELEMENTS - FILTER END **/

    // general changes to clicked elements - highlight
    $(this).toggleClass('active');



    if (entitytype == 'module') {
        $('#calendar-module-'+ entityid).toggleClass('active');

    }

    $('.mandatory-module, .recommended-module').hide();

    var _current_clicked_elem = this;
    var _final_belong_ids = [];


    $('.entities').removeClass('front-highlighted').removeClass('unclickable');

    $('.calendar-module').removeClass('front-highlighted').removeClass('unclickable');


    /* FOR BELONGINGS */
    if (typeof belongstoids != 'undefined' && belongstoids != '' && belongstoids != null) {

        // GET BELONGS TO IDS LEVEL 1 (courses)
        _final_belong_ids = getIdsArrayFromString(belongstoids);

          if (_final_belong_ids.length > 0) {

              for (var i = 0; i < _final_belong_ids.length; i++) {

                  var _current_owner_selector = '.entity-'+belongsto+'-'+_final_belong_ids[i];

                  //var higher_level_belongsto = $(_current_owner_selector).data('belongsto');
                  //var higher_level_belongstoids = $(_current_owner_selector).data('belongstoids');

                  var higher_level_dependencytype = $(_current_owner_selector).data('dependencytype');
                  var higher_level_dependenciesids = $(_current_owner_selector).data('dependenciesids');

                  var _final_lvl_up_belong_ids = [];

                  // GET BELONGS TO IDS LEVEL 2 (certificates)
                  /*if (typeof higher_level_belongstoids != 'undefined' && higher_level_belongstoids != '' && higher_level_belongstoids != null) {

                      _final_lvl_up_belong_ids = getIdsArrayFromString(higher_level_belongstoids);
                  }*/

                  if ($(_current_clicked_elem).hasClass('active')) {

                      // highlight level 1 (course)
                      $(_current_owner_selector).addClass('front-highlighted');

                      if (_final_belong_ids.length == 1) {
                          $(_current_owner_selector).addClass('active');
                      }
                  }
                  else {
                      $(_current_owner_selector).removeClass('front-highlighted');

                      if (_final_belong_ids.length == 1) {
                          $(_current_owner_selector).removeClass('active');
                      }
                  }

                  /*if (_final_lvl_up_belong_ids.length > 0) {

                      for (var z = 0; z < _final_lvl_up_belong_ids.length; z++) {

                          var _current_highlighted_owner_selector = '.entity-'+higher_level_belongsto+'-'+_final_lvl_up_belong_ids[z];

                          // highlight level 2 (certificate)

                          if ($(_current_clicked_elem).hasClass('active')) {
                              $(_current_highlighted_owner_selector).addClass('front-highlighted');

                              if (_final_belong_ids.length == 1 && _final_lvl_up_belong_ids.length == 1) {
                                  $(_current_highlighted_owner_selector).addClass('active');
                              }
                          }
                          else {
                              $(_current_highlighted_owner_selector).removeClass('front-highlighted');

                              if (_final_lvl_up_belong_ids.length == 1) {
                                  $(_current_highlighted_owner_selector).removeClass('active');
                              }
                          }


                      }

                  }*/


                  // SPECIAL FOR MODULES
                  if (higher_level_dependencytype == 'module' && higher_level_dependenciesids != '' && higher_level_dependenciesids != null) {

                      var _dependent_course_modules = [];

                      var _current_clicked_elm_connectionids_array = getIdsArrayFromString(connectionids);

                      console.log('_current_clicked_elm_connectionids_array');
                      console.log(_current_clicked_elm_connectionids_array);

                      _dependent_course_modules = getIdsArrayFromString(higher_level_dependenciesids);

                      if (_dependent_course_modules.length > 0) {

                          for (var xx = 0; xx < _dependent_course_modules.length; xx++) {

                              var _other_module_connected_to_course_selector = '.entity-' + higher_level_dependencytype + '-' + _dependent_course_modules[xx];

                              var _other_module_connection_ids = $(_other_module_connected_to_course_selector).data('connectionid');

                              var _other_module_connectionids_array = getIdsArrayFromString(_other_module_connection_ids);



                              console.log('_other_module_connectionids_array');
                              console.log(_other_module_connectionids_array);


                              var o_intersections_array = [];

                              if (_current_clicked_elm_connectionids_array.length > 0 && _other_module_connectionids_array.length > 0) {

                                  console.log('_current_clicked_elm_connectionids_array and _other_module_connectionids_array');

                                  if (_current_clicked_elm_connectionids_array.length == 1 && _other_module_connectionids_array.length == 1 && _current_clicked_elm_connectionids_array[0] == _other_module_connectionids_array[0]) {

                                      console.log('one elm both arrays');
                                      o_intersections_array = _current_clicked_elm_connectionids_array;

                                  }
                                  else {
                                      o_intersections_array = _current_clicked_elm_connectionids_array.filter(function(n) {

                                          return _other_module_connectionids_array.indexOf(n.toString()) !== -1;

                                      });
                                  }


                              }

                              console.log('o_intersections_array');
                              console.log(o_intersections_array);

                              if ($(_current_clicked_elem).hasClass('active')) {

                                  console.log('module active now');

                                  if (o_intersections_array.length > 0) {

                                      $(_other_module_connected_to_course_selector).addClass('front-highlighted');

                                      $('#calendar-module-' + _dependent_course_modules[xx]).addClass('front-highlighted');

                                  }

                              }
                              else {

                                  if (o_intersections_array.length > 0) {

                                      $(_other_module_connected_to_course_selector).removeClass('front-highlighted');

                                      $('#calendar-module-' + _dependent_course_modules[xx]).removeClass('front-highlighted');

                                  }

                              }
                          }
                      }
                  }
              }
          }
      }

      /* FOR DEPENDENCIES */
    if (typeof dependenciesids != 'undefined' && dependenciesids != '' && dependenciesids != null) {

        var _final_dependencies_ids = [];

        // GET DEPENDENCIES TO IDS LEVEL DOWN 1

        _final_dependencies_ids = getIdsArrayFromString(dependenciesids);

        if (_final_dependencies_ids.length > 0) {

            for (var ii = 0; ii < _final_dependencies_ids.length; ii++) {

                var _current_dependency_selector = '.entity-'+dependencytype+'-'+_final_dependencies_ids[ii];

                var lower_level_dependencytype = $(_current_dependency_selector).data('dependencytype');
                var lower_level_combinationscount = $(_current_dependency_selector).data('combinationscount');
                var lower_level_dependenciesids = $(_current_dependency_selector).data('dependenciesids');
                var lower_level_musthavemoduleid = $(_current_dependency_selector).data('musthavemoduleid');
                var lower_level_recommendedmoduleid = $(_current_dependency_selector).data('recommendedmoduleid');

                var _final_lvl_down_dep_ids = [];

                // GET DEPENDENCIES TO IDS LEVEL DOWN 2 (certificates)
                if (typeof lower_level_dependenciesids != 'undefined' && lower_level_dependenciesids != '' && lower_level_dependenciesids != null) {


                    _final_lvl_down_dep_ids = getIdsArrayFromString(lower_level_dependenciesids);

                }

                if ($(_current_clicked_elem).hasClass('active')) {

                    // highlight level 1 (course)
                    $(_current_dependency_selector).addClass('front-highlighted');

                    if (dependencytype == 'module') {
                        $('#calendar-module-' + _final_dependencies_ids[ii]).addClass('front-highlighted');
                    }

                    // if user clicked the course entity then we should make modules active
                    if (dependencytype == 'module' || dependencytype == 'course') {

                        if (combinationscount !="" && parseInt(combinationscount) == 1) {

                            $(_current_dependency_selector).addClass('active');

                            if (dependencytype == 'module') {
                                $('#calendar-module-' + _final_dependencies_ids[ii]).addClass('active');
                            }

                        }
                        else {

                            $(_current_dependency_selector).parents('.card:first').find('.choose-more-specific').show();

                        }

                        if (dependencytype == 'module' && musthavemoduleid != '' && $(_current_dependency_selector).data('entityid') == musthavemoduleid) {

                            $(_current_dependency_selector).addClass('active').find('.mandatory-module').show();
                            $('#calendar-module-' + _final_dependencies_ids[ii]).addClass('active');

                        }

                        if (dependencytype == 'module' && recommendedmoduleid != '' && $(_current_dependency_selector).data('entityid') == recommendedmoduleid) {

                            $(_current_dependency_selector).find('.recommended-module').show();

                        }

                    }

                    if (_final_lvl_down_dep_ids.length > 0) {

                        for (var zz = 0; zz < _final_lvl_down_dep_ids.length; zz++) {

                            var _current_lower_dep_selector = '.entity-'+lower_level_dependencytype+'-'+_final_lvl_down_dep_ids[zz];

                            // highlight level 2 (certificate)
                            $(_current_lower_dep_selector).addClass('front-highlighted');

                            if (lower_level_dependencytype == 'module') {
                                $('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('front-highlighted');
                            }

                            if (lower_level_dependencytype == 'module' || lower_level_dependencytype == 'course') {

                                if (lower_level_combinationscount != "" && parseInt(lower_level_combinationscount) == 1) {

                                    $(_current_lower_dep_selector).addClass('active');

                                    if (lower_level_dependencytype == 'module') {
                                        $('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('active');
                                    }

                                }
                                else {
                                    $(_current_lower_dep_selector).parents('.card:first').find('.choose-more-specific').show();
                                }

                                if (lower_level_dependencytype == 'module' && lower_level_musthavemoduleid != '' && $(_current_lower_dep_selector).data('entityid') == lower_level_musthavemoduleid) {

                                    $(_current_lower_dep_selector).addClass('active').find('.mandatory-module').show();
                                    $('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('active');

                                }

                                if (lower_level_dependencytype == 'module' && lower_level_recommendedmoduleid != '' && $(_current_lower_dep_selector).data('entityid') == lower_level_recommendedmoduleid) {

                                    $(_current_lower_dep_selector).addClass('active').find('.recommended-module').show();

                                    $('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('active');
                                }

                            }
                        }
                    }
                }
                else {

                    // highlight level 1 (course)
                    $(_current_dependency_selector).removeClass('front-highlighted').removeClass('active');

                    if (dependencytype == 'module') {
                        $('#calendar-module-' + _final_dependencies_ids[ii]).removeClass('front-highlighted').removeClass('active');
                    }

                    if (_final_lvl_down_dep_ids.length > 0) {

                        for (var zz = 0; zz < _final_lvl_down_dep_ids.length; zz++) {

                            var _current_lower_dep_selector = '.entity-'+lower_level_dependencytype+'-'+_final_lvl_down_dep_ids[zz];

                            // highlight level 2 (certificate)
                            $(_current_lower_dep_selector).removeClass('front-highlighted');

                            $(_current_lower_dep_selector).removeClass('active');

                            if (lower_level_dependencytype == 'module') {
                                $('#calendar-module-' + _final_lvl_down_dep_ids[zz]).removeClass('active').removeClass('front-highlighted');
                            }

                        }
                    }

                }
            }
        }
    }

    if ($(_current_clicked_elem).hasClass('active')) {
        // Make not highlighted courses unclickable and for each highlighted we find all modules and highlight them too
        $('.entities').each(function() {
            if (!$(this).hasClass('front-highlighted') && !$(this).hasClass('active')) {

                $(this).addClass('unclickable');

                if ($(this).data('entitytype') == 'module') {
                    $('#calendar-module-' + $(this).data('entityid')).addClass('unclickable');
                }

            }
            else {
                $(this).removeClass('unclickable');

                if ($(this).data('entitytype') == 'module') {
                    $('#calendar-module-' + $(this).data('entityid')).removeClass('unclickable');
                }
            }
        });
    }

});

/********** MAKE SECOND ENTITIES CLICK HANDLER TO SHOW DATA IN THE INFO BLOCK AND PUT ALL THE INFORMATION OF CLICKS INTO OBJECT FOR SENDING LATER IN FORM *********/

function correctionsToModulesAndPlanner()
{

    var number_of_filled_m_columns = parseInt($('.front-module.active').length);

    $('.course-info-row').show();
    $('.card-front-courses').parent().attr('class', 'col-md-8');

    $('#usr-data-1, #usr-data-2').removeClass('width-100-percents');

    if ($('#c-tab-planner').hasClass('tab-active')) {

        if (number_of_filled_m_columns > 0) {

            $('.expand-planner').show();
            $('.collapse-planner').hide();

            $('.row.program-info-row').show();

            $('.course-info-row').show();

            if (number_of_filled_m_columns == 1) {

                $('#card-front-info-1').show();
                $('#card-front-info-2').hide().addClass('hideImportant');
                console.log('active columns 1');

                $('.card-front-courses').parent().attr('class', 'col-md-4');
                $('#modules-and-planner-column').attr('class', 'col-md-8');

                $('#usr-data-1, #usr-data-2').addClass('width-100-percents');


            }
            else { //number_of_filled_m_columns == 2

                $('#card-front-info-1, #card-front-info-2').show().removeClass('hideImportant');
                $('.card-front-courses').parent().attr('class', 'col-md-8');
                $('#modules-and-planner-column').attr('class', 'col-md-4');

                console.log('active columns 2');
            }

            scrollToChosenModuleEvent($('.moduleEventToScrollTo').attr('id'));

        }
        else {

            console.log('active columns 0');

            $('.expand-planner').hide();
            $('.collapse-planner').hide();

            $('.row.program-info-row').hide();
            $('#modules-and-planner-column').attr('class', 'col-md-12');
            $('#card-front-info-1, #card-front-info-2').hide();

            $('.course-info-row').hide();
        }

    }
}

function setPriceForModuleEvents() {

    if ($('.main-front-page').hasClass('with-module-event-price')) {

        setTimeout(function(){

            if ($('.front-module.active').length > 0) {

                console.log('_text_of_kosten_price');

                var _text_of_kosten_price = '<span class="me-price-message">'+$('#choose-two-module-events-text').data('text')+'</span>';

                if ($('.chosen-details-module .module_events_ids_checkbox:checked').length == 1) {
                    console.log('_text_of_kosten_price 1');
                    _text_of_kosten_price = '<span class="me-price-message">'+$('#choose-one-more-module-event-text').data('text')+'</span>';
                }
                if ($('.chosen-details-module .module_events_ids_checkbox:checked').length > 1) {

                    console.log('.chosen-details-module .module_events_ids_checkbox:checked length');
                    console.log($('.chosen-details-module .module_events_ids_checkbox:checked').length);

                    _text_of_kosten_price = 0;
                    $('.chosen-details-module .module_events_ids_checkbox:checked').each(function() {
                        var _data_me_price = $(this).data('me_price').trim();
                        if (_data_me_price != '' && _data_me_price != null && _data_me_price != 0) {
                            _text_of_kosten_price += parseInt(_data_me_price);
                        }

                    });
                    _text_of_kosten_price = _text_of_kosten_price + ' CHF'
                }
                //console.log('_text_of_kosten_price L');
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").show();
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").next('.sf-fv').html(_text_of_kosten_price).show();

            }
            else {
                //console.log('_text_of_kosten_price E');
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").hide();
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").next('.sf-fv').html('').hide();
            }

        },750);

    }

}

$('.entities').click(function() {

    $('.double-course-chosen').css('visiblity', 'hidden');
    $('.card-front-courses').removeClass('has-two-active-courses');

    $('#errorDateCollisionMessage').addClass('invisible');

    if ($(this).hasClass('unclickable')) {
      return false;
    }

    $('.you-can-choose-other-module').remove();

    $('.chosen-details, .sf-course-title, .sf-module-title').html('');
    $('.chosen-info').hide().removeClass('e-visible');

    $('.card-front-info .spinner-border').show();

    var current_elm = this;

    var _module_index = 0;

    if ($('.front-course.active').length > 1) {

        $('.card-front-courses').addClass('has-two-active-courses');
        $('.double-course-chosen').css('visibility', 'visible');

        if ($('#c-tab-modules').hasClass('tab-active')) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.double-course-chosen').first().offset().top - 40
            }, 1000);
        }

    }

    setTimeout(function() {


        $('.card-front-info .spinner-border').hide();


        $('.entities.active').each(function() {

            // FOR MODULES
            if ($(this).hasClass('front-module')) {


                _module_index++;

                var _ent_module_html = '';

                if ($(this).data('content') != '') {
                    _ent_module_html += '<div class="current-entity-description">'+$(this).data('content')+'</div>';
                }

//console.log($('.front-module.active').length);

                if ($('.front-module.active').length == 2) {

                    //console.log('inside 2');
                    $('#card-front-info-1 .chosen-details-'+$(this).data('entitytype')).append(_ent_module_html);
                    $('#card-front-info-2 .chosen-details-'+$(this).data('entitytype')).append(_ent_module_html);

                    $('#card-front-info-1 .chosen-details-'+$(this).data('entitytype')).parents('.chosen-info:first').show().addClass('e-visible');


                    $('#card-front-info-2 .chosen-details-'+$(this).data('entitytype')).parents('.chosen-info:first').show().addClass('e-visible');

                }
                else {
                    //console.log('inside 1');
                    $('#card-front-info-1 .chosen-details-'+$(this).data('entitytype')).append(_ent_module_html);
                    $('#card-front-info-1 .chosen-details-'+$(this).data('entitytype')).parents('.chosen-info:first').show().addClass('e-visible');
                }


                if ($(this).hasClass('front-module') && $(this).find('.front-module-events').length > 0) {

                    var _module_events_html = '<div class="info-me"><span class="me-info-head" style="text-transform:uppercase;">'+ $('#translation-me').text() +':</span>'+ $(this).find('.front-module-events').html() +'</div>';


                    $('.card-front-info .chosen-details-'+$(this).data('entitytype')).append(_module_events_html);


                }

            }

            // FOR COURSES
            if ($(this).hasClass('front-course')) {

                var _front_course = this;
                var _ent_course_html = '';

                $('.sf-course-title').text(': '+$(this).attr('title'));

                if ($(this).data('content') != '') {
                    _ent_course_html += '<div class="current-entity-description">'+$(this).data('content')+'</div>';
                }

                $('#card-course-info .chosen-details-'+$(this).data('entitytype')).html(_ent_course_html).parents('.chosen-info:first').show().addClass('e-visible');

                var _course_modules_html = '';



                $('.front-module.active').each(function(index) {

                    var _must_or_recommended = '';
                    var _is_must = 0;

                    if ($(this).find('.recommended-module').is(':visible')) {
                        _must_or_recommended = ' ('+$(this).find('.recommended-module').text()+')';

                    }

                    if ($(this).find('.mandatory-module').is(':visible')) {
                        _must_or_recommended = ' ('+$(this).find('.mandatory-module').text()+')';
                        _is_must = 1;
                    }

                    var _module_letter = (index == 0 ? 'A' : 'B');

                    if ($('.spec-module-letter-'+_module_letter).length == 0) {
                        _course_modules_html += '<div class="spec-module-letter-'+_module_letter+'"><strong>Modul '+ _module_letter + ':</strong> ' + '<span class="sml-'+_module_letter+(_is_must == 1 ? ' is-must ' : '')+'" id="sml-'+$(this).data('entityid')+'">' +  $(this).attr('title') + _must_or_recommended + '</span></div>';
                    }


                });

                $('#card-course-info .chosen-details-module').append(_course_modules_html).parents('.chosen-info:first').show().addClass('e-visible');

                function _nl2br_(str) {
                    var breakTag = '<br>';
                    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
                }

                // special fields
                var _special_fields_html = '<div class="sf-fields row">';

                if ($(_front_course).data('fieldname1') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname1')+':</span>';
                }
                if ($(_front_course).data('fieldvalue1') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue1'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname2') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname2')+':</span>';
                }
                if ($(_front_course).data('fieldvalue2') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue2'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname3') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname3')+':</span>';
                }
                if ($(_front_course).data('fieldvalue3') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue3'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname4') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname4')+':</span>';
                }
                if ($(_front_course).data('fieldvalue4') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue4'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname5') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname5')+':</span>';
                }
                if ($(_front_course).data('fieldvalue5') != '') {
                    if ($(_front_course).data('fieldname5') == $(_front_course).data('fieldname6') && $(_front_course).data('fieldvalue6') != '') {
                        _special_fields_html += '<span class="sf-fv col-8"> <a href="' + $(_front_course).data('fieldvalue5') + '">' + $(_front_course).data('fieldvalue6') + '</a></span><br>';
                    }
                    else {
                        _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue5'))+'</span><br>';
                    }
                }

                _special_fields_html += '</div>';

                if ($('.chosen-details-sf-child').length == 0) {
                    $('#card-course-info .chosen-details-sf').append('<div class="chosen-details-sf-child">'+_special_fields_html+'</div>');

                    $('.chosen-details-sf-child .sf-fields .sf-fv.col-8').each(function() {

                        var _sf_8_txt = $(this).text().trim();

                        if (isValidURL1(_sf_8_txt)) {

                            var _prev_elem_ = $(this).prev('.sf-fn.col-4:first');

                            var _prev_elem_txt_ = $(_prev_elem_).text().replace(':', '');

                            $(_prev_elem_).text('');

                            $(this).html('<a href="'+_sf_8_txt+'" target="_blank" >'+_prev_elem_txt_+'</a>');

                        }
                    });

                    function isValidURL1(string) {
                        var regex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
                        return regex.test(string);
                    }

                    // hide course price to replace it with sum of module events prices
                    if ($('.main-front-page').hasClass('with-module-event-price')) {

                        $(".chosen-details-sf-child .sf-fn:contains('Kosten')").hide();
                        $(".chosen-details-sf-child .sf-fn:contains('Kosten')").next('.sf-fv').hide();

                    }
                }


            }

            setPriceForModuleEvents();


            $(document).off('click', '.front-me-name');
            $(document).on('click', '.front-me-name', function() {

                $(this).toggleClass('active');

                var module_id = $(this).prev('input.module_events_ids_checkbox').data('memoduleid');

                $(this).parents('.info-me:first').find('.front-me-name').not(this).each(function() {

                    $(this).removeClass('active');
                    $(this).next('.front-me-days').slideUp("slow");
                    $(this).prev('input.module_events_ids_checkbox').prop('checked', false);

                    $('#calendar-module-event-'+$(this).prev('input.module_events_ids_checkbox').data('meid')).removeClass('active');

                });

                if ($(this).hasClass('active')) {

                    $(this).next('.front-me-days').slideDown("slow");
                    $(this).prev('input.module_events_ids_checkbox').prop('checked', true);


                    $('#calendar-module-'+module_id).addClass('with-active-me');

                    $('#calendar-module-event-'+$(this).prev('input.module_events_ids_checkbox').data('meid')).addClass('active');
                }
                else {

                    $('#calendar-module-'+module_id).removeClass('with-active-me');
                    $(this).next('.front-me-days').slideUp("slow");
                    $(this).prev('input.module_events_ids_checkbox').prop('checked', false);
                    $('#calendar-module-event-'+$(this).prev('input.module_events_ids_checkbox').data('meid')).removeClass('active');
                }

                putDatesIntoFormStatus3(this);
                findDateCollisions();
                setPriceForModuleEvents();
            });

        });

        $('.front-module.active').each(function(index) {

            if (index == 0) {
                /* console.log('index xxx 0');
                 console.log(index);*/
                $('#card-front-info-1 .sf-module-title').text(': '+$(this).attr('title'));
                $('#event_name1').val($(this).attr('title'));
            }
            else {
                /*console.log('index xxx other');
                 console.log(index);*/
                $('#card-front-info-2 .sf-module-title').text(': '+$(this).attr('title'));
                $('#event_name2').val($(this).attr('title'));
            }
        });

        if ($('.front-module.active').length == 2) {


            $('#card-front-info-1 .chosen-details-module .current-entity-title:last').remove();
            $('#card-front-info-1 .chosen-details-module .current-entity-description:last').remove();
            $('#card-front-info-1 .chosen-details-module .info-me:last').remove();

            $('#card-front-info-2 .chosen-details-module .current-entity-title:first').remove();
            $('#card-front-info-2 .chosen-details-module .current-entity-description:first').remove();
            $('#card-front-info-2 .chosen-details-module .info-me:first').remove();


            // MODULE WITH THE CLOSEST BOOKING AVAILABLE DATE SHOULD BE MODULE A
            var _card_1_first_date = $('#card-front-info-1 .chosen-details-module .module_events_ids_checkbox:first').next('.front-me-name').find('.me-first-date').text().trim();

            var _card_2_first_date = $('#card-front-info-2 .chosen-details-module .module_events_ids_checkbox:first').next('.front-me-name').find('.me-first-date').text().trim();

            if (typeof _card_1_first_date != 'undefined' && _card_1_first_date != '' && _card_1_first_date != null && typeof _card_2_first_date != 'undefined' && _card_2_first_date != '' && _card_2_first_date != null) {

                var _aCard1FDate = _card_1_first_date.split('.');
                var _aCard2FDate = _card_2_first_date.split('.');

                var _a_card_1_f_date_milliseconds = Date.parse(_aCard1FDate[1] + '-' + _aCard1FDate[0] + '-' + _aCard1FDate[2]);
                var _a_card_2_f_date_milliseconds = Date.parse(_aCard2FDate[1] + '-' + _aCard2FDate[0] + '-' + _aCard2FDate[2]);


                if (_a_card_1_f_date_milliseconds > _a_card_2_f_date_milliseconds) {

                    var _sf_1_title = $('#card-front-info-1 .sf-module-title').text().trim();
                    var _chosen_details_module_1 = $('#card-front-info-1 .chosen-details-module').html();

                    var _sf_2_title = $('#card-front-info-2 .sf-module-title').text().trim();
                    var _chosen_details_module_2 = $('#card-front-info-2 .chosen-details-module').html();


                    $('.sml-A').appendTo('.spec-module-letter-B');
                    $('.sml-B').appendTo('.spec-module-letter-A');


                    $('#card-front-info-1 .sf-module-title').text(_sf_2_title);
                    $('#card-front-info-2 .sf-module-title').text(_sf_1_title);

                    $('#card-front-info-1 .chosen-details-module').html(_chosen_details_module_2);
                    $('#card-front-info-2 .chosen-details-module').html(_chosen_details_module_1);

                    $('#event_name1').val(_sf_2_title.replace(': ', ''));
                    $('#event_name2').val(_sf_1_title.replace(': ', ''));

                }

            }

            // Determine if one of the modules in the info columns is mandatory

            if ($('.is-must').length > 0) {

                var _m_id = $('.is-must').attr('id').replace('sml-', '');
                var _column_with_mandatory_m_index = $('.module_events_ids_checkbox-'+_m_id).parents('.card-front-info:first').attr('id').replace('card-front-info-', '');


                if (_column_with_mandatory_m_index == '1') {

                    if ($('#card-front-info-2 .you-can-choose-other-module').length == 0) {
                        $('#card-front-info-2').append('<div class="you-can-choose-other-module">'+$('.invisible-you-can-choose-other').data('youcanchooseother')+'</div>');
                    }

                }
                else {

                    if ($('#card-front-info-1 .you-can-choose-other-module').length == 0) {
                        $('#card-front-info-1').append('<div class="you-can-choose-other-module">'+$('.invisible-you-can-choose-other').data('youcanchooseother')+'</div>');
                    }

                }

            }
        }


        correctionsToModulesAndPlanner();


      // if we have active/chosen events on planner we should also make respective checkboxes checked again
      if ($('.content-of-event-cell.active').length > 0) {

          $('.content-of-event-cell.active').each(function() {

              var _me_id = $(this).attr('id').replace('calendar-module-event-', '');

              $('.module_events_ids_checkbox[data-meid="'+_me_id+'"]').each(function(){

                  $(this).prop('checked', true);

              });

          });

      }

      // check planner, if module is inactive then module events in his row should be inactive also
      $('.calendar-module').each(function(){

          if (!$(this).hasClass('active')) {

              $(this).parents('tr:first').find('.content-of-event-cell').each(function(){
                  $(this).removeClass('active')
              });

          }

      });

        /*console.log('second info in col');
        console.log($('#card-front-info-1 .chosen-details-module .info-me').length);*/

        if ($('#card-front-info-1 .chosen-details-module .info-me').length == 2) {
            $('#card-front-info-1 .chosen-details-module .info-me:nth-child(2)').remove();
        }

        if ($('#card-front-info-1 .chosen-details-module .current-entity-description').length == 2) {
            $('#card-front-info-1 .chosen-details-module .current-entity-description:nth-child(2)').remove();
        }
        /*$('#card-front-info-1 .chosen-details-module .info-me:nth-child(2)').remove();
        $('#card-front-info-1 .chosen-details-module .current-entity-description:nth-child(2)').remove();*/


        /* Show copy combination button for user who logged in on front page */
        if ($('.front-course.active').length > 0 && $('.front-module.active').length > 0) {

            setTimeout(function(){

                var _lgd_link_parts = '';
                var _mas_links_ids = [];
                var _das_links_ids = [];
                var _courses_links_ids = [];
                var _modules_links_ids = [];


                $('.entities.active').each(function(){

                    if ($(this).hasClass('front-mas')) {

                        _mas_links_ids.push($(this).data('entityid'));

                    }

                    if ($(this).hasClass('front-das')) {

                        _das_links_ids.push($(this).data('entityid'));

                    }

                    if ($(this).hasClass('front-course')) {

                        _courses_links_ids.push($(this).data('entityid'));

                    }

                    if ($(this).hasClass('front-module')) {

                        _modules_links_ids.push($(this).data('entityid'));

                    }

                });

                if (_mas_links_ids.length > 0) {
                    _lgd_link_parts += 'mas='+ _mas_links_ids.join(',');
                }

                if (_das_links_ids.length > 0) {
                    _lgd_link_parts += (_lgd_link_parts == '' ? '' : '&') + 'das=' + _das_links_ids.join(',');
                }

                if (_courses_links_ids.length > 0) {
                    _lgd_link_parts += (_lgd_link_parts == '' ? '' : '&') + 'courses=' + _courses_links_ids.join(',');
                }

                if (_modules_links_ids.length > 0) {
                    _lgd_link_parts += (_lgd_link_parts == '' ? '' : '&') + 'modules=' + _modules_links_ids.join(',');
                }

                //https://lets-get-digital.ch/de?modules=38,1&course=18

                $('body').append('<a style="display: none;" id="share-the-chosen-course" href="https://lets-get-digital.ch/de?'+_lgd_link_parts+'">'+$('#share-the-chosen-course-text').text()+'</a>');


                document.addEventListener("keydown", function(event) {
                    if (event.ctrlKey && event.code === "KeyC") {
                        // Ctrl+C was pressed
                        console.log("Ctrl+C pressed");
                        var _link_ = document.getElementById('share-the-chosen-course');

                        var _input_ = document.createElement('input');
                        _input_.setAttribute('value', _link_.href);
                        document.body.appendChild(_input_);
                        _input_.select();
                        document.execCommand('copy');
                        document.body.removeChild(_input_);
                        console.log('Link copied to clipboard');
                    }
                });

            },3000);

        }
        else {
            $('#share-the-chosen-course').remove();
        }
        /* Show copy combination button for user who logged in on front page end */
    }, 300);

});

/********** MAKE SECOND ENTITIES CLICK HANDLER TO SHOW DATA IN THE INFO BLOCK AND PUT ALL THE INFORMATION OF CLICKS INTO OBJECT FOR SENDING LATER IN FORM END *********/

/****** POSITION of right front panel corrections ******/

if ($('.card-front-modules').length > 0) {

    setTimeout(function(){

        var cfm_offset = $('.card-front-modules').offset();

        var cfm_width = parseInt($('.card-front-modules').innerWidth());

        var cfm_left = parseInt(cfm_offset.left);

        $('.card-front-info').css({'left': (cfm_left + cfm_width + 40) + 'px', 'display': 'block'});

    }, 1000);

}

/****** POSITION of right front panel corrections END ******/

/******* VALIDATION of user data form ******/

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

/*$('#call_back').click(function(e) {
    if ($(this).prop('checked')) {
        $("#call_back_phone").removeClass('make-invisible');
    }
    else {
        $("#call_back_phone").addClass('make-invisible');
    }
});*/
$(document).on('change', '.front-user-form input[type="file"]', function(e){

    var files = e.originalEvent.target.files;

    for (var i=0, len=files.length; i<len; i++){

        var extension = files[i].name.substr( (files[i].name.lastIndexOf('.') + 1) );

        if (files[i].size > 7000000 || extension != 'pdf') {//>7MB not allowed

            $(this).prev('.fhnwEventFilesContainer').addClass('with-error');

        }
        else {

            $(this).prev('.fhnwEventFilesContainer').removeClass('with-error');

        }

    }
});

function determineClientBrowser() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName  = navigator.appName;
    var fullVersion  = ''+parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion,10);
    var nameOffset,verOffset,ix;

// In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+6);
        if ((verOffset=nAgt.indexOf("Version"))!=-1)
            fullVersion = nAgt.substring(verOffset+8);
    }
// In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
    }
// In Chrome, the true version is after "Chrome"
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
    }
// In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset+7);
        if ((verOffset=nAgt.indexOf("Version"))!=-1)
            fullVersion = nAgt.substring(verOffset+8);
    }
// In Firefox, the true version is after "Firefox"
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset+8);
    }
// In most other browsers, "name/version" is at the end of userAgent
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
        (verOffset=nAgt.lastIndexOf('/')) )
    {
        browserName = nAgt.substring(nameOffset,verOffset);
        fullVersion = nAgt.substring(verOffset+1);
        if (browserName.toLowerCase()==browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
// trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
        fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
        fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
        fullVersion  = ''+parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion,10);
    }

    return browserName + ' ' + fullVersion + ' ' + majorVersion + ' ' + navigator.appName + ' ' + navigator.userAgent;

}

function determineClientOS() {
    var OSName="Unknown OS";
    if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
    if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
    if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

    return OSName;
}

// SUBMIT FOR REGULAR PAGE
$(document).off('click','.main-front-page .front-user-form button.submitter');
$(document).on('click','.main-front-page .front-user-form button.submitter', function(e) {

    var sbmtr_btn = this;

    console.log('sbmtr_btn');
    console.log(sbmtr_btn);

    $(sbmtr_btn).attr('disabled', 'disabled');

    $('.dynamic-input').remove();

    if ($(this).hasClass('ajax-submitter')) {
        e.preventDefault();
    }

    $('.front-user-form .error-message, .front-user-form .success-message, .error-message-chosen-me').hide();

    $('.front-user-form .error-message-specify').text('');

    $('.front-user-form input, .front-user-form textarea, .error-container').removeClass('with-error');

    $('input.input-with-error-inside').each(function() {

        $(this).attr('placeholder', $(this).data('placeholder'));

    });

    $(".info-me").removeClass('with-error');

    var errors = [];
    var study = [];
    var dataToSend = '';


    $('.entities.active').each(function(){

        var current_entity_type = $(this).data('entitytype');
        var current_entity_id = $(this).data('entityid');

        var study_object = {'entitytype': current_entity_type, 'entity_id': current_entity_id};
        //console.log(study_object);
        dataToSend += (dataToSend == '' ? '' : '&') + 'entities['+current_entity_type+'][]='+current_entity_id;

        $('form.front-user-form').prepend('<input class="dynamic-input" type="hidden" name="entities['+current_entity_type+'][]" value="'+current_entity_id+'" />');

        study.push(study_object);

    });

    if ($(".card-front-info .module_events_ids_checkbox:checked").length > 1) {



        $(".module_events_ids_checkbox:checked").each(function(){
            dataToSend += (dataToSend == '' ? '' : '&') + $(this).attr('name') + '='+$(this).data('meid');
        });

    }
    else {

        if ($("#secret_pdf_button").is(":visible")) {
            console.log('pdf btn is visible');
        }
        else {
            errors.push('study');
        }


    }

    // info events (if status infoevent)
    if ($('form .front-checkbox-container .info-event').length > 0 && $('form .front-checkbox-container .info-event:checked').length == 0) {
        errors.push('info_event');
    }


    $('form .input-with-error-inside').each(function(){

        if ($(this).val().trim() == '') {
            errors.push($(this).attr('id'));
        }
        if ($(this).attr('id') == 'mail' || $(this).attr('id') == 'customer_email') {

            if (!isEmail($(this).val())) {
                errors.push($(this).attr('id'));
            }
        }

    });


    // if 2 courses are active, then we make user choose one
    if ($('.front-course.active').length > 1) {
        errors.push('only_one_course_should_be_taken');
    }


    // study
    if (study.length == 0) {
        errors.push('study');
    }


    if ($('.front-statuses-checkbox:checked').length == 0) {
        errors.push('checkboxes');
    }

    if ($('form .fhnwEventFilesContainer.with-error').length > 0) {
        errors.push('pdf');
    }

    // inputs with files
    $('form .fileInputSMustFill').each(function() {

        if ($(this).val() == '') {
            $(this).prev('.fhnwEventFilesContainer').addClass('with-error');
            errors.push('pdf');
        }

    });

    // radios
    $('form .radios-elements-container').each(function(){

        var _has_values = false;

        $(this).find('input[type="radio"]').each(function(){
            if ($(this).prop('checked') == true) {
                _has_values = true;
            }
        });

        if (_has_values == false) {
            $(this).addClass('with-error');
        }

    });

    // specify elements
    if ($('.choose-more-specific:visible').length > 0) {

        errors.push('specify');

        var _final_specify_message = $('.error-message-specify').data('mspecify');
        var _the_replacer = '';

        $('.choose-more-specific:visible').each(function(index) {

            _the_replacer += $(this).parents('.card:first').find('h3').text().trim() + ((parseInt(index)+1) < $('.choose-more-specific:visible').length ? ', ' : '');

        });

        _final_specify_message = _final_specify_message.replace('xxxx', _the_replacer);

        $('.error-message-specify').text(_final_specify_message);

    }

    console.log(errors);

    if (errors.length > 0) {

        $(sbmtr_btn).removeAttr('disabled');

        e.preventDefault();

        for (var i = 0; i < errors.length; i++) {

            if ($('#'+errors[i]).length > 0) {

                $('#'+errors[i]).addClass('with-error');

                $('#'+errors[i]).attr('placeholder', $('#'+errors[i]).next('.error-message').text().trim());

            }
            else {

                $('.error-message-'+errors[i]).show();

            }

        }


        $([document.documentElement, document.body]).animate({
            scrollTop: $(".with-error, .error-message:visible, .double-course-chosen:visible").first().offset().top - 250
        }, 2000);


        return false;
    }
    else {
        if ($('input[name="contact_for_registration"]').prop('checked')) {

            //console.log('contact_for_registration');
            $('.front-user-form').attr('action', $('#ajax-post-url').val());
            $('.front-user-form').attr('method', 'POST');

            $('#client_os').remove();
            $('#client_browser_data').remove();

            var client_os = determineClientOS();
            var client_browser_data = determineClientBrowser();

            if (typeof client_os != 'undefined' && client_os != '') {
                $('.front-user-form').append('<input type="hidden" id="client_os" name="client_os" value="'+ client_os +'">');
            }

            if (typeof client_browser_data != 'undefined' && client_browser_data != '') {
                $('.front-user-form').append('<input type="hidden" id="client_browser_data" name="client_browser_data" value="'+ client_browser_data +'">');
            }


            $('.front-user-form').submit();
        }
        else {
            $('.front-user-form .success-message').show();

            dataToSend += (dataToSend == '' ? '' : '&')+'first_name='+$('.front-user-form #first_name1').val()+'&last_name='+$('.front-user-form #last_name').val()+'&email='+$('.front-user-form #customer_email').val() + '&phone=' +$('.front-user-form #customer_phone').val() + '&status='+$('.front-statuses-checkbox:checked').attr('id').replace('front-statuses-checkbox-', '');

            if ($('.front-user-form #ie_ort').length > 0) {

                dataToSend += '&ie_ort=' + $('.front-user-form #ie_ort').val();

            }
            if ($('.front-user-form #ie_plz').length > 0) {

                dataToSend += '&ie_plz=' + $('.front-user-form #ie_plz').val();

            }
            if ($('.front-user-form #ie_street_nr').length > 0) {

                dataToSend += '&ie_street_nr=' + $('.front-user-form #ie_street_nr').val();

            }

            if ($('.info-events-checkboxes .info-event:checked').length > 0) {

                $('.info-events-checkboxes .info-event:checked').each(function() {
                    dataToSend += '&info_event[]='+$(this).val();
                });

            }
            /*if ($('#call_back').prop('checked')) {
             dataToSend += '&callback=1&phone=' + $('#phone').val().trim();
             }
             if ($('#interested').prop('checked')) {
             dataToSend += '&interested=1';
             }*/
            $.ajax({
                url: $('#ajax-post-url').val(),
                method: 'POST',
                data: dataToSend,
                success: function(data) {
                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $('.success-message').text(data.success);

                        setTimeout(function(){
                            $('.success-message').text('').hide();
                        },4000);

                        $(sbmtr_btn).removeAttr('disabled');

                        if ($('.front-statuses-checkbox:checked').attr('name') == 'contact_for_registration' && typeof data.lead_id != 'undefined' && typeof data.course_id != 'undefined' && typeof data.module_event_id != 'undefined') {
//console.log(data);return false;
                            //location.href = 'https://fhnw.edu-crm.com/registration.html?form=anmeldung_cas&lead_id='+data.lead_id+'&course_id='+data.course_id+'&module_event_id='+data.module_event_id;


                        }

                    }
                }
            });
        }
    }

});

// SUBMIT FOR DAS PAGE
$(document).off('click','.main-front-das-page .front-user-form button.submitter');
$(document).on('click','.main-front-das-page .front-user-form button.submitter', function(e) {

    var sbmtr_btn = this;

    console.log('das sbmtr_btn');
    console.log(sbmtr_btn);

    $(sbmtr_btn).attr('disabled', 'disabled');

    $('.dynamic-input').remove();

    if ($(this).hasClass('ajax-submitter')) {
        e.preventDefault();
    }

    $('.front-user-form .error-message, .front-user-form .success-message, .error-message-chosen-me').hide();

    $('.front-user-form .error-message-specify').text('');

    $('.front-user-form input, .front-user-form textarea, .error-container').removeClass('with-error');

    $('input.input-with-error-inside').each(function() {

        $(this).attr('placeholder', $(this).data('placeholder'));

    });

    $(".info-me").removeClass('with-error');

    var errors = [];
    var study = [];
    var dataToSend = '';


    $('.unit.active').each(function(){

        var current_unit_type = $(this).data('unittype');
        var current_unit_id = $(this).data('unitid');

        var study_object = {'unittype': current_unit_type, 'unit_id': current_unit_id};
        //console.log(study_object);
        dataToSend += (dataToSend == '' ? '' : '&') + 'units['+current_unit_type+'][]='+current_unit_id;

        $('form.front-user-form').append('<input class="dynamic-input" type="hidden" name="units['+current_unit_type+'][]" value="'+current_unit_id+'" />');

        study.push(study_object);

    });

    if ($(".card-front-info .module_events_ids_checkbox:checked").length > 1) {



        $(".module_events_ids_checkbox:checked").each(function(){
            dataToSend += (dataToSend == '' ? '' : '&') + $(this).attr('name') + '='+$(this).data('meid');
        });

    }
    else {

        if ($("#secret_pdf_button").is(":visible")) {
            console.log('pdf btn is visible');
        }
        else {
            errors.push('study');
        }


    }

    // info events (if status infoevent)
    if ($('form .front-checkbox-container .info-event').length > 0 && $('form .front-checkbox-container .info-event:checked').length == 0) {
        errors.push('info_event');
    }


    $('form .input-with-error-inside').each(function(){

        if ($(this).val().trim() == '') {
            errors.push($(this).attr('id'));
        }
        if ($(this).attr('id') == 'mail' || $(this).attr('id') == 'customer_email') {

            if (!isEmail($(this).val())) {
                errors.push($(this).attr('id'));
            }
        }

    });


    // if 2 courses are active, then we make user choose one
    /*if ($('.unit-course.active').length > 1) {
        errors.push('only_one_course_should_be_taken');
    }*/


    // study
    if (study.length == 0) {
        errors.push('study');
    }


    if ($('.front-statuses-checkbox:checked').length == 0) {
        errors.push('checkboxes');
    }

    if ($('form .fhnwEventFilesContainer.with-error').length > 0) {
        errors.push('pdf');
    }

    // inputs with files
    $('form .fileInputSMustFill').each(function() {

        if ($(this).val() == '') {
            $(this).prev('.fhnwEventFilesContainer').addClass('with-error');
            errors.push('pdf');
        }

    });

    // radios
    $('form .radios-elements-container').each(function(){

        var _has_values = false;

        $(this).find('input[type="radio"]').each(function(){
            if ($(this).prop('checked') == true) {
                _has_values = true;
            }
        });

        if (_has_values == false) {
            $(this).addClass('with-error');
        }

    });

    // specify elements
    if ($('.choose-more-specific:visible').length > 0) {

        errors.push('specify');

        var _final_specify_message = $('.error-message-specify').data('mspecify');
        var _the_replacer = '';

        $('.choose-more-specific:visible').each(function(index) {

            _the_replacer += $(this).parents('.card:first').find('h3').text().trim() + ((parseInt(index)+1) < $('.choose-more-specific:visible').length ? ', ' : '');

        });

        _final_specify_message = _final_specify_message.replace('xxxx', _the_replacer);

        $('.error-message-specify').text(_final_specify_message);

    }

    console.log(errors);

    if (errors.length > 0) {

        $(sbmtr_btn).removeAttr('disabled');

        e.preventDefault();

        for (var i = 0; i < errors.length; i++) {

            if ($('#'+errors[i]).length > 0) {

                $('#'+errors[i]).addClass('with-error');

                $('#'+errors[i]).attr('placeholder', $('#'+errors[i]).next('.error-message').text().trim());

            }
            else {

                $('.error-message-'+errors[i]).show();

            }

        }


        $([document.documentElement, document.body]).animate({
            scrollTop: $(".with-error, .error-message:visible, .double-course-chosen:visible").first().offset().top - 250
        }, 2000);


        return false;
    }
    else {
        if ($('input[name="contact_for_registration"]').prop('checked')) {

            //console.log('contact_for_registration');
            $('.front-user-form').attr('action', $('#ajax-post-url').val());
            $('.front-user-form').attr('method', 'POST');

            $('#client_os').remove();
            $('#client_browser_data').remove();

            var client_os = determineClientOS();
            var client_browser_data = determineClientBrowser();

            if (typeof client_os != 'undefined' && client_os != '') {
                $('.front-user-form').append('<input type="hidden" id="client_os" name="client_os" value="'+ client_os +'">');
            }

            if (typeof client_browser_data != 'undefined' && client_browser_data != '') {
                $('.front-user-form').append('<input type="hidden" id="client_browser_data" name="client_browser_data" value="'+ client_browser_data +'">');
            }


            $('.front-user-form').submit();
        }
        else {
            $('.front-user-form .success-message').show();

            dataToSend += (dataToSend == '' ? '' : '&')+'first_name='+$('.front-user-form #first_name1').val()+'&last_name='+$('.front-user-form #last_name').val()+'&email='+$('.front-user-form #customer_email').val() + '&phone=' +$('.front-user-form #customer_phone').val() + '&status='+$('.front-statuses-checkbox:checked').attr('id').replace('front-statuses-checkbox-', '');

            if ($('.front-user-form #ie_ort').length > 0) {

                dataToSend += '&ie_ort=' + $('.front-user-form #ie_ort').val();

            }
            if ($('.front-user-form #ie_plz').length > 0) {

                dataToSend += '&ie_plz=' + $('.front-user-form #ie_plz').val();

            }
            if ($('.front-user-form #ie_street_nr').length > 0) {

                dataToSend += '&ie_street_nr=' + $('.front-user-form #ie_street_nr').val();

            }

            if ($('.info-events-checkboxes .info-event:checked').length > 0) {

                $('.info-events-checkboxes .info-event:checked').each(function() {
                    dataToSend += '&info_event[]='+$(this).val();
                });

            }
            /*if ($('#call_back').prop('checked')) {
             dataToSend += '&callback=1&phone=' + $('#phone').val().trim();
             }
             if ($('#interested').prop('checked')) {
             dataToSend += '&interested=1';
             }*/
            $.ajax({
                url: $('#ajax-post-url').val(),
                method: 'POST',
                data: dataToSend,
                success: function(data) {
                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $('.success-message').text(data.success);

                        setTimeout(function(){
                            $('.success-message').text('').hide();
                        },4000);

                        $(sbmtr_btn).removeAttr('disabled');

                        if ($('.front-statuses-checkbox:checked').attr('name') == 'contact_for_registration' && typeof data.lead_id != 'undefined' && typeof data.course_id != 'undefined' && typeof data.module_event_id != 'undefined') {
//console.log(data);return false;
                            //location.href = 'https://fhnw.edu-crm.com/registration.html?form=anmeldung_cas&lead_id='+data.lead_id+'&course_id='+data.course_id+'&module_event_id='+data.module_event_id;


                        }

                    }
                }
            });
        }
    }

});

$('input.form-check-custom-input').click(function() {

   $(this).parents('.error-container').removeClass('with-error');

});

$('input.input-with-error-inside').blur(function() {

    if ($(this).val().trim() != '') {
        $(this).removeClass('with-error');
    }

});

/******************* Prevent checking two same module events in right column ********************/

$(document).off('click', '.main-front-page .module_events_ids_checkbox');
$(document).on('click', '.main-front-page .module_events_ids_checkbox', function() {

    var _current_checkbox = this;
    var _current_days_container = $(this).next('.front-me-name');
    var _module_id = $(this).data('memoduleid');

    if ($(this).prop('checked') == true) {

        _current_days_container.addClass('active');
        $('#calendar-module-'+_module_id).addClass('with-active-me');
        $(_current_checkbox).parents('.info-me:first').find('.module_events_ids_checkbox').not(_current_checkbox).prop('checked', false);

        $(_current_checkbox).parents('.info-me:first').find('.module_events_ids_checkbox').each(function() {
            $('#calendar-module-event-'+$(this).data('meid')).removeClass('active');
        });

        $('#calendar-module-event-'+$(_current_checkbox).data('meid')).addClass('active');

        $(this).parents('.info-me:first').find('.front-me-name').not(_current_days_container).each(function() {

            $(this).removeClass('active');
            $(this).next('.front-me-days').slideUp("slow");
            $(this).prev('input.module_events_ids_checkbox').prop('checked', false);

        });

        $(this).next().next('.front-me-days').slideDown("slow");

        // determine which tab is active
        /*if ($('.custom-tab-modules').hasClass('ui-tabs-active')) {

           var _card_index = $(_current_checkbox).parents('.card-front-info:first').attr('id').replace('card-front-info-', '');

           $('#planner-card-front-info-'+_card_index).find('.module_events_ids_checkbox').each(function() {

               $(this).prop('checked', false);

               if ($(this).data('meid') == $(_current_checkbox).data('meid')) {
                   $(this).prop('checked', true);
               }

           });

        }*/
        /*else {

            var _card_index =  $(_current_checkbox).parents('.card-front-info:first').attr('id').replace('planner-card-front-info-', '');

            $('#card-front-info-'+_card_index).find('.module_events_ids_checkbox').each(function() {

                $(this).prop('checked', false);

                if ($(this).data('meid') == $(_current_checkbox).data('meid')) {
                    $(this).prop('checked', true);
                }

            });

        }*/

    }
    else {

        $('#calendar-module-'+_module_id).removeClass('with-active-me');
        $('#calendar-module-event-'+$(_current_checkbox).data('meid')).removeClass('active');

        $(this).next('.front-me-name').removeClass("active");
        $(this).next().next('.front-me-days').slideUp("slow");

        /*if ($('.custom-tab-modules').hasClass('ui-tabs-active')) {

            var _card_index =  $(_current_checkbox).parents('.card-front-info:first').attr('id').replace('card-front-info-', '');

            $('#planner-card-front-info-'+_card_index).find('.module_events_ids_checkbox').each(function() {

                $(this).prop('checked', false);

            });

        }*/
        /*else {

            var _card_index =  $(_current_checkbox).parents('.card-front-info:first').attr('id').replace('planner-card-front-info-', '');

            $('#card-front-info-'+_card_index).find('.module_events_ids_checkbox').each(function() {

                $(this).prop('checked', false);

            });

        }*/
    }

    putDatesIntoFormStatus3(_current_checkbox);
    findDateCollisions();
    setPriceForModuleEvents();
});

/****************** Prevent checking two same module events in right column END******************/




/******* VALIDATION of user data form END ******/

/******************** Remove Module Event Day **************************/

$(document).off('click', '.fa-times.med');
$('.fa-times.med').click(function() {
    var c = confirm($('#are_you_sure_text').text());

    if (c == true) {

        var _the_parent = $(this).parents('.row-me-days:first');

        $.ajax({
            url: $(this).data('removeurl'),
            method: 'POST',
            data: {'id': $(this).attr('id').replace('med-', '')},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    $('.success-message').text(data.success);
                    $(_the_parent).remove();

                }
            }
        });
    }
});

/******************** Remove Module Event Day END **************************/

/************************** Module Event Sortable ***************************/

$('.me-sortable-parent').sortable({
    item: '.module-event-sortable',
    start: function(event, ui) {

    },
    stop: function(event, ui) {

        var _strToSend = '';
        var _url_ = $('#change_module_events_sort_order').data('url');

        $('.module-event-sortable').each(function(index) {

            var _id_ = $(this).attr('id').replace('module-event-sortable-', '');

            $(this).find('.sort_order_container').text('#'+parseInt(index + 1));
            _strToSend += (_strToSend == '' ? '' : '&') + 'module_events['+ _id_ +']=' + parseInt(index + 1);

        });

        $.ajax({
            url: _url_,
            method: 'POST',
            data: _strToSend,
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    //console.log(data);

                }

            }
        });

    }
});
/************************** Module Event Sortable End ***************************/


/************************** Sort Days ***************************/

/*$('.module-event-days-parent').sortable({
    item: '.row-me-days',
    start: function(event, ui) {

    },
    stop: function(event, ui) {

        var _strToSend = '';
        var _url_ = $('#change_module_event_day_sort_order').data('url');

        $(ui.item).parents('.module-event-days-parent:first').find('.row-me-days').each(function(index) {

            var _id_ = $(this).attr('id').replace('row-me-days-', '');

            $(this).find('.day_sort_order_container').text('#'+parseInt(index + 1));
            _strToSend += (_strToSend == '' ? '' : '&') + 'module_events_days['+ _id_ +']=' + parseInt(index + 1);

        });

        $.ajax({
            url: _url_,
            method: 'POST',
            data: _strToSend,
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    //console.log(data);

                }

            }
        });
    }
});*/

/************************** Sort Days End ***************************/



/************************* Search By Lecturer Name and Status *****************************/

function workWithMeDayFilters() {

    var has_values = false;

    $('.row-with-me-days').removeClass('af-parent').hide();
    $('.row-me-days').show().removeClass('already-filtered');

    var all_bulk_checkboxes = $('.row-with-me-days .day_bulk_check, #day_bulk_all');

    $('#day_bulk_all').attr('disabled', 'disabled');

    $('.send-bulk-request').attr('disabled', 'disabled');

    //$('.send-bulk-request').hide();

    all_bulk_checkboxes.each(function(){
        $(this).prop('checked', false);
    });

    $('.hide-me-days').hide();
    $('.expand-me-days').show();

    $('.me_filter').each(function() {

        var _current_filter_input = this;

        if ($(_current_filter_input).val().trim() != '') {

            //console.log($(_current_filter_input).attr('id') + 'where value != ""');

            has_values = true;

            var _current_value = $(_current_filter_input).val().toLowerCase();

            var _input_important_part_name = $(_current_filter_input).attr('id').replace('me_filter', '');

            var _prefix = '';

            if ($('.already-filtered').length > 0) {
                _prefix = '.already-filtered ';
            }

            $(_prefix + '.quick-assign'+_input_important_part_name).each(function() {

                var _cell_value = $(this).text().trim().toLowerCase();

                if ($(_current_filter_input).attr('id') == 'me_filter_date' && _current_value.indexOf('-') != -1) {


                    var aFilterDates = _current_value.split('-');

                    var _startFDate = aFilterDates[0].trim();
                    var _endFDate = aFilterDates[1].trim();

                    if (_startFDate != '' && _endFDate != '') {

                      var _startFDateArray = _startFDate.split('.');
                      var _endFDateArray = _endFDate.split('.');

                      /*console.log('_startFDateArray');
                      console.log(_startFDateArray);
                      console.log('_endFDateArray');
                      console.log(_endFDateArray);*/

                      var _startFDate_milliseconds = Date.parse(_startFDateArray[1] + '-' + _startFDateArray[0] + '-' + _startFDateArray[2]);
                      var _endFDate_milliseconds = Date.parse(_endFDateArray[1] + '-' + _endFDateArray[0] + '-' + _endFDateArray[2]);

                      if (_cell_value != '') {

                        var _cell_valueArray = _cell_value.split('.');

                        var _cell_value_milliseconds = Date.parse(_cell_valueArray[1] + '-' + _cell_valueArray[0] + '-' + _cell_valueArray[2]);

                        if (_startFDate_milliseconds != 0 && _endFDate_milliseconds != 0 && _cell_value_milliseconds != 0 && _cell_value_milliseconds >= _startFDate_milliseconds && _cell_value_milliseconds <= _endFDate_milliseconds) {

                          $(this).parents('.row-me-days:first').addClass('already-filtered').show();

                        }
                        else {

                          $(this).parents('.row-me-days:first').removeClass('already-filtered').hide();

                        }

                      }
                      else {

                        $(this).parents('.row-me-days:first').removeClass('already-filtered').hide();

                      }

                    }
                    else {

                       $(this).parents('.row-me-days:first').removeClass('already-filtered').hide();

                    }


                }
                else {

                    if ($(_current_filter_input).attr('id') == 'me_filter_lecturer_name') {

                        _current_value = _current_value.replace(', ', ',').replace(', ', ',').replace(', ', ',').replace(', ', ',').replace(', ', ',');

                        /*console.log('_current_value z');
                        console.log(_current_value);*/

                        if (_current_value.indexOf(',') != -1) {

                            var has_nec_val = false;
                            var a_current_value = _current_value.split(',');

                            for (var xzz = 0; xzz < a_current_value.length; xzz++) {

                                if (_cell_value.indexOf(a_current_value[xzz]) != -1) {
                                    has_nec_val = true;
                                }

                            }

                            if (has_nec_val == true) {

                                $(this).parents('.row-me-days:first').addClass('already-filtered').show();

                            }
                            else {

                                $(this).parents('.row-me-days:first').removeClass('already-filtered').hide();

                            }

                        }
                        else {

                            if (_cell_value.indexOf(_current_value) != -1) {

                                $(this).parents('.row-me-days:first').addClass('already-filtered').show();

                            }
                            else {

                                $(this).parents('.row-me-days:first').removeClass('already-filtered').hide();

                            }

                        }

                    }
                    else {
                        if (_cell_value.indexOf(_current_value) != -1) {

                            $(this).parents('.row-me-days:first').addClass('already-filtered').show();

                        }
                        else {

                            $(this).parents('.row-me-days:first').removeClass('already-filtered').hide();

                        }
                    }

                }

            });

        }

    });

    console.log('has_values ccc');
    console.log(has_values);

    if (has_values == true) {

        $('.on-filter-hide').hide();

        /*$('.me_main_data_filter').attr('disabled', 'disabled');*/

/*        console.log('valuezerro1');
        console.log('me_main_data_filter_location');
        console.log($('#me_main_data_filter_location ').parent().html());
        console.log('me_main_data_filter_years');
        console.log($('#me_main_data_filter_years').parent().html());*/

        /*$('#me_main_data_filter_location').parent().addClass('disabledMultiselect');
        $('#me_main_data_filter_years').parent().addClass('disabledMultiselect');*/

    }
    else {

        //$('.row-with-me-days').addClass('af-parent').show();
        $('.on-filter-hide').show();

        /*$('.me_main_data_filter').removeAttr('disabled');*/

        //console.log('valuezerro2');

        /*$('#me_main_data_filter_location').parent().removeClass('disabledMultiselect');
        $('#me_main_data_filter_years').parent().removeClass('disabledMultiselect');*/

    }

    if ($('.already-filtered').length > 0) {

        $('#day_bulk_all').removeAttr('disabled');


        $('.already-filtered').each(function() {

            $(this).parents('.row-with-me-days:first').addClass('af-parent').show();

        });

    }

    if ($('#me_filter_lecturer_name').val() != '') {

        $('.quick-assign_date.same-day').each(function() {
            $(this).text($(this).data('same_day'));
        });

    }
    else {
        $('.quick-assign_date.same-day').each(function() {
            $(this).text('');
        });
    }
}


var w_r_timer_me1;
$('.me_filter').keyup(function(){

    console.log('me_filter keyup');
    var _me_this = this;
    w_r_timer_me1 && clearTimeout(w_r_timer_me1);

    w_r_timer_me1 = setTimeout(function() {

        var _is_chrono_checked = false;

        if ($('#me_filter_lecturer_name').val() != '') {
            $('#chronological_order').removeAttr('disabled');
            $('.chrono-order-lab').addClass('active-lab');
            $('#lects_to_xls').removeAttr('disabled').show();
        }
        else {
            $('#chronological_order').attr('disabled', 'disabled');
            $('#chronological_order').prop('checked', false);
            $('.chrono-order-lab').removeClass('active-lab');
            $('#lects_to_xls').attr('disabled', 'disabled').hide();
        }

        if ($('#chronological_order').prop('checked') == true) {
            _is_chrono_checked = true;

            $('#chronological_order').click();

        }

        $('.chronological-results').html('');
        $('.me-parent').show();

        workWithMeDayFilters();
        workWithMeMainFilters();

        if ($('.put_filter_on_map').length > 0) {
            $('.put_filter_on_map').click();
        }

        localStorage.setItem($(_me_this).attr('id'), $(_me_this).val());


        if (_is_chrono_checked == true) {
            $('#chronological_order').click();
        }



            /*if ($(".chronological-results .hasMinDate").length > 0) {

                $(".chronological-results .hasMinDate").each(function() {
                    $(this).removeClass('hasMinDate').appendTo('#module-event-' + $(this).data('parentme') + ' .module-event-days-parent');
                });

                $('.me-row.module-event:not(.module-event-archived)').each(function() {

                    var _curr_me_id = $(this).attr('id').replace('module-event-', '');

                    $('#module-event-'+_curr_me_id+' .row-me-days').sort(function(a, b) {

                        return parseInt($(a).data("index")) - parseInt($(b).data("index"));

                    }).prependTo('#module-event-'+_curr_me_id+' .module-event-days-parent');

                });
            }


            $('#chronological_order').prop('checked', false);*/






    }, 300);

});

$('#chronological_order').click(function() {

    /*console.log('chrono click 1');
    console.log('chrono_order prop checked');
    console.log($('#chronological_order').prop('checked'));*/

    var _co_checkbox = this;

    if ($(_co_checkbox).prop('checked') == true) {

        $('.chronological-results').html('');

        var me_filter_lecturer_name_value = $('#me_filter_lecturer_name').val().replace(', ', ',').replace(', ', ',').replace(', ', ',').replace(', ', ',').replace(', ', ',').trim();

        me_filter_lecturer_name_value = me_filter_lecturer_name_value.toLowerCase();
        var _aChronoNames = me_filter_lecturer_name_value.split(',');

        var _lect_name1 = '';

        for (var xxz1 = 0; xxz1 < _aChronoNames.length; xxz1++) {

            _lect_name1 += (_lect_name1 != '' ? ', ' : '') + _aChronoNames[xxz1];

        }

        $('<div class="chro-container chro-'+1+'"><h4>' + _lect_name1+':</h4><div id="chro-details-' + 1 + '" class="chro-details"></div></div>').appendTo('.chronological-results');

        $('.me-parent').hide();

        var _filtered_prefix = '';

        if ($('.module-event.me-filtered').length > 0) {
            _filtered_prefix = '.me-filtered';
        }


        $(".me-row.module-event:not(.module-event-archived)"+_filtered_prefix).each(function() {

            var _co_me = this;

            $(_co_me).data('mindatetime', 0);

            $(_co_me).find('.row-me-days.already-filtered').each(function() {

                var _co_me_day = this;
                var _co_me_day_date = $(_co_me_day).find('.quick-assign_date').text().trim();


                if ($(_co_me_day).find('.lecturer_now').length > 0) {



                    /*console.log('_co_me_day_date');
                    console.log(_co_me_day_date);*/

                    if (_co_me_day_date != '') {

                        var myDate = _co_me_day_date.split(".");

                        console.log('myDate');
                        console.log(myDate);

                        if (myDate != null && myDate.length != 0) {

                            var newDate = new Date(myDate[2], myDate[1], myDate[0]);
                            var newDateTime = newDate.getTime();

                            console.log('newDateTime');
                            console.log(newDateTime);

                            console.log('parseInt($(_co_me).data(\'mindatetime\'))');
                            console.log(parseInt($(_co_me).data('mindatetime')));

                            //if (newDateTime > 0 && (newDateTime < parseInt($(_co_me).data('mindatetime')) || parseInt($(_co_me).data('mindatetime')) == 0)) {

                            for (var xxz2 = 0; xxz2 < _aChronoNames.length; xxz2++) {

                                var _co_me_day_lect_name = $(_co_me_day).find('.quick-assign_lecturer_name').text().toLowerCase();

                                console.log('_co_me_day_lect_name');
                                console.log(_co_me_day_lect_name);

                                console.log('_aChronoNames[xxz2]');
                                console.log(_aChronoNames[xxz2]);

                                if (_co_me_day_lect_name.indexOf(_aChronoNames[xxz2]) != -1) {
                                    console.log('has chrono name');
                                    $(_co_me_day).data('mindatetime', newDateTime).appendTo('.chronological-results .chro-' + 1 + ' .chro-details');
                                    $(_co_me_day).addClass('hasMinDate mindatetime-' + newDateTime);
                                }

                            }


                            //}

                        }

                    }
                    else {

                        for (var xxz3 = 0; xxz3 < _aChronoNames.length; xxz3++) {

                            var _co_me_day_lect_name = $(_co_me_day).find('.quick-assign_lecturer_name').text();

                            if (_co_me_day_lect_name.indexOf(_aChronoNames[xxz3]) != -1) {
                                $(_co_me_day).data('mindatetime', 0).appendTo('.chronological-results .chro-' + 1 + ' .chro-details');
                                $(_co_me_day).addClass('hasMinDate mindatetime-' + 0);
                            }

                        }
                    }

                }

            });

        });

        $('.chronological-results .chro-details').each(function() {

            var current_chro_details_id = $(this).attr('id');

            $('#'+current_chro_details_id+' .hasMinDate').sort(function(a, b) {

                return parseInt($(a).data("mindatetime")) - parseInt($(b).data("mindatetime"));

            }).prependTo('#'+current_chro_details_id);

        });


        var _url_for_export = $('.fa-file-excel-link').data('url') + '?medIds=';
        var _med_days_ids = '';

        $('.chronological-results .chro-details .hasMinDate').each(function() {

            _med_days_ids += (_med_days_ids == '' ? '' : ',') + $(this).attr('id').replace('row-me-days-', '');

        });

        $('.fa-file-excel-link').show().attr('href', _url_for_export+_med_days_ids);


    }
    else {

        $('.me-parent').show();
        $('.fa-file-excel-link').hide();

        if ($(".chronological-results .hasMinDate").length > 0) {

            $(".chronological-results .hasMinDate").each(function() {
                $(this).removeClass('hasMinDate').appendTo('#module-event-' + $(this).data('parentme') + ' .module-event-days-parent');
            });

            $('.me-row.module-event:not(.module-event-archived)').each(function() {

                var _curr_me_id = $(this).attr('id').replace('module-event-', '');

                $('#module-event-'+_curr_me_id+' .row-me-days').sort(function(a, b) {

                    return parseInt($(a).data("index")) - parseInt($(b).data("index"));

                }).prependTo('#module-event-'+_curr_me_id+' .module-event-days-parent');

            });

            $('.chronological-results').html('');

        }

    }

});

$('#me_filter_status').change(function(){
//console.log('changed location');

    var _is_chrono_checked = false;

    if ($('#me_filter_lecturer_name').val() != '') {
        $('#chronological_order').removeAttr('disabled');
        $('.chrono-order-lab').addClass('active-lab');
    }
    else {
        $('#chronological_order').attr('disabled', 'disabled');
        $('#chronological_order').prop('checked', false);
        $('.chrono-order-lab').removeClass('active-lab');
    }

    if ($('#chronological_order').prop('checked') == true) {
        _is_chrono_checked = true;

        $('#chronological_order').click();

    }

    $('.chronological-results').html('');
    $('.me-parent').show();

    workWithMeDayFilters();
    workWithMeMainFilters();

    if ($('.put_filter_on_map').length > 0) {
        $('.put_filter_on_map').click();
    }

    localStorage.setItem($(this).attr('id'), $(this).val());

    if (_is_chrono_checked == true) {
        $('#chronological_order').click();
    }

});

/***Special Filter by STARTDATUM***/

function workWithMeMainFilters() {

    $('.module-event').show().removeClass('me-filtered');

    var day_filters_have_values = false;

    $('.me_filter').each(function() {

        if ($(this).val() != '') {
            day_filters_have_values = true;
        }

    });

    var has_values = false;

    $('.me_main_data_filter').each(function() {

        var changed_elem = this;

        var _current_filter_name = $(changed_elem).attr('id').replace('me_main_data_filter_', '');

        if (_current_filter_name == 'location') {
            var _current_value = $(changed_elem).val();
            if (_current_value.length == 0) {
                console.log('_current_value.length == 0');
                _current_value = '';
            }
        }
        else if (_current_filter_name == 'years') {
            var _current_value = $(changed_elem).val();
            if (_current_value.length == 0) {
                console.log('_current_value.length == 0');
                _current_value = '';
            }
        }
        else {
            var _current_value = $(changed_elem).val().toLowerCase();
        }

        console.log('_current_value');
        console.log(_current_value);

        var search_input = changed_elem;

        if (_current_value != '') {

            localStorage.setItem($(changed_elem).attr('id'), _current_value);

            has_values = true;

            //$('.me_filter').attr('disabled', 'disabled');

            var _prefix = '';

            if ($('.me-filtered').length > 0) {
                _prefix = '.me-filtered';
            }
            var _module_events = $(_prefix + '.module-event');

            /*if ($('.af-parent').length > 0) {
                _module_events = $('.af-parent').prev();
            }*/

            $(_module_events).each(function () {

//console.log('inside me fe');


                var _has_correct_module = 0;

                var mc_container = this;

                if ($('.af-parent').length > 0) {

                    if ($(mc_container).find('.af-parent').length == 0) {

                        //console.log($(this).attr('id') + ' to hide');
                        $(mc_container).hide().removeClass('me-filtered');

                        return true;
                    }
                }

                if (day_filters_have_values == true && $(mc_container).is(':visible') && $(mc_container).find('.module-event-days-parent .row-me-days:visible').length == 0) {

                    /*console.log('mc_container');
                    console.log(mc_container);*/

                    console.log($(mc_container).attr('id') + ' to hide');

                    $(mc_container).hide().removeClass('me-filtered');

                    return true;
                }

                var _column_value = $(this).find('.me-filters-column_'+_current_filter_name).text().trim().toLowerCase();

                if (_current_filter_name == 'location') {

                    for (var xyz = 0; xyz < _current_value.length; xyz++) {

                        var ready_current_value = _current_value[xyz];

                        if (typeof ready_current_value != 'undefined' && ready_current_value != '' && _column_value.indexOf(ready_current_value.trim().toLowerCase()) != -1) {
                            _has_correct_module = 1;
                        }

                    }

                }
                else if (_current_filter_name == 'years') {

                    for (var zyx = 0; zyx < _current_value.length; zyx++) {

                        var ready_current_value = _current_value[zyx];

                        if (typeof ready_current_value != 'undefined' && ready_current_value != '' && _column_value.indexOf(ready_current_value.trim().toLowerCase()) != -1) {
                            _has_correct_module = 1;
                        }

                    }

                }
                else {
                    if (_column_value.indexOf(_current_value) != -1) {
                        _has_correct_module = 1;
                    }
                }

                if (_has_correct_module == 1) {
                    $(mc_container).show().addClass('me-filtered');
                }
                else {
                    $(mc_container).hide().removeClass('me-filtered');
                }

            });

        }
        else {

        }

    });
    /*console.log('before has_values');
    console.log(has_values);*/

    if (has_values == false && day_filters_have_values == false) {
        //$('.me_filter').removeAttr('disabled');
        $('.module-event').show().removeClass('me-filtered');
        console.log('has_values no');
    }
    else {
        console.log('has_values yes');

        console.log('day_filters_have_values');
        console.log(day_filters_have_values);

        $('.module-event').each(function() {

            console.log($(this).attr('id') + ' visible is ' + $(this).is(':visible'));
            console.log('visible length ' + $(this).find('.module-event-days-parent .row-me-days:visible').length);

            if (day_filters_have_values == true && $(this).is(':visible') && $(this).find('.module-event-days-parent .row-me-days:visible').length == 0) {

                console.log('last each me');

                $(this).hide().removeClass('me-filtered');

            }

        });
    }

}


var w_r_timer_me2;
$('.me_main_data_filter:not(#me_main_data_filter_location,#me_main_data_filter_years,#me_main_data_filter_pic)').keyup(function(){
    var me_this = this;
    w_r_timer_me2 && clearTimeout(w_r_timer_me2);
    w_r_timer_me2 = setTimeout(function() {

        var _is_chrono_checked = false;

        if ($('#me_filter_lecturer_name').val() != '') {
            $('#chronological_order').removeAttr('disabled');
            $('.chrono-order-lab').addClass('active-lab');
        }
        else {
            $('#chronological_order').attr('disabled', 'disabled');
            $('#chronological_order').prop('checked', false);
            $('.chrono-order-lab').removeClass('active-lab');
        }

        if ($('#chronological_order').prop('checked') == true) {
            _is_chrono_checked = true;

            $('#chronological_order').click();

        }

        $('.chronological-results').html('');
        $('.me-parent').show();

        workWithMeDayFilters();
        workWithMeMainFilters();

        if ($('.put_filter_on_map').length > 0) {
            $('.put_filter_on_map').click();
        }

        localStorage.setItem($(me_this).attr('id'), $(me_this).val());

        if (_is_chrono_checked == true) {
            $('#chronological_order').click();
        }

    }, 300);
});
$('#me_main_data_filter_location').change(function(){

    var _is_chrono_checked = false;

    if ($('#me_filter_lecturer_name').val() != '') {
        $('#chronological_order').removeAttr('disabled');
        $('.chrono-order-lab').addClass('active-lab');
    }
    else {
        $('#chronological_order').attr('disabled', 'disabled');
        $('#chronological_order').prop('checked', false);
        $('.chrono-order-lab').removeClass('active-lab');
    }

    if ($('#chronological_order').prop('checked') == true) {
        _is_chrono_checked = true;

        $('#chronological_order').click();

    }

    $('.chronological-results').html('');
    $('.me-parent').show();


    workWithMeDayFilters();
    workWithMeMainFilters();

    if ($('.put_filter_on_map').length > 0) {
        $('.put_filter_on_map').click();
    }

    localStorage.setItem($(this).attr('id'), $(this).val());

    if (_is_chrono_checked == true) {
        $('#chronological_order').click();
    }

});

$('#me_main_data_filter_years').change(function(){

    var _is_chrono_checked = false;

    if ($('#me_filter_lecturer_name').val() != '') {
        $('#chronological_order').removeAttr('disabled');
        $('.chrono-order-lab').addClass('active-lab');
    }
    else {
        $('#chronological_order').attr('disabled', 'disabled');
        $('#chronological_order').prop('checked', false);
        $('.chrono-order-lab').removeClass('active-lab');
    }

    if ($('#chronological_order').prop('checked') == true) {
        _is_chrono_checked = true;

        $('#chronological_order').click();

    }

    $('.chronological-results').html('');
    $('.me-parent').show();

    workWithMeDayFilters();
    workWithMeMainFilters();

    if ($('.put_filter_on_map').length > 0) {
        $('.put_filter_on_map').click();
    }

    localStorage.setItem($(this).attr('id'), $(this).val());

    if (_is_chrono_checked == true) {
        $('#chronological_order').click();
    }

});
$('#me_main_data_filter_pic').change(function(){

    var _is_chrono_checked = false;

    if ($('#me_filter_lecturer_name').val() != '') {
        $('#chronological_order').removeAttr('disabled');
        $('.chrono-order-lab').addClass('active-lab');
    }
    else {
        $('#chronological_order').attr('disabled', 'disabled');
        $('#chronological_order').prop('checked', false);
        $('.chrono-order-lab').removeClass('active-lab');
    }

    if ($('#chronological_order').prop('checked') == true) {
        _is_chrono_checked = true;

        $('#chronological_order').click();

    }

    $('.chronological-results').html('');
    $('.me-parent').show();


    workWithMeDayFilters();
    workWithMeMainFilters();

    if ($('.put_filter_on_map').length > 0) {
        $('.put_filter_on_map').click();
    }

    localStorage.setItem($(this).attr('id'), $(this).val());

    if (_is_chrono_checked == true) {
        $('#chronological_order').click();
    }

});


$('#day_bulk_all').click(function(){

    var all_bulk_checkboxes = $('.already-filtered .day_bulk_check');

    if ($(this).is(":checked")) {
        $('.send-bulk-request').removeAttr('disabled');
        all_bulk_checkboxes.each(function(){
            $(this).prop('checked', true);
        });
    }
    else {
        $('.send-bulk-request').attr('disabled', 'disabled');
        all_bulk_checkboxes.each(function(){
            $(this).prop('checked', false);
        });
    }

});

$(document).on('click', '.already-filtered .day_bulk_check', function() {

    if ($('.already-filtered .day_bulk_check:checked').length > 0) {
        $('.send-bulk-request').removeAttr('disabled');
    }
    else {
        $('.send-bulk-request').attr('disabled', 'disabled');
    }

});

$('.me-clear-filters').click(function() {

    $('#me_main_data_filter_years').val('').change();

    $('.me-filter-form input, .me-filter-form select').val('');

    $('.me-filter-form input:first').keyup();

    $('.me_main_data_filter:first').keyup();

    //$('.me_bulk_check').prop('checked', false);

    $('.me_filter, .me_main_data_filter').each(function() {

        var _input_id = $(this).attr('id');

        localStorage.removeItem(_input_id);

    });

    localStorage.removeItem('chosen_opened_me');
    localStorage.removeItem('checked_module_events');

    if (!$('.me-clear-filters').hasClass('dont-touch-checkboxes')) {

        $('.container-of-module-events').removeClass('show-only-checked');

        $('.me_bulk_check:checked').each(function() {

            $(this).prop('checked', false);
            $(this).parents('.module-event:first').removeClass('module-event-show-only');

        });

    }
    else {

        $('.me-clear-filters').removeClass('dont-touch-checkboxes');

    }


    $('.me-row.module-event').attr('style', '');
    //console.log('remove item chosen_opened_me');

});

$('.me-show-only-checked').click(function() {

    $('.me-clear-filters').addClass('dont-touch-checkboxes');
    $('.me-clear-filters').click();

    if ($('.me_bulk_check:checked').length > 0) {

        $('.container-of-module-events').addClass('show-only-checked');

        var checked_module_events = [];
        //console.log('.me_bulk_check:checked');

//$('.module-event').show().removeClass('me-filtered');

        $('.module-event').hide().addClass('me-filtered');

        $('.me_bulk_check:checked').each(function() {

            $(this).parents('.module-event:first').show().removeClass('me-filtered').addClass('module-event-show-only');

            checked_module_events.push($(this).attr('id'));

        });

        localStorage.setItem("checked_module_events", JSON.stringify(checked_module_events));

    }

});

if (localStorage.getItem("checked_module_events") !== null) {
    //console.log('checked_module_events not null');
    var checked_module_events = JSON.parse(localStorage.getItem("checked_module_events"));

    //console.log('checked_module_events');
    //console.log(checked_module_events);

    for (var ss = 0; ss < checked_module_events.length; ss++) {
        $('#'+checked_module_events[ss]).prop('checked', true);
    }

    //console.log('meshowonlychecked click');
    $('.me-show-only-checked').click();
}

$('#howItWorks').click(function() {

    $(this).toggleClass('opened');

    $('#howItWorksDetails').toggle();

    if ($(this).hasClass('opened')) {
        $(this).text($(this).data('close'));
    }
    else {
        $(this).text($(this).data('open'));
    }

});
/********************** Search By Lecturer Name and Status End ***************************/

$('#invitationToLecturer').on('hidden.bs.modal', function () {

    $('.email-content-header .edit-email-content').removeClass('fa-times').addClass('fa-pencil-square');
    $('.me_email_content').addClass('active');
    $('.me_email_editable_content').removeClass('active');
    $('.email-save-success').text('').hide();
    $('#invitationToLecturer .btn-send').removeAttr('disabled');

});

$('#invitationToLecturer').on('show.bs.modal', function (event) {

    // remove old vals
    $('.success-message').text('');
    $('.email-save-success').text('').hide();
    $('#invitationToLecturer .lecturer_name, #invitationToLecturer .me_day_data, #invitationToLecturer .lecturer_email').html('');
    $('.error_lecturer_has_no_email').hide();

    $('#invitationToLecturer .modal-title').hide();

    $('.me_email_content,.me_email_editable_content').removeClass('active');

    $('#invitationToLecturer .spinner-container').hide();

    $('#invitationToLecturer .btn-send').show();

    $('#invitationToLecturer #email_subject, #invitationToLecturer #email_body').val('');

    $('#invitationToLecturer .meeb_text').html('');
    $('#invitationToLecturer .mees_text').text('');

    //console.log($('.secretary_emails_hidden').html());
    $('.secretary_emails_content').html($('.secretary_emails_hidden').html());
    $('.secretary_emails_content').find('#secretary_for_request_number_hidden').attr('id', 'secretary_for_request_number');


    // assign new vals

    var button = $(event.relatedTarget);
    var days_ids = [];
    var lecturers_ids = [];

    var aLecNames = [];
    var aDayInfo = [];
    var aLecEmails = [];

    var _lecturers_names = '';
    var _day_info = '';
    var _lecturers_emails = '';

    var is_multiple_request = 0;

    if ($(button).hasClass('request-single')) {

        $('#invitationToLecturer .modal-title.single').show();

        days_ids.push($(button).data('dayid')+'_'+$(button).data('lecturerid'));
        _lecturers_names = $(button).data('lecturerfullname');
        _day_info = $(button).data('dayinfo');
        _lecturers_emails = $(button).data('lectureremail');
        lecturers_ids.push($(button).data('lecturerid'));
    }
    else {

        var is_multiple_request = 1;

        $('#invitationToLecturer .modal-title.multiple').show();

        $('.already-filtered .day_bulk_check:checked').each(function(){

            days_ids.push($(this).data('dayid')+'_'+$(this).data('lecturerid'));
            aLecNames.push($(this).data('lecturerfullname'));
            aDayInfo.push($(this).data('dayinfo'));
            aLecEmails.push($(this).data('lectureremail'));
            lecturers_ids.push($(this).data('lecturerid'));
        });

        if (days_ids.length > 0) {
            days_ids = days_ids.filter(arrayUnique);
        }

        if (aLecNames.length > 0) {
            aLecNames = aLecNames.filter(arrayUnique);
            _lecturers_names = '<br>' + aLecNames.join(', <br>');
        }

        if (aDayInfo.length > 0) {
            aDayInfo = aDayInfo.filter(arrayUnique);
            _day_info = '<br>' + aDayInfo.join(', <br>');
        }

        if (aLecEmails.length > 0) {
            aLecEmails = aLecEmails.filter(arrayUnique);
            _lecturers_emails = '<br>' + aLecEmails.join(', <br>');
        }

    }


    $('#invitationToLecturer .lecturer_name').html(_lecturers_names);
    $('#invitationToLecturer .me_day_data').html(_day_info);
    $('#invitationToLecturer .lecturer_email').html(_lecturers_emails);


    if ($(button).data('lectureremail') == '') {

        $('.error_lecturer_has_no_email').show();
        $('#invitationToLecturer .btn-send').hide();

        $('#invitationToLecturer .spinner-container').hide();

    }
    else {

        // get email by code
        getEmailByCode(($('#s_messages_templates option').length > 0 && $('#s_messages_templates').val() != '' ? $('#s_messages_templates').val() : $('#single_day_lecturer_request').data('code')), true);

        $(document).off('click', '.email-content-header .edit-email-content');
        $(document).on('click', '.email-content-header .edit-email-content', function() {


            if ($(this).hasClass('fa-pencil-square')) {

                $(this).removeClass('fa-pencil-square').addClass('fa-times');
                $('.me_email_content').removeClass('active');
                $('.me_email_editable_content').addClass('active');
                $('.email-save-success').text('').hide();
                //$('#invitationToLecturer .btn-send').attr('disabled', 'disabled');

            }
            else {

                $(this).removeClass('fa-times').addClass('fa-pencil-square');
                $('.me_email_content').addClass('active');
                $('.me_email_editable_content').removeClass('active');
                $('.email-save-success').text('').hide();
                $('#invitationToLecturer .btn-send').removeAttr('disabled');

            }

        });

        $('.email-content-header .edit-email-content').click();
        $('.me_email_content').removeClass('active');

        // if user clicked save email:
        $(document).off('click', '.btn-save-email-content');
        $('.btn-save-email-content').click(function() {

            setEmailByCode($('#s_messages_templates').val());

            setTimeout(function(){
                $('#invitationToLecturer .email-save-success').hide();
                $('#invitationToLecturer .btn-send').removeAttr('disabled');
            },2000);

        });

        $('#invitationToLecturer #email_subject, #invitationToLecturer #email_body').blur(function(){
            $('.btn-save-email-content').click();
        });

        $(document).off('click', '#invitationToLecturer .btn-send');
        $(document).on('click', '#invitationToLecturer .btn-send', function(e) {

            $('.btn-save-email-content').click();

            $('.spinner-container.bottom-button-spinner').show();

            var dataLectObj = {'days_ids': days_ids, 'lecturers_ids': lecturers_ids, 'secretary_for_request_number': $('#secretary_for_request_number').val(), 'code': $('#s_messages_templates').val(), 'is_multiple_request': is_multiple_request};
            if ($('#send_only_to_secretary').prop('checked') == true) {
                dataLectObj.send_only_to_secretary = true;
            }

            setTimeout(function() {
                $.ajax({
                    url: $('#send_invitation_to_lecturer').data('url'),
                    method: 'POST',
                    data: dataLectObj,
                    success: function(data) {

                        if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                            $('.spinner-container').hide();

                            $('.success-message').text(data.success);

                            var _today = new Date();

                            var _todays_date = (parseInt(_today.getDate()) < 10 ? '0'+_today.getDate() : _today.getDate()) + '.' + ((parseInt(_today.getMonth()+1) < 10 ? '0'+(_today.getMonth()+1) : _today.getMonth()+1)) + '.' + _today.getFullYear();

                            if ($(button).hasClass('request-single')) {

                                var _lecturer_id = $(button).data('lecturerid');
                                var _mday_id = $(button).data('dayid');


                                $(button).parents('.row:first').find('#medtl-qas-contaner-'+_mday_id+'-'+$(button).data('medtlid') + ' .fa-comment-o').remove();
                                $(button).parents('.row:first').find('#medtl-qas-contaner-'+_mday_id+'-'+$(button).data('medtlid') + ' .medtl-qas-status-name').html($('#status_request_sent').data('status_text'));

                                $(button).parents('.row:first').find('#sent-request-date-'+_mday_id+'-'+$(button).data('medtlid')).text(_todays_date);

                                if ($('#usr-data-holder').length > 0) {
                                    $(button).parents('.row:first').find('#sent-request-date-'+_mday_id+'-'+$(button).data('medtlid')).next('.sent-request-pic').text($('#usr-data-holder').data('user_name'));
                                }

                                $(button).parents('.row:first').find('#sent-reply-date-'+_mday_id+'-'+$(button).data('medtlid')).text('');
                                //$(button).parents('.row:first').find('.fa-comment-o').hide();
                            }
                            else {
                                location.reload();
                            }

                            $('.already-filtered .day_bulk_check:checked').each(function(){
                                $(this).parents('.row-me-days:first').find('.sent-request-date').text(_todays_date);
                                $(this).parents('.row-me-days:first').find('.fa-comment-o').hide();
                            });

                            setTimeout(function(){
                                $('#invitationToLecturer .close.close-modal').click();
                            }, 1500);

                        }

                    }
                });
            }, 3000);



        });
    }

});


function getEmailByCode(email_code, showEmailContent = true)
{

    $.ajax({
        url: $('#get_email_by_code').data('url'),
        method: 'POST',
        data: {'code': email_code},
        success: function(data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {
                $('#s_messages_templates').html('');
                $('#invitationToLecturer #email_subject').val(data.subject);
                $('#invitationToLecturer #email_body').val(data.body);

                if (typeof data.messages != 'undefined' && data.messages.length > 0) {

                    for (var xx = 0; xx < data.messages.length; xx++) {

                        $('#s_messages_templates').append('<option '+(email_code == data.messages[xx].code ? 'selected' : '')+' title="'+data.messages[xx].contents+'" value="'+data.messages[xx].code+'">'+data.messages[xx].title+'</option>');

                    }

                }

                $('#invitationToLecturer .meeb_text').html(data.body.replace(/([^>])\n/g, '$1<br/>'));
                $('#invitationToLecturer .mees_text').text(data.subject);


                $('.spinner-container').hide();

                if (showEmailContent == true) {
                    $('#invitationToLecturer .me_email_content').addClass('active');
                }


            }

        }
    });

}

// change of the message in the request to lecturer popup
$(document).on('change', '#s_messages_templates', function() {
    getEmailByCode($(this).val(), false);

});

function setEmailByCode(email_code)
{

    // set current subject text to selected messages templates option
    $($('#s_messages_templates option[value="'+email_code+'"]')).text($('#invitationToLecturer #email_subject').val());

    $.ajax({
        url: $('#set_email_by_code').data('url'),
        method: 'POST',
        data: {'code': email_code, 'subject': $('#invitationToLecturer #email_subject').val(), 'body': $('#invitationToLecturer #email_body').val()},
        success: function(data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                $('.email-save-success').text(data.success).css({'display': 'inline-block'});

                $('#invitationToLecturer .meeb_text').html($('#invitationToLecturer #email_body').val().replace(/([^>])\n/g, '$1<br/>'));
                $('#invitationToLecturer .mees_text').text($('#invitationToLecturer #email_subject').val());



                $('.me_email_editable_content .spinner-container').hide();

                setTimeout(function(){
                    //$('#invitationToLecturer .email-content-header .fa').click();
                }, 1500);

            }

        }
    });

}

/************************ Status Comment Popover**************************/

$('.quick-assign_status .fa-comment-o').popover();

/************************************************************************/

/*********************** Day Topic Auto-complete ****************************/

var w_r_timer;
$(document).on("keyup", '.day-topic-search', function(){

    $('.day-topic-results').html('').hide();

    //$('.topic-lecturers-container').hide();
    //$('.topic-lecturers-container').html('');

    var _topic_name = $(this).val();
    //console.log(_topic_name);

    w_r_timer && clearTimeout(w_r_timer);

    w_r_timer = setTimeout(function() {

        $.ajax({
            url: $('#get_possible_day_topics').data('url'),
            method: 'POST',
            data: {'topic_name': _topic_name},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    console.log(data.topics_lecturers);

                    var _dt_results = '';

                    for (var med_id in data.topics_lecturers) {

                        _dt_results += '<div class="med-container">';

                        _dt_results += '<div class="result-day" id="result-day-'+med_id+'">'+data.topics_lecturers[med_id]['day'].name+'</div><div class="tlp-container">';

                        for (var _lecturer_id in data.topics_lecturers[med_id].lecturers) {

                            _dt_results += '<div class="topic_lecturers_parent"><a href="javascript:void(0);" class="topic_lecturers" id="topic_lecturers_'+_lecturer_id+'">'+data.topics_lecturers[med_id].lecturers[_lecturer_id]+'</a></div>';

                        }

                        _dt_results += '</div></div>';

                    }

                    $('.day-topic-results').html(_dt_results).show();

                }

                $(document).on('click', '.result-day', function(e) {

                    $('.day-topic-search').val($(this).text().trim());

                    var _new_lecturers_html = $(this).next('.tlp-container').html();

                    $('.topic-lecturers-container .topic_lecturers_parent').remove();

                    $('.topic-lecturers-container').append(_new_lecturers_html);

                    $('.day-topic-results').html('').hide();

                });

            }
        });

    }, 250);

});

/*********************** Day Topic Auto-complete End ************************/

/*********************** Quick Activation of Module Event *******************/

$(document).on('change', '.me-active', function() {

    var module_event_id = $(this).attr('id').replace('me-active-', '');

    var current_value =  $(this).val();

    console.log('module_event_id');
    console.log(module_event_id);
    console.log('current_value');
    console.log(current_value);

    if (current_value == 3) { // if special status

        $(this).next('.special_status_text').show();
        $(this).parent().find('.sst-input').focus();

    }
    else { // any other status

        $(this).next('.special_status_text').hide();

        if ($(this).parents('#universalModal:first').length == 1) {
            return false;
        }

        $.ajax({
            url: $('#change_active').data('url'),
            method: 'POST',
            data: {'module_event_id': module_event_id, 'active': current_value},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



                }

            }
        });
    }

});

$(document).off('input.sst-input');
$(document).on('blur', 'input.sst-input', function() {

    var module_event_id = $(this).data('moduleeventid');
    var _active = $(this).data('active');

    if (module_event_id != '') {

        if ($(this).parents('#universalModal:first').length == 1) {
            return false;
        }

        $.ajax({
            url: $('#change_active').data('url'),
            method: 'POST',
            data: {'module_event_id': module_event_id, 'active': _active, 'special_status_text': $(this).val()},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



                }

            }
        });
    }

});

/*********************** Quick Activation of Module Event End****************/

/*********************** Quick change of date ********************************/

function sendQuicklySelectedData(dataToSend)
{
    $.ajax({
        url: $('#quick_day_change').data('url'),
        method: 'POST',
        data: dataToSend,
        success: function(data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {


            }

        }
    });
}



function addLecturerToModuleEventDay(_current_quick_assign_cell) {

    var _html_to_insert = $('.all-lecturers-content').html();

    var _module_event_day_id = $(_current_quick_assign_cell).parents('.row-me-days:first').attr('id').replace('row-me-days-','');

    $(_current_quick_assign_cell).find('.existing_lecturer_content').hide();
    $(_current_quick_assign_cell).find('.qaln_select_holder').html(_html_to_insert);


    $(_current_quick_assign_cell).find('.quick-lecturer-pick').change(function(){

        var _new_lect_id = $(this).val();
        var _new_lect_name = $(this).find('option:not(.option-not-use):selected').text();
        /*console.log('opt text');
        console.log($(this).find('option:not(.option-not-use):selected').text());*/

        $(_current_quick_assign_cell).find('.existing_lecturer_content .lecturer_now_container').append('<div id="lecturer_now_'+_new_lect_id+'" class="lecturer_now"><input class="day_bulk_check" type="checkbox" name="day_bulk[]" id="day_bulk_"/><span class="ln_txt">'+_new_lect_name+'</span> <i class="remove_lecturer_from_day" data-lecturerid="' + _new_lect_id + '" data-medid="' + _module_event_day_id + '" ></i></div>');

        $(_current_quick_assign_cell).find('.quick-lecturer-pick').remove();

        $(_current_quick_assign_cell).find('.existing_lecturer_content').show();

        sendQuicklySelectedData({'day_id': $(_current_quick_assign_cell).parents('.row-me-days:first').attr('id').replace('row-me-days-',''), 'new_lecturer_id': _new_lect_id});

        setTimeout(function(){
            location.reload();
        },1200);


    });
}

$(document).on('click', '.lnc-module-event-day-id', function() {

    var _parent_cell = $(this).parents('.quick-assign_lecturer_name:first');

    addLecturerToModuleEventDay(_parent_cell);

});

$(document).on('dblclick', '.medtl-qas-contaner', function() {

    if ($('.container-of-module-events').hasClass('show-archived')) {
        return false;
    }

    if ($(this).hasClass('lec-archived')) {
        return false;
    }
    var _current_quick_assign_status_id_div = this;
    var _qad_text = $(this).text().trim();
    var _day_and_medtl = $(this).attr('id').replace('medtl-qas-contaner-', '');
    var aDayAndMedtl = _day_and_medtl.split('-');
    var _m_e_day_id = aDayAndMedtl[0];
    var _medtl_id = aDayAndMedtl[1];
    var _lect_id = $(this).data('lecturerid');

    console.log('_m_e_day_id');
    console.log(_m_e_day_id);

    console.log('_lect_id');
    console.log(_lect_id);
    $(this).find('.quick-lecturer-status-pick').remove();
    var _html_to_insert = $('.all-lecturers-statuses-content').html();

    $(this).find('.medtl-qas-status-name').text('');

    $(this).append(_html_to_insert);

    var _selected_option_id = '';


    $(this).find('.quick-lecturer-status-pick option').each(function() {

        if ($(this).text().trim().indexOf(_qad_text) != -1) {
            //console.log('equal');
            _selected_option_id = $(this).attr('value');
        }

    });

    $(this).find('.quick-lecturer-status-pick').val(_selected_option_id);

    $(this).find('.quick-lecturer-status-pick').change(function(){

        var _new_lect_status_id = $(this).val();

        $(_current_quick_assign_status_id_div).find('.medtl-qas-status-name').text($(this).find('option:not(.option-not-use):selected').text());

        $(this).remove();

        sendQuicklySelectedData({'day_id': $(_current_quick_assign_status_id_div).parents('.row-me-days:first').attr('id').replace('row-me-days-',''), 'new_lecturer_status_id': _new_lect_status_id, 'lecturer_id': _lect_id});

    });

});

$(document).off('dblclick', '.quick-assign');
$(document).on('dblclick', '.quick-assign', function(){

    if ($('.container-of-module-events').hasClass('show-archived')) {
        return false;
    }

    var _current_quick_assign_cell = this;
    console.log('_current_quick_assign_cell 1');
    console.log(_current_quick_assign_cell);
    var _qad_text = $(_current_quick_assign_cell).text().trim();
    var _html_to_insert = '';

    var _day_id_ = $(_current_quick_assign_cell).parents('.row-me-days:first').attr('id').replace('row-me-days-','');

    var _module_event_day_id = $(this).parents('.row-me-days:first').attr('id').replace('row-me-days-','');

    if ($(_current_quick_assign_cell).hasClass('quick-assign_location')) {

        _html_to_insert = '<input class="quick-input-location" id="quick-input-location-'+_day_id_+'" name="" type="text" value="'+ _qad_text +'">';
        $(_current_quick_assign_cell).html(_html_to_insert);

        $('#quick-input-location-'+_day_id_).focus();

        $(document).off('blur', '#quick-input-location-'+_day_id_);
        $(document).on('blur', '#quick-input-location-'+_day_id_, function(){

            sendQuicklySelectedData({'day_id': _module_event_day_id, 'location': $(this).val().trim()});

            $(_current_quick_assign_cell).html($(this).val().trim());

        });

    }

    if ($(_current_quick_assign_cell).hasClass('quick-assign_time')) {

        _qad_text = $(_current_quick_assign_cell).find('.qat-time').text().trim();

        var _qad_time_comment = $(_current_quick_assign_cell).find('.qat-time-comment').text().trim();

        $('#modalStartTime .btn-save-me-time').attr('id', 'btn-save-me-time-'+_day_id_);

        //all-unique-times
        $('#getModalStartTime').click();

        $('#modalStartTime .current-me-name').text($(_current_quick_assign_cell).parents('.row-me-days:first').find('.quick-assign_name').text().trim());

        _html_to_insert = '<div class="quick-time-container"><input type="text" value="'+_qad_text+'" id="quick-med-time-input"/><br><input placeholder="'+$('#comment_text').data('text')+'" type="text" value="'+_qad_time_comment+'"  id="quick-med-time-comment-input"/></div>';

        // add autocomplete
        _html_to_insert += $('.all-unique-times-container').html();

        //$(_current_quick_assign_cell).html(_html_to_insert);
        //$(_all_unique_items_html).appendTo(this);
        $('#modalStartTime .modal-body').html(_html_to_insert);

        $('#modalStartTime .all-unique-times').show();

       /* $(_current_quick_assign_cell).find('#quick-med-time-input').focus(function(){
            $('.all-unique-times').show();
        });*/



        $(document).off('#btn-save-me-time-'+_day_id_);
        $(document).on('click', '#btn-save-me-time-'+_day_id_, function() {
            //$(this).removeAttr('id');
            console.log('_day_id_');
            console.log(_day_id_);
console.log('_current_quick_assign_cell4');
console.log(_current_quick_assign_cell);
            //$('.all-unique-times').hide();

            $(_current_quick_assign_cell).find('.qat-time').html($('#quick-med-time-input').val());
            $(_current_quick_assign_cell).find('.qat-time-comment').html($('#quick-med-time-comment-input').val());

            sendQuicklySelectedData({'day_id': _day_id_, 'start_time': $('#quick-med-time-input').val(), 'start_time_comment': $('#quick-med-time-comment-input').val()});

            $('#modalStartTime .close.close-modal').click();
console.log('checkIfNeedToSwitchDaysOrder 1');
            checkIfNeedToSwitchDaysOrder();
        });

        $('#modalStartTime .all-unique-times .med-unique-time').click(function(e){

            if ($(e.target).hasClass('mut-remove')) {

                var _alunti_class = $(e.target).data('alunticlass');
                localStorage.setItem(_alunti_class, 1);
                $('.'+_alunti_class).hide();

                return false;
            }

            $('#modalStartTime').find('#quick-med-time-input').val($(this).text().trim());

        });

        $('#modalStartTime').find('#quick-med-time-input').focus();

    }

    if ($(_current_quick_assign_cell).hasClass('quick-assign_date')) {

        var previously_chosen_date = localStorage.getItem('previously_chosen_date');

        console.log('previously_chosen_date zz');
        console.log(previously_chosen_date);

        if (typeof previously_chosen_date != 'undefined' && previously_chosen_date != '' && previously_chosen_date != null && _qad_text == '') {
            _qad_text = previously_chosen_date;
        }

        if ($(this).hasClass('same-day') && $(this).data('same_day') != '') {

            _qad_text = $(this).data('same_day');

        }
        $(this).addClass('day-changed');

        //console.log('_qad_text');
        //console.log(_qad_text);

        _html_to_insert = '<input type="text" value="'+_qad_text+'" id="quick-date-input"/>';
        $(this).html(_html_to_insert);

    }
    if ($(_current_quick_assign_cell).hasClass('quick-assign_lecturer_name')) {


        addLecturerToModuleEventDay(this);


    }

    $( "#quick-date-input" ).datepicker({
        dateFormat: 'dd.mm.yy',
        prevText: '&#x3c;zur?ck', prevStatus: '',
        prevJumpText: '&#x3c;&#x3c;', prevJumpStatus: '',
        nextText: 'Vor&#x3e;', nextStatus: '',
        nextJumpText: '&#x3e;&#x3e;', nextJumpStatus: '',
        currentText: 'heute', currentStatus: '',
        todayText: 'heute', todayStatus: '',
        clearText: '-', clearStatus: '',
        closeText: 'schließen', closeStatus: '',
        monthNames: ['Januar','Februar','März','April','Mai','Juni', 'Juli','August','September','Oktober','November','Dezember'],
        monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun', 'Jul','Aug','Sep','Okt','Nov','Dez'],
        dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
        dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        onClose: function(selectedDate) {

            localStorage.setItem('previously_chosen_date', selectedDate);
            $(_current_quick_assign_cell).text(selectedDate);
            $( "#quick-date-input" ).datepicker( "destroy").remove();

            var quick_assign_time = $(_current_quick_assign_cell).parents('.row:first').find('.quick-assign_time').text().trim();

            if (quick_assign_time == '') {
                var default_time = '09.00 - 17.00';
                sendQuicklySelectedData({'day_id': $(_current_quick_assign_cell).parents('.row-me-days:first').attr('id').replace('row-me-days-',''), 'start_time': default_time});

                $(_current_quick_assign_cell).parents('.row:first').find('.quick-assign_time').text(default_time);
            }

            sendQuicklySelectedData({'day_id': $(_current_quick_assign_cell).parents('.row-me-days:first').attr('id').replace('row-me-days-',''), 'new_date': selectedDate});

            if ($('.module-event .row-me-days').length > 0) {
                determineLecturerDateCollisions();
            }

        }
    }).datepicker( "show" );

});
/*********************** Quick change of date End*****************************/


/*********************** Front Custom Tabs *****************************/
/*
if ($('#custom-tabs').length > 0) {
    $('#custom-tabs').tabs();
}

$(document).on('mouseover', '.scheduler-day-toggle', function(){



});*/


//Put module events names into table cells

setTimeout(function() {

    $('.mnd-values').each(function(index){

        index = parseInt(index)+1;
        var modules_events_hash = $(this).data('modules_events_hash');
        var modulename = $(this).data('modulename');
        var module_id = $(this).data('moduleid');
        var moduledescription = $(this).data('moduledescription');
        var _popover_html_planner = '<div class="popover" role="tooltip"><div class="arrow me"></div><h3 class="popover-header me"></h3><div class="popover-body me"></div></div>';

        var _0_50_color = $('.invisible_0_50_color').data('_0_50_color');
        var _50_80_color = $('.invisible_50_80_color').data('_50_80_color');
        var _80_100_color = $('.invisible_80_100_color').data('_80_100_color');


        console.log('_0_50_color');
        console.log(_0_50_color);
        console.log('_50_80_color');
        console.log(_50_80_color);
        console.log('_80_100_color');
        console.log(_80_100_color);

        var _aEventsTmpData = modules_events_hash.split(',');

        if (_aEventsTmpData.length > 0) {

            for (var aa = 0; aa < _aEventsTmpData.length; aa++) {

                var _aModuleEventCellsAndName = _aEventsTmpData[aa].split('_');

                if (_aModuleEventCellsAndName.length > 0) {

                    var _start_cell = parseInt(_aModuleEventCellsAndName[0]);
                    var _end_cell = parseInt(_aModuleEventCellsAndName[1]);
                    var _me_name = _aModuleEventCellsAndName[2];
                    var _me_id = _aModuleEventCellsAndName[3];
                    var _me_not_bookable = _aModuleEventCellsAndName[4];
                    var mnd_year = _aModuleEventCellsAndName[5];

                    var _capacity_text = '';
                    var _max_capacity = '';
                    var _actual_capacity = '';
                    var _percents_background = '';

                    if ($('.admin-real-events').length > 0) {

                        _max_capacity = _aModuleEventCellsAndName[6];
                        _actual_capacity = _aModuleEventCellsAndName[7];

                        if (typeof _max_capacity != 'undefined' && typeof _actual_capacity != 'undefined' && _max_capacity != '0' && _actual_capacity != '0') {

                            _max_capacity = parseInt(_max_capacity);
                            _actual_capacity = parseInt(_actual_capacity);

                            console.log('_max_capacity');
                            console.log(_max_capacity);
                            console.log('_actual_capacity');
                            console.log(_actual_capacity);

                            var _one_percent = _max_capacity / 100;
                            var _actual_percents = parseInt(_actual_capacity / _one_percent);

                            // determine color
                            if (_actual_percents) {

                                var __back_color = '';

                                if (_actual_percents > 0 && _actual_percents <= 50) {
                                    __back_color = _0_50_color;
                                }
                                if (_actual_percents > 50 && _actual_percents <= 80) {
                                    __back_color = _50_80_color;
                                }
                                if ((_actual_percents > 80 && _actual_percents <= 100) || _actual_percents > 100) {
                                    __back_color = _80_100_color;
                                }

                                console.log('__back_color');
                                console.log(__back_color);

                                console.log('_actual_percents');
                                console.log(_actual_percents);

                                console.log('_me_id');
                                console.log(_me_id);




                                if (__back_color != '') {

                                    _percents_background = 'background-color:' + __back_color + '!important;width:' + _actual_percents + '%;';

                                    //console.log('<style>#calendar-module-event-' + _me_id + ':before {' + _percents_background + '}</style>');

                                    $('<style>#calendar-module-event-' + _me_id + ':before {' + _percents_background + '}</style>').appendTo('head');
                                }


                            }
//$('.invisible-actualcapacity').data('actualcapacity').trim() + ' / ' + $('.invisible-maxcapacity').data('maxcapacity').trim()


                             _capacity_text = '<div class="capacity-text"><strong>' + $('.invisible-actualcapacity').data('actualcapacity').trim() + ': ' + _actual_capacity  + '<br>' + $('.invisible-maxcapacity').data('maxcapacity').trim() + ': ' + _max_capacity +'</strong></div>';

                        }

                    }




                    var _cell_width = 27;

                    // exclude xxx module events that have this xxx in name
                    if (typeof _me_name != 'undefined' && !_me_name.includes('XXX')) {

                        var _amount_of_cells_to_fill = _end_cell - _start_cell + 1;

                        var _cell_width_pixels = (_cell_width * _amount_of_cells_to_fill) - 1;

                        var _cells_comma_string = '';

                        for (var bb = _start_cell; bb <= _end_cell; bb++) {

                            _cells_comma_string += (_cells_comma_string == '' ? '' : ' ') + 'data-chosencell' + bb + '="'+bb+'"';

                        }

/*console.log('_amount_of_cells_to_fill');
console.log(_amount_of_cells_to_fill);*/

                        var _content_of_event_cells = '<div data-rowindex="'+index+'" data-colindex="'+_start_cell+'" class="content-of-event-cell '+(_me_not_bookable == 1 ? 'inactive-event' : '')+' apply-popover-tmp" data-moduleid="'+module_id+'" id="calendar-module-event-'+_me_id+'" style="width: '+(_amount_of_cells_to_fill > 1 ? _cell_width_pixels + 0 : _cell_width_pixels)+'px;" '+_cells_comma_string+'><span class="_me_name">' + _me_name + '</span></div>';

                        $('#real_events_container_'+mnd_year+' .scheduler-hour.scheduler-active[data-row="'+index+'"][data-col="'+_start_cell+'"]').append(_content_of_event_cells);

                        var final_html = '';
                        if (moduledescription != '') {
                            final_html += '<div>' + moduledescription + '</div>';
                        }
                        if (_capacity_text != '') {
                            final_html += _capacity_text;
                        }

                        $('.apply-popover-tmp').popover({
                            template: _popover_html_planner,
                            content: final_html,
                            title: '<strong>' + modulename + '</strong> ',
                            html: true,
                            trigger: 'hover',
                            placement: 'top',
                            attachment: 'top right',
                            targetAttachment: 'top left',
                            offset: '0px'
                        }).removeClass('apply-popover-tmp');

                    }
                }
            }

            // now go through all rows and determine if we have intersections in the module events in the row

            $('table.real_events').each(function(){

                var curr_table = this;

                $(curr_table).find('tbody tr').each(function(ind){

                    var _ind = parseInt(ind)+1;
                    var _c_row = this;

                    for (var nn = 0; nn < 52; nn++) {

                        if ($(_c_row).find('.content-of-event-cell[data-rowindex="'+_ind+'"][data-chosencell'+nn+'="'+nn+'"]').length > 1) {
                            $(_c_row).find('.content-of-event-cell[data-rowindex="'+_ind+'"][data-chosencell'+nn+'="'+nn+'"]').each(function(kz_ind){

                                $(this).addClass('half-height-block');

                                if (kz_ind > 0) {

                                    $(this).css({'top': '50%'});

                                }

                            });
                        }

                    }

                });

            });

            /*$('.scheduler-day-toggle').each(function(ind){

                var _ind = parseInt(ind)+1;
                var _c_row = $(this).parent();

                for (var nn = 0; nn < 52; nn++) {

                    if ($(_c_row).find('.content-of-event-cell[data-rowindex="'+_ind+'"][data-chosencell'+nn+'="'+nn+'"]').length > 1) {
                        $(_c_row).find('.content-of-event-cell[data-rowindex="'+_ind+'"][data-chosencell'+nn+'="'+nn+'"]').each(function(kz_ind){

                            $(this).addClass('half-height-block');

                            if (kz_ind > 0) {

                                $(this).css({'top': '50%'});

                            }

                        });
                    }

                }

            });*/

            // now show all the m.e. on planner
            $('.content-of-event-cell').show();

        }
    });

}, 1500);

// scroll to chosen module event on front Calendar
function scrollToChosenModuleEvent (calendar_m_e_id) {

    $('.modules_events_for_calendar').scrollTo('#'+calendar_m_e_id,500, {'offset': {'left': -300, 'top': 0}});
    $('.moduleEventToScrollTo').removeClass('moduleEventToScrollTo');


}

// clicks on Planner module events
$(document).on('click', '.content-of-event-cell', function() {

    //console.log('content-of event clicked');

    if ($('.admin-real-events').length > 0) {
        return;
    }

    //console.log('zzz use this event');

    var _module_id = $(this).data('moduleid');
    var _module_event_id = $(this).attr('id').replace('calendar-module-event-', '');

    if ($(this).hasClass('inactive-event') || ($('.calendar-module.active').length >= 2 && !$('#calendar-module-'+ _module_id).hasClass('active'))) {

        console.log('cant use this event');
        return false;
    }

    console.log('_module_event_id');
    console.log(_module_event_id);

    if ($(this).hasClass('active')) {

        console.log('m.e active');
        console.log('then deactivate all');

        $('#calendar-module-' + _module_id).click().removeClass('with-active-me');

    }
    else {

        var _parent_module = $('#calendar-module-'+_module_id);

        // deactivate all other events of this module because we can only have one
        /*$(this).parents('tr:first').find('.content-of-event-cell').each(function() {
            $(this).removeClass('active');
        });

        $(_parent_module).parents('tr:first').find('.content-of-event-cell').each(function() {
            $(this).removeClass('active');
        });*/

        $('.content-of-event-cell[data-moduleid="'+_module_id+'"]').each(function(){
            $(this).removeClass('active');
        });


        $(this).addClass('active moduleEventToScrollTo');
        $(_parent_module).addClass('with-active-me');

        // if module active, then we activate and this m.e.
        if (!$(_parent_module).hasClass('active')) {
            $(_parent_module).click();
        }

        setTimeout(function() {

            $('.module_events_ids_checkbox[data-meid="'+_module_event_id+'"]').parents('.info-me:first').find('.module_events_ids_checkbox').each(function(){

                $(this).next('.front-me-name').removeClass('active');
                $(this).next().next('.front-me-days').slideUp("slow");
                $(this).prop('checked', false);

            });

            $('.module_events_ids_checkbox[data-meid="'+_module_event_id+'"]').next('.front-me-name').addClass('active');
            $('.module_events_ids_checkbox[data-meid="'+_module_event_id+'"]').next().next('.front-me-days').slideDown("slow");
            $('.module_events_ids_checkbox[data-meid="'+_module_event_id+'"]').prop('checked', true);

        }, 550);

    }

});

// click on Planner modules will automatically click on Modules tab modules
$(document).on('click', '.calendar-module', function() {

    console.log('calendar-module clicked');

    var _module_id = $(this).attr('id').replace('calendar-module-', '');

    console.log('_module_id dda');
    console.log(_module_id);

    $('.entity-module-'+_module_id).click();

    $('.module_events_ids_checkbox[data-memoduleid="'+_module_id+'"]').each(function() {
        $(this).next('.front-me-name').removeClass('active');
        $(this).next().next('.front-me-days').slideUp("slow");

    });



});

/*********************** Front Custom Tabs End *****************************/

$('.c-tab').click(function() {


    /*console.log(parseInt($(window).innerWidth()));
    console.log($(this).attr('id'));*/

    if (parseInt($(window).innerWidth()) <= 480 && $(this).attr('id') == 'c-tab-planner') {

        $(this).removeClass('tab-active').blur();

        $('#go-to-desktop-version').show();

        setTimeout(function() {
            $('#go-to-desktop-version').hide();
        }, 3000);

        return false;
    }




    $('.separately-visible-items').hide();
    $('.c-tab').removeClass('tab-active');
    $(this).addClass('tab-active');

    var _current_clicked_tab = $(this).attr('id').replace('c-tab-', '');

    $('.' + _current_clicked_tab + '-visible').show();

    if (_current_clicked_tab == 'planner') {

        $('#card-front-info-1, #card-front-info-2').hide();

        $('.row.course-info-row').addClass('no-padding-top');
        $('.card.card-front-courses').addClass('no-borders');
        $('.card-front-modules').addClass('heightAutoImportant');

        correctionsToModulesAndPlanner();

    }
    else {

        $('.row.course-info-row').removeClass('no-padding-top').show();
        $('.card.card-front-courses').removeClass('no-borders');
        $('#card-front-info-1, #card-front-info-2').show().removeClass('hideImportant');
        $('#modules-and-planner-column').attr('class', 'col-md-4');
        $('.card-front-courses').parent().attr('class', 'col-md-8');
        $('.card-front-modules').removeClass('heightAutoImportant');
        $('#usr-data-1, #usr-data-2').removeClass('width-100-percents');
    }

});

/******************************** Expanded Planner ***************************************/
$('.expand-planner').click(function(){
    $('#modules-and-planner-column').addClass('expanded-planner');
    $(this).hide();
    $('.collapse-planner').show();
});
$('.collapse-planner').click(function(){
    $('#modules-and-planner-column').removeClass('expanded-planner');
    $(this).hide();
    $('.expand-planner').show();
});


setTimeout(function(){
    $('#front-flash-messages').html('');
}, 12000);


(function($) {

    "use strict";

    var pluginName = "multiSelect",
        defaults = {
            'containerHTML': '<div class="multi-select-container">',
            'menuHTML': '<div class="multi-select-menu">',
            'buttonHTML': '<span class="multi-select-button">',
            'menuItemsHTML': '<div class="multi-select-menuitems">',
            'menuItemHTML': '<label class="multi-select-menuitem">',
            'presetsHTML': '<div class="multi-select-presets">',
            'modalHTML': undefined,
            'menuItemTitleClass': 'multi-select-menuitem--titled',
            'activeClass': 'multi-select-container--open',
            'noneText': '-- Select --',
            'allText': undefined,
            'presets': undefined,
            'positionedMenuClass': 'multi-select-container--positioned',
            'positionMenuWithin': undefined,
            'viewportBottomGutter': 20,
            'menuMinHeight': 200
        };

    /**
     * @constructor
     */
    function MultiSelect(element, options) {
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    function arraysAreEqual(array1, array2) {
        if ( array1.length != array2.length ){
            return false;
        }

        array1.sort();
        array2.sort();

        for ( var i = 0; i < array1.length; i++ ){
            if ( array1[i] !== array2[i] ){
                return false;
            }
        }

        return true;
    }

    $.extend(MultiSelect.prototype, {

        init: function() {
            this.checkSuitableInput();
            this.findLabels();
            this.constructContainer();
            this.constructButton();
            this.constructMenu();
            this.constructModal();

            this.setUpBodyClickListener();
            this.setUpLabelsClickListener();

            this.$element.hide();
        },

        checkSuitableInput: function(text) {
            if ( this.$element.is('select[multiple]') === false ) {
                throw new Error('$.multiSelect only works on <select multiple> elements');
            }
        },

        findLabels: function() {
            this.$labels = $('label[for="' + this.$element.attr('id') + '"]');
        },

        constructContainer: function() {
            this.$container = $(this.settings['containerHTML']);
            this.$element.data('multi-select-container', this.$container);
            this.$container.insertAfter(this.$element);
        },

        constructButton: function() {
            var _this = this;
            this.$button = $(this.settings['buttonHTML']);
            this.$button.attr({
                'role': 'button',
                'aria-haspopup': 'true',
                'tabindex': 0,
                'aria-label': this.$labels.eq(0).text()
            })
                .on('keydown.multiselect', function(e) {
                    var key = e.which;
                    var returnKey = 13;
                    var escapeKey = 27;
                    var spaceKey = 32;
                    var downArrow = 40;
                    if ((key === returnKey) || (key === spaceKey)) {
                        e.preventDefault();
                        _this.$button.click();
                    } else if (key === downArrow) {
                        e.preventDefault();
                        _this.menuShow();
                        var group = _this.$presets || _this.$menuItems;
                        group.children(":first").focus();
                    } else if (key === escapeKey) {
                        _this.menuHide();
                    }
                }).on('click.multiselect', function(e) {
                    _this.menuToggle();
                })
                .appendTo(this.$container);

            this.$element.on('change.multiselect', function() {
                _this.updateButtonContents();
            });

            this.updateButtonContents();
        },

        updateButtonContents: function() {
            var _this = this;
            var options = [];
            var selected = [];

            this.$element.find('option').each(function() {
                var text = /** @type string */ ($(this).text());
                options.push(text);
                if ($(this).is(':selected')) {
                    selected.push( $.trim(text) );
                }
            });

            this.$button.empty();

            if (selected.length == 0) {
                this.$button.text( this.settings['noneText'] );
            } else if ( (selected.length === options.length) && this.settings['allText']) {
                this.$button.text( this.settings['allText'] );
            } else {
                this.$button.text( selected.join(', ') );
            }
        },

        constructMenu: function() {
            var _this = this;

            this.$menu = $(this.settings['menuHTML']);
            this.$menu.attr({
                'role': 'menu'
            }).on('keyup.multiselect', function(e){
                var key = e.which;
                var escapeKey = 27;
                if (key === escapeKey) {
                    _this.menuHide();
                    _this.$button.focus();
                }
            })
                .appendTo(this.$container);

            this.constructMenuItems();

            if ( this.settings['presets'] ) {
                this.constructPresets();
            }
        },

        constructMenuItems: function() {
            var _this = this;

            this.$menuItems = $(this.settings['menuItemsHTML']);
            this.$menu.append(this.$menuItems);

            this.$element.on('change.multiselect', function(e, internal) {
                // Don't need to update the menu items if this
                // change event was fired by our tickbox handler.
                if(internal !== true){
                    _this.updateMenuItems();
                }
            });

            this.updateMenuItems();
        },

        updateMenuItems: function() {
            var _this = this;
            this.$menuItems.empty();

            this.$element.children('optgroup,option').each(function(index, element) {
                var $item;
                if (element.nodeName === 'OPTION') {
                    $item = _this.constructMenuItem($(element), index);
                    _this.$menuItems.append($item);
                } else {
                    _this.constructMenuItemsGroup($(element), index);
                }
            });
        },

        upDown: function(type, e) {
            var key = e.which;
            var upArrow = 38;
            var downArrow = 40;

            if (key === upArrow) {
                e.preventDefault();
                var prev = $(e.currentTarget).prev();
                if (prev.length) {
                    prev.focus();
                } else if (this.$presets && type === 'menuitem') {
                    this.$presets.children(':last').focus();
                } else {
                    this.$button.focus();
                }
            } else if (key === downArrow) {
                e.preventDefault();
                var next = $(e.currentTarget).next();
                if (next.length || type === 'menuitem') {
                    next.focus();
                } else {
                    this.$menuItems.children(':first').focus();
                }
            }
        },

        constructPresets: function() {
            var _this = this;
            this.$presets = $(this.settings['presetsHTML']);
            this.$menu.prepend(this.$presets);

            $.each(this.settings['presets'], function(i, preset){
                var unique_id = _this.$element.attr('name') + '_preset_' + i;
                var $item = $(_this.settings['menuItemHTML'])
                    .attr({
                        'for': unique_id,
                        'role': 'menuitem'
                    })
                    .text(' ' + preset.name)
                    .on('keydown.multiselect', _this.upDown.bind(_this, 'preset'))
                    .appendTo(_this.$presets);

                var $input = $('<input>')
                    .attr({
                        'type': 'radio',
                        'name': _this.$element.attr('name') + '_presets',
                        'id': unique_id
                    })
                    .prependTo($item);

                $input.on('change.multiselect', function(){
                    _this.$element.val(preset.options);
                    _this.$element.trigger('change');
                });
            });

            this.$element.on('change.multiselect', function() {
                _this.updatePresets();
            });

            this.updatePresets();
        },

        updatePresets: function() {
            var _this = this;

            $.each(this.settings['presets'], function(i, preset){
                var unique_id = _this.$element.attr('name') + '_preset_' + i;
                var $input = _this.$presets.find('#' + unique_id);

                if ( arraysAreEqual(preset.options || [], _this.$element.val() || []) ){
                    $input.prop('checked', true);
                } else {
                    $input.prop('checked', false);
                }
            });
        },

        constructMenuItemsGroup: function($optgroup, optgroup_index) {
            var _this = this;

            $optgroup.children('option').each(function(option_index, option) {
                var $item = _this.constructMenuItem($(option), optgroup_index + '_' + option_index);
                var cls = _this.settings['menuItemTitleClass'];
                if (option_index !== 0) {
                    cls += 'sr';
                }
                $item.addClass(cls).attr('data-group-title', $optgroup.attr('label'));
                _this.$menuItems.append($item);
            });
        },

        constructMenuItem: function($option, option_index) {
            var unique_id = this.$element.attr('name') + '_' + option_index;
            var $item = $(this.settings['menuItemHTML'])
                .attr({
                    'for': unique_id,
                    'role': 'menuitem'
                })
                .on('keydown.multiselect', this.upDown.bind(this, 'menuitem'))
                .text(' ' + $option.text());

            var $input = $('<input>')
                .attr({
                    'type': 'checkbox',
                    'id': unique_id,
                    'value': $option.val()
                })
                .prependTo($item);

            $('<span class="checkmark"></span>').insertAfter($input);

            if ( $option.is(':disabled') ) {
                $input.attr('disabled', 'disabled');
            }
            if ( $option.is(':selected') ) {
                $input.prop('checked', 'checked');
            }

            $input.on('change.multiselect', function() {
                if ($(this).prop('checked')) {
                    $option.prop('selected', true);
                    $(this).parent().addClass('active-opt');
                } else {
                    $option.prop('selected', false);
                    $(this).parent().removeClass('active-opt');
                }

                // .prop() on its own doesn't generate a change event.
                // Other plugins might want to do stuff onChange.
                $option.trigger('change', [true]);
            });

            return $item;
        },

        constructModal: function() {
            var _this = this;

            if (this.settings['modalHTML']) {
                this.$modal = $(this.settings['modalHTML']);
                this.$modal.on('click.multiselect', function(){
                    _this.menuHide();
                })
                this.$modal.insertBefore(this.$menu);
            }
        },

        setUpBodyClickListener: function() {
            var _this = this;

            // Hide the $menu when you click outside of it.
            $('html').on('click.multiselect', function(){
                _this.menuHide();
            });

            // Stop click events from inside the $button or $menu from
            // bubbling up to the body and closing the menu!
            this.$container.on('click.multiselect', function(e){
                e.stopPropagation();
            });
        },

        setUpLabelsClickListener: function() {
            var _this = this;
            this.$labels.on('click.multiselect', function(e) {
                e.preventDefault();
                e.stopPropagation();
                _this.menuToggle();
            });
        },

        menuShow: function() {
            $('html').trigger('click.multiselect'); // Close any other open menus
            this.$container.addClass(this.settings['activeClass']);

            if ( this.settings['positionMenuWithin'] && this.settings['positionMenuWithin'] instanceof $ ) {
                var menuLeftEdge = this.$menu.offset().left + this.$menu.outerWidth();
                var withinLeftEdge = this.settings['positionMenuWithin'].offset().left +
                    this.settings['positionMenuWithin'].outerWidth();

                if ( menuLeftEdge > withinLeftEdge ) {
                    this.$menu.css( 'width', (withinLeftEdge - this.$menu.offset().left) );
                    this.$container.addClass(this.settings['positionedMenuClass']);
                }
            }

            var menuBottom = this.$menu.offset().top + this.$menu.outerHeight();
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if ( menuBottom > viewportBottom - this.settings['viewportBottomGutter'] ) {
                this.$menu.css({
                    'maxHeight': Math.max(
                        viewportBottom - this.settings['viewportBottomGutter'] - this.$menu.offset().top,
                        this.settings['menuMinHeight']
                    ),
                    'overflow': 'scroll'
                });
            } else {
                this.$menu.css({
                    'maxHeight': '',
                    'overflow': ''
                });
            }
        },

        menuHide: function() {
            this.$container.removeClass(this.settings['activeClass']);
            this.$container.removeClass(this.settings['positionedMenuClass']);
            this.$menu.css('width', 'auto');
        },

        menuToggle: function() {
            if ( this.$container.hasClass(this.settings['activeClass']) ) {
                this.menuHide();
            } else {
                this.menuShow();
            }
        }

    });

    $.fn[ pluginName ] = function(options) {
        return this.each(function() {
            if ( !$.data(this, "plugin_" + pluginName) ) {
                $.data(this, "plugin_" + pluginName,
                    new MultiSelect(this, options) );
            }
        });
    };

})(jQuery);


$('#combobox4_id').multiSelect({
    noneText: '',
    menuItemHTML: '<label class="multi-select-menuitem"></label>'
});


function parseUrlAndMakeModulesActive() {

    console.log('parseUrlAndMakeModulesActive');
    // http://cas.int/de?modules=1,2&course=2
    var _current_url = location.href;

    if (_current_url.indexOf('modules=') != -1 || _current_url.indexOf('courses=') != -1) {

        var url = new URL(_current_url);
        var _modules = url.searchParams.get('modules');

        console.log('_modules');
        console.log(_modules);

        var _courses = url.searchParams.get('courses');

        console.log('_courses');
        console.log(_courses);
        // if we make only course click
        if (_current_url.indexOf('cm=1') != -1) {

            setTimeout(function() {
                $('.entity-course-'+_courses).click();
            }, 1500);

        }
        else { // for modules cick
            if (typeof _modules != 'undefined' && _modules != null) {

                var _modulesArray = _modules.split(',');
                var _coursesArray = _courses.split(',');

                if (typeof _modulesArray != 'undefined' && _modulesArray.length > 0) {

                    //$('#calendar-module-'+_modulesArray[0]).addClass('speciality-'+_modulesArray[0]).click();

                    console.log('parseUrlAndMakeModulesActive 1');

                    $.each(_modulesArray, function(indx, module_id){

                        var delay = indx * 400;

                        console.log('delay 1');
                        console.log(delay);

                        // Use setTimeout to click the button after the delay
                        setTimeout(function() {
                            $('.entity-module-' + module_id).click();
                            console.log('.entity-module-' + module_id + ' clicked');
                        }, delay);

                    });

                    if (_courses.length > 0) {
                        setTimeout(function() {

                            //$('#calendar-module-'+_modulesArray[1]).addClass('speciality-'+_modulesArray[1]).click();

                            console.log('parseUrlAndMakeModulesActive 2');



                            if ($('.front-course.active').length > 1 || $('.front-course.active').length == 0) {
                                console.log('parseUrlAndMakeModulesActive 4');
                                $('.front-course.active.entity-course-'+_courses[0]).click();
                            }



                        }, (_modulesArray.length * 400 + 100));
                    }
                }

            }
        }
    }


}
setTimeout(parseUrlAndMakeModulesActive, 1500);

function putDatesIntoFormStatus3(clickedElement) {

    var column_parent = $(clickedElement).parents('.card-front-info:first');

    var column_parent_num = $(column_parent).attr('id').replace('card-front-info-', '');

    if ($(column_parent).find('.module_events_ids_checkbox:checked').length > 0) {

        var _startdatum = $(column_parent).find('.module_events_ids_checkbox:checked').next('.front-me-name').find('.me-first-date').text().trim();

        $('#chosen_datum'+column_parent_num).val(_startdatum);

        if ($('#chosen_datum1').val() != '' && $('#chosen_datum2').val() != '') {

            var aTmpDate1 = $('#chosen_datum1').val().split('.');
            var aTmpDate2 = $('#chosen_datum2').val().split('.');

            var chosen_datum1_tmp = $('#chosen_datum1').val();
            var chosen_datum2_tmp = $('#chosen_datum2').val();

            var event_name1 = $('#event_name1').val();
            var event_name2 = $('#event_name2').val();

            var chosen_datum1 = aTmpDate1[2] + '-' + aTmpDate1[1] + '-' + aTmpDate1[0];
            var chosen_datum2 = aTmpDate2[2] + '-' + aTmpDate2[1] + '-' + aTmpDate2[0];

            var date1 = new Date(chosen_datum1);
            var date2 = new Date(chosen_datum2);

            console.log('date1');
            console.log(date1);

            console.log('date2');
            console.log(date2);

            if (date1 > date2) {

                $('#chosen_datum1').val(chosen_datum2_tmp);
                $('#chosen_datum2').val(chosen_datum1_tmp);

                $('#event_name1').val(event_name2);
                $('#event_name2').val(event_name1);
            }

        }

    }
    else {
        $('#chosen_datum'+column_parent_num).val('');
    }

}


/*************** Local Storage ****************/
// for front video block
var _theVideoBlockWasShown = localStorage.getItem('video_block_was_shown');
var _theTipsWereShown = localStorage.getItem('tips_were_shown');
var _theMainQuestionsWereShown = localStorage.getItem('main_questions_were_shown');

if (!_theVideoBlockWasShown && _theTipsWereShown && _theMainQuestionsWereShown) {
    localStorage.setItem('video_block_was_shown', 1);
    $('#howItWorks').click();
}

// for admin module events filter
if ($('.me_filter').length > 0) {

    $('.me_filter, .me_main_data_filter').each(function() {

        var _input_id = $(this).attr('id');

        var _adminMeFilterInputVal = localStorage.getItem(_input_id);

        if (_adminMeFilterInputVal) {

            $(this).val(_adminMeFilterInputVal).change().keyup();

        }

    });

}


/****************************** SAVE IN LOCAL STORAGE THE LAST OPENED M.E. *******************************/
$('.expand-me-days').click(function() {

    var chosen_opened_me = $(this).parents('.module-event:first').attr('id').replace('module-event-', '');

    localStorage.setItem('chosen_opened_me', chosen_opened_me);

});

if (localStorage.getItem('chosen_opened_me') !== null) {

    var __chosen_opened_me__ = localStorage.getItem('chosen_opened_me');


    if ($('#module-event-' + __chosen_opened_me__).length > 0) {

        setTimeout(function() {

            $([document.documentElement, document.body]).animate({
                scrollTop: $('#module-event-'+__chosen_opened_me__).offset().top
            }, 1000);

        }, 1000);


        $('#module-event-'+__chosen_opened_me__+':visible').find('.expand-me-days').click();

    }
}

/****************************** SAVE IN LOCAL STORAGE THE LAST OPENED M.E. END ***************************/

// removed times
$(document).on('click', '.mut-remove', function() {

    var _alunti_class = $(this).data('alunticlass');
    localStorage.setItem(_alunti_class, 1);
    $('.'+_alunti_class).hide();
});

// on refresh page we add classes that are hidden, and times with those classes will not be visible
if (localStorage.length > 0) {

    var _custom_styles_ = '<style>';

    for (var i = 0; i < localStorage.length; i++) {

        if (localStorage.key(i).indexOf('alunti') != -1) {
            _custom_styles_ += '.'+localStorage.key(i)+' {display: none;}';
        }

    }
    _custom_styles_ += '</style>';

    $(_custom_styles_).appendTo('head');

}


/*************** Local Storage End ****************/





/*************** TIPS TO USE ****************/
if ($('.start-tips-modals').length > 0) {

    if (parseInt($(window).innerWidth()) <= 768) {
        $('body').append('<div class="front-tipslabel-container"><div class="front-tipslabel">'+$('.invisible-tipslabel').data('tipslabel')+'</div></div>');
    }
    else {
        $('body').prepend('<div class="front-tipslabel-container"><div class="front-tipslabel">'+$('.invisible-tipslabel').data('tipslabel')+'</div></div>');
    }

    if (!_theTipsWereShown && _theMainQuestionsWereShown) {

        localStorage.setItem('tips_were_shown', 1);

        $([document.documentElement, document.body]).animate({
            scrollTop: $('body').offset().top
        }, 1000);

        setTimeout(function(){
            $('.start-tips-modals').click();
        },1000);

    }

    $('.front-tipslabel').click(function() {

        //close video block first
        $('#howItWorks.opened').click();

        if ($(window).scrollTop() > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('body').offset().top
            }, 1000);

            setTimeout(function() {
                $('.start-tips-modals').click();
            }, 1000);
        }
        else {
            $('.start-tips-modals').click();
        }

    });
}

// for Tip 2 modal
$('#tip-2').on('shown.bs.modal', function () {

    $('.tip-2-special-element').addClass('tips-special-element');

    if (parseInt($(window).innerWidth()) > 767) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('body').offset().top
        }, 1000);
    }
    else {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('body').offset().top + 500
        }, 1000);
    }


});
$('#tip-2').on('hidden.bs.modal', function () {
    $('.tip-2-special-element').removeClass('tips-special-element');
});

// for Tip 3 modal
$('#tip-3').on('shown.bs.modal', function () {

    if (parseInt($(window).innerWidth()) > 767) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('body').offset().top
        }, 1000);
    }
    else {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.card-front-courses .tip-3-special-element').offset().top
        }, 1000);
    }


    $('.tip-3-special-element').addClass('tips-special-element');

});
$('#tip-3').on('hidden.bs.modal', function () {
    $('.tip-3-special-element').removeClass('tips-special-element');
});


// for Tip 4 modal

$('#tip-4').on('shown.bs.modal', function () {

    $('.entity-module-2').click();
    $('.entity-module-3').click();

    $('<style id="tmp-you-can-choose">.you-can-choose-other-module{display:none;}</style>').appendTo('head');

    if (parseInt($(window).innerWidth()) > 767) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('body').offset().top + 400
        }, 500);
    }
    else {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.program-info-row').offset().top + 480
        }, 500);
    }

    setTimeout(function() {

        $('#tip-4 .tip-arrow-img').show();
        $('.tip-4-special-element').addClass('tips-special-element');

    },800);

    setTimeout(function() {
        $('#card-front-info-1 input.module_events_ids_checkbox:first').click();
        $('.you-can-choose-other-module').remove();
    },1000);

});

$('#tip-4').on('hidden.bs.modal', function () {
    $('.tip-4-special-element').removeClass('tips-special-element');
    $('.entity-module-2').click();
    $('.entity-module-3').click();
    $('#tip-4 .tip-arrow-img').hide();
    $('#tmp-you-can-choose').remove();
});


// for Tip 5 modal
$('#tip-5').on('shown.bs.modal', function () {

    $('.tip-5-special-element').addClass('tips-special-element');


    if (parseInt($(window).innerWidth()) > 767) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#front-statuses-checkbox-32').offset().top - 350
        }, 1000);
    }
    else {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#front-statuses-checkbox-32').offset().top - 150
        }, 1000);
    }

    setTimeout(function() {
        $('#front-statuses-checkbox-32').click();
    },1000);

});

$('#tip-5').on('hidden.bs.modal', function () {
    $('.tip-5-special-element').removeClass('tips-special-element');
    $('#front-statuses-checkbox-32').click();
});

$('#tip-1, #tip-2, #tip-3, #tip-4, #tip-5, #tip-6').on('shown.bs.modal', function () {
    $('.front-tipslabel').hide();
});
$('#tip-1, #tip-2, #tip-3, #tip-4, #tip-5, #tip-6').on('hidden.bs.modal', function () {
    $('.front-tipslabel').show();
});

/*************** TIPS TO USE END ****************/

/*************** MAIN QUESTIONS ****************/
if ($('.start-main-questions-modals').length > 0) {

console.log('start-main-questions-modals');

    //if (!_theMainQuestionsWereShown) {

        console.log('_theMainQuestionsWereShown 1');

        $([document.documentElement, document.body]).animate({
            scrollTop: $('body').offset().top
        }, 1000);

        setTimeout(function(){
            console.log('_theMainQuestionsWereShown 2');
            $('#tip-1 .close').click();
            $('.start-main-questions-modals').click();

        },1100);

    //}

    $(document).on('click', '#main-questions-modal .form-with-labels input[name="have_courses"]', function() {
        $('.have_courses_form').hide();
        var _current_radio_id = $(this).attr('id');
        $('#'+_current_radio_id + '_form').show();

    });

    $(document).on('click', '#have_no_courses_form button', function() {

        $('#main-questions-modal .close').click();

        localStorage.setItem('main_questions_were_shown', 'no_courses');

    });

    $(document).on('click', '#have_your_courses_form button', function() {

        var _have_courses_array = $('#have_your_courses_select').val();

        if (_have_courses_array.length > 0) {

            $('#have_your_courses_select').next('.multi-select-container').removeClass('error-input');

            localStorage.setItem('main_questions_were_shown', _have_courses_array.join(','));

            $('#main-questions-modal .close').click();

        }
        else {

            $('#have_your_courses_select').parent().find('.multi-select-button').addClass('error-input');

        }

    });

    $(document).on('click', '#have_other_courses_form button', function() {

        var has_errors = false;

        $('#have_other_courses_form input').each(function() {

            if ($(this).attr('id') == 'other_course_certificate') {

                var fileInput = $('#other_course_certificate');
                if (fileInput[0].files.length === 0) {

                    fileInput.addClass('error-input');
                    has_errors = true;

                } else {
                    fileInput.removeClass('error-input');
                }
            }
            else {

                if ($(this).val() == '') {
                    has_errors = true;
                    $(this).addClass('error-input');
                }
                else {
                    $(this).removeClass('error-input');
                }

            }

        });

        if (has_errors == true) {

        }
        else {

            $('#main-questions-modal .close').click();

            localStorage.setItem('main_questions_were_shown', 'have_other');

            $('#have_other_courses_form').submit();
        }


    });

    $(document).on('change', '#have_other_courses_form input', function() {
        if ($(this).attr('id') == 'other_course_certificate') {

            var fileInput = $('#other_course_certificate');
            if (fileInput[0].files.length === 0) {

                fileInput.addClass('error-input');


            } else {
                fileInput.removeClass('error-input');
            }
        }
        else {

            if ($(this).val() == '') {

                $(this).addClass('error-input');
            }
            else {
                $(this).removeClass('error-input');
            }

        }
    });
}
/*************** MAIN QUESTIONS END ****************/

/************** POPOVER FOR MODULE ON FRONT PAGE *******************/

$('.front-module.entities').hover(function() {

    var final_module_hover_html = '';

    if ($(this).find('.front-module-events .front-me-days:first .fmd-container').length > 0) {

        final_module_hover_html = $(this).find('.front-module-events .front-me-days:first .fmd-container').html();

    }

    var _popover_front_module_html = '<div style="height:auto;max-height:initial;top:0;left:auto;right:-350px;width: 350px;max-width: 350px;" class="popover front-module-pvr" role="tooltip"><div class="arrow"></div><h3 class="popover-header"><strong>' + $(this).attr('title') + '</strong></h3><div class="popover-body">' + final_module_hover_html + '</div></div>';

    $(this).append(_popover_front_module_html);

}, function() {
    $('.front-module-pvr').remove();
});

/************** POPOVER FOR MODULE ON FRONT PAGE END ***************/


/******************** GENERAL FILTERS ********************/

// filtered row should have class row-for-filter, column should have class like: r-assign_first_name and input should have id like: r_filter_first_name

function generalFilters() {

    var has_values = false;

    $('.row-for-filter').show().removeClass('r-filtered');

    // special for imported user modules page
    if ($('.row-combo-parent').length > 0) {
        $('.row-combo-parent').show();
    }

    $('.r_filter').each(function() {

        var _current_filter_input = this;
        var _input_important_part_name = $(_current_filter_input).attr('id').replace('r_filter', '');


        if ($(_current_filter_input).val() != '') {

            //console.log($(_current_filter_input).attr('id'));

            has_values = true;

            var _current_value = $(_current_filter_input).val().toLowerCase();

            var _prefix = '';

            if ($('.r-filtered').length > 0) {
                _prefix = '.r-filtered ';
            }

            $(_prefix + '.r-assign'+_input_important_part_name).each(function() {

                var current_cell_t = this;

                var _cell_value = $(this).text().trim().toLowerCase();

                if (_cell_value.indexOf(_current_value) != -1) {

                    $(this).parents('.row-for-filter:first').addClass('r-filtered').show();

                }
                else {

                    $(this).parents('.row-for-filter:first').removeClass('r-filtered').hide();

                }

                // special for imported user modules page
                console.log('combo :visible');
                console.log($(current_cell_t).parents('.row-combo-parent:first').find('.row-combo-body:visible').length);

                if ($('.row-combo-parent').length > 0 && $(current_cell_t).parents('.row-combo-parent:first').find('.row-combo-body:visible').length == 0) {
                    console.log('no visible');
                    $(current_cell_t).parents('.row-combo-parent:first').hide().addClass('hideAdded');
                }


            });

        }

    });

}

$('.r_filter').keyup(function(){

    generalFilters();

});

/******************** GENERAL FILTERS END ********************/

/*********************** ADMIN LECTURER MULTISELECT ***********************/



/*********************** ADMIN LECTURER MULTISELECT END ***********************/
$(document).on('click', '.edit-elem.edit-lecturer, .lecturer_create', function() {

    function transformMultiselect() {

        if ($('.lecturer_m_days_container .multi-select-button').length == 0) {

            $('#lecturer_m_days').multiSelect({
                noneText: '',
                menuItemHTML: '<label class="multi-select-menuitem"></label>'
            });

        }
        else {
            clearInterval(tm_interval);
        }

    }

    var tm_interval = setInterval(transformMultiselect, 1000);

});

/******************** MODULE EVENT DAY EDIT DATEPICKER **********************/
$(document).on('click', '.edit-elem.get-lecturers-assigned-to-topic,.new-module-event-day', function() {

    var _current_date_input =  this;

    function transformToDatePicker() {

        if ($('.module-event-day-date.hasDatepicker').length == 0) {

            $(".module-event-day-date").datepicker({
                dateFormat: 'dd.mm.yy',
                prevText: '&#x3c;zur?ck', prevStatus: '',
                prevJumpText: '&#x3c;&#x3c;', prevJumpStatus: '',
                nextText: 'Vor&#x3e;', nextStatus: '',
                nextJumpText: '&#x3e;&#x3e;', nextJumpStatus: '',
                currentText: 'heute', currentStatus: '',
                todayText: 'heute', todayStatus: '',
                clearText: '-', clearStatus: '',
                closeText: 'schließen', closeStatus: '',
                monthNames: ['Januar','Februar','März','April','Mai','Juni', 'Juli','August','September','Oktober','November','Dezember'],
                monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun', 'Jul','Aug','Sep','Okt','Nov','Dez'],
                dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
                dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
                dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
                onClose: function(selectedDate) {
                    /*
                    var _aCard1FDate = _card_1_first_date.split('.');
                    var _aCard2FDate = _card_2_first_date.split('.');

                    var _a_card_1_f_date_milliseconds = Date.parse(_aCard1FDate[1] + '-' + _aCard1FDate[0] + '-' + _aCard1FDate[2]);*/
                    var _parsedDateArray = [];

                    //console.log(selectedDate);

                    $(_current_date_input).val(selectedDate);
//console.log($('.module-event-day-date.hasDatepicker'));
//console.log($('.module-event-day-date.hasDatepicker').parents('.modal-body:first').find('input[name="start_time"]'));
                    var quick_assign_time = $('.module-event-day-date.hasDatepicker').parents('.modal-body:first').find('input[name="start_time"]').val().trim();

                    if (quick_assign_time == '') {
                        var default_time = '09.00 - 17.00';

                        $('.module-event-day-date.hasDatepicker').parents('.elemContainer:first').find('input[name="start_time"]').val(default_time);
                    }

                    //$('.module-event-day-date').datepicker('destroy').remove();

                }
            });

        }
        else {
            clearInterval(dp_interval);
        }

    }

    var dp_interval = setInterval(transformToDatePicker, 1000);


});

/******************** MODULE EVENT DAY EDIT DATEPICKER END **********************/

/******************** QUICK ASSIGN OF MODULE EVENT DAY TIME IN EDIT POPUP *******************/

$(document).on('click', '.med-unique-time', function(e) {

    console.log(e.target);

    if ($(e.target).hasClass('mut-remove')) {
        return false;
    }

    var _curr_val = $(this).text().trim();

    $(this).parent().find('input[name="start_time"]').val(_curr_val);

});

/******************** QUICK ASSIGN OF MODULE EVENT DAY TIME IN EDIT POPUP END *******************/


/******************** MULTISELECT FOR LOCATIONS IN ADMIN *********************/
if ($('#me_main_data_filter_location').length > 0) {

    $('#me_main_data_filter_location').multiSelect({
        noneText: $('#mem_location_text').data('mem_location_text').trim(),
        menuItemHTML: '<label class="multi-select-menuitem"></label>'
    });

}


/******************** MULTISELECT FOR LOCATIONS IN ADMIN END *********************/

/*document.addEventListener ("keydown", function (zEvent) {
    if (zEvent.ctrlKey  &&  zEvent.altKey) {  // case sensitive
        $('#secret_pdf_button').show();
    }
} );*/

$(document).keydown(function(e){

    if ( e.ctrlKey && ( e.which === 18 ) ) {
        $('#secret_pdf_button').show();
    }

});

/******************** ADMIN MODULE EVENTS PDF *********************/

$('.me-make-pdf').click(function() {

    //empty form
    $('.secret-pdf-form').html('');

    if ($('.me_bulk_check:checked').length > 0) {

        //$('#admin-me-spinner').show();

        $('.me_bulk_check:checked').each(function(){

            var _module_event_id = $(this).attr('id').replace('bulk_','');
            var _module_id = $(this).data('moduleid');

            /*console.log('_module_event_id');
            console.log(_module_event_id);
            console.log('_module_id');
            console.log(_module_id);*/

            $('.secret-pdf-form').append('<input name="module_events_ids['+_module_id+'][]" value="'+_module_event_id+'" type="hidden"/>');

        });

        $('.secret-pdf-form').submit();

        //$('#admin-me-spinner').hide();
    }

});

/******************** ADMIN MODULE EVENTS PDF END *****************/

$('.secret-pdf-form').bind('ajax:complete', function() {

    console.log('submit complete');

});

/*************************** Autoscroll of calendar *****************************/

if ($('.modules_events_for_calendar').length > 0) {

    function calendarAutoscroll() {
        if (parseInt($('div.modules_events_for_calendar').scrollLeft()) == 0 && typeof $('div.modules_events_for_calendar').data('toScroll') != 'undefined') {

            $('div.modules_events_for_calendar').animate({
                scrollLeft: parseInt($('div.modules_events_for_calendar').data('toScroll'))
            }, 800);

        }
    }

    $('#c-tab-planner').click(function(){
        //calendarAutoscroll();
    });

}

/*************************** Autoscroll of calendar end ************************/

// validation of request lecturer status form

$('.lecturer-data-form button[type="submit"]').click(function(e) {

    var __errors = false;
    $('.lecturer-data-form .error-message').hide();

    $('.ldf-inp').removeClass('with-error');
    $('.ldf-inp').each(function(){

        if ($(this).val() == '' || $(this).val() == '0' || $(this).val() == 0) {

            console.log(this);
            console.log($(this).val());
            $(this).addClass('with-error');
            $(this).next('.error-message').show();
            __errors = true;
        }

    });

    if (__errors == true) {
        e.preventDefault();
    }

});

$('.ldf-inp').blur(function() {
    if ($(this).val() != '' && $(this).val() != '0' && $(this).val() != 0) {

        $(this).removeClass('with-error');
        $(this).next('.error-message').hide();

    }
});

/******************** ARCHIVE LECTURER ANSWER ************************/

$(document).on('click', '.medtola-archive', function(e) {

    var medtola_id = $(this).attr('id').replace('medtola-archive-', '');
    var parent_of_medtola = $(this).parents('.existing_lecturer_content:first');

    $.ajax({
        url: $('#archive_lecturer').data('url'),
        method: 'POST',
        data: {'medtola_id': medtola_id},
        success: function(data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                $('#medtola-archive-'+ medtola_id).parents('.lecturer_now:first').remove();
                $('#medtl-qas-contaner-'+data.module_event_day_id+'-'+medtola_id).remove();
                $('#rqst-button-and-date-'+data.module_event_day_id+'-'+medtola_id).remove();
                $('#sent-request-date-'+data.module_event_day_id+'-'+medtola_id).parents('.sent-request-date-and-pic:first').remove();
                $('#sent-reply-date-'+data.module_event_day_id+'-'+medtola_id).remove();

                // show the button archived answers at once
                if ($(parent_of_medtola).parents('.quick-assign_lecturer_name:first').find('.badge-medtola-archived').length == 0) {
                    $('<span class="badge badge-warning badge-medtola-archived" id="badge-medtola-archived-'+ data.module_event_day_id +'">'+$('#archived_txt').data('archived_text') + '</span>').appendTo($(parent_of_medtola).parents('.quick-assign_lecturer_name:first'));
                }

                $('#badge-medtola-archived-'+data.module_event_day_id+'.archived-lecturers-shown').click();

            }

        }
    });

});

$(document).on('click', '.medtola-restore', function(e) {

    var medtola_id = $(this).attr('id').replace('medtola-restore-', '');

    $.ajax({
        url: $('#restore_lecturer').data('url'),
        method: 'POST',
        data: {'medtola_id': medtola_id},
        success: function(data) {

            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                location.reload();

            }

        }
    });

});

$(document).on('click', '.remove_lecturer_from_day', function(e) {

    var lecturer_id = $(this).data('lecturerid');
    var module_event_day_id = $(this).data('medid');
    var medtolid = $(this).data('medtolid');

    var _current_remove_btn = this;

    var c = confirm($('#are_you_sure_text').data('are_you_sure_text'));

    if (c == true) {
        $.ajax({
            url: $('#remove_lecturer_from_day').data('url'),
            method: 'POST',
            data: {'module_event_day_id': module_event_day_id, 'lecturer_id': lecturer_id},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    $(_current_remove_btn).parents('.lecturer_now:first').remove();

                    $('#medtl-qas-contaner-'+module_event_day_id+'-'+medtolid).remove();
                    $('#rqst-button-and-date-'+module_event_day_id+'-'+medtolid).remove();
                    $('#sent-request-date-'+module_event_day_id+'-'+medtolid).remove();
                    $('#sent-reply-date-'+module_event_day_id+'-'+medtolid).remove();

                }
            }
        });
    }

});
/******************** ARCHIVE LECTURER ANSWER END ************************/

/********************** SHOW ARCHIVED LECTURERS ANSWERS IN POPUP *****************************/

function determineMedToLAStatusText(status_id) {

    var _status_text = '';

    switch (status_id) {

        case 1:
            _status_text = '<span class="badge badge-success">'+$('#yes_text').data('yes_text')+'</span>';
            break;

        case 2:
            _status_text = '<span class="badge badge-danger">'+$('#nope_text').data('nope_text')+'</span>';
            break;

        case 3:
            _status_text = '<span class="badge badge-info">'+$('#thinking_text').data('thinking_text')+'</span>';
            break;
    }

    return _status_text;
}

$(document).on('click', '.badge-medtola-archived', function() {

    var module_event_day_id = $(this).attr('id').replace('badge-medtola-archived-', '');
    var _button_clicked_ = this;

    $(this).toggleClass('archived-lecturers-shown');

    if ($(this).hasClass('archived-lecturers-shown')) {

        $(_button_clicked_).text($('#close_txt').data('close_txt'));

        $.ajax({
            url: $('#get_archived_lecturers').data('url'),
            method: 'POST',
            data: {'module_event_day_id': module_event_day_id},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '' && typeof data.medtola_data != 'undefined' && data.medtola_data != null && data.medtola_data != '') {

                    /*console.log('data.medtola_data');
                    console.log(data.medtola_data);*/

                    for (var i in data.medtola_data.lecturers) {


                        // add to lecturers column
                        $('<div id="lecturer_now_' + data.medtola_data.lecturers[i].lecturer_id + '" class="lecturer_now "><input type="checkbox" id="day_bulk_" disabled class="day_bulk_check lec-archived lec-archived-check"> <span class="ln_txt lec-archived lec-archived-name">' + data.medtola_data.lecturers[i].lecturer_name + '</span> <i style="cursor:pointer;" aria-hidden="true" id="unarchive-medtola-'+i+'" class="fa fa-share text-success unarchive-medtola lec-archived lec-archived-restore" title="'+$('#unarchive_text').data('unarchive_text')+'"></i></div>').appendTo($(_button_clicked_).parents('.row-me-days:first').find('.lecturer_now_container'));

                        // add to request sent column
                        $('<div id="sent-request-date-'+data.medtola_data.day_id+'-'+i+'" class="sent-request-date text-center lec-archived lec-archived-request-sent-date">'+data.medtola_data.lecturers[i].request_sent_date+'</div>').appendTo($(_button_clicked_).parents('.row-me-days:first').find('.me-day-request-date'));

                        // add to request answered column
                        $('<div id="sent-reply-date-'+data.medtola_data.day_id+'-'+i+'" class="sent-reply-date text-center lec-archived lec-archived-request-answered-date">'+data.medtola_data.lecturers[i].request_answered_date+'</div>').appendTo($(_button_clicked_).parents('.row-me-days:first').find('.me-day-reply-date'));

                        // add to status column

                        var _status_comment_html = data.medtola_data.lecturers[i].status_comment != '' ? '<i aria-hidden="true" data-toggle="popover" title="" data-content="'+data.medtola_data.lecturers[i].status_comment+'" data-placement="top" data-trigger="hover" data-placement="top" data-trigger="hover" class="fa fa-comment-o text-success" data-original-title=""></i>' : '';

                        $('<div data-lecturerid="' + data.medtola_data.lecturers[i].lecturer_id + '" id="medtl-qas-contaner-'+data.medtola_data.day_id+'-'+i+'" class="medtl-qas-contaner lec-archived"><span class="medtl-qas-status-name">'+data.medtola_data.lecturers[i].status_name+'</span> '+_status_comment_html+' </div>').appendTo($(_button_clicked_).parents('.row-me-days:first').find('.medtl-qas-parent'));


                    }

                    $('.medtl-qas-contaner.lec-archived .fa-comment-o').popover();


                    // UNARCHIVE
                    $('.unarchive-medtola').click(function() {

                        var _un_medtola_id = $(this).attr('id').replace('unarchive-medtola-', '');

                        $.ajax({
                            url: $('#unarchive_lecturer').data('url'),
                            method: 'POST',
                            data: {'medtola_id': _un_medtola_id},
                            success: function(data) {

                                if (typeof data.success != 'undefined' && data.success != null && data.success != '' && typeof data.medtola_data != 'undefined' && data.medtola_data != null && data.medtola_data != '') {

                                    $('#unarchive-medtola-' + _un_medtola_id).parents('.popup-medtola-archived:first').remove();

                                    location.reload();


                                }

                            }
                        });

                    });

                }

            }
        });

    }
    else {
        $(_button_clicked_).parents('.row-me-days:first').find('.lec-archived').parent('.lecturer_now ').remove();
        $(_button_clicked_).parents('.row-me-days:first').find('.lec-archived').remove();
        $(_button_clicked_).text($('#archived_txt').data('archived_text'));
    }

});

/********************** SHOW ARCHIVED LECTURERS ANSWERS IN POPUP END ***************************/


/********************** EDIT MODE FOR TRANSLATIONS ***************************/

$('#translations-edit-mode').click(function(){

    // add special class to parent div
    $('.translations-parent').addClass('edit-mode-active');

    // disable top search form
    $('.translations-parent.edit-mode-active #translations-form-filter input, .translations-parent.edit-mode-active #translations-form-filter button').each(function(){
        $(this).attr('disabled', 'disabled');
    });

    $('.translations-parent.edit-mode-active .edit-elem,.translations-parent.edit-mode-active .btn-special-remove').css({'visibility': 'hidden'});

    $('.translation-link-container').each(function() {

        var _trans_id = $(this).attr('id').replace('translation-link-container-', '');
        var _current_text = $(this).text().trim();

        $(this).hide();

        $('<input type="text" value="'+_current_text+'" class="form-control translation-input-container" id="translation-input-container-'+_trans_id+'"/>').insertAfter(this);

    });


});

$('#close-translations-edit-mode').click(function(){

    // enable top search form
    $('.translations-parent.edit-mode-active #translations-form-filter input, .translations-parent.edit-mode-active #translations-form-filter button').each(function(){
        $(this).removeAttr('disabled');
    });

    $('.translations-parent.edit-mode-active .edit-elem,.translations-parent.edit-mode-active .btn-special-remove,.translations-parent.edit-mode-active .btn-special-remove').css({'visibility': 'visible'});

    $('.translations-parent').removeClass('edit-mode-active');

    $('.translation-input-container').each(function() {
        $(this).remove();
    });

    $('.translation-link-container').show();

});

// bulk save translations
$(document).on('click', '#bulk-save-translations', function() {

    var _serializedForm = '';
    var _first_special_fix_elem = '';

    $('.translation-input-container').each(function(indi) {

        var trans_id = $(this).attr('id').replace('translation-input-container-', '').trim();
        var current_value = $(this).val().trim();

        _serializedForm += _serializedForm == '' ? '?' : '&' + 'translation['+trans_id+']='+encodeURIComponent(current_value);

        if (indi == 0) {
            _first_special_fix_elem = '&' + 'translation['+trans_id+']='+encodeURIComponent(current_value);
        }
    });

    _serializedForm +=_first_special_fix_elem;

    $.ajax({
        url: $('#translations_bulk_update').data('url'),
        method: 'POST',
        data: _serializedForm,
        success: function (data) {
            location.reload();
        }
    });

});

/********************** EDIT MODE FOR TRANSLATIONS END ***************************/

// loader for importing users modules
$('.submit-import-file-container #submit_import_file').click(function() {
    $('.submit-import-file-container .spinner-border').css('display', 'inline-block');
});

// users modules tabs
$('ul#imported_users_modules_tabs li').click(function(){

    $('ul#imported_users_modules_tabs li').removeClass('active');
    $(this).addClass('active');

    $('.iumt-tab').removeClass('active-iut-tab');
    $($(this).find('a').data('tab')).addClass('active-iut-tab');

});

// simple tabs
$('ul#simple_tabs li').click(function(){

    $('ul#simple_tabs li').removeClass('active');
    $(this).addClass('active');

    $('.smpl-tab').removeClass('active-smpl-tab');
    $($(this).find('a').data('tab')).addClass('active-smpl-tab');

});

$('.amc-see-people').click(function(){

    $(this).toggleClass('amc-active').next('.amc-people').toggleClass('active');
    if ($(this).hasClass('amc-active')) {
        $(this).text($(this).data('hidestudents'));
    }
    else {
        $(this).text($(this).data('seestudents'));
    }

});


$('.showStudentsAmountForEvent').click(function(e){

    var _combomoduleeventid = $(this).data('combomoduleeventid');
    var _combomoduleeventname = $(this).data('combomoduleeventname');

    $('#modalCombinationsStudentsAmounts .current-clicked-me').text(_combomoduleeventname);

    console.log('_all_modules_combinations');
    console.log(_all_modules_combinations);

    console.log('_combomoduleeventid');
    console.log(_combomoduleeventid);

    if (typeof _all_modules_combinations != 'undefined') {

        var combos_coming_from = {};
        var combos_go_to = {};

        $('#getModalCombinationsStudentsAmounts').click();


        for (var name_code in _all_modules_combinations) {

            console.log('_all_modules_combinations[name_code]');
            console.log(_all_modules_combinations[name_code]);

            /*console.log('_all_modules_combinations[name_code].occasions_ids_combos');
            console.log(_all_modules_combinations[name_code].occasions_ids_combos);*/

            for (var um_combo in _all_modules_combinations[name_code].occasions_ids_combos) {

                if (um_combo.indexOf(_combomoduleeventid) != -1) {

                    /*console.log('um_combo');
                    console.log(um_combo);*/
                    var splittedCombo = um_combo.split('_');

                    /*console.log('splittedCombo[0]');
                    console.log(splittedCombo[0]);

                    console.log('splittedCombo[1]');
                    console.log(splittedCombo[1]);*/

                    if (splittedCombo[0] == _combomoduleeventid) { //go to

                        /*console.log('go to');*/

                        if (typeof combos_go_to[splittedCombo[1]] != 'undefined') {

                            /*console.log('not first go to');

                            console.log('_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people');
                            console.log(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people);*/

                            combos_go_to[splittedCombo[1]] = combos_go_to[splittedCombo[1]] + Object.keys(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people).length;
                            /*console.log('combos_go_to');
                            console.log(combos_go_to);*/
                        }
                        else {
                            /*console.log('first go to');
                            console.log('_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people');
                            console.log(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people);*/
                            combos_go_to[splittedCombo[1]] = Object.keys(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people).length;

                           /* console.log('combos_go_to');
                            console.log(combos_go_to);*/
                        }

                    }
                    else { // coming from

                        /*console.log('go from');*/

                        if (typeof combos_coming_from[splittedCombo[0]] != 'undefined') {
                            /*console.log('not first come from');

                            console.log('_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people');
                            console.log(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people);*/

                            combos_coming_from[splittedCombo[0]] = combos_coming_from[splittedCombo[0]] + Object.keys(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people).length;

                            /*console.log('combos_coming_from');
                            console.log(combos_coming_from);*/
                        }
                        else {

                           /* console.log('first come from');
                            console.log('_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people');
                            console.log(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people);*/

                            combos_coming_from[splittedCombo[0]] = Object.keys(_all_modules_combinations[name_code].occasions_ids_combos[um_combo].people).length;

                            /*console.log('combos_coming_from');
                            console.log(combos_coming_from);*/
                        }

                    }

                }

            }

        }

/*        console.log('combos_go_to');
        console.log(combos_go_to);
        console.log('combos_coming_from');
        console.log(combos_coming_from);*/
        var _final_popup_combo_html = '';
        if (typeof combos_go_to != 'undefined' && typeof combos_coming_from != 'undefined' && typeof _all_modules != 'undefined') {

            _final_popup_combo_html += '<div class="row">';

            // going to
            _final_popup_combo_html += '<div class="col-md-6"><h5>'+$('#students_go_to').data('text')+'</h5>';
            if (Object.keys(combos_go_to).length > 0) {
                for (var comgt in combos_go_to) {
                    _final_popup_combo_html += '<div><small>'+_all_modules[comgt].full_name+'</small>  -  <strong>'+combos_go_to[comgt]+'</strong></div>'
                }
            }
            _final_popup_combo_html += '</div>';



            // coming from
            _final_popup_combo_html += '<div class="col-md-6"><h5>'+$('#students_go_from').data('text')+'</h5>';
            if (Object.keys(combos_coming_from).length > 0) {
                for (var comcf in combos_coming_from) {
                    _final_popup_combo_html += '<div><small>'+_all_modules[comcf].full_name+'</small>  -  <strong>'+combos_coming_from[comcf]+'</strong></div>'
                }
            }
            _final_popup_combo_html += '</div>';

            _final_popup_combo_html += '</div>';

            $('#modalCombinationsStudentsAmounts .modal-body').html(_final_popup_combo_html);

        }

    }

});

/******************** SECRET ADMIN MASS MODULE EVENT CHANGE *********************/

$(document).keydown(function(e){


    if (e.ctrlKey && (e.which === 90)) {
        console.log('ctrl + z 1');
        if ($('#secret_mass_me_edit_button').length > 0) {

            var left_pos = (parseInt($(window).innerWidth()) / 2) - (parseInt($('#secret_mass_me_edit_button').innerWidth()) / 2);

            $('#secret_mass_me_edit_button').css({'left': left_pos +'px'});

            if ($('#secret_mass_me_edit_button').is(':visible')) {
                $('#secret_mass_me_edit_button').hide();
            }
            else {

                $('#secret_mass_me_edit_button').show();

            }

        }

        if ($('.secret_get_imported_module_events_students').length > 0) {


            $('.secret_get_imported_module_events_students.without-date').each(function() {

                var _first_date = $(this).parents('.me-row.module-event:first').find('.row-with-me-days .module-event-days-parent .row-me-days:first .quick-assign_date').text().trim();

                $(this).attr('href', $(this).attr('href') + '&module_event_first_date='+_first_date);

                $(this).removeClass('without-date');
            });

            if ($('.secret_get_imported_module_events_students').is(':visible')) {

                $('.secret_get_imported_module_events_students').hide();

            }
            else {

                $('.secret_get_imported_module_events_students').css('display','inline-block');

            }

        }

    }
    if (e.ctrlKey && (e.which === 77)) {

        if ($('#show-students_map').length > 0) {





            $('#show-students_map').css('display', 'inline-block');

            if ($('.mapsscript').length == 0) {
                $('<script defer class="mapsscript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBQcNRinno7Hp9omOx4P1iPyVe5JzIqQzQ&language=en&callback=initMap"></script>').appendTo('body');


                // remove the periods which dont have module events dates
                /*$('#filter_by_period option').each(function() {

                    var _c_opt = this;
                    var _c_opt_val_ = $(this).attr('value');


                    var _has_me_dates = false;

                    $('.quick-assign.quick-assign_date').each(function() {

                        if ($(this).data('same_day') != '' && _c_opt_val_.indexOf($(this).data('same_day')) != -1) {

                            _has_me_dates = true;

                        }

                    });

                    if (_has_me_dates == false) {

                        $(_c_opt).remove();

                    }

                });*/

            }


            $('#show-students_map').click(function() {

                $(this).toggleClass('stm-active');

                if ($(this).hasClass('stm-active')) {

                    $('.students_map_container').appendTo('body').show();
                    $(this).text($(this).data('closemap'));
                    $('body').addClass('hasMapOpen');

                }
                else {

                    $(this).text($(this).data('stmap'));
                    $('.students_map_container').hide();

                    $('body').removeClass('hasMapOpen');

                    $('.students_map_container').insertBefore('.me-parent');
                }


            });

            $('#include_archived_to_filters').click(function(){

                console.log($(this).prop('checked'));
                if ($(this).prop('checked') == true) {

                    //console.log('include_archived_to_filters true');
                    $('.module-event.module-event-archived').each(function() {

                        $(this).removeClass('module-event-archived').addClass('module-event-archived-x');

                    });

                }
                else {

                    //console.log('include_archived_to_filters false');

                    $('.module-event.module-event-archived-x').each(function() {

                        $(this).removeClass('module-event-archived-x').addClass('module-event-archived');

                    });

                }

            });

            $('#include_archived_to_filters').click();
            $('#filter_by_period').val($('#filter_by_period option:nth-child('+(2)+')').attr('value')).change();
            $('#filter_by_period').val('').change();

            $('#show_students_map_2').click(function(){$('#show-students_map').click();});

            $('#hide_filters').click(function(){
                $('.me-filter-form').hide();
                $('#show_filters_over_map').show();
            });

            $('#show_filters_over_map').click(function() {
                $(this).hide();
                $('.me-filter-form').show();
            });

            $('#filter_by_period').change(function() {

                $('#me_filter_date').val($(this).val());
                $('#me_filter_status').change();

                setTimeout(function(){
                    $('#me_filter_date').change();
                    $('.put_filter_on_map').click();
                },1000);

            });


            $('#animate_all_periods').click(function(){

                $(this).attr('disabled', 'disabled');

                //console.log('animate_all_periods 0');

                var c_periods_timer = setInterval(_changePeriodsFunc, 3000);
                var _counter_of_cycles = 1;

                function _changePeriodsFunc() {

                    //console.log('animate_all_periods 1');

                    $('#stop_animate_all_periods').click(function() {
                        //console.log('animate_all_periods x');
                        clearInterval(c_periods_timer);

                        $('#animate_all_periods').removeAttr('disabled');

                        $('.put_filter_on_map').click();

                        return;
                    });

                    if (_counter_of_cycles < $('#filter_by_period option').length) {

                        //console.log('animate_all_periods 2');

                        var _coption_val_ = $('#filter_by_period option:nth-child('+(_counter_of_cycles+1)+')').attr('value');

                        //console.log('animate_all_periods value ' + _coption_val_);

                        $('#filter_by_period').val(_coption_val_).change();
                        $('.put_filter_on_map').click();

                    }
                    else {
                        //console.log('animate_all_periods 3');
                        clearInterval(c_periods_timer);
                        $('#animate_all_periods').removeAttr('disabled');
                        $('.put_filter_on_map').click();
                        return;
                    }

                    _counter_of_cycles++;

                }

            });


            var sm_select = $("#filter_by_period");
            var aFilterPeriods = [];

            $("#filter_by_period option").each(function() {

                var _cVl = $(this).val();

                if (_cVl != '') {
                    aFilterPeriods.push(_cVl);
                }

            });

            console.log('aFilterPeriods');
            console.log(aFilterPeriods);

            var sm_slider = $('<div id="sm_slider"></div>').appendTo('.close-hide-map-container').slider({
                min: 1,
                max: aFilterPeriods.length,
                range: "min",
                //values: aFilterPeriods,
                value: sm_select[0].selectedIndex + 1,
                slide: function(event, ui) {
                    sm_select[0].selectedIndex = ui.value - 1;
                    $('.put_filter_on_map').click();
                }
            });

            $("#filter_by_period").on("change", function() {
                sm_slider.slider("value", this.selectedIndex + 1 );
            });

        }

    }

});

$('#secret_mass_me_edit_button').click(function() {

    if (!$(this).hasClass('edit-on')) {

        // disable filters
        $('#form_filters_days, .row.row-main-filter').css('visibility', 'hidden');

        // change to save button
        $(this).addClass('edit-on').removeClass('btn-dark').addClass('btn-success');
        $(this).text($(this).data('savetext'));

        // put editable texts to inputs
        $('.editable-field').each(function(){

            var _module_event_id = $(this).parents('.module-event').attr('id').replace('module-event-', '');
            var _editable_field_name = $(this).data('editablefield');

            $(this).html('<input type="text" data-oldval="' + $(this).text().trim() + '" data-moduleeventid="'+_module_event_id+'" data-editablefieldname="'+_editable_field_name+'" class="form-control module_event_field module_event_field_'+_editable_field_name+'" value="' + $(this).text().trim() + '">');

        });

    }
    else {

        $('#form_filters_days, .row.row-main-filter').css('visibility', 'visible');

        // switch buttons
        $(this).removeClass('edit-on').removeClass('btn-success').addClass('btn-dark');
        $(this).text($(this).data('edittext'));

        // get all the data into array
        var dataToSend = [];
        $('.me-row').each(function(){

            var me_id = $(this).attr('id').replace('module-event-', '');

            var location = $(this).find('.module_event_field_location').val();
            $(this).find('.me-filters-column_location').html('').text(location);

            var eventnumber = $(this).find('.module_event_field_eventnumber').val();
            $(this).find('.me-filters-column_eventnumber').html('').text(eventnumber);

            var _mefObj = {'module_event_id': me_id, 'location': location, 'eventnumber': eventnumber};

            dataToSend.push(_mefObj);

        });

        console.log('dataToSend');
        console.log(dataToSend);

        $.ajax({
            url: $('#mass_update').data('url'),
            method: 'POST',
            data: {"data": JSON.stringify(dataToSend)},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    location.reload();

                }

            }
        });

    }

});

/*************** SPECIAL MODULE EVENT COMMENT POPUP *****************/
$('#specialModuleEventCommentModal').on('show.bs.modal', function (event) {


    $('#specialModuleEventComment').val('');
    $('#specialModuleEventCommentColor').val('');


    var _button = $(event.relatedTarget);
    var _special_comment = _button.data('special_comment');
    var _color = _button.data('color');
    var _module_event_id = _button.data('moduleeventid');


    $('#specialModuleEventComment').val(_special_comment);
    $('#specialModuleEventCommentColor').val(_color);


    var dataObj = {};


    // assign title and show loading spinner
    var modal = $(this);


    //modal.find('.modal-body').html(data);


    // SAVE COMMENT AND COLOR

    $(document).off('click', '#specialModuleEventCommentModal .btn-save');
    $(document).on('click', '#specialModuleEventCommentModal .btn-save', function(e) {

        $.ajax({
            url: $('#save_special_comment').data('url'),
            method: 'GET',
            data: {'module_event_id': _module_event_id, 'special_comment': $('#specialModuleEventCommentModal #specialModuleEventComment').val(), 'special_comment_color': $('#specialModuleEventCommentModal #specialModuleEventCommentColor').val()},
            success: function(data) {


                _button.data('special_comment',  $('#specialModuleEventCommentModal #specialModuleEventComment').val());
                _button.attr('title',  $('#specialModuleEventCommentModal #specialModuleEventComment').val());
                _button.data('color', $('#specialModuleEventCommentModal #specialModuleEventCommentColor').val());
                _button.find('i.fa').css('color', $('#specialModuleEventCommentModal #specialModuleEventCommentColor').val());

                $('#specialModuleEventCommentModal .close.close-modal').click();


                $(_button).popover('dispose');

                console.log(_button);

                setTimeout(function () {
                    $(_button).popover({
                        template: '<div class="popover module-event-special-message-highlight" role="tooltip"><div class="arrow me"></div><div class="popover-body me"></div></div>',
                        content: $('#specialModuleEventCommentModal #specialModuleEventComment').val(),
                        html: true,
                        trigger: 'hover',
                        placement: 'left',
                        attachment: 'top left',
                        targetAttachment: 'top left',
                        offset: '0px'
                    });
                }, 200);





            }
        });

    });

    // REMOVE COMMENT AND COLOR

    $(document).off('click', '#specialModuleEventCommentModal .btn-remove');
    $(document).on('click', '#specialModuleEventCommentModal .btn-remove', function(e) {

        $.ajax({
            url: $('#remove_special_comment').data('url'),
            method: 'GET',
            data: {'module_event_id': _module_event_id},
            success: function(data) {

                _button.data('special_comment',  '');
                _button.attr('title', '');
                _button.data('color', '');
                _button.find('i.fa').css('color', '#eee');

                $('#specialModuleEventCommentModal .close.close-modal').click();

            }
        });

    });

});

function adminCountAllModuleEventsStatuses()
{
    $('.module-event-year-row').each(function(){

        var meyr = this;

        $(meyr).find('.modeventyear-results').html('');

        var _current_year = $(meyr).data('modevyear');

        /*console.log('_current_year');
        console.log(_current_year);*/

        var _ModuleEventsStatuses = [];

        $('.module-event-year-'+_current_year).each(function(){

            var _active_value = $(this).find('.me-active').val();
            var _active_option_text = $(this).find('.me-active option[value="'+_active_value+'"]').text().trim();

           /* console.log('_active_value');
            console.log(_active_value);

            console.log('_active_option_text');
            console.log(_active_option_text);*/

            if (typeof _ModuleEventsStatuses[_active_option_text] != 'undefined') {

                _ModuleEventsStatuses[_active_option_text] = parseInt(_ModuleEventsStatuses[_active_option_text]) + 1;

            }
            else {
                _ModuleEventsStatuses[_active_option_text] = 1
            }

        });

        /*console.log('_ModuleEventsStatuses');
        console.log(_ModuleEventsStatuses);*/

        //if (_ModuleEventsStatuses.length > 0) {


            for (var _mes_ in _ModuleEventsStatuses) {

                var _mes_html = '<div class="mes"><strong>'+_mes_+': </strong>'+_ModuleEventsStatuses[_mes_]+'</div>';
              /*  console.log(_mes_);
                console.log(_ModuleEventsStatuses);
                console.log('_mes_html');
                console.log(_mes_html);*/
               $(_mes_html).appendTo($(meyr).find('.modeventyear-results'));

            }


       // }


    });
}

if ($('.module-event-year-row').length > 0) {

    adminCountAllModuleEventsStatuses();

    $(document).on('change', '.dropdown.me-active', function(){
        adminCountAllModuleEventsStatuses();
    });
}

// ADMIN MODULE EVENT SPECIAL MESSAGE ON DOT MOUSE OVER

$('.module-event-special-message').each(function(){

    $(this).popover({
        template: '<div class="popover module-event-special-message-highlight" role="tooltip"><div class="arrow me"></div><div class="popover-body me"></div></div>',
        content: $(this).attr('title'),
        html: true,
        trigger: 'hover',
        placement: 'left',
        attachment: 'top left',
        targetAttachment: 'top left',
        offset: '0px'
    });

});

/******************** MULTISELECT FOR YEARS IN ADMIN *********************/
if ($('#me_main_data_filter_years').length > 0) {

    $('#me_main_data_filter_years').multiSelect({
        noneText: $('#mem_years_text').data('mem_years_text').trim(),
        menuItemHTML: '<label class="multi-select-menuitem2"></label>'
    });

}

/******************** COMBINATIONS TOOLTIP *********************/
$('.mc-mh-name').each(function(){

    $(this).popover({
        template: '<div class="popover module-event-special-message-highlight combos" role="tooltip"><div class="arrow me"></div><div class="popover-body me"></div></div>',
        content: $(this).attr('title'),
        html: true,
        trigger: 'hover',
        placement: 'top',
        attachment: 'top left',
        targetAttachment: 'top left',
        offset: '0px'
    });

});


/**************** Collisions In Lecturer/Dates *****************/


function determineLecturerDateCollisions() {

    setTimeout(function(){
        if ($('.module-event .row-me-days').length > 0) {

            var dayAndLecturersData = [];

            $('.row-me-days').each(function(){

                var _current_me_day_row = this;
                var _current_day_id = $(_current_me_day_row).attr('id').replace('row-me-days-', '');

                var _med_date = $(_current_me_day_row).find('.quick-assign_date').text().trim();

                /*console.log('_current_day_id 1');
                console.log(_current_day_id);

                console.log('_med_date');
                console.log(_med_date);*/

                if (typeof _med_date != 'undefined' && _med_date != '' && $('#row-me-days-'+_current_day_id+' .lecturer_now_container .lecturer_now').length > 0) {

                    $('#row-me-days-'+_current_day_id+' .lecturer_now_container .lecturer_now').each(function(){

                        var _current_lecturer_id = $(this).attr('id').replace('lecturer_now_', '');

                        var _event_year = $(this).parents('.me-row.module-event').data('moduleeventyear');

                        if (typeof _current_lecturer_id != 'undefined' && _current_lecturer_id != '') {

                            var _composed_key = _med_date + '_' + _current_lecturer_id;

                            //764
                           /* console.log('row-me-days-+_current_day_id');
                            console.log(_current_day_id);
                            console.log('_composed_key');
                            console.log(_composed_key);*/

                            // if there is already such record we add data to it
                            if (typeof dayAndLecturersData[_composed_key] != 'undefined') {

                                dayAndLecturersData[_composed_key]._counter = dayAndLecturersData[_composed_key]._counter+1;
                                dayAndLecturersData[_composed_key].days_ids.push(_current_day_id);


                            }
                            else { // if no we create a new record in array
                                dayAndLecturersData[_composed_key] = {
                                    "lecturer_id": _current_lecturer_id,
                                    "med_date": _med_date,
                                    "_event_year": _event_year,
                                    "_counter": 1,
                                    "days_ids": [_current_day_id]
                                };
                            }

                        }

                    });

                }

            });

            /*console.log('dayAndLecturersData');
            console.log(dayAndLecturersData);*/

            if (dayAndLecturersData) {

                $.ajax({
                    url: $('#get_all_date_lecturer_combo').data('url'),
                    method: 'POST',
                    data: {},
                    success: function(data) {

                       /* console.log('data aa');
                        console.log(data);*/
                        var allowed_collisions = data['allowed_collisions'];

                        /*console.log('allowed_collisions');
                        console.log(allowed_collisions);*/

                        $('.row-with-me-days .lecturer-day-collision-indicator').removeClass('lecturer-day-collision-indicator');

                        var _text_collisions = $('#collisions_text').data('collisions');

                        $('.collisions-warning .cw-body').html('');
                        $('.collisions-warning h3').hide();

                        for (var day_lect_combo in dayAndLecturersData) {

                            if (typeof dayAndLecturersData[day_lect_combo] != 'undefined' && typeof dayAndLecturersData[day_lect_combo]._counter != 'undefined' && dayAndLecturersData[day_lect_combo]._counter > 1) {
                                /*console.log('dayAndLecturersData[day_lect_combo]._counter');
                                console.log(dayAndLecturersData[day_lect_combo]._counter);*/

                                $('.module-event-year-row-'+dayAndLecturersData[day_lect_combo]._event_year).find('.collisions-warning h3').show();

                                for (var xyz = 0; xyz < dayAndLecturersData[day_lect_combo].days_ids.length; xyz++) {

                                    var _day_id = dayAndLecturersData[day_lect_combo].days_ids[xyz];
                                    var _lecturer_id = dayAndLecturersData[day_lect_combo].lecturer_id;

                                    $('#row-me-days-'+_day_id + ' .quick-assign_date,#row-me-days-'+_day_id + ' #lecturer_now_'+_lecturer_id).addClass('lecturer-day-collision-indicator');

                                    $('#row-me-days-'+_day_id).parents('.row-with-me-days:first').find('h5').addClass('lecturer-day-collision-indicator');

                                    if (allowed_collisions.indexOf(dayAndLecturersData[day_lect_combo].med_date+'_'+dayAndLecturersData[day_lect_combo].lecturer_id) != -1) {

                                        $('#row-me-days-'+_day_id + ' .quick-assign_date,#row-me-days-'+_day_id + ' #lecturer_now_'+_lecturer_id).addClass('combo-allowed');

                                    }



                                }

                                $('.module-event-year-row-'+dayAndLecturersData[day_lect_combo]._event_year).find('.collisions-warning .cw-body').append('<div class="collision-child '+(allowed_collisions.indexOf(dayAndLecturersData[day_lect_combo].med_date+'_'+dayAndLecturersData[day_lect_combo].lecturer_id) != -1 ? 'combo-allowed' : '')+'" title="'+(allowed_collisions.indexOf(dayAndLecturersData[day_lect_combo].med_date+'_'+dayAndLecturersData[day_lect_combo].lecturer_id) != -1 ? $('#allowed_text').data('allowed_text') : '')+'"><span class="mecc-date">'+dayAndLecturersData[day_lect_combo].med_date+'</span> <span class="mecc-lecturer">'+ $('#lecturer_now_'+dayAndLecturersData[day_lect_combo].lecturer_id + ':first .ln_txt').text().trim() +'</span><input class="mecc-allowed" data-meccdate="' + dayAndLecturersData[day_lect_combo].med_date + '" data-mecclect="' + dayAndLecturersData[day_lect_combo].lecturer_id + '" type="checkbox" class="form-control" '+(allowed_collisions.indexOf(dayAndLecturersData[day_lect_combo].med_date+'_'+dayAndLecturersData[day_lect_combo].lecturer_id) != -1 ? 'checked="checked"' : '')+'></div>');

                            }

                        }

                    }

                });

            }
        }
    },2000);

}
determineLecturerDateCollisions();

$(document).on('click', '.collision-child .mecc-lecturer, .collision-child .mecc-date', function(){

    $('.me-clear-filters').click();

    var _the_date = $(this).parents('.collision-child:first').find('.mecc-date').text().trim();
    var _the_lect = $(this).parents('.collision-child:first').find('.mecc-lecturer').text().trim();

    $('#me_filter_date').val(_the_date);
    $('#me_filter_lecturer_name').val(_the_lect);

    $('#me_filter_status').change();

});

$(document).on('click', '.mecc-allowed', function() {

    var mecc_lect_id = $(this).data('mecclect');
    var mecc_date = $(this).data('meccdate');

    var _the_url = '';

    if ($(this).prop('checked') != true) {
        _the_url = $('#forbid_date_lecturer_combo').data('url');
        $(this).parent().removeClass('combo-allowed').removeAttr('title');
    }
    else {
        _the_url = $('#allow_date_lecturer_combo').data('url');
        $(this).parent().addClass('combo-allowed').attr('title', $('#allowed_text').data('allowed_text'));
    }

    $.ajax({
        url: _the_url,
        method: 'POST',
        data: {'lecturer_id': mecc_lect_id, 'collision_date': mecc_date},
        success: function(data) {



        }
    });

});

/************* ADMIN MODULE EVENT DAYS WITH SAME DATE TIME ORDER**************/

function checkIfNeedToSwitchDaysOrder() {
//$('<style>.module-event-days-parent .row-me-days:first-child .same-day::after{display:none!important;}</style>').appendTo('body');
    $('.quick-assign_date.same-day').each(function() {

        var _current_same_day = this;

        var _current_same_day_time = $(_current_same_day).next('.quick-assign_time').text().trim();

        var _current_date = $(_current_same_day).data('same_day');

        var _parent_row = $(_current_same_day).parents('.row-with-me-days:first');

        var _original_same_day = $(_parent_row).find('.quick-assign_date[data-same_day="'+_current_date+'"]:not(.same-day)');

        var _original_same_day_time = $(_original_same_day).next('.quick-assign_time').text().trim();


        if (_current_same_day_time != '' && _original_same_day_time != '') {

            var a_csdt = _current_same_day_time.split('-');
            var a_osdt = _original_same_day_time.split('-');

            var _same_day_time_start = a_csdt[0].trim().replace(':', '').replace('-', '').replace(' ', '').replace('.', '');
            var _original_day_time_start = a_osdt[0].trim().replace(':', '').replace('-', '').replace(' ', '').replace('.', '');

            var _same_day_time_start_ready = parseInt(_same_day_time_start, 10);
            var _original_day_time_start_ready = parseInt(_original_day_time_start, 10);

            if (Number.isInteger(_same_day_time_start_ready) && Number.isInteger(_original_day_time_start_ready) && _same_day_time_start_ready < _original_day_time_start_ready) {
                $(_current_same_day).parents('.row-me-days:first').insertBefore($(_original_same_day).parents('.row-me-days:first'));
                $(_current_same_day).text($(_current_same_day).data('same_day'));
                $(_original_same_day).text('');
            }

        }
    });

    $('.quick-assign_date').each(function() {
        if ($(this).text().trim() == '') {
            $('<style>#'+$(this).attr('id')+'::after{content:"'+$(this).data('same_day')+'";opacity: 0.5;}#'+$(this).attr('id')+'.day-changed::after{content:"";}</style>').insertBefore(this);
        }
    });
}

if ($('.quick-assign_date.same-day').length > 0) {
    checkIfNeedToSwitchDaysOrder();
}

if ($('#faq_accordion').length > 0) {
    //$('#faq_accordion').accordion();
    $("#faq_accordion").accordion({
        collapsible: true,
        active: false,
        animate: 500
    }).on("click", "h3.ui-accordion-header", function(e) {
        $("h3.ui-accordion-header").each(function(i, el) {
            $(this).find(".panel-icon").text($(el).is(".ui-state-active") ? "-" : "+")
        })
    }).show();

    $('#faq_accordion.ui-accordion .ui-accordion-content').css({'height': 'auto'});
}

if ($('.faq-sort-container').length > 0) {
    function makeFaqSortable() {

        $('.faq-sort-container').sortable({
            items: '.faq_panel',
            stop: function(event, ui) {

                var _faq_ids = '';

                $('.faq-sort-container .faq-header').each(function(_index) {

                    var _faq_id = $(this).data('faqid');
                    _faq_ids += (_faq_ids == '' ? '' : '&') + 'faq_ids[' + _faq_id + ']=' + parseInt(_index+1);

                });


                var _change_faq_order_url = $('#change_faq_sort_order').data('url');

                $.ajax({
                    url: _change_faq_order_url,
                    method: 'POST',
                    data: _faq_ids,
                    success: function(data) {

                        if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                            $('.success-message').text(data.success);

                        }

                    }
                });

            }
        });

    }

    makeFaqSortable();
}

if ($('.front-faq-header').length > 0) {

    $('.front-faq-header').click(function() {

        var track_faq_click_url = $('.invisible-track_faq_click').data('url');

        var usr_ip = $('#u_ip').val();

        var _faq_id = $(this).data('fqid');

        $.ajax({
            url: track_faq_click_url,
            method: 'POST',
            data: {'usr_ip': usr_ip, 'faq_id': _faq_id},
            success: function(data) {



            }
        });

    });

    // tabs buttons and content
    $('#faq-btn').click(function() {

        $(this).addClass('make-invisible');
        $('.front-faq-content').removeClass('make-invisible');

        $('#gaq-btn').removeClass('make-invisible');
        $('.front-gaq-content').addClass('make-invisible');

    });

    $('#gaq-btn').click(function() {

        $(this).addClass('make-invisible');
        $('.front-gaq-content').removeClass('make-invisible');

        $('#faq-btn').removeClass('make-invisible');
        $('.front-faq-content').addClass('make-invisible');

    });

}

if ($('.quizz-parent').length > 0) {

    $(document).on('change', '#predefined_element_id', function() {

        $('.slide-content').hide();

        var _pe_id = $(this).val();

        var _pe_code = $('#predefined_element_id option[value="'+_pe_id+'"]').data('code');

        var _slide_content_html = '';

        // translations
        var slide_title_text = $('#slide_title_text').data('text');
        var slide_text_text = $('#slide_text_text').data('text');
        var slide_image_text = $('#slide_image_text').data('text');

        var slide_image_ratio = $('#slide_image_ratio').data('text');

        var slide_image_resource = $('#slide_image_resource').data('text');
        var slide_video_text = $('#slide_video_text').data('text');
        var best_image_size_text = $('#best_image_sizes').data('text');

        var slide_over_radio_text = $('#slide_over_radio_text').data('text');

        if (_pe_code != '') {
            $('.slide-content').show();
        }

        var _slide_content_existed = '';

        var _existed_slide_image = '';
        var _existed_slide_image_source = '';
        var _existed_slide_video = '';
        var _existed_slide_title = '';
        var _existed_slide_text = '';

        var _existed_slide_ratio = '';

        var _existed_image_label_text =  $('#slide_existing_image_text').data('text');


        var _slide_content_existed_tmp = $('#predefined_element_id').data('slidecontent');

        console.log('_slide_content_existed_tmp');
        console.log(_slide_content_existed_tmp);

        if ( _slide_content_existed_tmp != '') {

            _slide_content_existed = _slide_content_existed_tmp;

            console.log('_slide_content_existed');
            console.log(_slide_content_existed);

            if (typeof _slide_content_existed['slide_image_source'] != 'undefined') {
                _existed_slide_image_source = _slide_content_existed['slide_image_source'];
            }

            if (typeof _slide_content_existed['slide_image'] != 'undefined') {
                _existed_slide_image = _slide_content_existed['slide_image'];
            }

            if (typeof _slide_content_existed['slide_video'] != 'undefined') {
                _existed_slide_video = _slide_content_existed['slide_video'];
            }

            if (typeof _slide_content_existed['slide_title'] != 'undefined') {
                _existed_slide_title = _slide_content_existed['slide_title'];
            }

            if (typeof _slide_content_existed['slide_text'] != 'undefined') {
                _existed_slide_text = _slide_content_existed['slide_text'];
            }

            if (typeof _slide_content_existed['slide_ratio'] != 'undefined') {
                _existed_slide_ratio = _slide_content_existed['slide_ratio'];
            }

        }



        switch (_pe_code) {

            case 'title_text_image':


                //$(this).parents('form:first').attr('enctype', 'multipart/form-data').attr('method', 'POST');
                var _slide_ratio_html = '<br><select class="form-control" name="slide_ratio" id="slide_ratio"><option '+(_existed_slide_ratio == '16 / 9' ? 'selected' : '') + ' value="16 / 9">16 / 9</option><option '+(_existed_slide_ratio == '4 / 3' ? 'selected' : '') + ' value="4 / 3">4 / 3</option></select><br>';

                _slide_content_html = `
                    <div class="column-parent">

                        <label>${slide_title_text}</label>
                        <input type="text" class="form-control" name="slide_title" value="${_existed_slide_title}" />

                    </div>

                    <div class="column-parent">

                        <label>${slide_text_text}</label>
                        <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                    </div>

                    <div class="column-parent">
                        <label>${slide_image_text}
                        <br><small><strong>${best_image_size_text}</strong></small>
                        </label>
                        ${_slide_ratio_html}
                        <div class="avatarimage" id="drop-area">
                            <img src="/images/grey_cube.png" alt="avatar" id="avatarimage">
                        </div>
                        <input type="file" class="form-control slide_image" name="slide_image" id="slide_image" value="" />
                        <br>
                        <label for="slide_image_source">${slide_image_resource}</label><br>
                        <input type="text" class="form-control slide_image_source" name="slide_image_source" id="slide_image_source" value="${_existed_slide_image_source}" />
                    </div>
                `;

                if (_existed_slide_image != '') {

                    _slide_content_html += `<div class="existed-image-container"><br><label class="slide-existing-image">${_existed_image_label_text}: </label><img class="sld-image" src="/uploads/${_existed_slide_image}" alt="">  <i class="fa fa-times" aria-hidden="true"></i>
                        <input type="hidden" name="existing_slide_image" value="${_existed_slide_image}">
                    </div>`;

                }

                break;

            case 'title_text_image_and_video':


                //$(this).parents('form:first').attr('enctype', 'multipart/form-data').attr('method', 'POST');
                var _slide_ratio_html = '<br><select class="form-control" name="slide_ratio" id="slide_ratio"><option '+(_existed_slide_ratio == '16 / 9' ? 'selected' : '') + ' value="16 / 9">16 / 9</option><option '+(_existed_slide_ratio == '4 / 3' ? 'selected' : '') + ' value="4 / 3">4 / 3</option></select><br>';

                _slide_content_html = `
                    <div class="column-parent">

                        <label>${slide_title_text}</label>
                        <input type="text" class="form-control" name="slide_title" value="${_existed_slide_title}" />

                    </div>

                    <div class="column-parent">

                        <label>${slide_text_text}</label>
                        <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                    </div>

                    <div class="column-parent">
                        <label>${slide_image_text}
                        <br><small><strong>${best_image_size_text}</strong></small>
                        </label>
                        ${_slide_ratio_html}
                        <div class="avatarimage" id="drop-area">
                            <img src="/images/grey_cube.png" alt="avatar" id="avatarimage">
                        </div>
                        <input type="file" class="form-control slide_image" name="slide_image" id="slide_image" value="" />
                        <br>
                        <label for="slide_image_source">${slide_image_resource}</label><br>
                        <input type="text" class="form-control slide_image_source" name="slide_image_source" id="slide_image_source" value="${_existed_slide_image_source}" />
                    </div>

                     <div class="column-parent">
                        <label>${slide_video_text}</label>
                        <input type="text" class="form-control slide_video" name="slide_video" id="slide_video" value="${_existed_slide_video}" />
                    </div>
                `;

                if (_existed_slide_image != '') {

                    _slide_content_html += `<div class="existed-image-container"><br><label class="slide-existing-image">${_existed_image_label_text}: </label><img class="sld-image" src="/uploads/${_existed_slide_image}" alt="">  <i class="fa fa-times" aria-hidden="true"></i>
                        <input type="hidden" name="existing_slide_image" value="${_existed_slide_image}">
                    </div>`;

                }

                break;

            case 'image_title_text':


            //$(this).parents('form:first').attr('enctype', 'multipart/form-data').attr('method', 'POST');
                var _slide_ratio_html = '<br><select class="form-control" name="slide_ratio" id="slide_ratio"><option '+(_existed_slide_ratio == '16 / 9' ? 'selected' : '') + ' value="16 / 9">16 / 9</option><option '+(_existed_slide_ratio == '4 / 3' ? 'selected' : '') + ' value="4 / 3">4 / 3</option></select><br>';

            _slide_content_html = `

                <div class="column-parent">
                    <label>${slide_image_text}
                    <br><small><strong>${best_image_size_text}</strong></small>
                    </label>
                    ${_slide_ratio_html}
                    <div class="avatarimage" id="drop-area">
                        <img src="/images/grey_cube.png" alt="avatar" id="avatarimage">
                    </div>
                    <input type="file" class="form-control slide_image" name="slide_image" id="slide_image" value="" />
                    <br>
                        <label for="slide_image_source">${slide_image_resource}</label><br>
                        <input type="text" class="form-control slide_image_source" name="slide_image_source" id="slide_image_source" value="${_existed_slide_image_source}" />
                </div>
                <div class="column-parent">

                    <label>${slide_title_text}</label>
                    <input type="text" class="form-control" name="slide_title" value="${_existed_slide_title}" />

                </div>

                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

            `;

                if (_existed_slide_image != '') {

                    _slide_content_html += `<div class="existed-image-container"><br><label class="slide-existing-image">${_existed_image_label_text}: </label><img class="sld-image" src="/uploads/${_existed_slide_image}" alt="">  <i class="fa fa-times" aria-hidden="true"></i>
                        <input type="hidden" name="existing_slide_image" value="${_existed_slide_image}">
                    </div>`;

                }


            break;

            case 'title_text_and_video':


                //$(this).parents('form:first').attr('enctype', 'multipart/form-data').attr('method', 'POST');

                _slide_content_html = `

                <div class="column-parent">

                    <label>${slide_title_text}</label>
                    <input type="text" class="form-control" name="slide_title" value="${_existed_slide_title}" />

                </div>

                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

                <div class="column-parent">
                    <label>${slide_video_text}</label>
                    <input type="text" class="form-control slide_video" name="slide_video" id="slide_video" value="${_existed_slide_video}" />
                </div>

            `;




                break;

            case 'image_and_text':

                //$(this).parents('form:first').attr('enctype', 'multipart/form-data').attr('method', 'POST');
                var _slide_ratio_html = '<br><select class="form-control" name="slide_ratio" id="slide_ratio"><option '+(_existed_slide_ratio == '16 / 9' ? 'selected' : '') + ' value="16 / 9">16 / 9</option><option '+(_existed_slide_ratio == '4 / 3' ? 'selected' : '') + ' value="4 / 3">4 / 3</option></select><br>';

                _slide_content_html = `

                <div class="column-parent">
                    <label>${slide_image_text}
                    <br><small><strong>${best_image_size_text}</strong></small>
                    </label>
                    ${_slide_ratio_html}
                    <div class="avatarimage" id="drop-area">
                        <img src="/images/grey_cube.png" alt="avatar" id="avatarimage">
                    </div>
                    <input type="file" class="form-control slide_image" name="slide_image" id="slide_image" value="" />
                    <br>
                        <label for="slide_image_source">${slide_image_resource}</label><br>
                        <input type="text" class="form-control slide_image_source" name="slide_image_source" id="slide_image_source" value="${_existed_slide_image_source}" />
                </div>

                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

            `;

                if (_existed_slide_image != '') {

                    _slide_content_html += `<div class="existed-image-container"><br><label class="slide-existing-image">${_existed_image_label_text}: </label><img class="sld-image" src="/uploads/${_existed_slide_image}" alt="">  <i class="fa fa-times" aria-hidden="true"></i>
                        <input type="hidden" name="existing_slide_image" value="${_existed_slide_image}">
                    </div>`;

                }

            break;

            case 'text_and_video':

                //$(this).parents('form:first').attr('enctype', 'multipart/form-data').attr('method', 'POST');

                _slide_content_html = `
                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

                <div class="column-parent">
                    <label>${slide_video_text}</label>
                    <input type="text" class="form-control slide_video" name="slide_video" id="slide_video" value="${_existed_slide_video}" />
                </div>

            `;

                break;

            case 'text_and_input':

                _slide_content_html = `


                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

            `;


                break;

            case 'last_slide':

                _slide_content_html = `


                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

            `;


                break;

            case 'text_and_memo':

                _slide_content_html = `


                <div class="column-parent">

                    <label>${slide_text_text}</label>
                    <textarea type="text" class="form-control" maxlength="300" name="slide_text">${_existed_slide_text}</textarea>

                </div>

            `;


                break;

            case 'text_and_3_radio_and_image':
            case 'text_and_4_radio_and_image':

                var _numbr_of_radio_btns = parseInt(_pe_code.replace('text_and_', '').replace('_radio', ''));

                var _radio_html_start = `<div class="column-parent"><label for="">${slide_over_radio_text}:</label><textarea class="form-control" name="slide_text" maxlength="300" id="" cols="30" rows="5">${_existed_slide_text}</textarea></div>`;

                var _radio_html_end = '';

                for (var zzx = 1; zzx <= _numbr_of_radio_btns; zzx++) {

                    var _existed_radio_text = '';

                    if (typeof _slide_content_existed['radio_buttons'] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code][zzx] != 'undefined') {

                        _existed_radio_text = _slide_content_existed['radio_buttons'][_pe_code][zzx];

                    }

                    var slide_radio_text = $('#slide_radio'+zzx+'_text').data('text');

                    _radio_html_end += `<div class="column-parent column-parent-dyn-radio"><label>${slide_radio_text}:</label><input class="form-control" type="text" value="${_existed_radio_text}" name="radio_buttons[${_pe_code}][${zzx}]"></div>`;

                }

                var _slide_ratio_html = '<br><select class="form-control" name="slide_ratio" id="slide_ratio"><option '+(_existed_slide_ratio == '16 / 9' ? 'selected' : '') + ' value="16 / 9">16 / 9</option><option '+(_existed_slide_ratio == '4 / 3' ? 'selected' : '') + ' value="4 / 3">4 / 3</option></select><br>';

                var add_image_html = `<div class="column-parent">
                        <label>${slide_image_text}
                        <br><small><strong>${best_image_size_text}</strong></small>
                        </label>
                        ${_slide_ratio_html}
                        <div class="avatarimage" id="drop-area">
                            <img src="/images/grey_cube.png" alt="avatar" id="avatarimage">
                        </div>
                        <input type="file" class="form-control slide_image" name="slide_image" id="slide_image" value="" />
                        <br>
                        <label for="slide_image_source">${slide_image_resource}</label><br>
                        <input type="text" class="form-control slide_image_source" name="slide_image_source" id="slide_image_source" value="${_existed_slide_image_source}" />
                    </div>`;

                if (_existed_slide_image != '') {

                    add_image_html += `<div class="existed-image-container"><br><label class="slide-existing-image">${_existed_image_label_text}: </label><img class="sld-image" src="/uploads/${_existed_slide_image}" alt="">  <i class="fa fa-times" aria-hidden="true"></i>
                        <input type="hidden" name="existing_slide_image" value="${_existed_slide_image}">
                    </div>`;

                }

                _slide_content_html = _radio_html_start + _radio_html_end + add_image_html;

                break;
            case 'text_and_2_radio':
            case 'text_and_3_radio':
            case 'text_and_4_radio':
            case 'text_and_5_radio':
            case 'text_and_6_radio':

                var _numbr_of_radio_btns = parseInt(_pe_code.replace('text_and_', '').replace('_radio', ''));

                var _radio_html_start = `<div class="column-parent"><label for="">${slide_over_radio_text}:</label><textarea class="form-control" name="slide_text" maxlength="300" id="" cols="30" rows="5">${_existed_slide_text}</textarea></div>`;

                var _radio_html_end = '';

                for (var zzx = 1; zzx <= _numbr_of_radio_btns; zzx++) {

                    var _existed_radio_text = '';

                    if (typeof _slide_content_existed['radio_buttons'] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code][zzx] != 'undefined') {

                        _existed_radio_text = _slide_content_existed['radio_buttons'][_pe_code][zzx];

                    }

                    var slide_radio_text = $('#slide_radio'+zzx+'_text').data('text');

                    _radio_html_end += `<div class="column-parent column-parent-dyn-radio"><label>${slide_radio_text}:</label><input class="form-control" type="text" value="${_existed_radio_text}" name="radio_buttons[${_pe_code}][${zzx}]"></div>`;

                }

                _slide_content_html = _radio_html_start + _radio_html_end;

                break;

            case 'image_and_2_radio':
            case 'image_and_3_radio':
            case 'image_and_4_radio':
            case 'image_and_5_radio':
            case 'image_and_6_radio':

                var _numbr_of_radio_btns = parseInt(_pe_code.replace('image_and_', '').replace('_radio', ''));

                var _slide_ratio_html = '<br><select class="form-control" name="slide_ratio" id="slide_ratio"><option '+(_existed_slide_ratio == '16 / 9' ? 'selected' : '') + ' value="16 / 9">16 / 9</option><option '+(_existed_slide_ratio == '4 / 3' ? 'selected' : '') + ' value="4 / 3">4 / 3</option></select><br>';

                var _radio_html_start = `<div class="column-parent">
                    <label>${slide_image_text}
                    <br><small><strong>${best_image_size_text}</strong></small>
                    </label>
                    ${_slide_ratio_html}
                    <div class="avatarimage" id="drop-area">
                        <img src="/images/grey_cube.png" alt="avatar" id="avatarimage">
                    </div>
                    <input type="file" class="form-control slide_image" name="slide_image" id="slide_image" value="" />
                    <br>
                        <label for="slide_image_source">${slide_image_resource}</label><br>
                        <input type="text" class="form-control slide_image_source" name="slide_image_source" id="slide_image_source" value="${_existed_slide_image_source}" />
                </div>`;

                if (_existed_slide_image != '') {

                    _radio_html_start += `<div class="existed-image-container"><br><label class="slide-existing-image">${_existed_image_label_text}: </label><img class="sld-image" src="/uploads/${_existed_slide_image}" alt="">  <i class="fa fa-times" aria-hidden="true"></i>
                        <input type="hidden" name="existing_slide_image" value="${_existed_slide_image}">
                    </div>`;

                }

                var _radio_html_end = '';

                for (var zzx = 1; zzx <= _numbr_of_radio_btns; zzx++) {

                    var _existed_radio_text = '';

                    if (typeof _slide_content_existed['radio_buttons'] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code][zzx] != 'undefined') {

                        _existed_radio_text = _slide_content_existed['radio_buttons'][_pe_code][zzx];

                    }

                    var slide_radio_text = $('#slide_radio'+zzx+'_text').data('text');

                    _radio_html_end += `<div class="column-parent column-parent-dyn-radio"><label>${slide_radio_text}:</label><input class="form-control" type="text" value="${_existed_radio_text}" name="radio_buttons[${_pe_code}][${zzx}]"></div>`;

                }

                _slide_content_html = _radio_html_start + _radio_html_end;

                break;

        }

        var add_top_link_text = $('#add_top_link').data('text');
        var add_bottom_link_text = $('#add_bottom_link').data('text');
        var add_url_text = $('#add_url').data('text');
        var open_in_new_tab_text = $('#open_in_new_tab').data('text');
        var link_text_text = $('#link_text').data('text');

        var add_top_link_text = $('#add_top_link').data('text');

        var top_links_existed_html = '';
        var bottom_links_existed_html = '';

        if (typeof _slide_content_existed != 'undefined' && typeof _slide_content_existed['top_link'] != 'undefined') {

            var astlp_counter1 = 0;

            for (var inx in _slide_content_existed['top_link']) {

                top_links_existed_html += '<div class="one-link-container"><input class="slide-link-form-control form-control" placeholder="'+link_text_text+'" type="text" value="'+_slide_content_existed['top_link'][inx]['text']+'" name="top_link_text['+astlp_counter1+']"><input class="slide-link-form-control form-control" placeholder="'+add_url_text+'" type="text" value="'+_slide_content_existed['top_link'][inx]['url']+'" name="top_link_url['+astlp_counter1+']"><input class="slide-link-form-control-check" type="checkbox" value="" name="top_link_new_tab['+astlp_counter1+']" title="'+open_in_new_tab_text+'"'+(_slide_content_existed['top_link'][inx]['new_tab'] == '1' ? ' checked="checked"' : '')+'><i aria-hidden="true" class="fa fa-times"></i></div>';
                astlp_counter1++;
            }
        }

        if (typeof _slide_content_existed != 'undefined' && typeof _slide_content_existed['bottom_link'] != 'undefined') {

            var astlp_counter2 = 0;

            for (var inx in _slide_content_existed['bottom_link']) {

                bottom_links_existed_html += '<div class="one-link-container"><input class="slide-link-form-control form-control" placeholder="'+link_text_text+'" type="text" value="'+_slide_content_existed['bottom_link'][inx]['text']+'" name="bottom_link_text['+astlp_counter2+']"><input class="slide-link-form-control form-control" placeholder="'+add_url_text+'" type="text" value="'+_slide_content_existed['bottom_link'][inx]['url']+'" name="bottom_link_url['+astlp_counter2+']"><input class="slide-link-form-control-check" type="checkbox" value="" name="bottom_link_new_tab['+astlp_counter2+']" title="'+open_in_new_tab_text+'"'+(_slide_content_existed['bottom_link'][inx]['new_tab'] == '1' ? ' checked="checked"' : '')+'><i aria-hidden="true" class="fa fa-times"></i></div>';

                astlp_counter2++;
            }
        }

        var top_links = `<div class="slide-top-links"><a href="javacript:void(0);" class="add-slide-top-link-plus">${add_top_link_text}</a><div class="slide-links-container">${top_links_existed_html}</div></div>`;

        var bottom_links =`<div class="slide-bottom-links"><a href="javacript:void(0);" class="add-slide-bottom-link-plus">${add_bottom_link_text}</a><div class="slide-links-container">${bottom_links_existed_html}</div></div>`;

        $('.slide-content').html(top_links+_slide_content_html+bottom_links);

        // top link + click
        $('.add-slide-top-link-plus').click(function() {
            var astlp_counter3 = $('.slide-top-links .slide-links-container .one-link-container').length;


            $('.slide-top-links .slide-links-container').append('<div class="one-link-container"><input class="slide-link-form-control form-control" placeholder="'+link_text_text+'" type="text" value="" name="top_link_text['+astlp_counter3+']"><input class="slide-link-form-control form-control" placeholder="'+add_url_text+'" type="text" value="" name="top_link_url['+astlp_counter3+']"><input class="slide-link-form-control-check" type="checkbox" value="" name="top_link_new_tab['+astlp_counter3+']" title="'+open_in_new_tab_text+'"><i aria-hidden="true" class="fa fa-times"></i></div>');

        });

        // bottom link + click

        $('.add-slide-bottom-link-plus').click(function() {
            var astlp_counter4 = $('.slide-bottom-links .slide-links-container .one-link-container').length;


            $('.slide-bottom-links .slide-links-container').append('<div class="one-link-container"><input class="slide-link-form-control form-control" placeholder="'+link_text_text+'" type="text" value="" name="bottom_link_text['+astlp_counter4+']"><input class="slide-link-form-control form-control" placeholder="'+add_url_text+'" type="text" value="" name="bottom_link_url['+astlp_counter4+']"><input class="slide-link-form-control-check" type="checkbox" value="" name="bottom_link_new_tab['+astlp_counter4+']" title="'+open_in_new_tab_text+'"><i aria-hidden="true" class="fa fa-times"></i></div>');

        });

        $(document).on('click', '.one-link-container .fa-times', function() {
            $(this).parents('.one-link-container:first').remove();
        });

        $('#avatarimage').click(function() {

            $('#slide_image').click();

        });

        /* DROP/ZOOM/CROP */

        $('#cropModal').on('hide.bs.modal', function () {
            $("#cropimage").html('<img id="imageprev" src=""/>');
        })

        /* UPLOAD Image */
        var slide_image_input = document.getElementById('slide_image');
        var $alert = $('.alert');

        /* DRAG and DROP File */
        $("#drop-area").on('dragenter', function (e){
            e.preventDefault();
        });

        $("#drop-area").on('dragover', function (e){
            e.preventDefault();
        });

        $("#drop-area").on('drop', function (e){
            var image = document.querySelector('#imageprev');
            var files = e.originalEvent.dataTransfer.files;

            var done = function (url) {
                slide_image_input.value = '';
                image.src = url;
                $alert.hide();
                $("#cropModal").modal({backdrop: "static"});
                cropImage();
            };

            var reader;
            var file;
            var url;

            if (files && files.length > 0) {
                file = files[0];

                if (URL) {
                    done(URL.createObjectURL(file));
                } else if (FileReader) {
                    reader = new FileReader();
                    reader.onload = function (e) {
                        done(reader.result);
                    };
                    reader.readAsDataURL(file);
                }
            }

            e.preventDefault();

        });

        /* INPUT UPLOAD FILE */
        slide_image_input.addEventListener('change', function (e) {
            var image = document.querySelector('#imageprev');
            var files = e.target.files;
            var done = function (url) {
                slide_image_input.value = '';
                image.src = url;
                $alert.hide();
                $("#cropModal").modal({backdrop: "static"});
                cropImage();

            };
            var reader;
            var file;
            var url;

            if (files && files.length > 0) {
                file = files[0];

                if (URL) {
                    done(URL.createObjectURL(file));
                } else if (FileReader) {
                    reader = new FileReader();
                    reader.onload = function (e) {
                        done(reader.result);
                    };
                    reader.readAsDataURL(file);
                }
            }
        });
        /* CROP IMAGE AFTER UPLOAD */
        function cropImage() {
            console.log('inside cropImage');
            var image = document.querySelector('#imageprev');
            var minAspectRatio = 0.5;
            var maxAspectRatio = 1.5;

            console.log('slide_ratio');
            console.log($('#slide_ratio').val());

            var cropper = new Cropper(image, {
                aspectRatio: $('#slide_ratio').val(),
                minCropBoxWidth: 1240,
                minCropBoxHeight: 700,

                ready: function () {
                    var cropper = this.cropper;
                    var containerData = cropper.getContainerData();
                    var cropBoxData = cropper.getCropBoxData();
                    var aspectRatio = cropBoxData.width / cropBoxData.height;
                    //var aspectRatio = 4 / 3;
                    var newCropBoxWidth;
                    cropper.setDragMode("move");
                    if (aspectRatio < minAspectRatio || aspectRatio > maxAspectRatio) {
                        newCropBoxWidth = cropBoxData.height * ((minAspectRatio + maxAspectRatio) / 2);

                        cropper.setCropBoxData({
                            left: (containerData.width - newCropBoxWidth) / 2,
                            width: newCropBoxWidth
                        });
                    }
                },

                cropmove: function () {
                    var cropper = this.cropper;
                    var cropBoxData = cropper.getCropBoxData();
                    var aspectRatio = cropBoxData.width / cropBoxData.height;

                    if (aspectRatio < minAspectRatio) {
                        cropper.setCropBoxData({
                            width: cropBoxData.height * minAspectRatio
                        });
                    } else if (aspectRatio > maxAspectRatio) {
                        cropper.setCropBoxData({
                            width: cropBoxData.height * maxAspectRatio
                        });
                    }
                },


            });

            $("#scaleY").click(function(){
                var Yscale = cropper.imageData.scaleY;
                if(Yscale==1){ cropper.scaleY(-1); } else {cropper.scaleY(1);};
            });

            $("#scaleX").click( function(){
                var Xscale = cropper.imageData.scaleX;
                if(Xscale==1){ cropper.scaleX(-1); } else {cropper.scaleX(1);};
            });

            $("#rotateR").click(function(){ cropper.rotate(45); });
            $("#rotateL").click(function(){ cropper.rotate(-45); });
            $("#reset").click(function(){ cropper.reset(); });

            var canvas_z = null;
            var initialAvatarURL = null;

            $("#saveAvatar").click(function(){
                var $progress = $('.progress');
                var $progressBar = $('.progress-bar');
                var avatar = document.getElementById('avatarimage');
                var $alert = $('.alert');


                canvas_z = cropper.getCroppedCanvas({

                });


                $progress.show();
                $alert.removeClass('alert-success alert-warning');
                canvas_z.toBlob(function (blob) {

                    $("#cropModal").modal('hide');
                    $progress.hide();
                    initialAvatarURL = avatar.src;
                    avatar.src = canvas_z.toDataURL();

                });

            });
        };

        /* DROP/ZOOM/CROP END */

    });

    // REMOVE SLIDE IMAGE
    $(document).on('click', '.existed-image-container .fa-times', function() {
        $(this).parents('.existed-image-container:first').remove();
    });

    // OPEN ALL CATS
    $('#open-all-cats').click(function(){
        $('.entity-parent.category-parent').addClass('shown');
    });

    // SHOW SLIDE PREVIEW
    $('#previewSlideModal').on('show.bs.modal', function (event) {

        var _button = $(event.relatedTarget);

        var _slide_id = $(_button).data('slideid');
        var _pe_code = $(_button).data('pecode');

        var _slide_content_existed = $(_button).data('slidecontent');

        var _existed_slide_image = '';
        var _existed_slide_image_source = '';
        var _existed_slide_image_source_text = $('#slide_image_resource').data('text');
        var _existed_slide_video = '';
        var _existed_slide_title = '';
        var _existed_slide_text = '';

        var final_preview_html = '';

        if ( _slide_content_existed != '') {

            console.log('_slide_content_existed');
            console.log(_slide_content_existed);

            if (typeof _slide_content_existed['slide_image'] != 'undefined') {
                _existed_slide_image = _slide_content_existed['slide_image'];
            }
            if (typeof _slide_content_existed['slide_image_source'] != 'undefined') {
                _existed_slide_image_source = _existed_slide_image_source_text +' '+_slide_content_existed['slide_image_source'];
            }

            if (typeof _slide_content_existed['slide_video'] != 'undefined') {
                _existed_slide_video = _slide_content_existed['slide_video'];
            }

            if (typeof _slide_content_existed['slide_title'] != 'undefined') {
                _existed_slide_title = _slide_content_existed['slide_title'];
            }

            if (typeof _slide_content_existed['slide_text'] != 'undefined') {
                _existed_slide_text = _slide_content_existed['slide_text'];
            }

            switch (_pe_code) {

                case 'title_text_image':


                    final_preview_html = `
                    <div class="preview-item pi-title">
                        ${_existed_slide_title}
                    </div>

                    <div class="preview-item pi-text">
                        ${_existed_slide_text}
                    </div>

                    <div class="preview-item pi-image">
                        <img title="${_existed_slide_image_source}" src="/uploads/${_existed_slide_image}" alt="">

                    </div>
                `;

                    break;

                case 'title_text_image_and_video':

                    var video_embed_id = '';

                    if (_existed_slide_video != '') {

                        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                        var match = _existed_slide_video.match(regExp);

                        video_embed_id = (match&&match[7].length==11) ? match[7] : '';

                    }

                    final_preview_html = `
                    <div class="preview-item pi-title">
                        ${_existed_slide_title}
                    </div>

                    <div class="preview-item pi-text">
                        ${_existed_slide_text}
                    </div>

                    <div class="preview-item pi-image">
                        <img title="${_existed_slide_image_source}" src="/uploads/${_existed_slide_image}" alt="">

                    </div>

                    <div class="preview-item pi-video">
                        <iframe class="pi-video-iframe" allow="fullscreen;" src="https://www.youtube.com/embed/${video_embed_id}?autoplay=1&mute=1"></iframe>
                    </div>
                `;

                    break;

                case 'image_title_text':

                    final_preview_html = `

                <div class="preview-item pi-image">
                        <img title="${_existed_slide_image_source}" src="/uploads/${_existed_slide_image}" alt="">

                </div>

                <div class="preview-item pi-title">
                    ${_existed_slide_title}
                </div>

                <div class="preview-item pi-text">
                    ${_existed_slide_text}
                </div>

            `;

                    break;

                case 'title_text_and_video':

                    var video_embed_id = '';

                    if (_existed_slide_video != '') {

                        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                        var match = _existed_slide_video.match(regExp);

                        video_embed_id = (match&&match[7].length==11) ? match[7] : '';

                    }

                    final_preview_html = `

                <div class="preview-item pi-title">
                    ${_existed_slide_title}
                </div>

                <div class="preview-item pi-text">
                    ${_existed_slide_text}
                </div>

                <div class="preview-item pi-video">
                        <iframe class="pi-video-iframe" allow="fullscreen;" src="https://www.youtube.com/embed/${video_embed_id}?autoplay=1&mute=1"></iframe>
                    </div>

            `;

                    break;

                case 'image_and_text':

                    final_preview_html = `

                <div class="preview-item pi-image">
                        <img title="${_existed_slide_image_source}" src="/uploads/${_existed_slide_image}" alt="">

                    </div>

                <div class="preview-item pi-text">
                    ${_existed_slide_text}
                </div>

            `;

                    break;

                case 'text_and_video':

                    var video_embed_id = '';

                    if (_existed_slide_video != '') {

                        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                        var match = _existed_slide_video.match(regExp);

                        video_embed_id = (match&&match[7].length==11) ? match[7] : '';

                    }

                    final_preview_html = `

                    <div class="preview-item pi-text">
                        ${_existed_slide_text}
                    </div>

                    <div class="preview-item pi-video">
                        <iframe class="pi-video-iframe" allow="fullscreen;" src="https://www.youtube.com/embed/${video_embed_id}?autoplay=1&mute=1"></iframe>
                    </div>

               `;

                break;

                case 'text_and_input':

                    final_preview_html = `

                        <div class="preview-item pi-text">
                            ${_existed_slide_text}
                        </div>
                        <div class="preview-item pi-textarea">
                            <input type="text" class="form-control">
                        </div>

                    `;


                break;

                case 'last_slide':

                    final_preview_html = `

                        <div class="preview-item pi-text">
                            ${_existed_slide_text}
                        </div>

                    `;

                break;

                case 'text_and_memo':

                    final_preview_html = `

                <div class="preview-item pi-text">
                    ${_existed_slide_text}
                </div>
                <div class="preview-item pi-textarea">
                <textarea class="form-control" name="" id="" cols="30" rows="2"></textarea>
                </div>
            `;


                    break;

                case 'text_and_3_radio_and_image':
                case 'text_and_4_radio_and_image':

                    var _numbr_of_radio_btns = parseInt(_pe_code.replace('text_and_', '').replace('_radio', ''));

                    var _radio_html_start = `
                    <div class="preview-item-container-with-radio">
                    <div class="preview-item pi-text">
                        ${_existed_slide_text}
                    </div>`;

                    var _radio_html_end = '<div class="radio-container-main">';

                    for (var zzx = 1; zzx <= _numbr_of_radio_btns; zzx++) {

                        var _existed_radio_text = '';

                        if (typeof _slide_content_existed['radio_buttons'] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code][zzx] != 'undefined') {

                            _existed_radio_text = _slide_content_existed['radio_buttons'][_pe_code][zzx];

                        }

                        var slide_radio_text = $('#slide_radio'+zzx+'_text').data('text');

                        _radio_html_end += `<div class="pi-radio"><label><input class="" type="radio" value="" name="radio_buttons[${_pe_code}]"> ${_existed_radio_text}</label></div>`;

                    }

                    _radio_html_end += '<div class="pi-clearfix"></div></div></div>';

                    var add_image_html = `<div class="preview-item pi-image">
                        <img title="${_existed_slide_image_source}" src="/uploads/${_existed_slide_image}" alt="">
                    </div>`;

                    final_preview_html = _radio_html_start + _radio_html_end + add_image_html;

                    break;

                case 'text_and_2_radio':
                case 'text_and_3_radio':
                case 'text_and_4_radio':
                case 'text_and_5_radio':
                case 'text_and_6_radio':

                    var _numbr_of_radio_btns = parseInt(_pe_code.replace('text_and_', '').replace('_radio', ''));

                    var _radio_html_start = `
                    <div class="preview-item-container-with-radio">
                    <div class="preview-item pi-text">
                        ${_existed_slide_text}
                    </div>`;

                    var _radio_html_end = '<div class="radio-container-main">';

                    for (var zzx = 1; zzx <= _numbr_of_radio_btns; zzx++) {

                        var _existed_radio_text = '';

                        if (typeof _slide_content_existed['radio_buttons'] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code][zzx] != 'undefined') {

                            _existed_radio_text = _slide_content_existed['radio_buttons'][_pe_code][zzx];

                        }

                        var slide_radio_text = $('#slide_radio'+zzx+'_text').data('text');

                        _radio_html_end += `<div class="pi-radio"><label><input class="" type="radio" value="" name="radio_buttons[${_pe_code}]"> ${_existed_radio_text}</label></div>`;

                    }

                    _radio_html_end += '<div class="pi-clearfix"></div></div></div>';

                    final_preview_html = _radio_html_start + _radio_html_end;

                    break;

                case 'image_and_2_radio':
                case 'image_and_3_radio':
                case 'image_and_4_radio':
                case 'image_and_5_radio':
                case 'image_and_6_radio':

                    var _numbr_of_radio_btns = parseInt(_pe_code.replace('image_and_', '').replace('_radio', ''));

                    var _radio_html_start = `
                    <div class="preview-item pi-image">
                        <img title="${_existed_slide_image_source}" src="/uploads/${_existed_slide_image}" alt="">

                    </div>`;

                    var _radio_html_end = '<div class="radio-container-main">';

                    for (var zzx = 1; zzx <= _numbr_of_radio_btns; zzx++) {

                        var _existed_radio_text = '';

                        if (typeof _slide_content_existed['radio_buttons'] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code] != 'undefined' && typeof _slide_content_existed['radio_buttons'][_pe_code][zzx] != 'undefined') {

                            _existed_radio_text = _slide_content_existed['radio_buttons'][_pe_code][zzx];

                        }

                        var slide_radio_text = $('#slide_radio'+zzx+'_text').data('text');

                        _radio_html_end += `<div class="pi-radio"><label><input class="" type="radio" value="" name="radio_buttons[${_pe_code}]"> ${_existed_radio_text}</label></div>`;

                    }

                    _radio_html_end += '<div class="pi-clearfix"></div></div></div>';

                    final_preview_html = _radio_html_start + _radio_html_end;

                    break;

            }


            var top_links_existed_html = '';
            var bottom_links_existed_html = '';

            if (typeof _slide_content_existed != 'undefined' && typeof _slide_content_existed['top_link'] != 'undefined') {

                top_links_existed_html = '<div class="preview-item pi-toplink">';

                for (var inx in _slide_content_existed['top_link']) {

                    top_links_existed_html += '<a href="'+_slide_content_existed['top_link'][inx]['url']+'" '+(_slide_content_existed['top_link'][inx]['new_tab'] == '1' ? ' target="_blank"' : '')+'>'+_slide_content_existed['top_link'][inx]['text']+'</a>';

                }

                top_links_existed_html += '</div>';

                final_preview_html = top_links_existed_html + final_preview_html;

            }

            if (typeof _slide_content_existed != 'undefined' && typeof _slide_content_existed['bottom_link'] != 'undefined') {

                bottom_links_existed_html = '<div class="preview-item pi-toplink">';
                var last_slide_icon = '';
                var last_slide_class = '';

                if (_pe_code == 'last_slide') {
                    last_slide_icon = '<i class="fa fa-square-o" aria-hidden="true"></i> ';
                    last_slide_class = 'last-slide-sbcl';
                }
                for (var inx in _slide_content_existed['bottom_link']) {

                    bottom_links_existed_html += '<a class="slide-bottom-custom-link '+last_slide_class+'" href="'+_slide_content_existed['bottom_link'][inx]['url']+'" '+(_slide_content_existed['bottom_link'][inx]['new_tab'] == '1' ? ' target="_blank"' : '')+'>'+last_slide_icon +_slide_content_existed['bottom_link'][inx]['text']+'</a>';

                }

                bottom_links_existed_html += '</div>';

                final_preview_html = final_preview_html + bottom_links_existed_html;
            }

            final_preview_html += '<div class="preview-item pi-next"><button class="btn btn-success">NEXT</button></div>'

            $('#previewSlideModal .modal-body').html(final_preview_html);

        }

    });

    // SORTING and DROPING SLIDES TO CONNECT TO QUIZ

    $('.quiz-children-container').sortable({
        placeholder: "sortable-placeholder",
        stop: function (event, ui) {

            var current_quiz_container = this;
            var quizid = $(this).data('quizid');

            var QuizSlides = 'q_id='+quizid;

            $(current_quiz_container).find('.slide-parent').each(function(index) {

                var _sld_id = $(this).data('slideid');

                $(this).find('form.sbmt-delete-form').replaceWith('<a class="remove-slide-from-quiz not-run-yet" id="remove_slide_from_quiz_'+quizid+'_'+_sld_id+'" href="javascript:void(0);"><i aria-hidden="true" class="fa fa-times"></i></a>');

                QuizSlides += '&quiz_slide['+quizid+'_'+_sld_id+']=' + (parseInt(index)+1);

            });

            $.ajax({
                url: $('#connect_slide_to_quiz').data('url'),
                type: "GET",
                data: QuizSlides,
                success: function (data) {

                    makeSlidesDeletable();

                }
            });

        },
        over: function ( event, ui ) {

            $(this).addClass('active');
            $(this).parents('.entity-parent.quizz-parent:first').addClass('shown');
            console.log('.entity-parent.quizz-parent:first');
            console.log(this);
        },
        out: function ( event, ui ) {

            $(this).removeClass('active');
        },
        receive : function(event, ui) {

            console.log('received from-slides-container to quiz');
            console.log('class');
            console.log($(ui.item).attr('class'));

            if ($(ui.item).hasClass('from-slides-container')) {
                console.log('from-slides-container');
                /*$(ui.sender).sortable('cancel');*/
            }


            var current_quiz_container = this;
            var quizid = $(this).data('quizid');

            console.log('current_quiz_container');
            console.log(current_quiz_container);

            console.log('current_quiz_container slide parent length');
            console.log($(current_quiz_container).find('.slide-parent').length);

            var QuizSlides = 'q_id='+quizid;

            $(current_quiz_container).find('.slide-parent').each(function(index) {

                var _sld_id = $(this).data('slideid');

                if ($(this).has('category-parent')) {

                    $(this).find('a.remove-slide-from-category').replaceWith('<a class="remove-slide-from-quiz not-run-yet" id="remove_slide_from_quiz_'+quizid+'_'+_sld_id+'" href="javascript:void(0);"><i aria-hidden="true" class="fa fa-times"></i></a>');

                }
                else {

                    $(this).find('form.sbmt-delete-form').replaceWith('<a class="remove-slide-from-quiz not-run-yet" id="remove_slide_from_quiz_'+quizid+'_'+_sld_id+'" href="javascript:void(0);"><i aria-hidden="true" class="fa fa-times"></i></a>');

                }



                QuizSlides += '&quiz_slide['+quizid+'_'+_sld_id+']=' + (parseInt(index)+1);

            });

            $.ajax({
                url: $('#connect_slide_to_quiz').data('url'),
                type: "GET",
                data: QuizSlides,
                success: function (data) {

                    makeSlidesDeletable();

                }
            });
        }

    });


    // SORTING and DROPING SLIDES TO CONNECT TO CATEGORIES

    $(document).on('click', '.entity-parent.category-parent .qtitle', function() {
        $(this).parents('.category-parent:first').toggleClass('shown');
    });

    $(document).on('click', '.entity-parent.quizz-parent .qtitle', function() {
        $(this).parents('.quizz-parent:first').toggleClass('shown');
    });

    $('.category-children-container').sortable({
        connectWith: '.quiz-children-container',
        helper: "clone",
        start: function (event, ui) {

            $('.category-children-container .category-parent.slide-parent').show();

            console.log('show all items');

            $(ui.item).addClass('from-slides-container');
            //var fcs_slide = $('.slides-children-container .from-slides-container').clone();
            //$(fcs_slide).removeClass('from-slides-container').addClass('cloned-fcs').insertAfter($('.slides-children-container .from-slides-container'));


        },
        remove: function (event, ui) {

            console.log('quizz-parent-id');
            console.log($(ui.item).parents('.quizz-parent:first').attr('id'));
            var dropped_into_parent_id = $(ui.item).parents('.entity-parent:first').attr('id');


            var _sld_id = $(ui.item).data('slideid');

            if ($('#'+ dropped_into_parent_id +' .quiz-children-container .slide-parent[data-slideid="'+_sld_id+'"]').length == 1) {
                ui.item.clone().appendTo('#'+ dropped_into_parent_id +' .quiz-children-container');
            }



            $(this).sortable('cancel');
        },
        stop:function (event, ui) {

            var _current_slides_parent = this;
            //console.log('dropped slide into slides container');

            var allSlidesOrders = '';

            $('.category-children-container .slide-parent').each(function(index) {

                var catid = $(this).parents('.category-children-container:first').data('catid');
                allSlidesOrders += (allSlidesOrders != '' ? '&' : '') + 'slide['+catid +'_' + $(this).data('slideid')+']='+ (parseInt(index)+1);

            });

            $.ajax({
                url: $('#set_slide_order_in_cat').data('url'),
                type: "GET",
                data: allSlidesOrders,
                success: function (data) {

                }
            });

        },
        over: function ( event, ui ) {

            $(this).addClass('active');
            $(this).parents('.entity-parent.category-parent:first').addClass('shown');
        },
        out: function ( event, ui ) {

            $(this).removeClass('active');
        },
        receive : function(event, ui) {
            console.log('received from-slides-container to cat');
            if ($(ui.item).hasClass('from-slides-container')) {
                console.log('from-slides-container');
                /*$(ui.sender).sortable('cancel');*/
            }

            var current_cat_container = this;
            var catid = $(this).data('catid');

            var CatSlides = 'c_id='+catid;

            console.log('current_cat_container');
            console.log(current_cat_container);

            $(current_cat_container).find('.slide-parent').each(function(index) {

                var _sld_id = $(this).data('slideid');

                $(this).find('form.sbmt-delete-form').replaceWith('<a class="remove-slide-from-category not-run-yet" id="remove_slide_from_category_'+catid+'_'+_sld_id+'" href="javascript:void(0);"><i aria-hidden="true" class="fa fa-times"></i></a>');

                CatSlides += '&category_slide['+catid+'_'+_sld_id+']=' + (parseInt(index)+1);

            });

            $.ajax({
                url: $('#connect_slide_to_category').data('url'),
                type: "GET",
                data: CatSlides,
                success: function (data) {

                    makeSlidesDeletable();

                }
            });
        }

    });



    $('.slides-children-container').sortable({
        connectWith: '.quiz-children-container, .category-children-container',
        helper: "clone",
        start: function (event, ui) {

            //$('.slides-children-container .quizz-parent.slide-parent').show();

            console.log('show all itemszz');
            console.log($(ui.item));

            $(ui.item).addClass('from-slides-container');
            //var fcs_slide = $('.slides-children-container .from-slides-container').clone();
            //$(fcs_slide).removeClass('from-slides-container').addClass('cloned-fcs').insertAfter($('.slides-children-container .from-slides-container'));


        },
        remove: function (event, ui) {

           // console.log('quizz-parent-id');
            //console.log($(ui.item).parents('.quizz-parent:first').attr('id'));
            var dropped_into_parent_id = $(ui.item).parents('.entity-parent:first').attr('id');

            console.log('dropped_into_parent_id');
            console.log(dropped_into_parent_id);

            var _sld_id = $(ui.item).data('slideid');

            if ($('#'+dropped_into_parent_id).hasClass('quizz-parent')) {

                if ($('#'+ dropped_into_parent_id +' .quiz-children-container .slide-parent[data-slideid="'+_sld_id+'"]').length == 1) {
                    ui.item.clone().appendTo('#'+ dropped_into_parent_id +' .quiz-children-container');
                }
            }
            else {
                console.log('dropped in cat');

                if ($('#'+ dropped_into_parent_id +' .category-children-container .slide-parent[data-slideid="'+_sld_id+'"]').length == 1) {

                    $(ui.item).removeClass('slide-no-connections').addClass('slide-has-connections');

                    ui.item.clone().appendTo('#'+ dropped_into_parent_id +' .category-children-container');

                }

            }

            $(this).sortable('cancel');
        },
        stop:function (event, ui) {

            var _current_slides_parent = this;
            //console.log('dropped slide into slides container');

            var allSlidesOrders = '';

            $('.slides-children-container .slide-parent').each(function(index) {

                allSlidesOrders += (allSlidesOrders != '' ? '&' : '') + 'slide['+$(this).data('slideid')+']='+ (parseInt(index)+1);

            });

            $.ajax({
                url: $('#set_slide_order').data('url'),
                type: "GET",
                data: allSlidesOrders,
                success: function (data) {

                }
            });

        }
    });

    function makeSlidesDeletable() {

        $('.remove-slide-from-quiz.not-run-yet').each(function(){

            var _current_q_slide = this;
            $(_current_q_slide).removeClass('not-run-yet');

            $(_current_q_slide).click(function(){

                var quiz_slide = $(this).attr('id').replace('remove_slide_from_quiz_', '');

                $.ajax({
                    url: $('#remove_slide_from_quiz').data('url'),
                    type: "GET",
                    data: {'quiz_slide': quiz_slide},
                    success: function (data) {
                        $(_current_q_slide).parents('.slide-parent:first').remove();
                    }
                });

            });

        });

        $('.remove-slide-from-category.not-run-yet').each(function(){

            var _current_c_slide = this;
            $(_current_c_slide).removeClass('not-run-yet');

            $(_current_c_slide).click(function(){

                var category_slide = $(this).attr('id').replace('remove_slide_from_category_', '');

                $.ajax({
                    url: $('#remove_slide_from_category').data('url'),
                    type: "GET",
                    data: {'category_slide': category_slide},
                    success: function (data) {
                        $(_current_c_slide).parents('.slide-parent:first').remove();
                        location.reload();
                    }
                });

            });

        });

    }

    makeSlidesDeletable();

}

/* FRONT PREVIEW NEXT*/
if ($('.front-slide-parent').length > 0) {
    $('.front-slide-parent:first').show();

    $('.front-slide-parent .pi-next button.fqp-next-btn').click(function() {

        console.log('clicked button next');
        var _cur_parent = $(this).parents('.front-slide-parent:first');

        if ($(_cur_parent).next().hasClass('front-slide-parent')) {
            $(_cur_parent).hide();
            $(_cur_parent).next().show();
        }

        if ($(this).hasClass('fqp-next-btn-before-finish')) {

            var _current_quiz_next_link = this;

            if ($(this).hasClass('not-yet-fired')) {

                var _quiz_id = $(this).data('quizid');

                $.ajax({
                    url: $('#track_quiz').data('url'),
                    method: 'GET',
                    data: {'plus_one': 1, 'quiz_id': _quiz_id},
                    success: function(data) {
                        $(_current_quiz_next_link).removeClass('not-yet-fired');
                    }
                });

            }

        }

    });

    $('.front-slide-parent .pi-next button.fqp-prev-btn').click(function() {

        console.log('clicked button next');
        var _cur_parent = $(this).parents('.front-slide-parent:first');

        if ($(_cur_parent).prev().hasClass('front-slide-parent')) {
            $(_cur_parent).hide();
            $(_cur_parent).prev().show();
        }

    });

}

if ($('#top_help_quiz').length > 0) {

    var _url_for_quzzes_page = $('#top_help_text').data('url');
    var _text_for_quzzes_page = $('#top_help_text').data('text');

    if ($('.front-tipslabel-container').length > 0) {

        $('.front-tipslabel-container').append('<a target="_blank" class="top_help_text_label" href="'+_url_for_quzzes_page+'">'+_text_for_quzzes_page+'</a>');

    }
    else {

        $('body').prepend('<div class="front-tipslabel-container"></div>')
        $('.front-tipslabel-container').append('<a target="_blank" class="top_help_text_label" href="'+_url_for_quzzes_page+'">'+_text_for_quzzes_page+'</a>');

    }

    if ($('#faq_accordion').length > 0) {
        $('<a target="_blank" href="'+_url_for_quzzes_page+'">' + _text_for_quzzes_page + '</a>').insertAfter('#faq_accordion');
    }

}

if ($('.container-of-module-events').length > 0) {

    $('.archive-me').click(function(){

        var _cicked_icn = this;
        var module_event_id = $(this).data('meid');

        $.ajax({
            url: $('#archive').data('url'),
            method: 'POST',
            data: {'module_event_id': module_event_id},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    $(_cicked_icn).parents('.me-row:first').addClass('module-event-archived');

                }

            }
        });

    });

    $('.unarchive-me').click(function(){

        var module_event_id = $(this).data('meid');

        var _cicked_icn = this;

        $.ajax({
            url: $('#unarchive').data('url'),
            method: 'POST',
            data: {'module_event_id': module_event_id},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    $(_cicked_icn).parents('.me-row:first').removeClass('module-event-archived');

                }

            }
        });

    });

    $('#show-only-archived').click(function(){

        $('.me-clear-filters').click();
        $('.container-of-module-events').addClass('show-archived');

    });

    $('#show-only-active').click(function(){

        $('.me-clear-filters').click();
        $('.container-of-module-events').removeClass('show-archived');

    });

}

if ($('.front-statuses-checkbox').length > 0 && location.href.indexOf('front-statuses-checkbox') != -1) {

    if (location.href.indexOf('front-statuses-checkbox-31') != -1) {
        $('#front-statuses-checkbox-31').click();
    }
    if (location.href.indexOf('front-statuses-checkbox-32') != -1) {
        $('#front-statuses-checkbox-32').click();
    }
    if (location.href.indexOf('front-statuses-checkbox-33') != -1) {
        $('#front-statuses-checkbox-33').click();
    }
    if (location.href.indexOf('front-statuses-checkbox-34') != -1) {
        $('#front-statuses-checkbox-34').click();
    }

}

// slide connections tabs
if ($('.tab-show-slides').length > 0) {

    $('.tab-show-slides').click(function() {

        $('.tab-show-slides').removeClass('active');

        $(this).addClass('active');

        if ($(this).attr('id') == 'tab-show-slides-assigned') {
            $(this).parents('.md-slides:first').addClass('show-slides-with-connections');
        }
        else {
            $(this).parents('.md-slides:first').removeClass('show-slides-with-connections');
        }


    });

}


if ($('.container-of-lecturers').length > 0) {

    $('.archive-me').click(function(){

        var _cicked_icn = this;
        var lecturer_id = $(this).data('leid');

        $.ajax({
            url: $('#archive').data('url'),
            method: 'POST',
            data: {'lecturer_id': lecturer_id},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    $(_cicked_icn).parents('.le-row:first').addClass('lecturer-archived');

                }

            }
        });

    });

    $('.unarchive-me').click(function(){

        var lecturer_id = $(this).data('leid');

        var _cicked_icn = this;

        $.ajax({
            url: $('#unarchive').data('url'),
            method: 'POST',
            data: {'lecturer_id': lecturer_id},
            success: function(data) {

                if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                    $(_cicked_icn).parents('.le-row:first').removeClass('lecturer-archived');

                }

            }
        });

    });

    $('#le-show-only-archived').click(function(){
        $('.container-of-lecturers').addClass('show-archived');
    });

    $('#le-show-only-active').click(function(){
        $('.container-of-lecturers').removeClass('show-archived');
    });

}

/* MODULE EVENTS LECTURERS EXPORT*/
/*$("#fln_from, #fln_to").datepicker({
    dateFormat: 'dd.mm.yy',
    prevText: '&#x3c;zur?ck', prevStatus: '',
    prevJumpText: '&#x3c;&#x3c;', prevJumpStatus: '',
    nextText: 'Vor&#x3e;', nextStatus: '',
    nextJumpText: '&#x3e;&#x3e;', nextJumpStatus: '',
    currentText: 'heute', currentStatus: '',
    todayText: 'heute', todayStatus: '',
    clearText: '-', clearStatus: '',
    closeText: 'schließen', closeStatus: '',
    monthNames: ['Januar','Februar','März','April','Mai','Juni', 'Juli','August','September','Oktober','November','Dezember'],
    monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun', 'Jul','Aug','Sep','Okt','Nov','Dez'],
    dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
    dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
    onClose: function(selectedDate) {

    }
});*/

$('#lects_to_xls').click(function() {

    //empty form
    $('.secret-xls-form').html('');

    if ($('.me_bulk_check:checked').length > 0) {

        var _allowed_lects = [];
        var a_current_value = [];

        var me_filter_lecturer_name_value = $('#me_filter_lecturer_name').val().replace(', ', ',').replace(', ', ',').replace(', ', ',').replace(', ', ',').replace(', ', ',');

        if (me_filter_lecturer_name_value.indexOf(',') != -1) {

            a_current_value = me_filter_lecturer_name_value.split(',');

        }


        $('.me_bulk_check:checked').each(function(){

            var _module_event_id = $(this).attr('id').replace('bulk_','');
            var _module_id = $(this).data('moduleid');

           /* console.log('_module_event_id');
            console.log(_module_event_id);
            console.log('_module_id');
            console.log(_module_id);*/
            $('#module-event-'+ _module_event_id + ' .row-me-days:visible').each(function() {

                var _med_id = $(this).attr('id').replace('row-me-days-', '');

                $(this).find('.lecturer_now').each(function(){

                    var _lect_id = $(this).attr('id').replace('lecturer_now_', '');
                    var _lect_name = $(this).find('.ln_txt').text().trim();

                    for (var xzz = 0; xzz < a_current_value.length; xzz++) {

                        if (_lect_name.indexOf(a_current_value[xzz]) != -1) {
                            $('.secret-xls-form').append('<input name="lectIds[]" value="'+_lect_id+'" type="hidden"/>');
                        }

                    }

                });


                $('.secret-xls-form').append('<input name="medIds[]" value="'+_med_id+'" type="hidden"/>');

            });


        });

        $('.secret-xls-form').submit();

    }

});

/******************** ADMIN MODULE EVENTS PDF END *****************/

$('.secret-xls-form').bind('ajax:complete', function() {

    console.log('submit complete');

});

$('#me_filter_date').popover({
    template: '<div class="popover module-event-special-message-highlight" role="tooltip"><div class="arrow me"></div><div class="popover-body me"></div></div>',
    content: $('#me_filter_date').data('msg'),
    html: true,
    trigger: 'hover',
    placement: 'top',
    attachment: 'top left',
    targetAttachment: 'top left',
    offset: '0px'
});

$('#me_filter_lecturer_name').popover({
    template: '<div class="popover module-event-special-message-highlight" role="tooltip"><div class="arrow me"></div><div class="popover-body me"></div></div>',
    content: $('#me_filter_lecturer_name').data('msg'),
    html: true,
    trigger: 'hover',
    placement: 'top',
    attachment: 'top left',
    targetAttachment: 'top left',
    offset: '0px'
});
/* MODULE EVENTS LECTURERS EXPORT END*/

/* ADMIN ROLES*/
$(document).on('click', '.hlg_head label input', function() {
    if ($(this).prop('checked') == true) {

        $(this).parents('.hidden_links_group:first').find('.hlg_links input[type="checkbox"]').prop('checked', true);

        if ($(this).parents('.hidden_links_group:first').find('.fa-angle-down:visible').length > 0) {
            $(this).parents('.hidden_links_group:first').find('.fa-angle-down:visible').click();
        }

    }
    else {

        $(this).parents('.hidden_links_group:first').find('.hlg_links input[type="checkbox"]').prop('checked', false);

    }
});

$(document).on('click','.hidden_links_group i.fa-angle-down', function() {
    $(this).parents('.hidden_links_group:first').addClass('opened');
});

$(document).on('click','.hidden_links_group i.fa-angle-up', function() {
    $(this).parents('.hidden_links_group:first').removeClass('opened');
});


/* ADMIN ROLES END*/

/* NEW COMBINATIONS TABS */
$('#ctm-tab, #dtc-tab, #mtc-tab').click(function(){
    $('.bulk_check:checked').prop('checked', false);
});

/* DAS */
$('#dtc-tab').click(function(){

    $('#tabs-3').html('');

    $.ajax({
        url: $('#get_das_to_course').data('url'),
        method: 'GET',
        data: {},
        success: function(data) {

            if (typeof data !=  'undefined' && data != null && data != '') {

                // Step 1
                // add main html
                $('#tabs-2').html(data);


                // Step 2
                // assign header functions
                function assignNewHeaderDas(chosenElement, massAssignment = false, makeCopy=false)
                {

                    console.log('assignNewHeaderDas copy ' + makeCopy);

                    $('.you-are-copying').hide();
                    var _allBulkCombinations = '';
                    var _current_header = '';
                    var _course_id_1 = '';
                    var _course_id_2 = '';
                    var _das_id_ = '';
                    var _das_to_course_id_ = '';

                    if (massAssignment == false) {

                        $(chosenElement).addClass('dcp-head-active');

                        $('#setModalCombinationNameDas').click();

                        _current_header = chosenElement;
                        _course_id_1 = $(chosenElement).parents('.dc-container:first').find('.course-holder:first').data('courseholder');
                        _course_id_2 = $(chosenElement).parents('.dc-container:first').find('.course-holder:last').data('courseholder');
                        // load all courses
                        _das_id_ = $(chosenElement).data('dasid');
                        _das_to_course_id_ = $(chosenElement).data('dastocourseid');

                    }
                    else {

                        _allBulkCombinations = $('#coursesPairsInp').val();
                        //console.log(_allBulkCombinations);

                    }

                    if (makeCopy == true) {
                        $('.you-are-copying').show();
                    }

                    $.ajax({
                        url: $('#get_all_das_names').data('urlstore'),
                        method: 'GET',
                        data: '',
                        success: function (data) {
                            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                var _dases_names_html = '<div class="choose_das_name_container"><div class="form-group"><label for="new_das_name">'+$('#translation-new_das_title').text()+'</label><input class="form-control" type="text" value="" id="new_das_name" placeholder=""/></div><div class="form-group"><label for="choose_das_name">'+$('#translation-choose_existing_das_title').text()+'</label><select size="3" class="custom-select" id="choose_das_name">';

                                for (var i = 0; i < data.dases.length; i++) {

                                    if (massAssignment == false) {

                                        if (makeCopy == true) {

                                            if (
                                                (typeof data.dases[i].must_have_course_id == 'undefined' || data.dases[i].must_have_course_id == null || data.dases[i].must_have_course_id == '0' || data.dases[i].must_have_course_id == 0 ||

                                                    (typeof data.dases[i].must_have_course_id != 'undefined' && data.dases[i].must_have_course_id != null && data.dases[i].must_have_course_id != '0' && data.dases[i].must_have_course_id != 0 && (data.dases[i].must_have_course_id == _course_id_1 || data.dases[i].must_have_course_id == _course_id_2)))

                                                && parseInt(data.dases[i].id) != parseInt(_das_id_)) {

                                                _dases_names_html += '<option value="' + data.dases[i].id + '" '+ (parseInt(data.dases[i].id) == parseInt(_das_id_) ? 'selected="selected"' : '') +' >' + data.dases[i].title + '</option>';

                                            }

                                        }
                                        else {
//console.log('make copy false')
                                            if (typeof data.dases[i].must_have_course_id != 'undefined' && data.dases[i].must_have_course_id != null && data.dases[i].must_have_course_id != '0') {

                                                if (data.dases[i].must_have_course_id == _course_id_1 || data.dases[i].must_have_course_id == _course_id_2) {
                                                    _dases_names_html += '<option value="' + data.dases[i].id + '" '+ (parseInt(data.dases[i].id) == parseInt(_das_id_) ? 'selected="selected"' : '') +' >' + data.dases[i].title + '</option>';
                                                }

                                            }
                                            else {
                                                _dases_names_html += '<option value="' + data.dases[i].id + '" '+ (parseInt(data.dases[i].id) == parseInt(_das_id_) ? 'selected="selected"' : '') +' >' + data.dases[i].title + '</option>';
                                            }

                                        }

                                    }
                                    else {
                                        _dases_names_html += '<option value="' + data.dases[i].id + '" '+ (parseInt(data.dases[i].id) == parseInt(_das_id_) ? 'selected="selected"' : '') +' >' + data.dases[i].title + '</option>';
                                    }

                                }

                                _dases_names_html += '</select></div></div>';

                                $('#modalCombinationNameDas .modal-body').html(_dases_names_html);

                            }
                        }
                    });

                    $(document).off('focus', '#new_das_name');
                    $(document).on('focus', '#new_das_name', function() {
                        //console.log('focus in');
                        $('#choose_das_name').attr('disabled', 'disabled');
                    });

                    // if user entered a new name
                    $(document).off('blur', '#new_das_name');
                    $(document).on('blur', '#new_das_name', function() {

                        var _title = $(this).val().trim();

                        if (_title != '') {

                            var _valuesToSend = {'das_to_course_id': _das_to_course_id_, 'title': _title, 'course_id_1' : _course_id_1, 'course_id_2': _course_id_2};

                            if (massAssignment == true && _allBulkCombinations != '') {
                                _valuesToSend = _allBulkCombinations + '&title='+_title;
                            }

                            if (makeCopy == true) {
                                _valuesToSend.makeCopy = 1;
                            }

                            $.ajax({
                                url: $('#dases_store').data('urlstore'),
                                method: 'POST',
                                data: _valuesToSend,
                                success: function (data) {

                                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                        if (massAssignment == true && _allBulkCombinations != '') {
                                            $(chosenElement).each(function() {

                                                $(this).parent().find('.dcp-head-text').text(_title);
                                                $(this).parent().data('dasid', data.das_id).removeClass('dcp-combination-impossible');

                                                var _elem_head_id = $(this).parent().attr('id');

                                                if (typeof data.dasesToCoursesIds != 'undefined') {

                                                    $('#'+_elem_head_id).data('dastocourseid', data.dasesToCoursesIds[_elem_head_id.replace('dcp-head-', '')]);

                                                }

                                            });
                                        }
                                        else {

                                            $(_current_header).find('.dcp-head-text').text(_title);
                                            $(_current_header).data('dasid', data.das_id).removeClass('dcp-combination-impossible');
                                            $(_current_header).data('dastocourseid', data.das_to_course_id);

                                        }

                                        $('#modalCombinationNameDas .close-modal').click();
                                    }

                                    if (makeCopy == true) {
                                        location.reload();
                                    }

                                }
                            });
                        }

                        $('#choose_das_name').removeAttr('disabled');
                    });


                    // if user chose existing course title
                    $(document).off('click', '.btn-save-combination-name');
                    $(document).on('click', '.btn-save-combination-name', function() {

                        var _das_id = $('#choose_das_name').val();
                        var _title = '';

                        $('#choose_das_name').find("option:selected").each(function(index) {
                            _title += (_title == '' ? '' : ' / ') + $(this).text().trim();
                        });


                        var _valuesToSend = {'das_to_course_id': _das_to_course_id_, 'das_id': _das_id, 'course_id_1' : _course_id_1, 'course_id_2': _course_id_2};

                        if (massAssignment == true && _allBulkCombinations != '') {
                            _valuesToSend = _allBulkCombinations + '&title='+_title+'&das_id='+_das_id;
                        }

                        if (makeCopy == true) {
                            _valuesToSend.makeCopy = 1;
                        }

                        if (_title != '' && _das_id != '') {

                            $.ajax({
                                url: $('#set_das_name').data('urlstore'),
                                method: 'POST',
                                data: _valuesToSend,
                                success: function (data) {
                                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                        if (massAssignment == true && _allBulkCombinations != '') {
                                            $(chosenElement).each(function() {

                                                $(this).parent().find('.dcp-head-text').html(_title);
                                                $(this).parent().data('dasid', data.das_id);

                                                if (data.course_id == 1) {
                                                    $(this).parent().addClass('dcp-combination-impossible');
                                                }
                                                else {
                                                    $(this).parent().removeClass('dcp-combination-impossible');
                                                }


                                                var _elem_head_id = $(this).parent().attr('id');

                                                if (typeof data.dasesToCoursesIds != 'undefined') {

                                                    $('#'+_elem_head_id).data('dastocourseid', data.dasesToCoursesIds[_elem_head_id.replace('dcp-head-', '')]);


                                                }

                                            });
                                        }
                                        else {

                                            $(_current_header).find('.dcp-head-text').text(_title);
                                            $(_current_header).data('dasid', data.course_id);
                                            $(_current_header).data('dastocourseid', data.das_to_course_id);

                                            if (data.das_id == 1) {
                                                $(_current_header).addClass('dcp-combination-impossible');
                                            }
                                            else {
                                                $(_current_header).removeClass('dcp-combination-impossible');
                                            }

                                        }

                                        $(_current_header).parents('.dc-container:first').appendTo('.courses-combinations');

                                        $('#modalCombinationNameDas .close-modal').click();

                                    }

                                    if (makeCopy == true) {
                                        location.reload();
                                    }
                                }
                            });

                        }

                    });
                }

                // Step 3
                // double click on head combos and copy

                $(document).on('dblclick', '.dcp-head', function() {
                    $('#coursesPairsInp').remove();
                    assignNewHeaderDas(this, false, false);

                });

                $('#modalCombinationNameDas').on('show.bs.modal', function (event) {
                    $('.dcp-head.dcp-head-active').removeClass('dcp-head-active');
                });

                if ($('.dcp-head').length > 0) {

                    // hide copy icon for combinations which already have 2 combinations
                    $('.dcp-head').each(function(){

                        var combomod1 = $(this).data('combomod1');
                        var combomod2 = $(this).data('combomod2');

                        if (typeof combomod1 != 'undefined' && typeof combomod2 != 'undefined' && $('.combo-mod-'+ combomod1 + '-' + combomod2).length > 1) {
                            $(this).find('.fa-files-o').hide();
                        }

                    });

                    $(document).on('click','.fa-files-o', function(){

                        assignNewHeaderDas($(this).parent(), false, true);

                    });
                }

                // Step 4
                // eye clicks
                $('.dcp-head .fa-eye').click(function() {

                    $('.dc-combinations-without-das').hide();
                    // remove previous click on show details
                    $('.dc-container.greenBorder').removeClass('greenBorder');
                    $('.combination-details').removeClass('active');

                    $('.bulk_check.disabledCheck').removeAttr('disabled').removeClass('disabledCheck');
                    //$('.mc-parent-disabled').sortable("enable").removeClass('mc-parent-disabled');

                    var _disable_must_have_course = false;

                    if ($(this).parents('.dcp-head').hasClass('dcp-combination-impossible')) {
                        _disable_must_have_course = true;
                    }


                    var _parent = $(this).parents('.dc-container:first');
                    var das_to_course_id = $(_parent).find('.dcp-head').data('dastocourseid');


                    if (typeof das_to_course_id != 'undefined' && das_to_course_id != null && das_to_course_id != '') {

                        $.ajax({
                            url: $('#get_das_combination_info').data('urlstore'),
                            method: 'POST',
                            data: {'das_to_course_id': das_to_course_id},
                            success: function (data) {

                                if (typeof data != 'undefined' && data != null && data != '') {

                                    $(_parent).addClass('greenBorder');
                                    $('.combination-details').addClass('active');

                                    // change width of box container to 50% and set 2 columns
                                    $('.dc-all-container').removeClass('col-md-12');
                                    $('.dc-all-container').addClass('col-md-6');
                                    $('.courses-combinations').css('columns', '2');

                                    $(_parent).find('.bulk_check').attr('disabled', 'disabled').addClass('disabledCheck');
                                    //$(_parent).find('.mc-parent').sortable( "disable").addClass('mc-parent-disabled');

                                    // show returned info

                                    $('.combination-details .cd-body').html(data);

                                    if (_disable_must_have_course == true) {
                                        $('.combination-details .cd-body input.must-have-course-check').attr('disabled', 'disabled');
                                    }

                                    $('.mandatory-courses-combos-tooltip, .recommended-courses-combos-tooltip').popover({'html': true});

                                }
                            }
                        });

                    }

                });

                // Step 5
                // close of chosen combo details
                $('.dc-cd-head button.close').click(function() {

                    $('.dc-container.greenBorder').removeClass('greenBorder');
                    $('.combination-details').removeClass('active');

                    $('.bulk_check.disabledCheck').removeAttr('disabled').removeClass('disabledCheck');
                    //$('.mc-parent-disabled').sortable("enable").removeClass('mc-parent-disabled');

                    // restore width of box container to 100% and set 4 columns
                    $('.dc-all-container').removeClass('col-md-6');
                    $('.dc-all-container').addClass('col-md-12');
                    $('.courses-combinations').css('columns', '4');
                    $('.dc-combinations-without-das').css('display', 'flex');

                });

                // Step 6
                // check musthave and recommeneded courses
                // musthave
                $(document).on('click', '.das-cd-courses .must-have-course-check', function() {

                    var _current_id = $(this).attr('id');
                    var _course_id = $(this).val();
                    var _das_id = $('.cd-das').attr('id').replace('das-id-', '');
                    var _action = '';

                    $('.das-cd-courses .must-have-course-check').not('#'+_current_id).prop('checked', false);
                    $(this).parents('.cd-course:first').find('.recommended-course-check').prop('checked', false);


                    if ($(this).is(":checked")) {

                        _action = 'add';

                    }
                    else {

                        _action = 'remove';
                    }

                    var _urlstore = $('#set_das_must_have_course').data('urlstore');

                    $.ajax({
                        url: _urlstore,
                        method: 'POST',
                        data: {'action': _action, 'course_id': _course_id, 'das_id': _das_id},
                        success: function (data) {

                            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



                            }
                        }
                    });
                });

                // recommended
                $(document).on('click', '.das-cd-courses .recommended-course-check', function() {

                    var _current_id = $(this).attr('id');
                    var _course_id = $(this).val();
                    var _das_id = $('.cd-das').attr('id').replace('das-id-', '');
                    var _action = '';

                    $('.das-cd-courses .recommended-course-check').not('#'+_current_id).prop('checked', false);
                    $(this).parents('.cd-course:first').find('.must-have-course-check').prop('checked', false);



                    if ($(this).is(":checked")) {

                        _action = 'add';

                    }
                    else {

                        _action = 'remove';
                    }

                    var _urlstore = $('#set_das_recommended_course').data('urlstore');

                    $.ajax({
                        url: _urlstore,
                        method: 'POST',
                        data: {'action': _action, 'course_id': _course_id, 'das_id': _das_id},
                        success: function (data) {

                            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



                            }
                        }
                    });
                });

                // STEP 7 Filters
                $('#search-by-das').change(function() {

                    $('.dc-combinations-without-das .dc-container').appendTo('.courses-combinations');
                    $('.dc-combinations-without-das').remove();
                    $('.dc-container').removeClass('make-invisible');
                    $('#search-by-course-1,#search-by-course-2,#search-by-course-types').val('');

                    combinationsFiltersDas();

                    var _das_id = $(this).val();

                    //console.log('_crs_id');
                    //console.log(_crs_id);

                    if (_das_id != '') {

                        $('<div class="dc-combinations-without-das"></div>').insertAfter('.courses-combinations');

                        var _das_must_have_c_id = $('.dcp-head-'+_das_id+':first').data('musthavecourseid');

                        $('.dc-container .dcp-head').each(function() {
                            if ($(this).hasClass('dcp-head-'+_das_id)) {

                                var _current_must_have_c = $(this).data('musthavecourseid');

                                var mh_course = $(this).parents('.dc-container:first').find('.dc-parent .course-holder-'+_current_must_have_c);

                                $(mh_course).prependTo($(this).parents('.dc-container:first').find('.dc-parent'));

                            }
                            else {

                                if ($(this).parents('.dc-container:first').find('.dc-parent .course-holder-'+_das_must_have_c_id).length == 0) {

                                    $(this).parents('.dc-container:first').addClass('make-invisible');

                                }
                                else {
                                    if ($(this).hasClass('dcp-combination-impossible') || $(this).data('dasid')=='') {

                                        $(this).parents('.dc-container:first').appendTo('.dc-combinations-without-das');

                                    }
                                    else {
                                        $(this).parents('.dc-container:first').addClass('make-invisible');
                                    }
                                }

                            }

                            console.log('ko');
                        });

                    }
                    else {

                    }

                });


                $('.dc-all-container .search-by-course').keyup(function() {
                    combinationsFiltersDas();
                });

                $('.dc-all-container #search-by-course-types').change(function(){
                    combinationsFiltersDas();
                });

            }

        }
    });

});

/* MAS */
$('#mtc-tab').click(function(){

    $('#tabs-2').html('');

    console.log('mtc-tab clicked');

    $.ajax({
        url: $('#get_mas_to_course').data('url'),
        method: 'GET',
        data: {},
        success: function(data) {

            if (typeof data !=  'undefined' && data != null && data != '') {

                console.log('returned mas data 1');
                // Step 1
                // add main html
                $('#tabs-3').html(data);


                // Step 2
                // assign header functions
                function assignNewHeaderMas(chosenElement, massAssignment = false, makeCopy=false)
                {

                    console.log('assignNewHeaderMas copy ' + makeCopy);

                    $('.you-are-copying').hide();
                    var _allBulkCombinations = '';
                    var _current_header = '';
                    var _course_id_1 = '';
                    var _course_id_2 = '';
                    var _course_id_3 = '';
                    var _mas_id_ = '';
                    var _mas_to_course_id_ = '';

                    if (massAssignment == false) {

                        $(chosenElement).addClass('macp-head-active');

                        $('#setModalCombinationNameMas').click();

                        _current_header = chosenElement;
                        _course_id_1 = $(chosenElement).parents('.mac-container:first').find('.course-holder:nth-child(1)').data('courseholder');
                        _course_id_2 = $(chosenElement).parents('.mac-container:first').find('.course-holder:nth-child(2)').data('courseholder');
                        _course_id_3 = $(chosenElement).parents('.mac-container:first').find('.course-holder:nth-child(3)').data('courseholder');
                        // load all courses
                        _mas_id_ = $(chosenElement).data('masid');
                        _mas_to_course_id_ = $(chosenElement).data('mastocourseid');

                    }
                    else {

                        _allBulkCombinations = $('#coursesPairsInp').val();
                        //console.log(_allBulkCombinations);

                    }

                    if (makeCopy == true) {
                        $('.you-are-copying').show();
                    }

                    $.ajax({
                        url: $('#get_all_mas_names').data('urlstore'),
                        method: 'GET',
                        data: '',
                        success: function (data) {
                            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                var _mases_names_html = '<div class="choose_mas_name_container"><div class="form-group"><label for="new_mas_name">'+$('#translation-new_mas_title').text()+'</label><input class="form-control" type="text" value="" id="new_mas_name" placeholder=""/></div><div class="form-group"><label for="choose_mas_name">'+$('#translation-choose_existing_mas_title').text()+'</label><select size="3" class="custom-select" id="choose_mas_name">';

                                for (var i = 0; i < data.mases.length; i++) {

                                    if (massAssignment == false) {

                                        if (makeCopy == true) {

                                            if (
                                                (typeof data.mases[i].must_have_course_id == 'undefined' || data.mases[i].must_have_course_id == null || data.mases[i].must_have_course_id == '0' || data.mases[i].must_have_course_id == 0 ||

                                                    (typeof data.mases[i].must_have_course_id != 'undefined' && data.mases[i].must_have_course_id != null && data.mases[i].must_have_course_id != '0' && data.mases[i].must_have_course_id != 0 && (data.mases[i].must_have_course_id == _course_id_1 || data.mases[i].must_have_course_id == _course_id_2 || data.mases[i].must_have_course_id == _course_id_3)))

                                                && parseInt(data.mases[i].id) != parseInt(_mas_id_)) {

                                                _mases_names_html += '<option value="' + data.mases[i].id + '" '+ (parseInt(data.mases[i].id) == parseInt(_mas_id_) ? 'selected="selected"' : '') +' >' + data.mases[i].title + '</option>';

                                            }

                                        }
                                        else {
//console.log('make copy false')
                                            if (typeof data.mases[i].must_have_course_id != 'undefined' && data.mases[i].must_have_course_id != null && data.mases[i].must_have_course_id != '0') {

                                                if (data.mases[i].must_have_course_id == _course_id_1 || data.mases[i].must_have_course_id == _course_id_2 || data.mases[i].must_have_course_id == _course_id_3) {
                                                    _mases_names_html += '<option value="' + data.mases[i].id + '" '+ (parseInt(data.mases[i].id) == parseInt(_mas_id_) ? 'selected="selected"' : '') +' >' + data.mases[i].title + '</option>';
                                                }

                                            }
                                            else {
                                                _mases_names_html += '<option value="' + data.mases[i].id + '" '+ (parseInt(data.mases[i].id) == parseInt(_mas_id_) ? 'selected="selected"' : '') +' >' + data.mases[i].title + '</option>';
                                            }

                                        }

                                    }
                                    else {
                                        _mases_names_html += '<option value="' + data.mases[i].id + '" '+ (parseInt(data.mases[i].id) == parseInt(_mas_id_) ? 'selected="selected"' : '') +' >' + data.mases[i].title + '</option>';
                                    }

                                }

                                _mases_names_html += '</select></div></div>';

                                $('#modalCombinationNameMas .modal-body').html(_mases_names_html);

                            }
                        }
                    });

                    $(document).off('focus', '#new_mas_name');
                    $(document).on('focus', '#new_mas_name', function() {
                        //console.log('focus in');
                        $('#choose_mas_name').attr('disabled', 'disabled');
                    });

                    // if user entered a new name
                    $(document).off('blur', '#new_mas_name');
                    $(document).on('blur', '#new_mas_name', function() {

                        var _title = $(this).val().trim();

                        if (_title != '') {

                            var _valuesToSend = {'mas_to_course_id': _mas_to_course_id_, 'title': _title, 'course_id_1' : _course_id_1, 'course_id_2': _course_id_2, 'course_id_3': _course_id_3};

                            if (massAssignment == true && _allBulkCombinations != '') {
                                _valuesToSend = _allBulkCombinations + '&title='+_title;
                            }

                            if (makeCopy == true) {
                                _valuesToSend.makeCopy = 1;
                            }

                            $.ajax({
                                url: $('#mases_store').data('urlstore'),
                                method: 'POST',
                                data: _valuesToSend,
                                success: function (data) {

                                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                        if (massAssignment == true && _allBulkCombinations != '') {
                                            $(chosenElement).each(function() {

                                                $(this).parent().find('.macp-head-text').text(_title);
                                                $(this).parent().data('masid', data.mas_id).removeClass('macp-combination-impossible');

                                                var _elem_head_id = $(this).parent().attr('id');

                                                if (typeof data.masesToCoursesIds != 'undefined') {

                                                    $('#'+_elem_head_id).data('mastocourseid', data.masesToCoursesIds[_elem_head_id.replace('macp-head-', '')]);

                                                }

                                            });
                                        }
                                        else {

                                            $(_current_header).find('.macp-head-text').text(_title);
                                            $(_current_header).data('masid', data.mas_id).removeClass('macp-combination-impossible');
                                            $(_current_header).data('mastocourseid', data.mas_to_course_id);

                                        }

                                        $('#modalCombinationNameMas .close-modal').click();
                                    }

                                    if (makeCopy == true) {
                                        location.reload();
                                    }

                                }
                            });
                        }

                        $('#choose_mas_name').removeAttr('disabled');
                    });


                    // if user chose existing course title
                    $(document).off('click', '.btn-save-combination-name');
                    $(document).on('click', '.btn-save-combination-name', function() {

                        var _mas_id = $('#choose_mas_name').val();
                        var _title = '';

                        $('#choose_mas_name').find("option:selected").each(function(index) {
                            _title += (_title == '' ? '' : ' / ') + $(this).text().trim();
                        });


                        var _valuesToSend = {'mas_to_course_id': _mas_to_course_id_, 'mas_id': _mas_id, 'course_id_1' : _course_id_1, 'course_id_2': _course_id_2, 'course_id_3': _course_id_3};

                        if (massAssignment == true && _allBulkCombinations != '') {
                            _valuesToSend = _allBulkCombinations + '&title='+_title+'&mas_id='+_mas_id;
                        }

                        if (makeCopy == true) {
                            _valuesToSend.makeCopy = 1;
                        }

                        if (_title != '' && _mas_id != '') {

                            $.ajax({
                                url: $('#set_mas_name').data('urlstore'),
                                method: 'POST',
                                data: _valuesToSend,
                                success: function (data) {
                                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                                        if (massAssignment == true && _allBulkCombinations != '') {
                                            $(chosenElement).each(function() {

                                                $(this).parent().find('.macp-head-text').html(_title);
                                                $(this).parent().data('masid', data.mas_id);

                                                if (data.course_id == 1) {
                                                    $(this).parent().addClass('macp-combination-impossible');
                                                }
                                                else {
                                                    $(this).parent().removeClass('macp-combination-impossible');
                                                }


                                                var _elem_head_id = $(this).parent().attr('id');

                                                if (typeof data.masesToCoursesIds != 'undefined') {

                                                    $('#'+_elem_head_id).data('mastocourseid', data.masesToCoursesIds[_elem_head_id.replace('macp-head-', '')]);


                                                }

                                            });
                                        }
                                        else {

                                            $(_current_header).find('.macp-head-text').text(_title);
                                            $(_current_header).data('masid', data.course_id);
                                            $(_current_header).data('mastocourseid', data.mas_to_course_id);

                                            if (data.mas_id == 1) {
                                                $(_current_header).addClass('macp-combination-impossible');
                                            }
                                            else {
                                                $(_current_header).removeClass('macp-combination-impossible');
                                            }

                                        }

                                        $(_current_header).parents('.mac-container:first').appendTo('.courses-combinations');

                                        $('#modalCombinationNameMas .close-modal').click();

                                    }

                                    if (makeCopy == true) {
                                        location.reload();
                                    }
                                }
                            });

                        }

                    });
                }

                // Step 3
                // double click on head combos and copy

                $(document).on('dblclick', '.macp-head', function() {
                    $('#coursesPairsInp').remove();
                    assignNewHeaderMas(this, false, false);

                });

                $('#modalCombinationNameMas').on('show.bs.modal', function (event) {
                    $('.macp-head.macp-head-active').removeClass('macp-head-active');
                });

                if ($('.macp-head').length > 0) {

                    // hide copy icon for combinations which already have 2 combinations
                    $('.macp-head').each(function(){

                        var combomod1 = $(this).data('combomod1');
                        var combomod2 = $(this).data('combomod2');
                        var combomod3 = $(this).data('combomod3');

                        if (typeof combomod1 != 'undefined' && typeof combomod2 != 'undefined' && typeof combomod3 != 'undefined' && $('.combo-mod-'+ combomod1 + '-' + combomod2 + '-' + combomod3).length > 1) {
                            $(this).find('.fa-files-o').hide();
                        }

                    });

                    $(document).on('click','.fa-files-o', function(){

                        assignNewHeaderMas($(this).parent(), false, true);

                    });
                }

                // Step 4
                // eye clicks
                $('.macp-head .fa-eye').click(function() {

                    $('.mac-combinations-without-mas').hide();
                    // remove previous click on show details
                    $('.mac-container.greenBorder').removeClass('greenBorder');
                    $('.combination-details').removeClass('active');

                    $('.bulk_check.disabledCheck').removeAttr('disabled').removeClass('disabledCheck');
                    //$('.mc-parent-disabled').sortable("enable").removeClass('mc-parent-disabled');

                    var _disable_must_have_course = false;

                    if ($(this).parents('.macp-head').hasClass('macp-combination-impossible')) {
                        _disable_must_have_course = true;
                    }


                    var _parent = $(this).parents('.mac-container:first');
                    var mas_to_course_id = $(_parent).find('.macp-head').data('mastocourseid');


                    if (typeof mas_to_course_id != 'undefined' && mas_to_course_id != null && mas_to_course_id != '') {

                        $.ajax({
                            url: $('#get_mas_combination_info').data('urlstore'),
                            method: 'POST',
                            data: {'mas_to_course_id': mas_to_course_id},
                            success: function (data) {

                                if (typeof data != 'undefined' && data != null && data != '') {

                                    $(_parent).addClass('greenBorder');
                                    $('.combination-details').addClass('active');

                                    // change width of box container to 50% and set 2 columns
                                    $('.mac-all-container').removeClass('col-md-12');
                                    $('.mac-all-container').addClass('col-md-6');
                                    $('.courses-combinations').css('columns', '2');

                                    $(_parent).find('.bulk_check').attr('disabled', 'disabled').addClass('disabledCheck');
                                    //$(_parent).find('.mc-parent').sortable( "disable").addClass('mc-parent-disabled');

                                    // show returned info

                                    $('.combination-details .cd-body').html(data);

                                    if (_disable_must_have_course == true) {
                                        $('.combination-details .cd-body input.must-have-course-check').attr('disabled', 'disabled');
                                    }

                                    $('.mandatory-courses-combos-tooltip, .recommended-courses-combos-tooltip').popover({'html': true});

                                }
                            }
                        });

                    }

                });

                // Step 5
                // close of chosen combo details
                $('.mac-cd-head button.close').click(function() {

                    $('.mac-container.greenBorder').removeClass('greenBorder');
                    $('.combination-details').removeClass('active');

                    $('.bulk_check.disabledCheck').removeAttr('disabled').removeClass('disabledCheck');
                    //$('.mc-parent-disabled').sortable("enable").removeClass('mc-parent-disabled');

                    // restore width of box container to 100% and set 4 columns
                    $('.mac-all-container').removeClass('col-md-6');
                    $('.mac-all-container').addClass('col-md-12');
                    $('.courses-combinations').css('columns', '4');
                    $('.mac-combinations-without-mas').css('display', 'flex');

                });

                // Step 6
                // check musthave and recommeneded courses
                // musthave
                $(document).on('click', '.mas-cd-courses .must-have-course-check', function() {

                    var _current_id = $(this).attr('id');
                    var _course_id = $(this).val();
                    var _mas_id = $('.cd-mas').attr('id').replace('mas-id-', '');
                    var _action = '';

                    $('.mas-cd-courses .must-have-course-check').not('#'+_current_id).prop('checked', false);
                    $(this).parents('.cd-course:first').find('.recommended-course-check').prop('checked', false);


                    if ($(this).is(":checked")) {

                        _action = 'add';

                    }
                    else {

                        _action = 'remove';
                    }

                    var _urlstore = $('#set_mas_must_have_course').data('urlstore');

                    $.ajax({
                        url: _urlstore,
                        method: 'POST',
                        data: {'action': _action, 'course_id': _course_id, 'mas_id': _mas_id},
                        success: function (data) {

                            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



                            }
                        }
                    });
                });

                // recommended
                $(document).on('click', '.mas-cd-courses .recommended-course-check', function() {

                    var _current_id = $(this).attr('id');
                    var _course_id = $(this).val();
                    var _mas_id = $('.cd-mas').attr('id').replace('mas-id-', '');
                    var _action = '';

                    $('.mas-cd-courses .recommended-course-check').not('#'+_current_id).prop('checked', false);
                    $(this).parents('.cd-course:first').find('.must-have-course-check').prop('checked', false);



                    if ($(this).is(":checked")) {

                        _action = 'add';

                    }
                    else {

                        _action = 'remove';
                    }

                    var _urlstore = $('#set_mas_recommended_course').data('urlstore');

                    $.ajax({
                        url: _urlstore,
                        method: 'POST',
                        data: {'action': _action, 'course_id': _course_id, 'mas_id': _mas_id},
                        success: function (data) {

                            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



                            }
                        }
                    });
                });

                // STEP 7 Filters
                $('#search-by-mas').change(function() {

                    $('.mac-combinations-without-mas .mac-container').appendTo('.courses-combinations');
                    $('.mac-combinations-without-mas').remove();
                    $('.mac-container').removeClass('make-invisible');
                    $('#search-by-course-1,#search-by-course-2,#search-by-course-3,#search-by-course-types').val('');

                    combinationsFiltersMas();

                    var _mas_id = $(this).val();

                    //console.log('_crs_id');
                    //console.log(_crs_id);

                    if (_mas_id != '') {

                        $('<div class="mac-combinations-without-mas"></div>').insertAfter('.courses-combinations');

                        var _mas_must_have_c_id = $('.macp-head-'+_mas_id+':first').data('musthavecourseid');

                        $('.mac-container .macp-head').each(function() {
                            if ($(this).hasClass('macp-head-'+_mas_id)) {

                                var _current_must_have_c = $(this).data('musthavecourseid');

                                var mh_course = $(this).parents('.mac-container:first').find('.mac-parent .course-holder-'+_current_must_have_c);

                                $(mh_course).prependTo($(this).parents('.mac-container:first').find('.mac-parent'));

                            }
                            else {

                                if ($(this).parents('.mac-container:first').find('.mac-parent .course-holder-'+_mas_must_have_c_id).length == 0) {

                                    $(this).parents('.mac-container:first').addClass('make-invisible');

                                }
                                else {
                                    if ($(this).hasClass('macp-combination-impossible') || $(this).data('masid')=='') {

                                        $(this).parents('.mac-container:first').appendTo('.mac-combinations-without-mas');

                                    }
                                    else {
                                        $(this).parents('.mac-container:first').addClass('make-invisible');
                                    }
                                }

                            }

                            console.log('ko');
                        });

                    }
                    else {

                    }

                });


                $('.mac-all-container .search-by-course').keyup(function() {
                    combinationsFiltersMas();
                });

                $('.mac-all-container #search-by-course-types').change(function(){
                    combinationsFiltersMas();
                });

            }

        }
    });

});

$('#ctm-tab').click(function(){

    $('#tabs-2').html('');
    $('#tabs-3').html('');

});
/* NEW COMBINATIONS TABS END */

/* NEW FRONT PAGE WITH DAS */

// click on das
$(document).on('click', '.unit-das', function() {

    console.log('unit-das / mas clicked');

    $('.row-front-courses,.row-front-modules').removeClass('active');
    $('.unit-course,.unit-module').removeClass('active').removeClass('unavailable').removeClass('unclickable').removeClass('cannot-have-2-active-course-in-one-range').removeClass('unit-highlighted');

    $('.mandatory-module, .recommended-module').hide();

    $('.unit-das').not(this).removeClass('active');

    $(this).toggleClass('active');

    // hide all unit-courses and show only which belong to active das
    //$('.unit-course.visible-element,.unit-module.visible-element').removeClass('visible-element');

    if ($(this).hasClass('active') == true) {

        $('.stat-container').addClass('opened');
        var _range_1_courses = $(this).data('range1courses');
        var _range_2_courses = $(this).data('range2courses');
        var _range_3_courses = $(this).data('range3courses');


        $('.das-mas-description-container').html($(this).data('content'));

        if (typeof _range_1_courses == 'number') {

            console.log('_range_1_courses type');
            console.log(typeof _range_1_courses);

            _range_1_courses = _range_1_courses.toString();
        }

        if (typeof _range_2_courses == 'number') {
            _range_2_courses = _range_2_courses.toString();
        }

        if (typeof _range_3_courses == 'number') {
            _range_3_courses = _range_3_courses.toString();
        }

        console.log('_range_1_courses');
        console.log(_range_1_courses);
        console.log('_range_2_courses');
        console.log(_range_2_courses);
        console.log('_range_3_courses');
        console.log(_range_3_courses);

        if (_range_1_courses !='') {

            var _range_1_courses_array =  _range_1_courses.indexOf(',') != -1 ? _range_1_courses.split(',') : [_range_1_courses];

            console.log('_range_1_courses_array');
            console.log(_range_1_courses_array);

            if (_range_1_courses_array.length > 0) {

                $('.row-front-courses-1').addClass('active');
                $('.row-front-courses-1 .unit-course').addClass('unavailable');

                for (var rca = 0; rca < _range_1_courses_array.length; rca++) {

                    $('.col-content-course-range-1 .unit-course-'+_range_1_courses_array[rca]).removeClass('unavailable').addClass('unit-highlighted');

                }

            }

        }
        else {
            $('.row-front-courses-1 .unit-course').removeClass('unit-highlighted').addClass('unavailable');
        }

        if (_range_2_courses != '') {

            var _range_2_courses_array =  _range_2_courses.indexOf(',') != -1 ? _range_2_courses.split(',') : [_range_2_courses];

            console.log('_range_2_courses_array');
            console.log(_range_2_courses_array);

            if (_range_2_courses_array.length > 0) {

                $('.row-front-courses-2').addClass('active');
                $('.row-front-courses-2 .unit-course').addClass('unavailable');

                for (var rca = 0; rca < _range_2_courses_array.length; rca++) {

                    $('.col-content-course-range-2 .unit-course-'+_range_2_courses_array[rca]).removeClass('unavailable').addClass('unit-highlighted');

                }

            }


        }
        else {
            $('.row-front-courses-2 .unit-course').removeClass('unit-highlighted').addClass('unavailable');
        }

        if (_range_3_courses != '') {



            var _range_3_courses_array =  _range_3_courses.indexOf(',') != -1 ? _range_3_courses.split(',') : [_range_3_courses];

            console.log('_range_3_courses_array');
            console.log(_range_3_courses_array);

            if (_range_3_courses_array.length > 0) {


                $('.row-front-courses-3').addClass('active');
                $('.row-front-courses-3 .unit-course').addClass('unavailable');

                for (var rca = 0; rca < _range_3_courses_array.length; rca++) {

                    $('.col-content-course-range-3 .unit-course-'+_range_3_courses_array[rca]).removeClass('unavailable').addClass('unit-highlighted');

                }

            }

        }
        else {
            $('.row-front-courses-3 .unit-course').removeClass('unit-highlighted').addClass('unavailable');
        }

        // CHECK ALL HIGHLIGHTED COURSES AND MAKE MODULES HIGHLIGHTED

        if ($('.unit-course.unit-highlighted').length > 0) {

            // RESET ALL MODULES
            $('.unit.unit-module').removeClass('active').removeClass('unit-highlighted').addClass('unavailable');

            $('.unit-course.unit-highlighted').each(function(){

                var _range_num = $(this).data('rangenum');

                var _cur_active_course = this; //cac

                var _cac_modules_ids_ = $(_cur_active_course).data('dependenciesids');

                if (_cac_modules_ids_ != '') {

                    /*console.log('_cac_modules_ids_');
                    console.log(_cac_modules_ids_);*/

                    var _cac_modules_ids_array = _cac_modules_ids_.split(',');

                    if (_cac_modules_ids_array.length > 0) {

                        for (var cacm = 0; cacm < _cac_modules_ids_array.length; cacm++) {

                            /*console.log('#unit-module-' + _range_num + '-' + _cac_modules_ids_array[cacm]);

                            console.log('unit module ID');
                            console.log(_range_num);*/

                            $('#unit-module-' + _range_num + '-' + _cac_modules_ids_array[cacm]).removeClass('unavailable').addClass('unit-highlighted');

                        }

                    }

                }

            });

        }

    }
    else {
        $('.stat-container').removeClass('opened');

        $('.das-mas-description-container').html('');

        for (var rangenum in [1,2,3]) {

            if ($('.row-front-modules-' +rangenum+' .unit-module.active').length == 0) {
                $('.front-statistics-'+rangenum+' .fsd-module-1').removeClass('u-active').find('.fsd-m-name').text($('#not-set-module-text').data('text'));
                $('.front-statistics-'+rangenum+' .fsd-module-2').removeClass('u-active').find('.fsd-m-name').text($('#not-set-module-text').data('text'));
            }


            if ($('.row-front-modules-' +rangenum+' .unit-module.active').length == 1) {
                $('.front-statistics-'+rangenum+' .fsd-module-2').removeClass('u-active').find('.fsd-m-name').text($('#not-set-module-text').data('text'));
            }

            $('.front-statistics-'+rangenum+' .fsd-course-parent').removeClass('u-active').find('.fsd-course-name').text($('#not-set-course-text').data('text'));

            $('.main-front-das-page .module_events_ids_checkbox:checked').each(function(){
                $(this).click();
            });
        }
    }

});

/*$(document).on('click', '.unit-course', function() {


    if ($(this).hasClass('unclickable')) {
        return false;
    }

    // GET COURSE ID AND ITS RANGE
    var _current_unit_course = this;

    var _current_course_id_string = $(this).attr('id').replace('unit-course-', '');
    var _ccis_array = _current_course_id_string.split('-');
    var _current_course_id = _ccis_array[1];
    var _range_num = _ccis_array[0];

    console.log('_range_num');
    console.log(_range_num);


    // CHECK IF THERE ARE ACTIVE COURSES IN CURRENT RANGE AND DEACTIVATE THEM AND THEIR MODULES (AND REMOVE UNSELECTABLE CLASS)

    if ($('#row-front-courses-'+_range_num + ' .unit-course.active').length > 0) {

        console.log('in '+'#row-front-courses-'+_range_num+ ' active courses length='+$('#row-front-courses-'+_range_num + ' .unit-course.active').length);

        $('#row-front-courses-'+_range_num + ' .unit-course.active').each(function(){

            var _cur_active_course = this; //cac

            var _cac_modules_ids_ = $(_cur_active_course).data('dependenciesids');

            if (_cac_modules_ids_ != '') {

                console.log('_cac_modules_ids_');
                console.log(_cac_modules_ids_);

                var _cac_modules_ids_array =  _cac_modules_ids_.split(',');

                if (_cac_modules_ids_array.length > 0) {

                    for (var cacm = 0; cacm < _cac_modules_ids_array.length; cacm++) {

                        for (var fff = 1; fff <= 3; fff++) {

                            console.log('#unit-module-' + fff + '-' + _cac_modules_ids_array[cacm]);

                            if (fff != _range_num) {

                                console.log('unit module ID');
                                console.log(_range_num);

                                $('#unit-module-' + fff + '-' + _cac_modules_ids_array[cacm]).removeClass('unclickable');

                            }
                            else {

                                $('#unit-module-' + fff + '-' + _cac_modules_ids_array[cacm]).removeClass('active').removeClass('unclickable');

                            }

                        }

                    }

                }

            }

        });

    }

    $(_current_unit_course).parents('.row-front-courses:first').find('.unit-course').not(_current_unit_course).removeClass('active');

    // add remove active class
    $(_current_unit_course).toggleClass('active');

    $('#row-front-modules-'+_range_num+' .mandatory-module, #row-front-modules-'+_range_num + ' .recommended-module').hide();

    // hide all modules
    $(_current_unit_course).parents('.row-front-courses:first').next('.row-front-modules').find('.unit-module').removeClass('visible-element');


    var _c_numbr = $(_current_unit_course).parents('.row-front-courses:first').attr('id').replace('row-front-courses-', '');

    if ($(_current_unit_course).hasClass('active')) {

       $('#row-front-modules-'+_c_numbr).addClass('active');

       // remove active class from all previously active modules in same range (1, 2 or 3)
       //$('#row-front-modules-'+_c_numbr+' .unite-module').removeClass('active').removeClass('unclickable');

       var _course_modules_ids_ = $(_current_unit_course).data('dependenciesids');

       var _c_must_have_mod_ = $(_current_unit_course).data('musthavemoduleid');
       var _c_recom_mod_ = $(_current_unit_course).data('recommendedmoduleid');

      /!* console.log('_c_must_have_mod_');
       console.log(_c_must_have_mod_);

       console.log('_c_recom_mod_');
       console.log(_c_recom_mod_);*!/

       if (_course_modules_ids_ != '') {

            var _course_modules_ids_array =  _course_modules_ids_.split(',');

            if (_course_modules_ids_array.length > 0) {


                for (var rca = 0; rca < _course_modules_ids_array.length; rca++) {


                    $(_current_unit_course).parents('.row-front-courses:first').next('.row-front-modules').find('.unit-module-'+_course_modules_ids_array[rca]).addClass('visible-element');

                    /!*console.log('unit_ID');
                    console.log($('#unit-module-'+_c_numbr+'-'+_course_modules_ids_array[rca]).data('unitid'));*!/

                    if (_c_must_have_mod_ == $(_current_unit_course).parents('.row-front-courses:first').next('.row-front-modules').find('.unit-module-'+_course_modules_ids_array[rca]).data('unitid')) {

                        /!*console.log('_c_must_have_mod_ equal');*!/


                        $(_current_unit_course).parents('.row-front-courses:first').next('.row-front-modules').find('.unit-module-'+_course_modules_ids_array[rca]).find('.mandatory-module').show();
                    }

                    if (_c_recom_mod_ == $(_current_unit_course).parents('.row-front-courses:first').next('.row-front-modules').find('.unit-module-'+_course_modules_ids_array[rca]).data('unitid')) {

                        /!*console.log('_c_recom_mod_ equal');*!/

                        $(_current_unit_course).parents('.row-front-courses:first').next('.row-front-modules').find('.unit-module-'+_course_modules_ids_array[rca]).find('.recommended-module').show();
                    }

                }

            }

       }

        //Click and active of Course will make inactive/hidden of this course in other 2 sets

        for (var xyz = 1; xyz <= 3; xyz++) {

            if (xyz != _range_num) {
                $('#unit-course-'+xyz+'-'+_current_course_id).addClass('unclickable');
            }

        }

    }
    else {
        $('#row-front-modules-'+_c_numbr).removeClass('active');
        $('.unit-module').removeClass('active').removeClass('unclickable');


        //Unclick and deactivate of Course will make inactive/hidden of this course in other 2 sets

        for (var zyx = 1; zyx <= 3; zyx++) {

            if (zyx != _range_num) {
                $('#unit-course-'+zyx+'-'+_current_course_id).removeClass('unclickable');
            }

        }

    }

});
$(document).on('click', '.unit-module', function() {

    if ($(this).hasClass('unclickable')) {
        return false;
    }

    // GET MODULE ID AND ITS RANGE
    var _current_module_ = this;
    var _current_module_id_string = $(this).attr('id').replace('unit-module-', '');
    var _cmis_array = _current_module_id_string.split('-');
    var _current_module_id = _cmis_array[1];
    var _range_num = _cmis_array[0];


    $(_current_module_).toggleClass('active');


    if ($(_current_module_).hasClass('active')) {

        // IF IN CURRENT RANGE ALREADY 2 ACTIVE MODULES WE MAKE UNCLICKABLE THE OTHERS
        if ($('.row-front-modules-'+_range_num+' .unit-module.active').length == 2) {

            $(_current_module_).parents('.row-front-modules:first').find('.unit-module:not(.active)').addClass('unclickable');
            $(_current_module_).parents('.row-front-modules:first').next('.row-front-courses').addClass('active');

        }
        else {

        }

        // Click and active of Module will make inactive/hidden of this Module in other 2 sets that are lower
        for (var xyz = 1; xyz <= 3; xyz++) {

            if (xyz != _range_num) {

                $('#unit-module-'+xyz+'-'+_current_module_id).addClass('unclickable');

            }

        }

    }
    else {

        // Unclick and deactivate of Module will make inactive/hidden of this Module in other 2 sets
        for (var zyx = 1; zyx <= 3; zyx++) {

            if (zyx != _range_num) {

                $('#unit-module-'+zyx+'-'+_current_module_id).removeClass('unclickable');

            }

        }

    }

    // only 1 module just got active
    if ($('.row-front-modules-'+_range_num+' .unit-module.active').length == 1) {

        $('.row-front-modules-'+_range_num+' .unit-module.unclickable').removeClass('unclickable');

        var _last_active_module = $('.row-front-modules-'+_range_num+' .unit-module.active').data('connectionid');



    }

    // 0 modules are active
    if ($('.row-front-modules-'+_range_num+' .unit-module.active').length == 0) {

        $('.row-front-modules-'+_range_num+' .unit-module.unclickable').removeClass('unclickable');

    }

});*/

$('.unit-course,.unit-module').click(function() {

    if ($(this).hasClass('unclickable') || $(this).hasClass('unavailable') || $(this).hasClass('cannot-have-2-active-course-in-one-range') || $(this).hasClass('already-chosen')) {
        return false;
    }

    var rangenum = $(this).data('rangenum');
    var unitid = $(this).data('unitid');
    var unittype = $(this).data('unittype');
    var belongsto = $(this).data('belongsto');
    var belongstoids = $(this).data('belongstoids');
    var dependenciesids = $(this).data('dependenciesids');
    var dependencytype = $(this).data('dependencytype');
    var combinationscount = $(this).data('combinationscount');
    var musthavemoduleid = $(this).data('musthavemoduleid');
    var recommendedmoduleid = $(this).data('recommendedmoduleid');
    var connectionids = $(this).data('connectionid');

    var _not_inculde_unclickable_class = ':not(.unclickable, .unavailable, .cannot-have-2-active-course-in-one-range, .already-chosen)';

    $('.choose-more-specific').hide();

    /************ Process situation when user picked course and modules and then unclicked course, we need to remove also checkboxes for module events *************/
    if ($(this).hasClass('active') && unittype == 'course' && $('.row-front-courses-'+rangenum+' .unit.unit-course.active').length == 1) {

        console.log('active course clicked');
        $('.main-front-das-page .module_events_ids_checkbox:checked').each(function(){
            $(this).click();
        });

    }


    /************ Process combination when 2 modules were active and then user unclicks one of them *************/
    if ($(this).hasClass('active') && unittype == 'module' && $('.row-front-modules-'+rangenum+' .unit.unit-module.active').length == 2) {

        console.log('two active modules one clicked');

        $(this).removeClass('active');

        for (var _ma_ = 1; _ma_ <= 3; _ma_++) {

            if (_ma_ != rangenum) {

                $('#unit-' + unittype + '-' + _ma_ + '-' + unitid).removeClass('already-chosen');

            }

        }

        var _id_of_one_remained_module = $('.row-front-modules-'+rangenum+' .unit.unit-module.active:first').data('unitid');

        $('.row-front-modules-'+rangenum+' .unit-module').removeClass('unclickable').removeClass('unit-highlighted').removeClass('active');

        //$('.calendar-module').removeClass('unclickable').removeClass('unit-highlighted').removeClass('active');

        //$('.content-of-event-cell').removeClass('active').removeClass('inactive-event');

        if ($('.row-front-courses-'+rangenum+' .unit-course.active').length == 0) {
            $('.row-front-modules-'+rangenum+' .front-m.mandatory-module, .row-front-modules-'+rangenum+' .front-m.recommended-module').hide();
        }


        $('.double-course-chosen').css('visibility', 'hidden');
        //$('.card-front-courses').removeClass('has-two-active-courses');

        $('.row-front-modules-'+rangenum+' .unit-module-' + _id_of_one_remained_module).click();

        return false;
    }


    /************ Process combination of clicks when user clicked on course, then clicked on module, then unclicked the module ************/
    if ($(this).hasClass('active') && unittype == 'module' && $('.row-front-courses-'+rangenum+' .unit.unit-course.active').length > 0) {

        console.log('unclick module which was active');

        if ($('.row-front-courses-'+rangenum+' .unit-course.active').length == 0) {
            $(this).find('.mandatory-module,.recommended-module').hide();
        }

        $(this).removeClass('active');

        for (var _ma_ = 1; _ma_ <= 3; _ma_++) {

            if (_ma_ != rangenum) {

                $('#unit-' + unittype + '-' + _ma_ + '-' + unitid).removeClass('already-chosen');

            }

        }

        //$('#calendar-module-' + unitid).removeClass('active');

        var _final_courses_ids = [];

        _final_courses_ids.push($('.row-front-courses-'+rangenum+' .unit.unit-course.active').data('unitid'));


        if (_final_courses_ids.length > 0) {

            for (var aa = 0; aa < _final_courses_ids.length; aa++) {

                var _course_dependencies = $('.row-front-courses-'+rangenum+' .unit-course-'+_final_courses_ids[aa]).data('dependenciesids');

                var _modules_ids_array = getIdsArrayFromString(_course_dependencies);

                if (_modules_ids_array.length > 0) {

                    for (var mm = 0; mm < _modules_ids_array.length; mm++) {
                        $('.row-front-modules-'+rangenum+' .unit-module-'+_modules_ids_array[mm]).removeClass('unclickable').addClass('unit-highlighted');
                        //$('#calendar-module-' + _modules_ids_array[mm]).removeClass('unclickable').addClass('unit-highlighted');
                    }

                }
            }
        }

        // IF LAST ACTIVE MODULE WAS UNCLICKED WE REMOVE ACTIVE AND UNCLICKABLE CLASSES FROM ALL COURSES AND UNCLICKABLE CLASS FROM ALL MODULES
        if ($('.row-front-modules-'+rangenum+' .unit.unit-module.active').length == 0) {

            $('.row-front-courses-'+rangenum+' .unit.unit-course').each(function(){

                //$(this).removeClass('active').removeClass('unclickable').removeClass('unit-highlighted');

            });

            $('.row-front-modules-'+rangenum+' .unit.unit-module').each(function(){

                $(this).removeClass('unclickable').removeClass('unit-highlighted');

                //$('#calendar-module-' + $(this).data('unitid')).removeClass('unclickable').removeClass('unit-highlighted');

            });

        }

        return false;
    }


    /** WHEN USER CLICKS ON HIGHLIGHTED ELEMENTS - FILTER **/
    if ($(this).hasClass('unit-highlighted') && !$(this).hasClass('active') && unittype == 'module') {

        console.log('click on highlighted module');

        var __current_unit__ = this;
        var _current_unit_connections_ids = $(this).data('connectionid');

        var _current_unit_connections_ids_array = [];

        if (typeof _current_unit_connections_ids != 'undefined' && _current_unit_connections_ids != '' && _current_unit_connections_ids != null) {

            // GET BELONGS TO IDS LEVEL 1 (courses)

            console.log('_current_unit_connections_ids');
            console.log(_current_unit_connections_ids);


            _current_unit_connections_ids_array = getIdsArrayFromString(_current_unit_connections_ids);

            console.log('_current_unit_connections_ids_array');
            console.log(_current_unit_connections_ids_array);

            if (_current_unit_connections_ids_array.length > 0) {


                /******* GET ALL ACTIVE UNITS CONNECTIONS *********/

                var _active_units_connections_array = [];


                if ($(__current_unit__).parents('.card-body:first').find('.active').length == 1) {

                    $(__current_unit__).parents('.card-body:first').find('.active').each(function() {

                        var _active_unit_connections = $(this).data('connectionid');

                        _active_units_connections_array = _active_units_connections_array.concat(getIdsArrayFromString(_active_unit_connections));

                    });

                }



                if (_active_units_connections_array.length > 0) {
                    _active_units_connections_array = _active_units_connections_array.filter(arrayUnique);
                }

                console.log('_active_units_connections_array');
                console.log(_active_units_connections_array);

                var intersections_array = [];

                if (_active_units_connections_array.length > 0 && _current_unit_connections_ids_array.length > 0) {

                    console.log('_active_units_connections_array and _current_unit_connections_ids_array');

                    intersections_array = _current_unit_connections_ids_array.filter(function(n) {

                        return _active_units_connections_array.indexOf(n.toString()) != -1;

                    });

                    //intersections_array = _current_unit_connections_ids_array.filter(value => _active_units_connections_array.includes(value));

                }

                console.log('intersections_array');
                console.log(intersections_array);

                if (intersections_array.length > 0) {
                    _current_unit_connections_ids_array = intersections_array;
                }

                console.log('_current_unit_connections_ids_array');
                console.log(_current_unit_connections_ids_array);

                var _number_of_already_active_elements_ = parseInt($(__current_unit__).parents('.card-body:first').find('.unit-highlighted.active').length);

                console.log('_number_of_already_active_elements_');
                console.log(_number_of_already_active_elements_);

                for (var ee = 0; ee < _current_unit_connections_ids_array.length; ee++) {

                    $(__current_unit__).parents('.card-body:first').find('.unit-highlighted:not(.active)').each(function() {

                        var _flow_unit_connections = $(this).data('connectionid');

                        console.log('_flow_unit_connections');
                        console.log(_flow_unit_connections);

                        var _flow_unit_connections_array = [];

                        if (typeof _flow_unit_connections != 'undefined' && _flow_unit_connections != '') {

                            _flow_unit_connections_array = getIdsArrayFromString(_flow_unit_connections);

                        }

                        console.log('_flow_unit_connections_array');
                        console.log(_flow_unit_connections_array);

                        if (_flow_unit_connections_array.indexOf(_current_unit_connections_ids_array[ee].toString()) > -1 && _number_of_already_active_elements_ < 1) {

                            console.log('can-stay');
                            console.log($(this).data('unitid'));

                            $(this).addClass('can-stay');
                            //$('#calendar-module-' + $(this).data('unitid')).addClass('can-stay');

                        }

                    });

                }

                $(__current_unit__).parents('.card-body:first').find('.unit-highlighted:not(.active):not(.can-stay)').addClass('unclickable').removeClass('unit-highlighted');

                //$('#calendar-module-'+ unitid).parents('#real_events_next_year').find('.unit-highlighted:not(.active):not(.can-stay)').addClass('unclickable').removeClass('unit-highlighted');

                $(__current_unit__).parents('.card-body:first').find('.unit-highlighted.can-stay').removeClass('can-stay');

                //$('#calendar-module-'+ unitid).parents('#real_events_next_year').find('.unit-highlighted.can-stay').removeClass('can-stay');
            }
        }

        $(this).addClass('active').removeClass('unclickable');

        if (unittype == 'module') {

            //$('#calendar-module-'+ unitid).addClass('active').removeClass('unclickable');

        }

        //MAKE ACTIVE THOSE COURSES TO WHICH ACTIVE MODULES BELONG
        var _activeModulesCoursesIds = [];

        $('.row-front-modules-'+rangenum+' .unit-module.unit.active').each(function() {

            var _belongToCourseIds = $(this).data('belongstoids');
            //var _belongToCourseIdsArray = [];
            console.log('_belongToCourseIds');
            console.log(_belongToCourseIds);

            if (_belongToCourseIds != '') {

                _activeModulesCoursesIds = _activeModulesCoursesIds.concat(getIdsArrayFromString(_belongToCourseIds));

            }

        });

        var _courseIntersectionsIds = find_duplicate_in_array(_activeModulesCoursesIds);

        console.log('_courseIntersectionsIds');
        console.log(_courseIntersectionsIds);



        if (_courseIntersectionsIds.length > 0) {

            for (var _tt = 0; _tt < _courseIntersectionsIds.length; _tt++) {

                // ONLY COURSE with correct connection ids will stay
                if (_current_unit_connections_ids_array.length > 0) {

                    var _curr_course_connections_ids = $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).data('connectionid');

                    if (typeof _curr_course_connections_ids != 'undefined' && _curr_course_connections_ids != '' && _curr_course_connections_ids != null) {

                        var _curr_course_connections_ids_array = getIdsArrayFromString(_curr_course_connections_ids);

                        //console.log('_curr_course_connections_ids_array');
                        //console.log(_curr_course_connections_ids_array);

                        for (var _yy = 0; _yy < _current_unit_connections_ids_array.length; _yy++) {
                            if (_curr_course_connections_ids_array.length > 0 && in_array(_current_unit_connections_ids_array[_yy], _curr_course_connections_ids_array)) {

                                console.log('intersection with '+_current_unit_connections_ids_array[_yy]);

                                $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).addClass('active');

                                var _course_must_have_module_ = $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).data('musthavemoduleid');
                                var _course_recommended_module_ = $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).data('recommendedmoduleid');

                                if (_course_must_have_module_ !== '0' && _course_must_have_module_ != '') {

                                    $('.row-front-modules-'+rangenum+' .unit-module-'+_course_must_have_module_+'.active').find('.mandatory-module').show();

                                }
                                if (_course_recommended_module_ !== '0' && _course_recommended_module_ != '') {

                                    $('.row-front-modules-'+rangenum+' .unit-module-'+_course_recommended_module_+'.active').find('.recommended-module').show();

                                }

                            }
                        }

                    }

                }
                else {

                    $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).addClass('active');

                    var _course_must_have_module_ = $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).data('musthavemoduleid');
                    var _course_recommended_module_ = $('.row-front-courses-'+rangenum+' .unit.unit-highlighted.unit-course-'+_courseIntersectionsIds[_tt]).data('recommendedmoduleid');

                    if (_course_must_have_module_ !== '0' && _course_must_have_module_ != '') {

                        $('.row-front-modules-'+rangenum+' .unit-module-'+_course_must_have_module_+'.active').find('.mandatory-module').show();

                    }
                    if (_course_recommended_module_ !== '0' && _course_recommended_module_ != '') {

                        $('.row-front-modules-'+rangenum+' .unit-module-'+_course_must_have_module_+'.active').find('.recommended-module').show();

                    }

                }

            }

            $('.row-front-courses-'+rangenum+' .unit-course.unit-highlighted:not(.active)').removeClass('unit-highlighted').addClass('unclickable');

        }


        // disable same modules in other ranges
        for (var _ma_ = 1; _ma_ <= 3; _ma_++) {

            if (_ma_ != rangenum) {
                console.log('prevent another click');
                console.log('#unit-' + unittype + '-' + _ma_ + '-' + unitid);
                $('#unit-' + unittype + '-' + _ma_ + '-' + unitid).addClass('already-chosen');

            }

        }


        return false;
    }

    /** WHEN USER CLICKS ON HIGHLIGHTED ELEMENTS - FILTER END **/

    // general changes to clicked elements - highlight
    $(this).toggleClass('active');

    if ($(this).hasClass('active')) {

        console.log(unittype + ' ' + unitid+' is active');

        // disable same modules / courses in other ranges
        for (var _ma_ = 1; _ma_ <= 3; _ma_++) {

            if (_ma_ != rangenum) {

                console.log('prevent another click');
                console.log('#unit-' + unittype + '-' + _ma_ + '-' + unitid);

                $('#unit-' + unittype + '-' + _ma_ + '-' + unitid).addClass('already-chosen');

                console.log('added class already-chosen');

            }

        }

        if (unittype == 'course') {

            // if clicked unit is course we make other courses in this range unclickable and add class cannot-have-2-active-course-in-one-range
            $('#row-front-courses-' + rangenum + ' .unit-course').not(this).addClass('cannot-have-2-active-course-in-one-range');

        }

    }
    else {

        // if clicked unit is course we make other courses in this range unclickable and add class cannot-have-2-active-course-in-one-range
        if (unittype == 'course') {

            $('#row-front-courses-' + rangenum + ' .unit-course').not(this).removeClass('cannot-have-2-active-course-in-one-range');
            $('#row-front-modules-' + rangenum + ' .mandatory-module, #row-front-modules-' + rangenum + ' .recommended-module').hide();

            $('#row-front-modules-' + rangenum + ' .unit-module.active').each(function() {

                var _internal_rangenum = $(this).data('rangenum');
                var _internal_unitid = $(this).data('unitid');
                var _internal_unittype = $(this).data('unittype');

                for (var _ma_ = 1; _ma_ <= 3; _ma_++) {

                    if (_ma_ != _internal_rangenum) {

                        $('#unit-' + _internal_unittype + '-' + _ma_ + '-' + _internal_unitid).removeClass('already-chosen');

                    }

                }

            });

        }
        else {

            for (var _ma_ = 1; _ma_ <= 3; _ma_++) {

                if (_ma_ != rangenum) {

                    console.log('prevent another click');
                    console.log('#unit-' + unittype + '-' + _ma_ + '-' + unitid);

                    $('#unit-' + unittype + '-' + _ma_ + '-' + unitid).removeClass('already-chosen');

                    console.log('removed class already-chosen');

                }

            }

        }

    }


    if (unittype == 'module') {
        //$('#calendar-module-'+ unitid).toggleClass('active');

    }

    if ($('.row-front-courses-'+rangenum+' .unit-course.active').length == 0) {
        $('.mandatory-module, .recommended-module').hide();
    }

    var _current_clicked_elem = this;
    var _final_belong_ids = [];


    $('.row-front-courses-'+rangenum+' .unit,.row-front-modules-'+rangenum+' .unit').removeClass('unit-highlighted').removeClass('unclickable');

    //$('.calendar-module').removeClass('unit-highlighted').removeClass('unclickable');


    /* FOR BELONGINGS */
    if (typeof belongstoids != 'undefined' && belongstoids != '' && belongstoids != null) {

        // GET BELONGS TO IDS LEVEL 1 (courses)
        _final_belong_ids = getIdsArrayFromString(belongstoids);

        if (_final_belong_ids.length > 0) {

            for (var i = 0; i < _final_belong_ids.length; i++) {

                var _u_prefix_1 = '';

                if (belongsto == 'course') {
                    _u_prefix_1 = '.row-front-courses-' + rangenum + ' ';
                }

                var _current_owner_selector = _u_prefix_1 + '.unit-'+belongsto+'-'+_final_belong_ids[i]+_not_inculde_unclickable_class;

                // GET BELONGS TO IDS LEVEL 2 (DAS)
                var _final_lvl_up_belong_ids = [];
                //var higher_level_belongsto = $(_current_owner_selector).data('belongsto');
                //var higher_level_belongstoids = $(_current_owner_selector).data('belongstoids');

                /*if (typeof higher_level_belongstoids != 'undefined' && higher_level_belongstoids != '' && higher_level_belongstoids != null) {

                    _final_lvl_up_belong_ids = getIdsArrayFromString(higher_level_belongstoids);
                }*/

                var higher_level_dependencytype = $(_current_owner_selector).data('dependencytype');
                var higher_level_dependenciesids = $(_current_owner_selector).data('dependenciesids');


                if ($(_current_clicked_elem).hasClass('active')) {

                    // highlight level 1 (course)
                    $(_current_owner_selector).addClass('unit-highlighted');

                    if (_final_belong_ids.length == 1) {
                        $(_current_owner_selector).addClass('active');
                    }
                }
                else {
                    $(_current_owner_selector).removeClass('unit-highlighted');

                    if (_final_belong_ids.length == 1) {
                        $(_current_owner_selector).removeClass('active');
                    }
                }

                // SPECIAL FOR MODULES
                if (higher_level_dependencytype == 'module' && higher_level_dependenciesids != '' && higher_level_dependenciesids != null) {

                    var _dependent_course_modules = [];

                    var _current_clicked_elm_connectionids_array = getIdsArrayFromString(connectionids);

                    console.log('_current_clicked_elm_connectionids_array');
                    console.log(_current_clicked_elm_connectionids_array);

                    _dependent_course_modules = getIdsArrayFromString(higher_level_dependenciesids);

                    if (_dependent_course_modules.length > 0) {

                        for (var xx = 0; xx < _dependent_course_modules.length; xx++) {

                            var _u_prefix_2 = '';

                            if (higher_level_dependencytype == 'module') {
                                _u_prefix_2 = '.row-front-modules-' + rangenum + ' ';
                            }
                            if (higher_level_dependencytype == 'course') {
                                _u_prefix_2 = '.row-front-courses-' + rangenum + ' ';
                            }

                            var _other_module_connected_to_course_selector = _u_prefix_2 + '.unit-' + higher_level_dependencytype + '-' + _dependent_course_modules[xx];

                            var _other_module_connection_ids = $(_other_module_connected_to_course_selector).data('connectionid');

                            var _other_module_connectionids_array = getIdsArrayFromString(_other_module_connection_ids);



                            console.log('_other_module_connectionids_array');
                            console.log(_other_module_connectionids_array);


                            var o_intersections_array = [];

                            if (_current_clicked_elm_connectionids_array.length > 0 && _other_module_connectionids_array.length > 0) {

                                console.log('_current_clicked_elm_connectionids_array and _other_module_connectionids_array');

                                if (_current_clicked_elm_connectionids_array.length == 1 && _other_module_connectionids_array.length == 1 && _current_clicked_elm_connectionids_array[0] == _other_module_connectionids_array[0]) {

                                    console.log('one elm both arrays');
                                    o_intersections_array = _current_clicked_elm_connectionids_array;

                                }
                                else {
                                    o_intersections_array = _current_clicked_elm_connectionids_array.filter(function(n) {

                                        return _other_module_connectionids_array.indexOf(n.toString()) !== -1;

                                    });
                                }


                            }

                            console.log('o_intersections_array');
                            console.log(o_intersections_array);

                            if ($(_current_clicked_elem).hasClass('active')) {

                                console.log('module active now');

                                if (o_intersections_array.length > 0) {

                                    $(_other_module_connected_to_course_selector).addClass('unit-highlighted');

                                    //$('#calendar-module-' + _dependent_course_modules[xx]).addClass('unit-highlighted');

                                }

                            }
                            else {

                                if (o_intersections_array.length > 0) {

                                    $(_other_module_connected_to_course_selector).removeClass('unit-highlighted');

                                    //$('#calendar-module-' + _dependent_course_modules[xx]).removeClass('unit-highlighted');

                                }

                            }
                        }
                    }
                }
            }
        }
    }

    /* FOR DEPENDENCIES */
    if (typeof dependenciesids != 'undefined' && dependenciesids != '' && dependenciesids != null) {

        var _final_dependencies_ids = [];

        // GET DEPENDENCIES TO IDS LEVEL DOWN 1

        _final_dependencies_ids = getIdsArrayFromString(dependenciesids);

        if (_final_dependencies_ids.length > 0) {

            for (var ii = 0; ii < _final_dependencies_ids.length; ii++) {

                var _u_prefix_3 = '';

                if (dependencytype == 'module') {
                    _u_prefix_3 = '.row-front-modules-' + rangenum + ' ';
                }
                if (dependencytype == 'course') {
                    _u_prefix_3 = '.row-front-courses-' + rangenum + ' ';
                }

                var _current_dependency_selector = _u_prefix_3 + '.unit-'+dependencytype+'-'+_final_dependencies_ids[ii]+_not_inculde_unclickable_class;

                var lower_level_dependencytype = $(_current_dependency_selector).data('dependencytype');
                var lower_level_combinationscount = $(_current_dependency_selector).data('combinationscount');
                var lower_level_dependenciesids = $(_current_dependency_selector).data('dependenciesids');
                var lower_level_musthavemoduleid = $(_current_dependency_selector).data('musthavemoduleid');
                var lower_level_recommendedmoduleid = $(_current_dependency_selector).data('recommendedmoduleid');

                var _final_lvl_down_dep_ids = [];

                // GET DEPENDENCIES TO IDS LEVEL DOWN 2 (certificates)
                if (typeof lower_level_dependenciesids != 'undefined' && lower_level_dependenciesids != '' && lower_level_dependenciesids != null) {

                    _final_lvl_down_dep_ids = getIdsArrayFromString(lower_level_dependenciesids);

                }

                if ($(_current_clicked_elem).hasClass('active')) {

                    // highlight level 1 (course)
                    $(_current_dependency_selector).addClass('unit-highlighted');

                    if (dependencytype == 'module') {
                        //$('#calendar-module-' + _final_dependencies_ids[ii]).addClass('unit-highlighted');
                    }

                    // if user clicked the course unit then we should make modules active
                    if (dependencytype == 'module' || dependencytype == 'course') {

                        if (combinationscount !="" && parseInt(combinationscount) == 1) {

                            $(_current_dependency_selector).addClass('active');

                            if (dependencytype == 'module') {
                                //$('#calendar-module-' + _final_dependencies_ids[ii]).addClass('active');
                            }

                        }
                        else {

                            $(_current_dependency_selector).parents('.card-body:first').find('.choose-more-specific').show();

                        }

                        if (dependencytype == 'module' && musthavemoduleid != '' && $(_current_dependency_selector).data('unitid') == musthavemoduleid) {

                            $(_current_dependency_selector).addClass('active').find('.mandatory-module').show();
                            //$('#calendar-module-' + _final_dependencies_ids[ii]).addClass('active');

                            for (var _sa_ = 1; _sa_ <= 3; _sa_++) {

                                if (_sa_ != rangenum) {

                                    $('#unit-' + dependencytype + '-' + _sa_ + '-' + musthavemoduleid).addClass('already-chosen');

                                }

                            }

                        }

                        if (dependencytype == 'module' && recommendedmoduleid != '' && $(_current_dependency_selector).data('unitid') == recommendedmoduleid) {

                            $(_current_dependency_selector).find('.recommended-module').show();

                        }

                    }

                    if (_final_lvl_down_dep_ids.length > 0) {

                        for (var zz = 0; zz < _final_lvl_down_dep_ids.length; zz++) {

                            var _current_lower_dep_selector = '.unit-'+lower_level_dependencytype+'-'+_final_lvl_down_dep_ids[zz]+_not_inculde_unclickable_class;

                            // highlight level 2 (certificate)
                            $(_current_lower_dep_selector).addClass('unit-highlighted');

                            if (lower_level_dependencytype == 'module') {
                                //$('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('unit-highlighted');
                            }

                            if (lower_level_dependencytype == 'module' || lower_level_dependencytype == 'course') {

                                if (lower_level_combinationscount != "" && parseInt(lower_level_combinationscount) == 1) {

                                    $(_current_lower_dep_selector).addClass('active');

                                    if (lower_level_dependencytype == 'module') {
                                        //$('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('active');
                                    }

                                }
                                else {
                                    $(_current_lower_dep_selector).parents('.card-body:first').find('.choose-more-specific').show();
                                }

                                if (lower_level_dependencytype == 'module' && lower_level_musthavemoduleid != '' && $(_current_lower_dep_selector).data('unitid') == lower_level_musthavemoduleid) {

                                    $(_current_lower_dep_selector).addClass('active').find('.mandatory-module').show();

                                    for (var _pa_ = 1; _pa_ <= 3; _pa_++) {

                                        if (_pa_ != rangenum) {

                                            $('#unit-' + lower_level_dependencytype + '-' + _pa_ + '-' + lower_level_musthavemoduleid).addClass('already-chosen');

                                        }

                                    }

                                    //$('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('active');

                                }

                                if (lower_level_dependencytype == 'module' && lower_level_recommendedmoduleid != '' && $(_current_lower_dep_selector).data('unitid') == lower_level_recommendedmoduleid) {

                                    $(_current_lower_dep_selector).addClass('active').find('.recommended-module').show();

                                    //$('#calendar-module-' + _final_lvl_down_dep_ids[zz]).addClass('active');
                                }

                            }
                        }
                    }
                }
                else {

                    // highlight level 1 (course)
                    $(_current_dependency_selector).removeClass('unit-highlighted').removeClass('active');

                    if (dependencytype == 'module') {
                        //$('#calendar-module-' + _final_dependencies_ids[ii]).removeClass('unit-highlighted').removeClass('active');
                    }

                    if (_final_lvl_down_dep_ids.length > 0) {

                        for (var zz = 0; zz < _final_lvl_down_dep_ids.length; zz++) {

                            var _u_prefix_4 = '';

                            if (lower_level_dependencytype == 'module') {
                                _u_prefix_4 = '.row-front-modules-' + rangenum + ' ';
                            }
                            if (lower_level_dependencytype == 'course') {
                                _u_prefix_4 = '.row-front-courses-' + rangenum + ' ';
                            }

                            var _current_lower_dep_selector = _u_prefix_4 + '.unit-'+lower_level_dependencytype+'-'+_final_lvl_down_dep_ids[zz];

                            // highlight level 2 (certificate)
                            $(_current_lower_dep_selector).removeClass('unit-highlighted').removeClass('active');

                            if (lower_level_dependencytype == 'module') {
                                //$('#calendar-module-' + _final_lvl_down_dep_ids[zz]).removeClass('active').removeClass('unit-highlighted');
                            }

                        }
                    }

                }
            }
        }
    }

    if ($(_current_clicked_elem).hasClass('active')) {
        // Make not highlighted courses unclickable and for each highlighted we find all modules and highlight them too
        $('.row-front-modules-' + rangenum + ' .unit, .row-front-modules-' + rangenum + ' .unit').each(function() {
            if (!$(this).hasClass('unit-highlighted') && !$(this).hasClass('active')) {

                $(this).addClass('unclickable');

                if ($(this).data('unittype') == 'module') {
                    //$('#calendar-module-' + $(this).data('unitid')).addClass('unclickable');
                }

            }
            else {
                $(this).removeClass('unclickable');

                if ($(this).data('unittype') == 'module') {
                    //$('#calendar-module-' + $(this).data('unitid')).removeClass('unclickable');
                }
            }
        });
    }
    else {
        for (var _oa_ = 1; _oa_ <= 3; _oa_++) {

            if (_oa_ != rangenum) {

                $('#unit-' + unittype + '-' + _oa_ + '-' + unitid).removeClass('already-chosen');

            }

        }
    }

});


function setPriceForModuleEventsDas() {

    if ($('.main-front-page').hasClass('with-module-event-price')) {

        setTimeout(function(){

            if ($('.unit-module.active').length > 0) {

                console.log('_text_of_kosten_price');

                var _text_of_kosten_price = '<span class="me-price-message">'+$('#choose-two-module-events-text').data('text')+'</span>';

                if ($('.chosen-details-module .module_events_ids_checkbox:checked').length == 1) {
                    console.log('_text_of_kosten_price 1');
                    _text_of_kosten_price = '<span class="me-price-message">'+$('#choose-one-more-module-event-text').data('text')+'</span>';
                }
                if ($('.chosen-details-module .module_events_ids_checkbox:checked').length > 1) {

                    console.log('.chosen-details-module .module_events_ids_checkbox:checked length');
                    console.log($('.chosen-details-module .module_events_ids_checkbox:checked').length);

                    _text_of_kosten_price = 0;
                    $('.chosen-details-module .module_events_ids_checkbox:checked').each(function() {
                        var _data_me_price = $(this).data('me_price').trim();
                        if (_data_me_price != '' && _data_me_price != null && _data_me_price != 0) {
                            _text_of_kosten_price += parseInt(_data_me_price);
                        }

                    });
                    _text_of_kosten_price = _text_of_kosten_price + ' CHF'
                }
                //console.log('_text_of_kosten_price L');
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").show();
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").next('.sf-fv').html(_text_of_kosten_price).show();

            }
            else {
                //console.log('_text_of_kosten_price E');
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").hide();
                $(".chosen-details-sf-child .sf-fn:contains('Kosten')").next('.sf-fv').html('').hide();
            }

        },750);

    }

}

function findDateCollisionsDas() {

    $('.me-day-date').removeClass('error-collision-date');

    var _all_active_me_days_ = $('.front-me-name.active+.front-me-days .me-day-date');
    $('.errorDateCollisionMessage').addClass('invisible');

    $('.collisions_happened_base').val(0);

    for (var i = 0; i < _all_active_me_days_.length; i++) {
        var currentElement = $(_all_active_me_days_[i]).html();
        var currentElementRangeNum = $(_all_active_me_days_[i]).parents('.course-module-range-info:first').attr('id').replace('course-module-range-info-','');

        /*console.log('currentElementRangeNum');
        console.log(currentElementRangeNum);*/

        for (var j = i + 1; j < _all_active_me_days_.length; j++) {

            var otherElement = $(_all_active_me_days_[j]).html();
            var otherElementRangeNum = $(_all_active_me_days_[j]).parents('.course-module-range-info:first').attr('id').replace('course-module-range-info-','');

            if (currentElement == otherElement) {

                $(_all_active_me_days_[i]).addClass('error-collision-date');
                $(_all_active_me_days_[j]).addClass('error-collision-date');

                $('#errorDateCollisionMessage-'+currentElementRangeNum).removeClass('invisible');
                $('#errorDateCollisionMessage-'+otherElementRangeNum).removeClass('invisible');

                $('#collisions_happened-'+currentElementRangeNum).val(1);
                $('#collisions_happened-'+otherElementRangeNum).val(1);

            }
        }
    }

}

function putDatesIntoFormStatus3Das(clickedElement, rangenum) {

    $('.course-module-range-info-'+rangenum+' .card-front-info').each(function(inx) {

        var column_parent = this;

        var column_parent_num = $(column_parent).attr('id').replace('card-front-info-'+rangenum+'-', '');

        if ($(column_parent).find('.sf-module-title').text() != '') {

            if ($(column_parent).find('.module_events_ids_checkbox:checked').length > 0) {

                var _startdatum = $(column_parent).find('.module_events_ids_checkbox:checked').next('.front-me-name').find('.me-first-date').text().trim();

                console.log('_startdatum kk');
                console.log(_startdatum);

                $('.form-modules-container-'+rangenum+' #chosen_datum-'+rangenum+'-'+column_parent_num).val(_startdatum);

            }
            else {
                $('.form-modules-container-'+rangenum+' #chosen_datum-'+rangenum+'-'+column_parent_num).val('');
            }

        }
        else {
            $('.form-modules-container-'+rangenum+' #chosen_datum-'+rangenum+'-'+column_parent_num).val('');
        }


    });

}

function correctionsToModulesAndPlannerDas()
{

    var number_of_filled_m_columns = parseInt($('.front-module.active').length);

    $('.course-info-row').show();
    $('.card-front-courses').parent().attr('class', 'col-md-8');

    $('#usr-data-1, #usr-data-2').removeClass('width-100-percents');

    $('.row.program-info-row').show();

}

// UNITS SECOND CLICK EVENT
$('.unit-course,.unit-module').click(function() {

    $('.double-course-chosen').css('visiblity', 'hidden');
    $('.card-front-courses').removeClass('has-two-active-courses');

    $('#errorDateCollisionMessage').addClass('invisible');

    if ($(this).hasClass('unclickable') || $(this).hasClass('unavailable') || $(this).hasClass('cannot-have-2-active-course-in-one-range') || $(this).hasClass('already-chosen')) {
        return false;
    }

    var rangenum = $(this).data('rangenum');
    var unitid = $(this).data('unitid');
    var unittype = $(this).data('unittype');

    // REMOVE All Previously Chosen

    if ($('.unit-module.active').length > 0) {

        $('.main-front-das-page').addClass('has-active-modules');

    }
    else {

        $('.main-front-das-page').removeClass('has-active-modules');

    }


    $('.you-can-choose-other-module').remove();

    // #course-module-range-info-

    $('#course-module-range-info-' + rangenum + ' .chosen-details, #course-module-range-info-' + rangenum + ' .sf-course-title, #course-module-range-info-' + rangenum + ' .sf-module-title').html('');


    $('#course-module-range-info-' + rangenum + ' .chosen-info').hide().removeClass('e-visible');

    $('#course-module-range-info-' + rangenum + ' .card-front-info .spinner-border').show();

    var current_elm = this;

    var _module_index = 0;

    /*if ($('#row-front-courses-' + rangenum + ' .unit-course.active').length > 1) {

        $('.card-front-courses').addClass('has-two-active-courses');
        $('.double-course-chosen').css('visibility', 'visible');

        if ($('#c-tab-modules').hasClass('tab-active')) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.double-course-chosen').first().offset().top - 40
            }, 1000);
        }

    }*/

    setTimeout(function() {



        $('#course-module-range-info-' + rangenum + ' .card-front-info .spinner-border').hide();

        $('.front-statistics-'+rangenum+' .fsd-course-parent .fa-times').removeClass('invisible-elem');
        $('.front-statistics-'+rangenum+' .fsd-module .fa-times').removeClass('invisible-elem');


        if ($('.row-front-courses-' + rangenum + ' .unit-course.active').length == 0) {
            $('.front-statistics-'+rangenum+' .fsd-course-parent').removeClass('u-active').find('.fsd-course-name').text($('#not-set-course-text').data('text'));

            $('#row-front-courses-'+rangenum).removeClass('has-active-course');
            $('.col-content-course-range-'+rangenum+' .chosen-course-info').html('');
        }
        else {
            $('#row-front-courses-'+rangenum).addClass('has-active-course');
        }

        if ($('.row-front-modules-' +rangenum+' .unit-module.active').length == 0) {
            $('.front-statistics-'+rangenum+' .fsd-module-1').removeClass('u-active').find('.fsd-m-name').text($('#not-set-module-text').data('text'));
            $('.front-statistics-'+rangenum+' .fsd-module-2').removeClass('u-active').find('.fsd-m-name').text($('#not-set-module-text').data('text'));
        }

        if ($('.row-front-modules-' +rangenum+' .unit-module.active').length == 1) {
            $('.front-statistics-'+rangenum+' .fsd-module-2').removeClass('u-active').find('.fsd-m-name').text($('#not-set-module-text').data('text'));
        }

        $('.row-front-courses-' + rangenum + ' .unit-course.active, .row-front-modules-' +rangenum+' .unit-module.active').each(function() {

            // FOR MODULES
            if ($(this).hasClass('unit-module')) {

                //fsd-module

                _module_index++;

                $('.front-statistics-' + rangenum + ' .fsd-module-' + _module_index).addClass('u-active').find('.fsd-m-name').text($(this).find('.fm-name-text').text().trim());

                var _ent_module_html = '';

                if ($(this).data('content') != '') {
                    _ent_module_html += '<div class="current-unit-description">'+$(this).data('content')+'</div>';
                }

//console.log($('.front-module.active').length);

                if ($('.row-front-modules-' +rangenum+' .unit-module.active').length == 2) {

                    //console.log('inside 2');
                    $('#course-module-range-info-' +rangenum+' .card-front-info-1 .chosen-details-'+$(this).data('unittype')).append(_ent_module_html);
                    $('#course-module-range-info-' +rangenum+' .card-front-info-2 .chosen-details-'+$(this).data('unittype')).append(_ent_module_html);

                    $('#course-module-range-info-' +rangenum+' .card-front-info-1 .chosen-details-'+$(this).data('unittype')).parents('.chosen-info:first').show().addClass('e-visible');


                    $('#course-module-range-info-' +rangenum+' .card-front-info-2 .chosen-details-'+$(this).data('unittype')).parents('.chosen-info:first').show().addClass('e-visible');

                }
                else {
                    //console.log('inside 1');
                    $('#course-module-range-info-' +rangenum+' .card-front-info-1 .chosen-details-'+$(this).data('unittype')).append(_ent_module_html);
                    $('#course-module-range-info-' +rangenum+' .card-front-info-1 .chosen-details-'+$(this).data('unittype')).parents('.chosen-info:first').show().addClass('e-visible');
                }


                if ($(this).hasClass('unit-module') && $(this).find('.front-module-events').length > 0) {

                    var _module_events_html = '<div class="info-me"><span class="me-info-head" style="text-transform:uppercase;">'+ $('#translation-me').text() +':</span>'+ $(this).find('.front-module-events').html() +'</div>';


                    $('#course-module-range-info-' +rangenum+' .card-front-info .chosen-details-'+$(this).data('unittype')).append(_module_events_html);


                    console.log('module_events_checked_by_ranges');
                    console.log(module_events_checked_by_ranges);

                    $('#course-module-range-info-' +rangenum+' .card-front-info .chosen-details-'+$(this).data('unittype') + ' .module_events_ids_checkbox').each(function(){

                        console.log('$(this).data(\'meid\')');
                        console.log($(this).data('meid'));

                        if (module_events_checked_by_ranges.length > 0 && module_events_checked_by_ranges.indexOf($(this).data('meid')) !== -1) {

                            console.log('module_events_checked_by_ranges.indexOf checked');
                            $(this).prop('checked', true);

                        }

                    });
                }

            }

            // FOR COURSES
            if ($(this).hasClass('unit-course')) {

                var _front_course = this;
                var _ent_course_html = '';

                $('#course-module-range-info-' +rangenum+ ' .sf-course-title').text(': '+$(this).attr('title'));

                $('.front-statistics-' + rangenum + ' .fsd-course-parent').addClass('u-active').find('.fsd-course-name').text($(_front_course).find('.fc-title').text().trim());

                if ($(this).data('content') != '') {
                    _ent_course_html += '<div class="current-unit-description">'+$(this).data('content')+'</div>';
                }

                $('#course-module-range-info-' +rangenum+ ' #card-course-info .chosen-details-'+$(this).data('unittype')).html(_ent_course_html).parents('.chosen-info:first').show().addClass('e-visible');

                var _course_modules_html = '';



                $('.row-front-modules-' +rangenum+' .unit-module.active').each(function(index) {

                    var _must_or_recommended = '';
                    var _is_must = 0;

                    if ($(this).find('.recommended-module').is(':visible')) {
                        _must_or_recommended = ' ('+$(this).find('.recommended-module').text()+')';

                    }

                    if ($(this).find('.mandatory-module').is(':visible')) {
                        _must_or_recommended = ' ('+$(this).find('.mandatory-module').text()+')';
                        _is_must = 1;
                    }

                    var _module_letter = (index == 0 ? 'A' : 'B');

                    if ($('.spec-module-letter-'+_module_letter).length == 0) {
                        _course_modules_html += '<div class="spec-module-letter-'+_module_letter+'"><strong>Modul '+ _module_letter + ':</strong> ' + '<span class="sml-'+_module_letter+(_is_must == 1 ? ' is-must ' : '')+'" id="sml-'+$(this).data('unitid')+'">' +  $(this).attr('title') + _must_or_recommended + '</span></div>';
                    }


                });

                $('#course-module-range-info-' +rangenum+ ' #card-course-info .chosen-details-module').append(_course_modules_html).parents('.chosen-info:first').show().addClass('e-visible');


                function _nl2br_(str) {
                    var breakTag = '<br>';
                    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
                }

                // special fields
                var _special_fields_html = '<div class="sf-fields row">';

                if ($(_front_course).data('fieldname1') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname1')+':</span>';
                }
                if ($(_front_course).data('fieldvalue1') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue1'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname2') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname2')+':</span>';
                }
                if ($(_front_course).data('fieldvalue2') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue2'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname3') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname3')+':</span>';
                }
                if ($(_front_course).data('fieldvalue3') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue3'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname4') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname4')+':</span>';
                }
                if ($(_front_course).data('fieldvalue4') != '') {
                    _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue4'))+'</span><br>';
                }

                if ($(_front_course).data('fieldname5') != '') {
                    _special_fields_html += '<span class="sf-fn col-4">'+$(_front_course).data('fieldname5')+':</span>';
                }
                if ($(_front_course).data('fieldvalue5') != '') {
                    if ($(_front_course).data('fieldname5') == $(_front_course).data('fieldname6') && $(_front_course).data('fieldvalue6') != '') {
                        _special_fields_html += '<span class="sf-fv col-8"> <a href="' + $(_front_course).data('fieldvalue5') + '">' + $(_front_course).data('fieldvalue6') + '</a></span><br>';
                    }
                    else {
                        _special_fields_html += '<span class="sf-fv col-8"> '+_nl2br_($(_front_course).data('fieldvalue5'))+'</span><br>';
                    }
                }

                _special_fields_html += '</div>';

                if ($('#course-module-range-info-' +rangenum+ ' .chosen-details-sf-child').length == 0) {
                    $('#course-module-range-info-' +rangenum+ ' #card-course-info .chosen-details-sf').append('<div class="chosen-details-sf-child">'+_special_fields_html+'</div>');

                    // hide course price to replace it with sum of module events prices
                    if ($('.main-front-page').hasClass('with-module-event-price')) {

                        $("#course-module-range-info-"+rangenum+" .chosen-details-sf-child .sf-fn:contains('Kosten')").hide();
                        $("#course-module-range-info-"+rangenum+" .chosen-details-sf-child .sf-fn:contains('Kosten')").next('.sf-fv').hide();

                    }
                }

                $('.col-content-course-range-'+rangenum+' .chosen-course-info').html($('#course-module-range-info-' +rangenum+ ' .front-info .chosen-details-course').parents('.col-md-6:first').html());

            }

            // update the module events Calendar View block
            if ($('#cac-calview').length > 0 && $('#cac-calview').hasClass('active')) {
                $('#cac-calview.active').click();
            }
            //setPriceForModuleEventsDas();

        });

        $('.front-statistics-' + rangenum + ' .fsd-course-parent .fsd-course-name, .front-statistics-' + rangenum + ' .fsd-m-name, .front-statistics-' + rangenum + ' .fsd-me-name').css('visibility', 'visible');

        $('.row-front-modules-' + rangenum + ' .unit-module.active').each(function(index) {

            if (index == 0) {
                /* console.log('index xxx 0');
                 console.log(index);*/
                $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .sf-module-title').text(': '+$(this).attr('title'));
                $('.form-modules-container-' + rangenum + ' .event_name1').val($(this).attr('title'));
            }
            else {
                /*console.log('index xxx other');
                 console.log(index);*/
                $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .sf-module-title').text(': '+$(this).attr('title'));
                $('.form-modules-container-' + rangenum + ' .event_name2').val($(this).attr('title'));
            }
        });


        // Change color of modules on calendar
        changeModulesOnCalendarDas();
        moduleEventsCheckedPutOnCalendarDas();


        if ($('.row-front-courses-' + rangenum + ' .unit-course.active').length > 0) {

            $('#course_name-'+rangenum).val($('.row-front-courses-' + rangenum + ' .unit-course.active .fc-title').text());

        }
        else {

            $('#course_name-'+rangenum).val('');

        }

        if ($('.row-front-modules-' + rangenum + ' .unit-module.active').length == 2) {


            $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .current-entity-title:last').remove();
            $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .current-entity-description:last').remove();
            $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .info-me:last').remove();

            $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .chosen-details-module .current-entity-title:first').remove();
            $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .chosen-details-module .current-entity-description:first').remove();
            $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .chosen-details-module .info-me:first').remove();


            // MODULE WITH THE CLOSEST BOOKING AVAILABLE DATE SHOULD BE MODULE A
            var _card_1_first_date = $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .module_events_ids_checkbox:first').next('.front-me-name').find('.me-first-date').text().trim();

            var _card_2_first_date = $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .chosen-details-module .module_events_ids_checkbox:first').next('.front-me-name').find('.me-first-date').text().trim();

            if (typeof _card_1_first_date != 'undefined' && _card_1_first_date != '' && _card_1_first_date != null && typeof _card_2_first_date != 'undefined' && _card_2_first_date != '' && _card_2_first_date != null) {

                var _aCard1FDate = _card_1_first_date.split('.');
                var _aCard2FDate = _card_2_first_date.split('.');

                var _a_card_1_f_date_milliseconds = Date.parse(_aCard1FDate[1] + '-' + _aCard1FDate[0] + '-' + _aCard1FDate[2]);
                var _a_card_2_f_date_milliseconds = Date.parse(_aCard2FDate[1] + '-' + _aCard2FDate[0] + '-' + _aCard2FDate[2]);


                if (_a_card_1_f_date_milliseconds > _a_card_2_f_date_milliseconds) {

                    var _sf_1_title = $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .sf-module-title').text().trim();
                    var _chosen_details_module_1 = $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module').html();

                    var _sf_2_title = $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .sf-module-title').text().trim();
                    var _chosen_details_module_2 = $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .chosen-details-module').html();


                    $('#course-module-range-info-' + rangenum + ' .sml-A').appendTo('#course-module-range-info-' + rangenum + ' .spec-module-letter-B');
                    $('#course-module-range-info-' + rangenum + ' .sml-B').appendTo('#course-module-range-info-' + rangenum + ' .spec-module-letter-A');


                    $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .sf-module-title').text(_sf_2_title);
                    $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .sf-module-title').text(_sf_1_title);

                    $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module').html(_chosen_details_module_2);
                    $('#course-module-range-info-' + rangenum + ' .card-front-info-2 .chosen-details-module').html(_chosen_details_module_1);

                    $('.form-modules-container-' + rangenum + ' .event_name1').val(_sf_2_title.replace(': ', ''));
                    $('.form-modules-container-' + rangenum + ' .event_name2').val(_sf_1_title.replace(': ', ''));

                }

            }

            // Determine if one of the modules in the info columns is mandatory

            if ($('#course-module-range-info-' + rangenum + ' .is-must').length > 0) {

                var _m_id = $('#course-module-range-info-' + rangenum + ' .is-must').attr('id').replace('sml-', '');
                var _column_with_mandatory_m_index = $('#course-module-range-info-' + rangenum + ' .module_events_ids_checkbox-'+_m_id).parents('.card-front-info:first').attr('id').replace('card-front-info-', '');


                if (_column_with_mandatory_m_index == '1') {

                    if ($('#course-module-range-info-' + rangenum + ' .card-front-info-2 .you-can-choose-other-module').length == 0) {
                        $('#course-module-range-info-' + rangenum + ' .card-front-info-2').append('<div class="you-can-choose-other-module">'+$('.invisible-you-can-choose-other').data('youcanchooseother')+'</div>');
                    }

                }
                else {

                    if ($('#course-module-range-info-' + rangenum + ' .card-front-info-1 .you-can-choose-other-module').length == 0) {
                        $('#course-module-range-info-' + rangenum + ' .card-front-info-1').append('<div class="you-can-choose-other-module">'+$('.invisible-you-can-choose-other').data('youcanchooseother')+'</div>');
                    }

                }

            }
        }


        correctionsToModulesAndPlannerDas();


        // if we have active/chosen events on planner we should also make respective checkboxes checked again
        /*if ($('.content-of-event-cell.active').length > 0) {

            $('.content-of-event-cell.active').each(function() {

                var _me_id = $(this).attr('id').replace('calendar-module-event-', '');

                $('.module_events_ids_checkbox[data-meid="'+_me_id+'"]').each(function(){

                    $(this).prop('checked', true);

                });

            });

        }*/

        // check planner, if module is inactive then module events in his row should be inactive also
        /*$('.calendar-module').each(function(){

            if (!$(this).hasClass('active')) {

                $(this).parents('tr:first').find('.content-of-event-cell').each(function(){
                    $(this).removeClass('active')
                });

            }

        });*/

        /*console.log('second info in col');
        console.log($('#card-front-info-1 .chosen-details-module .info-me').length);*/

        if ($('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .info-me').length == 2) {
            $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .info-me:nth-child(2)').remove();
        }

        if ($('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .current-entity-description').length == 2) {
            $('#course-module-range-info-' + rangenum + ' .card-front-info-1 .chosen-details-module .current-entity-description:nth-child(2)').remove();
        }
        /*$('#card-front-info-1 .chosen-details-module .info-me:nth-child(2)').remove();
        $('#card-front-info-1 .chosen-details-module .current-entity-description:nth-child(2)').remove();*/


        /* Show copy combination button for user who logged in on front page */
        /*if ($('.unit-course.active').length > 0 && $('.unit-module.active').length > 0) {

            setTimeout(function(){

                var _lgd_link_parts = '';
                var _mas_links_ids = [];
                var _das_links_ids = [];
                var _courses_links_ids = [];
                var _modules_links_ids = [];


                $('.entities.active').each(function(){

                    if ($(this).hasClass('front-mas')) {

                        _mas_links_ids.push($(this).data('entityid'));

                    }

                    if ($(this).hasClass('front-das')) {

                        _das_links_ids.push($(this).data('entityid'));

                    }

                    if ($(this).hasClass('front-course')) {

                        _courses_links_ids.push($(this).data('entityid'));

                    }

                    if ($(this).hasClass('front-module')) {

                        _modules_links_ids.push($(this).data('entityid'));

                    }

                });

                if (_mas_links_ids.length > 0) {
                    _lgd_link_parts += 'mas='+ _mas_links_ids.join(',');
                }

                if (_das_links_ids.length > 0) {
                    _lgd_link_parts += (_lgd_link_parts == '' ? '' : '&') + 'das=' + _das_links_ids.join(',');
                }

                if (_courses_links_ids.length > 0) {
                    _lgd_link_parts += (_lgd_link_parts == '' ? '' : '&') + 'courses=' + _courses_links_ids.join(',');
                }

                if (_modules_links_ids.length > 0) {
                    _lgd_link_parts += (_lgd_link_parts == '' ? '' : '&') + 'modules=' + _modules_links_ids.join(',');
                }

                //https://lets-get-digital.ch/de?modules=38,1&course=18

                $('body').append('<a style="display: none;" id="share-the-chosen-course" href="https://lets-get-digital.ch/de?'+_lgd_link_parts+'">'+$('#share-the-chosen-course-text').text()+'</a>');


                document.addEventListener("keydown", function(event) {
                    if (event.ctrlKey && event.code === "KeyC") {
                        // Ctrl+C was pressed
                        console.log("Ctrl+C pressed");
                        var _link_ = document.getElementById('share-the-chosen-course');

                        var _input_ = document.createElement('input');
                        _input_.setAttribute('value', _link_.href);
                        document.body.appendChild(_input_);
                        _input_.select();
                        document.execCommand('copy');
                        document.body.removeChild(_input_);
                        console.log('Link copied to clipboard');
                    }
                });

            },3000);

        }
        else {
            $('#share-the-chosen-course').remove();
        }*/
        /* Show copy combination button for user who logged in on front page end */
    }, 300);

});



$(document).off('click', '.main-front-das-page .front-me-name');
$(document).on('click', '.main-front-das-page .front-me-name', function() {

    $(this).prev('input.module_events_ids_checkbox').click();

    /*console.log('.main-front-das-page .front-me-name');

    var rangenum = $(this).parents('.course-module-range-info:first').attr('id').replace('course-module-range-info-', '');

    $(this).toggleClass('active');

    var module_id = $(this).prev('input.module_events_ids_checkbox').data('memoduleid');

    $(this).parents('.info-me:first').find('.front-me-name').not(this).each(function() {

        $(this).removeClass('active');
        $(this).next('.front-me-days').slideUp("slow");
        $(this).prev('input.module_events_ids_checkbox').prop('checked', false);

        //$('#calendar-module-event-'+$(this).prev('input.module_events_ids_checkbox').data('meid')).removeClass('active');

    });

    if ($(this).hasClass('active')) {

        $(this).next('.front-me-days').slideDown("slow");
        $(this).prev('input.module_events_ids_checkbox').prop('checked', true);


        //$('#calendar-module-'+module_id).addClass('with-active-me');

        //$('#calendar-module-event-'+$(this).prev('input.module_events_ids_checkbox').data('meid')).addClass('active');
    }
    else {

        //$('#calendar-module-'+module_id).removeClass('with-active-me');
        $(this).next('.front-me-days').slideUp("slow");
        $(this).prev('input.module_events_ids_checkbox').prop('checked', false);
        //$('#calendar-module-event-'+$(this).prev('input.module_events_ids_checkbox').data('meid')).removeClass('active');
    }

    console.log('range in chckbx');
    console.log(rangenum);

    putDatesIntoFormStatus3Das(this, rangenum);
    findDateCollisionsDas();
    moduleEventsCheckedPutOnCalendarDas();*/
    //setPriceForModuleEventsDas();
});

var module_events_checked_by_ranges = [];

$(document).off('click', '.main-front-das-page .module_events_ids_checkbox');
$(document).on('click', '.main-front-das-page .module_events_ids_checkbox', function() {

    console.log('.main-front-das-page .module_events_ids_checkbox clicked');

    var _current_checkbox = this;
    var _current_days_container = $(this).next('.front-me-name');
    var _module_id = $(this).data('memoduleid');
    var rangenum = $(this).parents('.course-module-range-info:first').attr('id').replace('course-module-range-info-', '');

    if ($(this).prop('checked') == true) {

        _current_days_container.addClass('active');
        //$('#calendar-module-'+_module_id).addClass('with-active-me');
        $(_current_checkbox).parents('.info-me:first').find('.module_events_ids_checkbox').not(_current_checkbox).prop('checked', false);

        /*$(_current_checkbox).parents('.info-me:first').find('.module_events_ids_checkbox').each(function() {
            $('#calendar-module-event-'+$(this).data('meid')).removeClass('active');
        });*/

        //$('#calendar-module-event-'+$(_current_checkbox).data('meid')).addClass('active');

        $(this).parents('.info-me:first').find('.front-me-name').not(_current_days_container).each(function() {

            $(this).removeClass('active');
            $(this).next('.front-me-days').slideUp("slow");
            $(this).prev('input.module_events_ids_checkbox').prop('checked', false);

        });

        $(this).next().next('.front-me-days').slideDown("slow");

        // determine which tab is active

    }
    else {

        //$('#calendar-module-'+_module_id).removeClass('with-active-me');
        //$('#calendar-module-event-'+$(_current_checkbox).data('meid')).removeClass('active');

        $(this).next('.front-me-name').removeClass("active");
        $(this).next().next('.front-me-days').slideUp("slow");

        /*if ($('.custom-tab-modules').hasClass('ui-tabs-active')) {

            var _card_index =  $(_current_checkbox).parents('.card-front-info:first').attr('id').replace('card-front-info-', '');

            $('#planner-card-front-info-'+_card_index).find('.module_events_ids_checkbox').each(function() {

                $(this).prop('checked', false);

            });

        }*/
        /*else {

            var _card_index =  $(_current_checkbox).parents('.card-front-info:first').attr('id').replace('planner-card-front-info-', '');

            $('#card-front-info-'+_card_index).find('.module_events_ids_checkbox').each(function() {

                $(this).prop('checked', false);

            });

        }*/
    }


    putDatesIntoFormStatus3Das(_current_checkbox, rangenum);
    findDateCollisionsDas();
    moduleEventsCheckedPutOnCalendarDas();
    //setPriceForModuleEvents();
});


/* NEW FRONT PAGE WITH DAS END */
var _dp_ = {};

function changeModulesOnCalendarDas() {

    dasCreateResourcesAndEvents();

    if (typeof _dp_ != 'undefined' && typeof _dp_.resources != 'undefined' && _dp_.resources.length > 0) {


        if ($('.unit-module.active').length > 0) {

            for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                if (typeof _dp_.resources[_cx_].children != 'undefined' && _dp_.resources[_cx_].children.length > 0) {

                    for (var _mx_=0; _mx_ < _dp_.resources[_cx_].children.length; _mx_++) {

                        _dp_.resources[_cx_].children[_mx_].backColor = '';

                    }

                }

            }

        }
        else {

            for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                _dp_.resources[_cx_].backColor = '';

            }

        }



        $('.row-front-modules .unit-module.active').each(function() {

            var _c_m_a_ = this;
            var _mID_ = $(_c_m_a_).data('unitid');


            for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                if (typeof _dp_.resources[_cx_].children != 'undefined' && _dp_.resources[_cx_].children.length > 0) {

                    for (var _mx_=0; _mx_ < _dp_.resources[_cx_].children.length; _mx_++) {

                        if (_dp_.resources[_cx_].children[_mx_].id == 'M'+_mID_) {

                            _dp_.resources[_cx_].children[_mx_].backColor = '#fef387';

                        }

                    }

                }

            }

            for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                if (_dp_.resources[_cx_].id == 'M'+_mID_) {

                    _dp_.resources[_cx_].backColor = '#fef387';

                }

            }

        });

        _dp_.update();

        $("#dp div:contains('DEMO')").filter(function() {
            return $(this).text().trim() === "DEMO";
        }).text('');

        putActiveCoursesInCalendarCorner();

    }

}

function moduleEventsCheckedPutOnCalendarDas() {

    if (typeof _dp_ != 'undefined' && typeof _dp_.events != 'undefined' && typeof _dp_.events.list != 'undefined' && _dp_.events.list.length > 0) {

        //console.log('_dp_.events inside 1');

        for (var _cx_=0; _cx_ < _dp_.events.list.length; _cx_++) {

            /*console.log('_dp_.events.list[_cx_]');
            console.log(_dp_.events.list[_cx_]);*/

            _dp_.events.list[_cx_].backColor = '';

        }

        var _me_checked_array = {
            '1': [],
            '2': [],
            '3': []
        };

        module_events_checked_by_ranges = [];

        $('.module_events_ids_checkbox').each(function() {

            var _c_m_a_ = this;
            var _meID_ = $(_c_m_a_).data('meid');


            if ($(_c_m_a_).prop('checked') == true) {

                module_events_checked_by_ranges.push(_meID_);

                var range_num = $(_c_m_a_).parents('.course-module-range-info').attr('id').replace('course-module-range-info-', '');

                for (var _cx_=0; _cx_ < _dp_.events.list.length; _cx_++) {

                    if (_dp_.events.list[_cx_].customEventId == _meID_) {

                        _dp_.events.list[_cx_].backColor = '#fef387';

                        _me_checked_array[range_num].push('<span class="event-sub-txt">'+_dp_.events.list[_cx_].text+'</span>');


                    }

                }

                // for calendar list view
                if ($('#calview-item-module-event-'+_meID_).length > 0) {

                    $('#calview-item-module-event-'+_meID_).removeClass('ci-disabled').addClass('active');

                    var _ci_module_id_ = $('#calview-item-module-event-'+_meID_).data('calvmoduleid');

                    $('.calview-item-module-'+_ci_module_id_).not('#calview-item-module-event-'+_meID_).addClass('ci-disabled').removeClass('active');

                }

            }
            else {

                if ($('#calview-item-module-event-'+_meID_).length > 0 && $('#calview-item-module-event-'+_meID_).hasClass('active')) {

                    var _ci_module_id_ = $('#calview-item-module-event-'+_meID_).data('calvmoduleid');

                    $('.calview-item-module-'+_ci_module_id_).removeClass('ci-disabled').removeClass('active');

                }

            }
            // for calendar



        });

        for (var range_num in _me_checked_array) {

            var _f_stat_me_html = '';

            if (_me_checked_array[range_num].length > 0) {

                $('.front-statistics-'+range_num+' .fsd-module-events .fa-times').removeClass('invisible-elem');

                for (var iz = 0; iz < _me_checked_array[range_num].length; iz++) {

                    //_f_stat_me_html += _me_checked_array[range_num][iz];
                    $('.front-statistics-' + range_num + ' .fsd-module-events-'+(iz+1)).addClass('u-active');
                    $('.front-statistics-' + range_num + ' .fsd-module-events-'+(iz+1)+' .fsd-me-name').html(_me_checked_array[range_num][iz]);

                }

                if (_me_checked_array[range_num].length == 1) {
                    $('.front-statistics-' + range_num + ' .fsd-module-events-2').removeClass('u-active');
                    $('.front-statistics-' + range_num + ' .fsd-module-events-2 .fsd-me-name').html($('#not-set-module-event-text').data('text'));
                }

            }
            else {
                $('.front-statistics-' + range_num + ' .fsd-module-events-1,.front-statistics-' + range_num + ' .fsd-module-events-2').removeClass('u-active');
                $('.front-statistics-' + range_num + ' .fsd-module-events-1 .fsd-me-name').html($('#not-set-module-event-text').data('text'));
                $('.front-statistics-' + range_num + ' .fsd-module-events-2 .fsd-me-name').html($('#not-set-module-event-text').data('text'));
            }


        }


        _dp_.update();

        $("#dp div:contains('DEMO')").filter(function() {
            return $(this).text().trim() === "DEMO";
        }).text('');

        putActiveCoursesInCalendarCorner();

    }

}

function putActiveCoursesInCalendarCorner() {

    var pacincc_html = '<div class="calendar-course-title">' + $('#choosen-courses-cal').data('text') + ':</div>';
    $('.unit-course.active').each(function() {
        pacincc_html += '<div class="calendar-course-name">' + $(this).find('.fc-title').text().trim() + '</div>';
    });

/*    console.log('pacincc_html');
    console.log(pacincc_html);*/

    $('#dp .scheduler_default_corner').html('');


}

function dasCreateResourcesAndEvents() {

    var resources = [];
    var events = [];

/*    console.log('_modules_and_events_for_calendar2z');
    console.log(_modules_and_events_for_calendar);*/



    if (Object.keys(_modules_and_events_for_calendar).length !== 0) {

        console.log('_modules_and_events_for_calendar3');
        resources = [/*{name: " ", id: 'C1', expanded: true, children: []}*/];

        if ($('.unit-course.active').length > 0) {

            $('.unit-course.active').each(function() {

                resources.push(
                    {name: $(this).find('.fc-title').text(), id: 'C' + $(this).data('unitid'), expanded: true, backColor: '#002f6c', color: '#fff', children: [

                        ]}
                );

            });

            for (var _mod_id_ in _modules_and_events_for_calendar) {

                if ($('.unit-module-'+_mod_id_+'.active').length > 0) {

                    var _c_id_ = $('.unit-module-'+_mod_id_+'.active').parents('.row-front-parent:first').find('.unit-course.active').data('unitid');

                    for (var _r_ in resources) {


                        if (resources[_r_].id == 'C'+_c_id_) {

                            resources[_r_].children.push({name: _modules_and_events_for_calendar[_mod_id_].module_name, id: 'M'+_mod_id_, cssClass: ''});

                        }

                    }

                }
                else {
                    resources.push({name: _modules_and_events_for_calendar[_mod_id_].module_name, id: 'M'+_mod_id_, cssClass: ''});
                }

            }


        }
        else {

            for (var _mod_id_ in _modules_and_events_for_calendar) {

                resources.push({name: _modules_and_events_for_calendar[_mod_id_].module_name, id: 'M'+_mod_id_, cssClass: ''});

            }

        }

    }

/*    console.log('resources2z');
    console.log(resources);*/

    for (_mod_id_ in _modules_and_events_for_calendar) {

        for (var _mod_ev_id_ in  _modules_and_events_for_calendar[_mod_id_].module_events) {

            if (typeof _modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].start_date != 'undefined' && _modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].start_date != null && typeof _modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].end_date != 'undefined' && _modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].end_date != null) {

                var final_start_date = '';
                var final_start_date_tmp = _modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].start_date.split('-');

                if (final_start_date_tmp.length > 0 && typeof final_start_date_tmp[0] != 'undefined' && typeof final_start_date_tmp[1] != 'undefined' && typeof final_start_date_tmp[2] != 'undefined') {
                    final_start_date = final_start_date_tmp[2] + '.' + final_start_date_tmp[1] + '.' + final_start_date_tmp[0];
                }

                var final_end_date = '';
                var final_end_date_tmp = _modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].end_date.split('-');

                if (final_end_date_tmp.length > 0 && typeof final_end_date_tmp[0] != 'undefined' && typeof final_end_date_tmp[1] != 'undefined' && typeof final_end_date_tmp[2] != 'undefined') {
                    final_end_date = final_end_date_tmp[2] + '.' + final_end_date_tmp[1] + '.' + final_end_date_tmp[0];
                }

                var e = {
                    start:  new DayPilot.Date(_modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].start_date + 'T23:59:00'),
                    end:  new DayPilot.Date(_modules_and_events_for_calendar[_mod_id_].module_events[_mod_ev_id_].end_date + 'T23:59:00'),
                    id: DayPilot.guid(),
                    resource: 'M'+_mod_id_,
                    text: final_start_date + ' - ' + final_end_date,
                    backColor: '#F1F1EE',
                    customEventId: _mod_ev_id_,
                };

                events.push(e);

            }

        }

    }

/*    console.log('events');
    console.log(events);*/

    _dp_.update({resources, events});

    $("#dp div:contains('DEMO')").filter(function() {
        return $(this).text().trim() === "DEMO";
    }).text('');

}

$(document).ready(function() {

    if ($('.main-front-das-page').length > 0) {

        function initiateCalendar() {

            console.log('ran initiateCalendar');

            var divToRemove = document.getElementById("dp");

            if (divToRemove) {
                // Remove the div element
                divToRemove.remove();
            }

            var _divElement = document.createElement("div");

            // Set the id attribute to "dp"
            _divElement.id = "dp";

            document.body.appendChild(_divElement);

            const today1 = new Date();
            const year1 = today1.getFullYear().toString();
            const month1 = (today1.getMonth() + 1).toString().padStart(2, '0');
            const day1 = today1.getDate().toString().padStart(2, '0');

            const formattedDate1 = `${year1}-${month1}-${day1}`;


            _dp_ = new DayPilot.Scheduler("dp", {
                startDate: formattedDate1,
                days: 730,
                scale: "Week",
                timeHeaders: [
                    {groupBy: "Quarter"},
                    {groupBy: "Month", format: "MMMM yyyy"},
                    {groupBy: "Week"}
                ],
                treeEnabled: true,
                treePreventParentUsage: true,
                heightSpec: "Max",
                height: 650,
                cellWidth: 30,
                cellHeight: 30,
                locale: 'de-de',
                eventMovingStartEndEnabled: true,
                eventResizingStartEndEnabled: true,
                timeRangeSelectingStartEndEnabled: true,
                contextMenu: new DayPilot.Menu({
                    items: [
                        /*{
                            text: "Edit",
                            onClick: (args) => {
                                dp.events.edit(args.source);
                            }
                        },
                        {
                            text: "Delete",
                            onClick: (args) => {
                                dp.events.remove(args.source);
                            }
                        },
                        {text: "-"},
                        {
                            text: "Select",
                            onClick: (args) => {
                                dp.multiselect.add(args.source);
                            }
                        }*/
                    ]
                }),
                onBeforeEventRender: (args) => {
                    args.data.moveDisabled = true;
                },
                onEventMoved: (args) => {
                    /*dp.message("Moved: " + args.e.text());*/
                },
                onEventMoving: (args) => {

                    args.left.enabled = false;
                    args.right.enabled = false;
                    args.allowed = false;

                    /*if (args.e.resource() === "A" && args.resource === "B") {  // don't allow moving from A to B
                        args.left.enabled = false;
                        args.right.html = "You can't move an event from Room 1 to Room 2";

                        args.allowed = false;
                    }
                    else if (args.resource === "B") {  // must start on a working day, maximum length one day
                        while (args.start.getDayOfWeek() === 0 || args.start.getDayOfWeek() === 6) {
                            args.start = args.start.addDays(1);
                        }
                        args.end = args.start.addDays(1);  // fixed duration
                        args.left.enabled = false;
                        args.right.html = "Events in Room 2 must start on a workday and are limited to 1 day.";
                    }

                    if (args.resource === "C") {
                        const except = args.e.data;
                        const events = dp.rows.find(args.resource).events.all();

                        let start = args.start;
                        let end = args.end;
                        let overlaps = events.some(item => item.data !== except && DayPilot.Util.overlaps(item.start(), item.end(), start, end));

                        while (overlaps) {
                            start = start.addDays(1);
                            end = end.addDays(1);
                            overlaps = events.some(item => item.data !== except && DayPilot.Util.overlaps(item.start(), item.end(), start, end));
                        }

                        if (args.start !== start) {
                            args.start = start;
                            args.end = end;

                            args.left.enabled = false;
                            args.right.html = "Start automatically moved to " + args.start.toString("d MMMM, yyyy");
                        }

                    }*/
                },
                onEventResized: (args) => {
                    _dp_.message("Resized: " + args.e.text());
                },
                onTimeRangeSelected: async (args) => {
                    /*const modal = await DayPilot.Modal.prompt("New event name:", "New Event")
                    dp.clearSelection();
                    if (modal.canceled) {
                        return;
                    }
                    const name = modal.result;
                    dp.events.add({
                        start: args.start,
                        end: args.end,
                        id: DayPilot.guid(),
                        resource: args.resource,
                        text: name
                    });
                    dp.message("Created");*/
                },
                onEventMove: (args) => {
                    /*if (args.ctrl) {
                        dp.events.add({
                            start: args.newStart,
                            end: args.newEnd,
                            text: "Copy of " + args.e.text(),
                            resource: args.newResource,
                            id: DayPilot.guid()  // generate random id
                        });

                        // notify the server about the action here
                        args.preventDefault(); // prevent the default action - moving event to the new location
                    }*/
                },
                onEventClick: (args) => {

                    console.log('args.e.data');
                    console.log(args.e.data);

                    var selectedResource = args.resource;
                    //console.log("Selected Resource: ", selectedResource);

                    var activeColor = '#fef387';
                    var defaultColor = '#F1F1EE';

                    var moduleEventId = args.e.data.customEventId;
                    var module_id = '';


                    if (typeof args.e.data.resource != 'undefined') {
                        module_id = args.e.data.resource.replace('M', '');
                    }

                    if (module_id != '') {

                        console.log('args module_id exists '+ module_id);

                        if ($('.unit-module-'+module_id+ '.active:not(.unclickable, .unavailable, .cannot-have-2-active-course-in-one-range, .already-chosen)').length == 1) {

                            console.log('only if module_id active '+ module_id);

                            if (args.e.data.backColor == defaultColor || args.e.data.backColor == '') { // was not active then MAKE ACTIVE

                                console.log('was defaultColor');


                                    $('.unit-module-'+module_id+ '.active:not(.unclickable, .unavailable, .cannot-have-2-active-course-in-one-range, .already-chosen)').addClass('module-active-from-cal');

                                    console.log('inside manual click from calendar 1');

                                    // click on first not active and not blocked module
                                    //$('.unit-module-'+module_id+ ':not(.unclickable, .unavailable, .cannot-have-2-active-course-in-one-range, .already-chosen):first').addClass('module-active-from-cal').click();

                                    // open accordeon if it is closed
                                   // $('.module-active-from-cal').parents('.row-front-parent:not(.opened)').next('.front-statistics').click();

                                    var m_range_num = $('.module-active-from-cal').parents('.row-front-modules').attr('id').replace('row-front-modules-', '');

                                    console.log('m_range_num');
                                    console.log(m_range_num);
                                    // click on respective module event checkbox

                                    $('.course-module-range-info-' + m_range_num + ' .module_events_ids_checkbox[value="'+moduleEventId+'"]').click();

                                    args.e.data.backColor = activeColor;


                                    if ($('.unit-module.active').length > 0) {

                                        for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                                            if (typeof _dp_.resources[_cx_].children != 'undefined' && _dp_.resources[_cx_].children.length > 0) {

                                                for (var _mx_=0; _mx_ < _dp_.resources[_cx_].children.length; _mx_++) {

                                                    if (_dp_.resources[_cx_].children[_mx_].id == 'M'+module_id) {

                                                        console.log('module ' + module_id + ' has active me');
                                                        _dp_.resources[_cx_].children[_mx_].cssClass = 'has-active-me';

                                                    }

                                                }

                                            }

                                        }

                                    }
                                    else {

                                        for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                                            if (_dp_.resources[_cx_].id == 'M'+module_id) {

                                                console.log('module ' + module_id + ' has active me');
                                                _dp_.resources[_cx_].cssClass = 'has-active-me';

                                            }

                                        }

                                    }


                                    // remove temp class module-active-from-cal from module
                                    $('.module-active-from-cal').removeClass('module-active-from-cal');



                                //args.e.data.backColor == activeColor;

                            }
                            else {

                                console.log('was activeColor');

                                //args.e.data.resource.cssClass('');

                                console.log('inside manual click from calendar 2');

                                // click on first not active and not blocked module
                                $('.unit-module-'+module_id+ '.active').addClass('module-active-from-cal');

                                var m_range_num = $('.module-active-from-cal').parents('.row-front-modules').attr('id').replace('row-front-modules-', '');

                                $('.course-module-range-info-' + m_range_num + ' .module_events_ids_checkbox[value="'+moduleEventId+'"]').click();

                                args.e.data.backColor = defaultColor;


                                if ($('.unit-module.active').length > 0) {

                                    for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                                        if (typeof _dp_.resources[_cx_].children != 'undefined' && _dp_.resources[_cx_].children.length > 0) {

                                            for (var _mx_=0; _mx_ < _dp_.resources[_cx_].children.length; _mx_++) {

                                                if (_dp_.resources[_cx_].children[_mx_].id == 'M'+module_id) {

                                                    console.log('module ' + module_id + ' has active me');
                                                    _dp_.resources[_cx_].children[_mx_].cssClass = '';

                                                }

                                            }

                                        }

                                    }

                                }
                                else {

                                    for (var _cx_=0; _cx_ < _dp_.resources.length; _cx_++) {

                                        if (_dp_.resources[_cx_].id == 'M'+module_id) {

                                            _dp_.resources[_cx_].cssClass = '';

                                        }

                                    }

                                }



                                //$('.module-active-from-cal').removeClass('module-active-from-cal').click();

                                console.log('end of args active');

                            }

                            _dp_.update();

                            $("#dp div:contains('DEMO')").filter(function() {
                                return $(this).text().trim() === "DEMO";
                            }).text('');

                            putActiveCoursesInCalendarCorner();
                        }
                    }
                }
            });

            _dp_.init();
            //dp.scrollTo("2023-03-01");

            const app = {
                barColor(i) {
                    /*const colors = ["#3c78d8", "#6aa84f", "#f1c232", "#cc0000"];
                    return colors[i % 4];*/
                },
                barBackColor(i) {
                    /*const colors = ["#a4c2f4", "#b6d7a8", "#ffe599", "#ea9999"];
                    return colors[i % 4];*/
                },
                loadData() {

                    dasCreateResourcesAndEvents();

                },
            };

            app.loadData();

        }


        initiateCalendar();

        var _hh_dp_timer = setInterval(_dpFunc_, 300);
        var _counter_of_cycles_dp = 0;

        function _dpFunc_() {

            if (_counter_of_cycles_dp >= 50) {

                clearInterval(_hh_dp_timer);
                return;

            }

            if ($('#dp').length > 0) {

                setTimeout(function() {


                    $("#dp div:contains('DEMO')").filter(function() {
                        return $(this).text().trim() === "DEMO";
                    }).text('');

                    putActiveCoursesInCalendarCorner();


                }, 500);

                setTimeout(function() {

                    $('#dp').appendTo('#dp-container');

                },1000);

                clearInterval(_hh_dp_timer);

                return;
            }

        }

        var _hh_dp_counter = 0;
        var _hh_dp_timer2 = setInterval(_dpFunc_2, 1500);

        function _dpFunc_2() {

            _hh_dp_counter++;

            //console.log('_dpFunc_2 ' + (_hh_dp_counter*1500));

            if ($("#dp:contains('trial')").length > 0) {

                console.log('found trial phrase');
                initiateCalendar();
                changeModulesOnCalendarDas();
                moduleEventsCheckedPutOnCalendarDas();

                setTimeout(function() {

                    $('#dp').appendTo('#dp-container');
                    _dpFunc_();
                },1500);

            }

        }


        // ACCORDION
        // Hide all accordion content except the first level
        $('.front-statistics').click(function(){

            $(this).prev('.row-front-parent').toggleClass('opened');

        });

        $('.row-front-parent .rfp-closer').click(function() {

            $(this).parents('.row-front-parent:first').removeClass('opened');

        });


        // TOP TABS
        $('.top-cdm-tab').click(function() {

            console.log('zetkey3');
            $('.top-cdm-tab').removeClass('active');
            $(this).addClass('active');

            //var _cdm_id = $(this).attr('id').replace('top-cdm-tab-', '');
            var _cdm_suffix = $(this).attr('id').replace('top-cdm-', '');

            $('.main-front-das-page').removeClass('tab-das').removeClass('tab-mas').addClass(_cdm_suffix);

            if ($('.unit-das.active').length > 0) {
                $('.unit-das.active').click();
            }
            if ($('.unit-mas.active').length > 0) {
                $('.unit-mas.active').click();
            }

        });

        if (location.href.indexOf('active_tab=das') != -1) {
            $('#top-cdm-tab-das').click();
        }
        if (location.href.indexOf('active_tab=mas') != -1) {
            $('#top-cdm-tab-mas').click();
        }

        // BOTTOM TABS
        $('.cac').click(function() {

            var _cac_id = $(this).attr('id').replace('cac-', '');

            $('.cac,.cac-row').removeClass('active');

            $(this).addClass('active');

            $('.cac-row-'+_cac_id).addClass('active');

            if (_cac_id == 'calview') {

                $('.parent-calview').html('');

                var _a_module_events_ = [];

                $('.cac-row-checkboxes .course-module-range-info .module_events_ids_checkbox').each(function() {

                    var _module_id_ = $(this).data('memoduleid');

                    var _is_checked = $(this).prop('checked');

                    var _module_name_ = $('.unit-module-'+_module_id_ + ':first').find('.fm-name-text:first').text().trim();

                    var _module_event_id_ = $(this).data('meid');

                    var _module_event_name_ = $(this).next('.front-me-name').data('frontmename');

                    var _current_earliest_date_ = $(this).next('.front-me-name').find('.me-first-date').data('earliestdate');


                    if (typeof _current_earliest_date_ != 'undefined' && _current_earliest_date_ != '') {

                        _a_module_events_.push({
                            'date': _current_earliest_date_,
                            'module_event_name': _module_event_name_,
                            'module_event_id': _module_event_id_,
                            'module_name': _module_name_,
                            'module_id': _module_id_,
                            'checked': _is_checked
                        });

                    }

                });

                if (_a_module_events_.length > 0) {

                    _a_module_events_.sort(function(a,b){
                        return new Date(a.date) - new Date(b.date);
                    });

                    for (var i = 0; i < _a_module_events_.length; i++) {

                        var _ready_date_a = _a_module_events_[i].date.split('-');

                        var _ready_date = _ready_date_a[2] + '.' + _ready_date_a[1] + '.' + _ready_date_a[0];


                        if ($('#calview-item-module-event-'+_a_module_events_[i].module_event_id).length == 0) {

                            $('.parent-calview').append('<div id="calview-item-module-event-'+_a_module_events_[i].module_event_id+'" data-calvmoduleid="'+_a_module_events_[i].module_id+'" data-calvmoduleeventid="'+_a_module_events_[i].module_event_id+'" class="calview-item ' + (_a_module_events_[i].checked == true ? 'active' : '') + ' calview-item-module-'+_a_module_events_[i].module_id+'"><div class="calvi-1">' + _a_module_events_[i].module_event_name + '</div><div class="calvi-2">' + _ready_date + '</div><div class="calvi-3">' + _a_module_events_[i].module_name + '</div></div>');

                        }

                    }

                    $('.parent-calview .calview-item.active').each(function() {

                        var _module_id_ = $(this).data('calvmoduleid');

                        $('.calview-item-module-'+_module_id_).not(this).addClass('ci-disabled');

                    });

                    $('.calview-item').not('.ci-disabled').click(function() {

                        var _module_event_id = $(this).data('calvmoduleeventid');

                        $('.cac-row-checkboxes .course-module-range-info .module_events_ids_checkbox[data-meid="'+_module_event_id+'"]').click();

                    });

                }

            }

        });
        if (parseInt($(window).innerWidth()) <= 768) {
            $('#cac-checkboxes').click();
            $('#cac-calendar').hide();
        }


    }
});

/*DAS MAS END*/

$(document).on('change', '.show-tbd-pick', function() {

    var _med_id = $(this).parents('.me-show-tbd').attr('id').replace('me-show-tbd-', '')
    var _show_tbd_value = $(this).val();

console.log('_show_tbd_value');
console.log(_show_tbd_value);

    $.ajax({
        url: $('#show_tbd_url').data('url'),
        method: 'POST',
        data: {'med_id': _med_id, 'show_tbd_value': _show_tbd_value},
        success: function (data) {
            if (typeof data.success != 'undefined' && data.success != null && data.success != '') {



            }
        }
    });

});

/* Copy Module Event Dates Admin Modal */

$('#ModalCopyDates').on('show.bs.modal', function (event) {

    $('#ModalCopyDates .warning-2').removeClass('active');

    var button = $(event.relatedTarget);
    var module_event_id = button.data('meid');
    var module_name = button.data('modulename');
    var module_event_name = button.data('moduleeventname');

    var _final_module_events_selector_html = '<input class="form-control" id="me_names_filter" placeholder="'+$('#filter_text').data('text')+'"/><br><div class="me-to">'+$('#me-to-text').data('text')+'</div><select class="form-control" id="copy_to_me_id" name="copy_to_me_id"><option value="">'+$('#copy_to_select').data('text')+'</option>';

    $('.me-parent .module-event:not(.module-event-archived)').each(function() {

        var _new_me_id = $(this).attr('id').replace('module-event-', '');


        var _new_mod_name = $(this).find('.me-filters-column_modulename .mh-mod-name').text();


        var _new_me_name = $(this).find('.me-filters-column_title').text();


        _final_module_events_selector_html += '<option value="' + _new_me_id + '">' + _new_mod_name + ' ' + _new_me_name + '</option>';

    });

    _final_module_events_selector_html += '</select>';

    var modal = $(this);
    modal.find('.modal-title .current-me-name').text(module_name + ' ' + module_event_name);
    modal.find('.modal-body').html(_final_module_events_selector_html);


    $('#me_names_filter').change(function() {

        $('#copy_to_me_id option').show();

        if ($(this).val() != '') {

            //console.log($(_current_filter_input).attr('id'));

            var has_values = true;

            var _current_value = $(this).val().toLowerCase();



            $('#copy_to_me_id option').each(function() {

                var current_cell_t = this;

                var _cell_value = $(this).text().trim().toLowerCase();

                if (_cell_value.indexOf(_current_value) != -1) {

                    $//(this).parents('.row-for-filter:first').addClass('r-filtered').show();

                }
                else {

                    $(this).hide();

                }

            });

        }

    });



    $(document).off('.btn-save-me-dates');
    $(document).on('click', '.btn-save-me-dates', function() {



        if ($('#copy_to_me_id').val() != '') {
            $.ajax({
                url: $('#copy_days_dates').data('url'),
                method: 'POST',
                data: {'module_event_id': module_event_id, 'copy_to_me_id': $('#copy_to_me_id').val()},
                success: function (data) {
                    if (typeof data.success != 'undefined' && data.success != null && data.success != '') {

                        $('.btn-close-me-dates').click();
                        location.reload();

                    }
                    else {

                        $('#ModalCopyDates .warning-2').addClass('active');

                    }
                }
            });
        }

    });

});

/* Copy Module Event Dates Admin Modal End */

if ($('.front-m-link-copier').length > 0) {
    $('.front-m-link-copier').click(function(event) {
        event.preventDefault();

        var ___href = $(this).attr('href');
        var textArea = document.createElement('textarea');
        textArea.value = location.host + ___href;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        $(this).popover({
            content: $('#text_link_was_copied').data('text'),
            placement: 'top',
            trigger: 'manual'
        }).popover('show');

        setTimeout(() => {
            $(this).popover('hide');
        }, 3000); // Hide popover after 2 seconds

    });
}


